/* Stickiply Studio, the product page lab's engine.
 *
 * Moved out of sections/proof-lab-order.liquid on 17 Sep 2026: that file had reached 262,086 bytes
 * against Shopify's 262,144 ceiling with 95 percent of it this script, so a fix could only land by
 * deleting measured comments to make room.
 *
 * AN ASSET IS NEVER PROCESSED BY LIQUID. A first attempt at this move left the section's Liquid
 * COMMENTS in here and they printed on the live page as visible text, and substituted a setting
 * with string concatenation inside a template literal so that printed too. Both are why nothing
 * Liquid may survive into this file: settings arrive as data attributes, comments are deleted.
 */
const PL_CUSTOM = (function(){
  /* The tool waits inside <template data-pl-tpl> until Studio opens, and
     document.querySelector never looks inside a template's content, so look
     there too. Without this the custom size box was off on the live stickers
     page from the 17 Sep split until 22 Sep 2026. */
  var h = document.querySelector('proof-lab-tool');
  if (!h) {
    var t = document.querySelector('template[data-pl-tpl]');
    h = t && t.content ? t.content.querySelector('proof-lab-tool') : null;
  }
  return !!(h && h.dataset && h.dataset.plCustom === '1');
})();
/* P128 (25 Sep 2026): width x height and a free quantity, priced by /api/custom-quote. OFF unless the
   section's "True-size pricing" setting is ticked on THAT theme (data-true-size="1"), so pushing these
   files to live changes nothing until Thomas turns it on there. Needs the custom size box too. */
const PL_TRUE_SIZE = (function(){
  var h = document.querySelector('proof-lab-tool');
  if (!h) {
    var t = document.querySelector('template[data-pl-tpl]');
    h = t && t.content ? t.content.querySelector('proof-lab-tool') : null;
  }
  return !!(h && h.dataset && h.dataset.trueSize === '1' && h.dataset.plCustom === '1');
})();
/* P128 SIZE GRID (27 Sep 2026): on the grid product (theme setting stk_grid_handle) the section
   hands over data-grid = snippets/stk-grid-config.liquid: every listed variant's id, SKU, Size,
   Finish, price in the CART currency and its stickiply.grid {n,f,u,v}. Size x Finish are the
   options, one sticker per variant; the quantity is the cart line's. The true cut size snaps UP
   to the grid (0.5 cm steps to 10 cm, 1 cm above, over 28 cm refused) and picks that variant;
   the price is assets/stk-grid-price.js, the Bulk price function's own rule. null elsewhere, so
   every other product runs exactly as before. */
const PL_GRID = (function(){
  var h = document.querySelector('proof-lab-tool');
  if (!h) {
    var t = document.querySelector('template[data-pl-tpl]');
    h = t && t.content ? t.content.querySelector('proof-lab-tool') : null;
  }
  if (!h || !h.dataset || !h.dataset.grid) return null;
  try {
    var g = JSON.parse(h.dataset.grid);
    return (g && Array.isArray(g.variants) && g.variants.length) ? g : null;
  } catch (e) { return null; }
})();
/* CUSTOM MAGNETS (30 Oct 2026, P13 magnets): the magnets grid (Size S1-S15 x Finish x Quantity 12-100 in 4s and 110-200 in
   10s, printed on A4, stickiply.grid v mbands-2026-10-30) rides the band product's path with its own limits, read from data-grid
   ("kind":"magnets", snippets/stk-bands-config-magnets.liquid): a true size 20 to 75 mm on the longest side and at least 20 mm
   on the shortest, a typed quantity UP to the next pack (12 under 12), over 200 the email line, its own ladder section. false on
   every other product, so every other product runs exactly as before. */
const PL_MG = !!(PL_GRID && PL_GRID.kind === "magnets");
/* 2 Oct 2026: every band price in GBP pence, from product metafield stickiply.band_prices
   ({"v":stamp,"q":[50..2000],"p":{"MATTE":{"S1":[40 prices]...},...}}), printed by the section
   beside data-grid. Studio prices from it with no ladder request; null = the ladder as before. */
const PL_BAND_PRICES = (function(){
  var h = document.querySelector('proof-lab-tool');
  if (!h) {
    var t = document.querySelector('template[data-pl-tpl]');
    h = t && t.content ? t.content.querySelector('proof-lab-tool') : null;
  }
  if (!h || !h.dataset || !h.dataset.bandPrices) return null;
  try {
    var j = JSON.parse(h.dataset.bandPrices);
    return (j && Array.isArray(j.q) && j.q.length && j.p && typeof j.p === 'object') ? j : null;
  } catch (e) { return null; }
})();

(function(){
if(customElements.get("proof-lab-tool")) return;

/* i18n (P1, 22 Sep 2026). Customer-facing words come from the stk-i18n-studio JSON island that
   sections/proof-lab-order.liquid renders before this script. Every English fallback below is the
   text this file carried before, so English renders exactly as it did. A value may carry [name]
   placeholders (the island passes them through), filled by stkFmt; stkEsc makes a value safe
   inside innerHTML. */
var stkT = window.stkT || function (k, f) { return f; };
function stkFmt(s, vars){ s=String(s==null?"":s); return vars ? s.replace(/\[(\w+)\]/g, function(m, n){ return vars[n]!=null ? String(vars[n]) : m; }) : s; }
function stkEsc(s){ return String(s==null?"":s).replace(/[&<>"]/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }
/* 7 Oct 2026 (P212 audit 4): a SAVE badge in the product page's words and number format: the key its rows print,
   'stk.stk_addons.save_badge' | t: percent: n | upcase ("SAVE 19%", "19 % SPAREN", "-19 %", "AHORRA 19 %"). A page whose
   island lacks that key keeps the old stk.pricing.save wording. */
function stkSaveBadge(n){ var s=stkT("stk.stk_addons.save_badge",null); return (typeof s==="string" && /\{\{\s*percent\s*\}\}/.test(s)) ? s.replace(/\{\{\s*percent\s*\}\}/g, String(n)).toUpperCase() : stkFmt(stkT("stk.pricing.save","SAVE [n]%"),{n:n}); }
/* P172 (2 Oct 2026): a date SHOWN to people, in the page language ("2.10.2026" on /de). English keeps the browser's own
   format, exactly as before. */
function stkDate(ts){ var d=new Date(ts), lang=document.documentElement.lang||""; try{ return (!lang || /^en\b/i.test(lang)) ? d.toLocaleDateString() : d.toLocaleDateString(lang); }catch(e){ return d.toLocaleDateString(); } }
/* P172: a decimal SHOWN to people, in the page language ("0,5" on /nl). English keeps toFixed, so it
   prints exactly as before. Never used for maths, cut/print files, cart properties or data attributes. */
function stkDec(v, dp){ v=Number(v); var lang=document.documentElement.lang||"en"; if(/^en\b/i.test(lang) || !isFinite(v)) return v.toFixed(dp); try{ return new Intl.NumberFormat(lang,{minimumFractionDigits:dp,maximumFractionDigits:dp,useGrouping:false}).format(v); }catch(e){ return v.toFixed(dp); } }
/* the noun a product is made of (data-noun, an English setting value) shown in the page language;
   an unknown noun is shown as it is, with an English plural, as before */
var NOUN_WORDS = { sticker:[stkT("stk.studio.nouns.sticker","sticker"),stkT("stk.studio.nouns.stickers","stickers")], magnet:[stkT("stk.studio.nouns.magnet","magnet"),stkT("stk.studio.nouns.magnets","magnets")] };
function nounOne(n){ return NOUN_WORDS.hasOwnProperty(n) ? NOUN_WORDS[n][0] : n; }
function nounMany(n){ return NOUN_WORDS.hasOwnProperty(n) ? NOUN_WORDS[n][1] : n+"s"; }
/* PRODUCT WORDING (Custom Magnets, 25 Sep 2026). The Studio is one file for every product it
   sells; the words that change with the product live in this ONE table, keyed by the section's
   noun setting (data-noun), then by the stkT key the sticker wording uses. Each entry names the
   key its translation will live under and its English. A noun with no table, and every key not
   listed, reads exactly as before, so the vinyl stickers page is unchanged. */
var NOUN_TEXT = { magnet: {
  "stk.studio.tool.corners_info": ["stk.studio.magnet.corners_info", "Your artwork is a rectangle, so the cut uses straight edges and true corners. 90° is for labels. Magnets keep a radius so the corners do not lift."],
  "stk.studio.tool.dl_cut": ["stk.studio.magnet.dl_cut", "Magnet cut file SVG"],
  "stk.studio.tool.dl_print": ["stk.studio.magnet.dl_print", "Magnet print PNG · 300 DPI"],
  "stk.studio.tool.dl_print_note": ["stk.studio.magnet.dl_print_note", "Already in the ZIP · finished magnet, transparent"],
  "stk.studio.tool.dl_proof_note": ["stk.studio.magnet.dl_proof_note", "Your magnet with its cut line · not a print file"],
  "stk.studio.readme.print_desc": ["stk.studio.magnet.print_desc", "(finished magnet artwork, transparent)"],
  "stk.studio.readme.mockup_desc": ["stk.studio.magnet.mockup_desc", "(your magnet in the finish you chose, on a\ntransparent background, for your own product photos and listings)"],
  "stk.studio.msg.over10": ["stk.studio.magnet.over75", "Magnets over 7.5 cm are priced by hand. Email hello@stickiply.com."],
  "stk.studio.order.over10_note": ["stk.studio.magnet.over75_note", "Magnets over 7.5 cm are priced by hand. Email hello@stickiply.com with your size and quantity."],
  "stk.studio.order.bands_too_big": ["stk.studio.magnet.too_big", "Magnets go up to 7.5 cm on the longest side. Email hello@stickiply.com for anything bigger."],
  "stk.studio.msg.qty_mismatch": ["stk.studio.magnet.qty_mismatch", "Your designs add up to [shares] magnets but the pack is [pack]. Please adjust the quantities so they add up to [pack]."]
} };
/* One design per order (max_designs 1, Custom Magnets: "1 design per package"): the sentences
   that speak of several designs or files, in their one-design words. Same shape as NOUN_TEXT. */
var ONE_TEXT = {
  "stk.studio.tool.drop_title": ["stk.studio.one.drop_title", "Drag & Drop your artwork file here or click to upload!"],
  "stk.studio.order.final_lead": ["stk.studio.one.final_lead", "Check your design, its cut line, style and quantity. Then download your files or add them straight to your cart."]
};
/* the noun and the design count are read the way PL_CUSTOM reads its flag: the tool may still
   wait inside its template */
var PL_HOSTDATA = (function(){
  var h = document.querySelector('proof-lab-tool');
  if (!h) { var t = document.querySelector('template[data-pl-tpl]'); h = t && t.content ? t.content.querySelector('proof-lab-tool') : null; }
  return (h && h.dataset) || {};
})();
var PL_NOUN = String(PL_HOSTDATA.noun || "sticker").trim().toLowerCase() || "sticker";
function plWords(baseT, words){
  return function(k, f){ return words.hasOwnProperty(k) ? baseT(words[k][0], words[k][1]) : baseT(k, f); };
}
if (NOUN_TEXT.hasOwnProperty(PL_NOUN)) stkT = plWords(stkT, NOUN_TEXT[PL_NOUN]);
if (String(PL_HOSTDATA.maxDesigns || "") === "1") stkT = plWords(stkT, ONE_TEXT);
/* Per product, same key: a finish word with no preset of its own is drawn as a holo-proof.js
   look. Magnets Holographic = the Oil Spill holographic LAMINATE over the print (the product's
   own description: "gloss with a rainbow shimmer", from the holographic laminate range). */
var NOUN_LOOK = { magnet: { holo: "laminate-oil" } };
var FINISH_LOOK = NOUN_LOOK.hasOwnProperty(PL_NOUN) ? NOUN_LOOK[PL_NOUN] : {};
function lookOf(f){ return FINISH_LOOK.hasOwnProperty(f) ? FINISH_LOOK[f] : f; }
/* the name a design carries until its own file names it (it can reach the cart line) */
var DEFAULT_ART = "stickiply-" + (NOUN_WORDS.hasOwnProperty(PL_NOUN) ? PL_NOUN : "sticker");

/* PDF.js is loaded lazily the first time a PDF is dropped. */
var PDFJS_SRC = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
var PDFJS_WORKER = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
var pdfjsLoading = null;
function loadPdfJs(){
  if(window.pdfjsLib){ window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; return Promise.resolve(window.pdfjsLib); }
  if(pdfjsLoading) return pdfjsLoading;
  pdfjsLoading = new Promise(function(res,rej){
    var s=document.createElement("script");
    s.src=PDFJS_SRC;
    s.onload=function(){
      if(window.pdfjsLib){ window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; res(window.pdfjsLib); }
      else rej(new Error("pdfjsLib missing after load"));
    };
    s.onerror=function(){ rej(new Error("pdf.js failed to load")); };
    document.head.appendChild(s);
  });
  return pdfjsLoading;
}
/* 18 Oct 2026 (P215): pdf-lib, loaded only when a PDF's cut line has to be taken out of its content (a spot colour
   with a cut name, or a magenta outline the customer may switch on). 207 KB gzip, 34-38 ms; never for other files. */
var PDFLIB_SRC = "https://cdnjs.cloudflare.com/ajax/libs/pdf-lib/1.17.1/pdf-lib.min.js";
var pdfLibLoading = null;
function loadPdfLib(){
  if(window.PDFLib && window.PDFLib.PDFDocument) return Promise.resolve(window.PDFLib);
  if(pdfLibLoading) return pdfLibLoading;
  pdfLibLoading = new Promise(function(res,rej){
    var s=document.createElement("script");
    s.src=PDFLIB_SRC;
    s.onload=function(){ if(window.PDFLib && window.PDFLib.PDFDocument) res(window.PDFLib); else { pdfLibLoading=null; rej(new Error("PDFLib missing after load")); } };
    s.onerror=function(){ pdfLibLoading=null; rej(new Error("pdf-lib failed to load")); };
    document.head.appendChild(s);
  });
  return pdfLibLoading;
}

/* The tool's stylesheet is assets/proof-lab.css, linked into the shadow root.
   See the header of that file for why it is not a string any more. */
const PL_HTML = `<div class="app">
  <div class="tool">
    <div class="stagewrap">
    <div class="doctabs hidden" id="docTabs"></div>
    <div class="stage" id="stage">
      <div class="canvas-tools" id="canvasTools" style="display:none">
        <div class="ctool on" id="ctoolCut" title="${stkEsc(stkT("stk.studio.tool.toggle_cut","Toggle cut line"))}"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M20 4 8.12 15.88"/><path d="M14.47 14.48 20 20"/><path d="M8.12 8.12 12 12"/></svg></div>
        
        <div class="ctool disabled" id="ctoolUndo" title="${stkEsc(stkT("stk.studio.tool.undo_title","Undo (Ctrl/Cmd+Z)"))}"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg></div>
        <div class="ctool disabled" id="ctoolRedo" title="${stkEsc(stkT("stk.studio.tool.redo_title","Redo (Ctrl/Cmd+Shift+Z)"))}"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 14l5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13"/></svg></div>
        <div class="ctool" id="ctoolErase" title="${stkEsc(stkT("stk.studio.tool.erase_title","Clean up · erase stray pixels"))}" aria-pressed="false"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 20H20"/><path d="m15 5-9.5 9.5a2.1 2.1 0 0 0 0 3l2 2a2.1 2.1 0 0 0 3 0L20 10"/><path d="m11 9 4 4"/></svg></div>
        <div class="ctool" id="ctoolFill" title="${stkEsc(stkT("stk.studio.tool.fill_title","Fill brush · paint gaps in the border colour"))}" aria-pressed="false"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08"/><path d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z"/></svg></div>
        <div class="ctool" id="ctoolWand" title="${stkEsc(stkT("stk.studio.tool.wand_title","Magic wand · tap a colour to remove that area, tap again to bring it back"))}" aria-pressed="false"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 4V2"/><path d="M15 16v-2"/><path d="M8 9h2"/><path d="M20 9h2"/><path d="M17.8 11.8 19 13"/><path d="M15 9h.01"/><path d="M17.8 6.2 19 5"/><path d="m3 21 9-9"/><path d="M12.2 6.2 11 5"/></svg></div>
      </div>
      <div class="erase-bar" id="eraseBar">
        <span id="eraseLbl">${stkEsc(stkT("stk.studio.tool.eraser","Eraser"))}</span>
        <input type="range" id="eraseSize" min="0.5" max="8" step="0.5" value="2" aria-label="${stkEsc(stkT("stk.studio.tool.eraser_size_aria","Eraser size in mm"))}">
        <span id="eraseSizeVal">${stkDec(2,1)}mm</span>
        <button type="button" id="eraseUndo" disabled>${stkEsc(stkT("stk.studio.tool.undo","Undo"))}</button>
        <button type="button" id="eraseRedo" disabled>${stkEsc(stkT("stk.labs.sheet.redo","Redo"))}</button>
        <button type="button" id="eraseClear" disabled>${stkEsc(stkT("stk.studio.tool.eraser_reset","Reset"))}</button>
      </div>
      <div class="canvas-dims" id="canvasDims"><b>${stkEsc(stkT("stk.studio.tool.true_size","TRUE SIZE"))}</b><span id="dimText"></span></div>
      <canvas id="preview" class="hidden"></canvas>
      <div id="drop">
        <div class="drop__ic"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M17 8l-5-5-5 5"/><path d="M12 3v12"/></svg></div>
        <h2><span class="t-desk">${stkEsc(stkT("stk.studio.tool.drop_title","Drag & Drop your artwork files here or click to upload!"))}</span><span class="t-tap">${stkEsc(stkT("stk.studio.tool.drop_title_tap","Tap to upload your artwork"))}</span></h2>
        <p>${stkEsc(stkT("stk.studio.tool.drop_types","Accepted file types: PNG, JPEG, WEBP, PDF, SVG or AI"))}</p>
      </div>
      <div class="zoomctl" id="zoomctl" style="display:none">
        <button id="zoomOut" title="${stkEsc(stkT("stk.studio.tool.zoom_out","Zoom out"))}">&minus;</button>
        <button id="zoomFit" title="${stkEsc(stkT("stk.studio.tool.zoom_fit","Centre & fit"))}"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M16 3h3a2 2 0 0 1 2 2v3"/><path d="M8 21H5a2 2 0 0 1-2-2v-3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg></button>
        <button id="zoomIn" title="${stkEsc(stkT("stk.studio.tool.zoom_in","Zoom in"))}">+</button>
      </div>
      <div class="spin" id="spin">${stkEsc(stkT("stk.studio.tool.processing","PROCESSING…"))}</div>
      <div class="doctoast hidden" id="docToast"><span id="docToastMsg"></span><button id="docToastUndo">${stkEsc(stkT("stk.studio.tool.undo","Undo"))}</button></div>
      <div class="docgrid hidden" id="docGrid">
        <div class="docgrid__bar">
          <div class="docgrid__title">${stkEsc(stkT("stk.studio.tool.all_designs","All designs"))}</div>
          <button type="button" class="docgrid__close" id="docGridClose" title="${stkEsc(stkT("stk.studio.tool.close","Close"))}">&times;</button>
        </div>
        <div class="docgrid__scroll" id="docGridScroll"></div>
        <div class="docgrid__bulk hidden" id="docGridBulk">
          <span id="docGridBulkCount"></span>
          <button type="button" id="docGridApply">${stkEsc(stkFmt(stkT("stk.studio.grid.apply_n","Apply settings to [designs]"),{designs:0}))}</button>
          <button type="button" class="primary" id="docGridZip">${stkEsc(stkFmt(stkT("stk.studio.grid.download_n","Download [designs] as ZIP"),{designs:0}))}</button>
        </div>
      </div>
      <input type="file" id="file" accept="image/png,image/jpeg,image/webp,image/svg+xml,application/pdf,.pdf,.svg,.ai,application/illustrator" multiple style="display:none">
    </div>
    </div>

    <div class="panel">
      <div class="panel__body">
      
      <div class="stepstrip" id="stepStrip" hidden></div>
      <div id="viewSticker" class="steppane on">
        <div class="step" id="step1" data-step="1">
          <div class="step__head"><span class="step__ic step__ic--o"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/></svg></span><span class="step__t">${stkEsc(stkT("stk.studio.tool.step_artwork","Artwork"))}</span><span class="step__n step__n--num">1</span><button type="button" class="step__tick" data-tick aria-label="${stkEsc(stkT("stk.studio.tool.step_done_aria","Mark this step finished"))}" title="${stkEsc(stkT("stk.studio.tool.step_done_title","Finished"))}"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m4.5 12.5 5 5 10-11"/></svg></button></div>
          <div class="step__body">
          
          <div class="sameask" id="sameAsk" hidden>
            <span class="sameask__q">${stkEsc(stkT("stk.studio.tool.same_ask","Apply the same settings to this design?"))}</span>
            <div class="sameask__tiles" id="sameTiles"></div>
            <div class="sameask__acts">
              <button type="button" class="stepdone" data-same="1">${stkEsc(stkT("stk.studio.tool.same_confirm","Confirm"))}</button>
              <button type="button" class="ghost" data-same="0">${stkEsc(stkT("stk.studio.tool.same_start_over","Start over"))}</button>
            </div>
          </div>
          <div class="upslot" id="slotArt">
            <div class="upslot__ic"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M17 8l-5-5-5 5"/><path d="M12 3v12"/></svg></div>
            <div class="upslot__t"><span class="t-desk">${stkEsc(stkT("stk.studio.tool.drop_title","Drag & Drop your artwork files here or click to upload!"))}</span><span class="t-tap">${stkEsc(stkT("stk.studio.tool.drop_title_tap","Tap to upload your artwork"))}</span></div>
            <div class="upslot__s" id="slotArtSub" hidden></div>
            <div class="upslot__types">${stkEsc(stkT("stk.studio.tool.drop_types","Accepted file types: PNG, JPEG, WEBP, PDF, SVG or AI"))}</div>
          </div>
          <div class="dpiwrap"><div id="dpi"></div></div>
          <div class="row" style="margin-top:12px">
            <span class="lbl">${stkEsc(stkT("stk.studio.tool.remove_bg","Remove background"))}</span>
            <div class="toggle" id="rmBg"></div>
          </div>
          <div class="group hidden" id="gTol" style="margin-top:14px;margin-bottom:0">
            <label class="lbl-sub">${stkEsc(stkT("stk.studio.tool.remove_bg_strength","Background removal strength"))}</label>
            <input type="range" id="tol" min="0" max="100" step="1" value="45">
            <div class="range-meta"><span>${stkEsc(stkT("stk.studio.tool.gentle","Gentle"))}</span><span id="tolVal">45%</span><span>${stkEsc(stkT("stk.studio.tool.aggressive","Aggressive"))}</span></div>
            <div class="lbl-sub" style="margin-top:12px">${stkEsc(stkT("stk.studio.tool.remove_cols","Colours being removed"))}</div>
            <div id="rmColsWrap"></div>
            <div class="hint" id="dustNote" style="display:none;text-align:center"></div>
          </div>
          <div class="group" id="savedGroup" style="margin-top:16px;margin-bottom:0">
            <label class="lbl-sub">${stkEsc(stkT("stk.studio.tool.saved_designs","Saved designs"))}</label>
            <div class="row" style="justify-content:center;gap:9px">
              <button class="ghost" id="saveDesignBtn" style="margin:0;width:auto;padding:9px 16px">${stkEsc(stkT("stk.studio.tool.save_this","Save this design"))}</button>
              <button class="ghost" id="showDesignsBtn" style="margin:0;width:auto;padding:9px 16px">${stkEsc(stkT("stk.studio.tool.my_designs","My designs"))}</button>
            </div>
            <div id="savedList" class="layerlist" style="margin-top:10px;display:none"></div>
            <div class="hint" id="savedHint"></div>
          </div>
          </div>
        </div>

        <div class="step collapsed" id="step2" data-step="2">
          <div class="step__head"><span class="step__ic step__ic--p"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h9"/><circle cx="17" cy="6" r="2.5"/><path d="M20 12h-9"/><circle cx="7" cy="12" r="2.5"/><path d="M4 18h8"/><circle cx="16" cy="18" r="2.5"/></svg></span><span class="step__t">${stkEsc(stkT("stk.studio.tool.step_design","Design"))}</span><span class="step__n step__n--num">2</span><button type="button" class="step__tick" data-tick aria-label="${stkEsc(stkT("stk.studio.tool.step_done_aria","Mark this step finished"))}" title="${stkEsc(stkT("stk.studio.tool.step_done_title","Finished"))}"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m4.5 12.5 5 5 10-11"/></svg></button></div>
          <div class="step__body">
          <div class="group">
            <label class="lbl-sub">${stkEsc(stkT("stk.studio.tool.size_label","Size · longest edge of the cut"))}</label>
            <div class="seg" id="sizeSeg">
              <button data-v="2">${stkEsc(stkT("stk.studio.tool.size_2","2in · 5cm"))}</button>
              <button data-v="3" class="on">${stkEsc(stkT("stk.studio.tool.size_3","3in · 7.5cm"))}</button>
              ${PL_MG ? '' : `<button data-v="4">${stkEsc(stkT("stk.studio.tool.size_4","4in · 10cm"))}</button>`}
            </div>
            ${PL_TRUE_SIZE ? `<div class="sizewrap sizewrap--bar${PL_CUSTOM ? '' : ' is-off'}">
              <div class="stkcq stkcq--size sizebar">
                <span class="stkcq__ic" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" focusable="false"><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z"/></svg></span>
                <input type="number" id="sizeCustom" step="0.1" aria-label="${stkEsc(stkT("stk.studio.tool.custom_size_aria","Custom size, longest edge"))}"${PL_CUSTOM ? '' : ' disabled'} hidden style="display:none">
                <span class="stkcq__wh">
                  <input type="number" class="stkcq__in stkcq__in--wh" id="sizeW" step="0.1" min="0" inputmode="decimal" placeholder="${stkEsc(stkT("stk.labs.sheet.width_short","W"))}" aria-label="${stkEsc(stkT("stk.labs.bookmark.editor.width","Width"))}"${PL_CUSTOM ? '' : ' disabled'}>
                  <span class="stkcq__x" aria-hidden="true">&times;</span>
                  <input type="number" class="stkcq__in stkcq__in--wh" id="sizeH" step="0.1" min="0" inputmode="decimal" placeholder="${stkEsc(stkT("stk.labs.sheet.height_short","H"))}" aria-label="${stkEsc(stkT("stk.labs.bookmark.editor.height","Height"))}"${PL_CUSTOM ? '' : ' disabled'}>
                </span>
                <span class="stkcq__seg" id="sizeUnitSw" role="group" aria-label="${stkEsc(stkT("stk.studio.tool.units_aria","Units"))}">
                  <span class="stkcq__seg-hl" aria-hidden="true"></span>
                  <button type="button" class="stkcq__seg-b is-on" data-u="cm" aria-pressed="true">cm</button>
                  <button type="button" class="stkcq__seg-b" data-u="in" aria-pressed="false">in</button>
                </span>
                <span class="stkcq__u" id="sizeUnitLbl" aria-hidden="true"></span>
              </div>
              ${PL_CUSTOM ? '' : '<span class="sizewrap__off">'+stkEsc(stkT("stk.studio.tool.custom_size_off","Stickers only for now"))+'</span>'}
              <div class="sizeerr" id="sizeErr" role="alert" hidden></div>
            </div>` : `
            <div class="sizewrap${PL_CUSTOM ? '' : ' is-off'}">
              <span class="sizecap">${stkEsc(stkT("stk.studio.tool.custom_size","Custom size"))}</span>
              ${PL_CUSTOM ? '' : '<span class="sizewrap__off">'+stkEsc(stkT("stk.studio.tool.custom_size_off","Stickers only for now"))+'</span>'}
              <div class="sizectl">
                <input type="number" id="sizeCustom" step="0.1" placeholder="${stkEsc(stkT("stk.studio.tool.custom_size_placeholder","auto"))}" aria-label="${stkEsc(stkT("stk.studio.tool.custom_size_aria","Custom size, longest edge"))}"${PL_CUSTOM ? '' : ' disabled'}>
                <div class="seg seg--units" id="sizeUnitSeg" role="group" aria-label="${stkEsc(stkT("stk.studio.tool.units_aria","Units"))}">
                  <button type="button" data-u="cm" class="on">cm</button>
                  <button type="button" data-u="in">in</button>
                </div>
                <span class="sizeunit" id="sizeUnitLbl" aria-hidden="true"></span>
              </div>
            </div>`}
          </div>
          <div class="group hidden" id="gOwnCut">
            <div class="row">
              <span class="lbl">${stkEsc(stkT("stk.studio.cut.switch","Use the cut line from my file"))}</span>
              <div class="toggle" id="ownCutToggle"></div>
            </div>
            <div class="hint sizewrap__off" id="ownCutNote" style="display:none;text-align:center;margin-top:10px"></div>
          </div>
          <div class="group">
            <label class="lbl-sub">${stkEsc(stkT("stk.studio.tool.shape","Shape"))}</label>
            <div class="seg" id="shapeSeg">
              <button data-v="custom" class="on"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z"/></svg>${stkEsc(stkT("stk.studio.tool.shape_diecut","Die-cut"))}</button>
              <button data-v="circle"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="8.5"/></svg>${stkEsc(stkT("stk.studio.tool.shape_circle","Circle"))}</button>
              <button data-v="square"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="3"/></svg>${stkEsc(stkT("stk.studio.tool.shape_square","Square"))}</button>
              <button data-v="rect"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="3" y="6" width="18" height="12" rx="3"/></svg>${stkEsc(stkT("stk.studio.tool.shape_rect","Corners"))}</button>
            </div>
            <div class="sizewrap__off" data-cutlock style="display:none;margin-top:10px;text-align:center">${stkEsc(stkT("stk.studio.cut.locked","Set by the cut line in your file"))}</div>
          </div>
          <div class="group" id="gBorder">
            <div class="sizewrap__off" data-cutlock style="display:none;margin-bottom:12px;text-align:center">${stkEsc(stkT("stk.studio.cut.locked","Set by the cut line in your file"))}</div>
            <div class="row">
              <span class="lbl">${stkEsc(stkT("stk.studio.tool.add_border","Add border"))}</span>
              <div class="toggle on" id="borderToggle"></div>
            </div>
            <div id="gBorderW" style="margin-top:14px">
              <label class="lbl-sub">${stkEsc(stkT("stk.studio.tool.border_width","Border width"))}</label>
              <div class="seg" id="borderWSeg"><button type="button" data-bw="2" class="on"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" aria-hidden="true"><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z" stroke-width="1.2"/><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z" transform="translate(12 12) scale(.86) translate(-12 -12)" stroke-width="1.2" opacity=".55"/></svg>2mm</button><button type="button" data-bw="3"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" aria-hidden="true"><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z" stroke-width="2"/><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z" transform="translate(12 12) scale(.78) translate(-12 -12)" stroke-width="1.2" opacity=".55"/></svg>3mm</button><button type="button" data-bw="4"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" aria-hidden="true"><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z" stroke-width="2.8"/><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z" transform="translate(12 12) scale(.7) translate(-12 -12)" stroke-width="1.2" opacity=".55"/></svg>4mm</button><button type="button" data-bw="5"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" aria-hidden="true"><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z" stroke-width="3.6"/><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z" transform="translate(12 12) scale(.62) translate(-12 -12)" stroke-width="1.2" opacity=".55"/></svg>5mm</button></div>
              <input type="range" id="borderW" min="2" max="5" step="0.5" value="2">
              <div class="range-meta"><span>2mm</span><span id="borderVal">${stkDec(2,1)}mm</span><span>5mm</span></div>
            </div>
          </div>
          <div class="group" id="gSnap" style="margin-top:16px;display:none">
            <label class="lbl-sub">${stkEsc(stkT("stk.studio.tool.corners","Corners"))}<button type="button" class="idot" id="cornerInfo" aria-label="${stkEsc(stkT("stk.studio.tool.corners_info_aria","About corners"))}" aria-expanded="false">i</button></label>
            <div class="seg" id="cornerSnapSeg">
              <button data-v="sq"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="4" y="5" width="16" height="14" rx="0"/></svg>90&deg;</button>
              <button data-v="r4" class="on"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="4" y="5" width="16" height="14" rx="2"/></svg>4mm</button>
              <button data-v="r65"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="4" y="5" width="16" height="14" rx="3.5"/></svg>6.5mm</button>
              <button data-v="r8"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="4" y="5" width="16" height="14" rx="5"/></svg>8mm</button>
            </div>
            <div class="ipop" id="cornerInfoPop">${stkEsc(stkT("stk.studio.tool.corners_info","Your artwork is a rectangle, so the cut uses straight edges and true corners. 90° is for labels. Stickers keep a radius so the corners do not lift."))}</div>
            <div class="hint" id="snapNote" style="display:none"></div>
          </div>
          <div class="group" id="gSmooth">
            <label class="lbl-sub">${stkEsc(stkT("stk.studio.tool.cut_smoothing","Cut smoothing"))}</label>
            <input type="range" id="smooth" min="0" max="5" step="0.5" value="1">
            <div class="range-meta"><span>0mm</span><span id="smoothVal">${stkDec(1,1)}mm</span><span>5mm</span></div>
          </div>
          <div class="group hidden" id="gFit">
            <label class="lbl-sub">${stkEsc(stkT("stk.studio.tool.fit","Artwork fit"))}<button type="button" class="idot" id="fitInfo" aria-label="${stkEsc(stkT("stk.studio.tool.fit_info_aria","About positioning"))}" aria-expanded="false">i</button></label>
            <div class="seg" id="fitSeg">
              <button data-v="fill">${stkEsc(stkT("stk.studio.tool.fit_fill","Fill"))}</button>
              <button data-v="centre" class="on">${stkEsc(stkT("stk.studio.tool.fit_centre","Centre"))}</button>
              <button data-v="edge">${stkEsc(stkT("stk.studio.tool.fit_edge","Edge"))}</button>
            </div>
            <div id="gArtPct" style="margin-top:14px">
              <input type="range" id="artPct" min="50" max="150" step="5" value="100" aria-label="${stkEsc(stkT("stk.studio.tool.art_pct_aria","Artwork size inside the shape"))}">
              <div class="range-meta"><span>50%</span><span id="artPctVal">100%</span><span>150%</span></div>
            </div>
            <div class="ipop" id="fitInfoPop">${stkEsc(stkT("stk.studio.tool.fit_info","Drag the artwork to reposition. Double-click to recentre."))}</div>
          </div>
          <div class="group hidden" id="gCorner">
            <label class="lbl-sub">${stkEsc(stkT("stk.studio.tool.rounded","Rounded corners"))}</label>
            <div class="seg" id="cornerSeg">
              <button data-v="none">${stkEsc(stkT("stk.studio.tool.round_none","Minimal"))}</button>
              <button data-v="soft" class="on">${stkEsc(stkT("stk.studio.tool.round_soft","Soft"))}</button>
              <button data-v="medium">${stkEsc(stkT("stk.studio.tool.round_medium","Medium"))}</button>
              <button data-v="heavy">${stkEsc(stkT("stk.studio.tool.round_heavy","Heavy"))}</button>
            </div>
          </div>
          <div class="group" id="gBgBlock">
            <label class="lbl-sub">${stkEsc(stkT("stk.studio.tool.bg_label","Border & background colour"))}<button type="button" class="idot" id="bgInfo" aria-label="${stkEsc(stkT("stk.studio.tool.bg_info_aria","About auto bleed"))}" aria-expanded="false">i</button></label>
          <div class="group" style="margin-bottom:0">
            <div class="seg" id="bgModeSeg">
              <button data-v="solid"><span class="modesw" data-modesw="solid"></span>${stkEsc(stkT("stk.studio.tool.bg_solid","Solid"))}</button>
              <button data-v="gradient"><span class="modesw" data-modesw="gradient"></span>${stkEsc(stkT("stk.studio.tool.bg_gradient","Gradient"))}</button>
              <button data-v="auto" class="on" title="${stkEsc(stkT("stk.studio.tool.bg_auto_title","The border grows from the artwork's own edge colours"))}"><span class="modesw" data-modesw="auto"></span>${stkEsc(stkT("stk.studio.tool.bg_auto","Auto"))}</button>
            </div>
            <div class="ipop" id="bgAutoHint">${stkEsc(stkT("stk.studio.tool.bg_auto_hint","Auto Bleed creates bleed around your artwork based on its outer most pixels."))}</div>
            <div id="bgSolidWrap" style="margin-top:12px"><div id="bgHost"></div></div>
            <div id="bgGradWrap" style="margin-top:12px;display:none">
              <div class="lbl-sub">${stkEsc(stkT("stk.studio.tool.bg_from","From"))}</div><div id="bgFromHost"></div>
              <div class="lbl-sub" style="margin-top:10px">${stkEsc(stkT("stk.studio.tool.bg_to","To"))}</div><div id="bgToHost"></div>
              <div class="lbl-sub" style="margin-top:10px">${stkEsc(stkT("stk.studio.tool.bg_angle","Angle"))}</div>
              <div class="row" style="justify-content:center;gap:14px">
                <div class="dial" id="gradDial"><div class="dial__dot" id="gradDialDot"></div></div>
                <span class="lbl" id="gradAngleVal">135&deg;</span>
              </div>
            </div>
          </div>
          </div>
          <div class="group" id="gPreviewBlock" style="margin-bottom:0">
          <div class="row" style="margin-bottom:0">
            <span class="lbl">${stkEsc(stkT("stk.studio.tool.show_cut","Show cut line"))}</span>
            <div class="toggle on" id="cutToggle"></div>
          </div>
          </div>
          </div>
        </div>

        <div class="step collapsed" id="step3" data-step="3" hidden>
          <div class="step__head"><span class="step__ic step__ic--y"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></span><span class="step__t">${stkEsc(stkT("stk.studio.tool.step_order","Order"))}</span><span class="step__n step__n--num">3</span></div>
          <div class="step__body">
            <div id="cartMount"></div>
            
          </div>
        </div>
      </div>
      
      <div id="cartFoot"></div>
      </div>
    </div>
  </div>

  <div class="dlcard">
    <div class="dl-group dl-group--order">
      <div class="dl-group__head"><span class="dl-badge dl-badge--go">${stkEsc(stkT("stk.studio.tool.dl_badge_order","FOR YOUR ORDER"))}</span><span class="dl-group__t">${stkEsc(stkT("stk.studio.tool.dl_order_title","This is the file to upload when you order"))}</span></div>
      <button class="dl dl--zip" id="dlZip" disabled><span class="dl__ic"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4l2 2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2Z"/><path d="M14 10v1"/><path d="M14 13v1"/><path d="M14 16v1"/></svg></span><span class="dl__tx">${stkEsc(stkT("stk.studio.tool.dl_zip","Download order files (ZIP)"))}<small>${stkEsc(stkT("stk.studio.tool.dl_zip_note","Print PNG + cut SVG at your exact size · upload this one file with your order"))}</small></span></button>
      <div class="dlrow dlrow--sub" style="margin-bottom:0">
        <button class="dl dl--svg" id="dlCut" disabled><span class="dl__ic"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M20 4 8.12 15.88"/><path d="M14.47 14.48 20 20"/><path d="M8.12 8.12 12 12"/></svg></span><span class="dl__tx">${stkEsc(stkT("stk.studio.tool.dl_cut","Sticker cut file SVG"))}<small>${stkEsc(stkT("stk.studio.tool.dl_cut_note","Already in the ZIP · vector cut path + 1.5mm bleed"))}</small></span></button>
        <button class="dl dl--png" id="dlPrint" disabled><span class="dl__ic"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/></svg></span><span class="dl__tx">${stkEsc(stkT("stk.studio.tool.dl_print","Sticker print PNG · 300 DPI"))}<small>${stkEsc(stkT("stk.studio.tool.dl_print_note","Already in the ZIP · finished sticker, transparent"))}</small></span></button>
      </div>
    </div>
    <div class="dl-group dl-group--preview">
      <div class="dl-group__head"><span class="dl-badge dl-badge--stop">${stkEsc(stkT("stk.studio.tool.dl_badge_preview","PREVIEW ONLY"))}</span><span class="dl-group__t">${stkEsc(stkT("stk.studio.tool.dl_preview_title","Just for checking your design - please don't upload this with your order"))}</span></div>
      <button class="dl dl--proof" id="dlProof" disabled><span class="dl__ic"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg></span><span class="dl__tx">${stkEsc(stkT("stk.studio.tool.dl_proof","Proof PNG"))}<small>${stkEsc(stkT("stk.studio.tool.dl_proof_note","Your sticker with its cut line · not a print file"))}</small></span></button>
    </div>
    <div class="dlcard__foot">
      <button class="ghost" id="resetBtn">${stkEsc(stkT("stk.studio.tool.clear_all","Clear all"))}</button>
    </div>
    <div id="note"></div>
  </div>
</div>
`;

function plInit(root){
const CUST_ID=(root.host && root.host.dataset.custId) || "guest";
const CUST_NAME=(root.host && root.host.dataset.custName) || "";
const openWheels=new Set();   // host ids whose wheel stays open across re-renders

/* ================= authored: state ================= */
const SIZE_MM = PL_MG ? {2:50.8, 3:75} : {2:50.8, 3:76.2, 4:101.6};   /* magnets: 3 in is 7.5 cm, the A4 ceiling (30 Oct) */
/* A typed size overrides the preset chips. 285mm is the practical ceiling:
   sheets are A3 (297mm short edge) and a die-cut sticker has to fit inside the
   marks and bleed. 10mm is the floor - below that the cut is not reliable. */
const SIZE_MIN_MM = PL_MG ? 20 : 10, SIZE_MAX_MM = PL_MG ? 75 : 285;
/* Display unit only - the stored value is always mm, so switching units never
   changes the sticker, just how the same number is written. */
/* ONE UNITS SWITCH (builder audit row 15, 31 Oct 2026; Thomas, 22 Oct: "one overall toggle cm/inch top right next to the
   sun icon rather than on every bloody control", "and automatically selected per region visited from"). The switch is the
   bar's (sections/proof-lab-order.liquid, beside the sun); this tool follows it. Same contract as the Editor's units.js and
   the Gang Studio: a saved click (localStorage 'stk-lab-units') wins; with none, the storefront country decides, inches for
   US, LR and MM, cm everywhere else; every change is the document event 'stk:lab-units' {unit, from}. Controls show the
   active unit only (the size chips show one half of their existing "2in · 5cm" string). Display only: lengths stay mm. */
function plUnitStart(){
  try{ const v=localStorage.getItem("stk-lab-units"); if(v==="cm"||v==="in") return v; }catch(e){}
  let c=null; try{ c=window.Shopify&&window.Shopify.country; }catch(e){}
  c=(typeof c==="string"&&/^[A-Za-z]{2}$/.test(c))?c.toUpperCase():null;
  return (c&&["US","LR","MM"].indexOf(c)>=0)?"in":"cm";
}
let sizeUnit = plUnitStart();
function plUnitLbl(){ return sizeUnit==="in" ? stkT("stk.labs.sheet.unit_in","in") : stkT("stk.labs.sheet.unit_cm","cm"); }
function plLenTxt(mm){ return sizeUnit==="in" ? stkDec(mm/25.4,2) : stkDec(mm/10,1); }
const PL_CHIP_KEYS={2:["stk.studio.tool.size_2","2in · 5cm"],3:["stk.studio.tool.size_3","3in · 7.5cm"],4:["stk.studio.tool.size_4","4in · 10cm"]};
function plChipTxt(v){ const k=PL_CHIP_KEYS[v]; if(!k) return ""; const t=String(stkT(k[0],k[1])); const p=t.split(" · "); return p.length===2 ? (sizeUnit==="in"?p[0]:p[1]).trim() : t; }
function paintSizeChips(){ try{ [...$("sizeSeg").querySelectorAll("button[data-v]")].forEach(b=>{ const s=plChipTxt(b.dataset.v); if(s) b.textContent=s; }); }catch(e){} }
const UNIT_PER_MM = { cm: 0.1, in: 1/25.4 };
const fromMm = mm => mm*UNIT_PER_MM[sizeUnit];
const toMm   = v  => v/UNIT_PER_MM[sizeUnit];
const BORDER_MIN_MM = 2, BORDER_MAX_MM = 5;
const CORNER_F  = {none:0, soft:.06, medium:.12, heavy:.22};
const MIN_CORNER_MM = 1.5;
const WORK = (window.matchMedia&&matchMedia("(max-width:760px)").matches)?1500:2000;
const PRINT_DPI = 300;         // floor: never export below this
/* Ceiling and area cap for exports. The working canvas already holds far more
   detail than 300dpi - a PDF rasterises at 2000px, which is ~640dpi on a 79mm
   sticker - and the old fixed 300 threw that away, resampling crisp line art
   down until it printed blocky. Export at whatever the artwork actually carries.
   Thomas, 26 Aug 2026. */
const EXPORT_DPI_MAX = 900, EXPORT_PX_MAX = 120e6;
function exportDpi(sceneW, sceneH, mmpp){
  const src = mmpp>0 ? 25.4/mmpp : PRINT_DPI;
  let dpi = Math.max(PRINT_DPI, Math.min(EXPORT_DPI_MAX, src));
  const px = (sceneW*mmpp/25.4*dpi) * (sceneH*mmpp/25.4*dpi);
  if(px > EXPORT_PX_MAX) dpi *= Math.sqrt(EXPORT_PX_MAX/px);
  return dpi;
}
const BLEED_MM = 1.5;            // background colour extends this far past the cut
const CUT_COLOUR = "#FF00FF";    // 100% magenta, 0% C/Y/K
const CUT_PT = 1;                // cut line weight in points
const PT_TO_MM = 25.4/72;        // 1pt = 0.352778mm
const CUT_STROKE_MM = (CUT_PT*PT_TO_MM).toFixed(4);  // "0.3528"
const VEC_TARGET = 2000;   // longest edge when rasterising PDF/SVG vector input
const RAINBOW = ["#ff5d5d","#ffb648","#ffe34d","#5ddb7e","#4dc6ff","#7a6bff","#e05dff","#ff5d5d"];

const opts = {
  shape:"custom", borderMm:2, fit:"centre", corner:"soft",
  /* v4.3 (Thomas: "a slider for the circle and square for the size of the artwork inside"): percent of
     the chosen fit, 100 = the fit exactly as before */
  artPct:100,
  cut:true, sizeIn:3, sizeCustomMm:null, smoothMm:1, border:true, offX:0, offY:0,
  /* Auto is the default bleed: it grows the border and bleed from the artwork's own
     edge colours, so a sticker exported without anyone touching this control still has
     something real under the cut line instead of the old default white. Customers can
     still switch to Solid or Gradient. AI/_rules/LAB-RULES.md rule 2. */
  bgMode:"auto", bg:"#ffffff", bgFrom:"#ffc63c", bgTo:"#f15a24", bgAngle:135,
  removeBg:false, removeTol:45, removeCols:[], removeInner:false,
  cornerMode:"r4", cornerAuto:true, labelApplied:false, labelAuto:false,
  /* the automatic bleed colour (28 Sep 2026): bgEdge = this artwork's own edge colour (null = none found),
     bgAutoArmed = set by a fresh upload only, bgPicked = the customer chose a solid colour, bgAutoPick = the
     current bg came from bgEdge. Kept here so every copy of opts carries or clears all four together. */
  bgEdge:null, bgAutoArmed:false, bgPicked:false, bgAutoPick:false,
  /* 18 Oct 2026 (P215): "own" = the design is cut on the cut line from the customer's file (custCut below).
     A flag here, so undo covers the switch; the path itself is never in opts (sceneKey stringifies opts). */
  cutMode:""
};
/* The factory settings, kept so "No, start fresh" on a second design has
   something to go back to (v1.7). Plain data, so a JSON round trip is a
   complete copy. */
const OPTS_DEFAULT = JSON.parse(JSON.stringify(opts));
let srcImg=null, art=null, trimRatio=1, mask0=null;
/* 18 Oct 2026 (P215): the active design's cut line from its own file, null for every other file. Per design
   (docs[].custCut, saved as its own record field). {kind:"named"|"candidate", segs: the outer path as absolute
   M/L/C/Z in srcImg px, bb: its exact box, mmPerPx (null = unitless file), fileMm, inner, refused, label, colour,
   xf: srcImg px -> art px (set by processSource), imgFull/imgStrip: a candidate's two renders}. */
let custCut=null;
/* v3.6: shape / colour mode picked while there is no artwork yet (segGroup sets, processSource keeps) */
const preArt={ shape:false, bgMode:false, bg:false };
let srcIsVector=false;
let artName=DEFAULT_ART;
let artCx=0, artCy=0, artMaxRad=1;
let dilCache={}, dilPad=0, palette=[], paletteLight=[];
let baseScene=null, cutStroke=null, animRaf=0;
/* the bleed, drawn at 50% round the sticker on the design field only (both tools; Thomas, 28 Sep: "make it show
   the bleed but at like 50% transparency on the design field so customers can see they're actually doing something").
   Never part of baseScene, so the proof, mock-up, print and cut files are unchanged. */
let bleedGhost=null, bleedGhostOff=[0,0], wantGhost=false;   /* wantGhost: set by render() only */
let darkMode=false;
let zoom=1, panX=0, panY=0;
let pickingRm=false;
/* Clean-up eraser. Strokes live in work-canvas space as groups (one group per
   drag), so a group can be undone and the rest replayed. They are re-applied
   inside processSource BEFORE the trim, which is what makes them survive a
   change of background-removal colour or tolerance. */
let erasing=false, eraseStrokes=[], trimOff={x:0,y:0}, curErase=null;
const BASICS = ["#ffffff","#1a1a20"];
/* ================= authored: multi-artwork docs =================
   One Doc per uploaded artwork. The globals above are always the ACTIVE
   doc's state; docs[] holds every other doc's saved copy. Switching tabs
   captures the outgoing doc, then copies the incoming one back into the
   globals - it never re-runs processSource(). */
/* WHAT SURVIVES WHAT (v2.9.3, Thomas 17 Sep). Three paths disagreed; this is the rule,
   and every path below obeys it.
     CLOSE with back / x / Escape, nothing ordered: the pack survives as it was.
     REMOVE a design: gone - from docs[], from its autosave record, and from the undo
       stash when the 8s toast ends or the pack is dropped. Only UNDO brings it back.
     ADD TO CART succeeds: the pack is the cart line's now. resetPack() empties it, the
       lab closes, the card stands over the product page, the next open starts on
       ARTWORK. ADD MORE DESIGNS is the one exception: it reopens with a fresh pack. */
let docs=[], activeIdx=-1, docSeq=0, closedDoc=null, closedTimer=0;
/* 20-step undo, per doc - same swap pattern as the rest of Doc state: the
   active doc's stacks live in these globals, captureDoc()/loadDocGlobals()
   move them in and out of docs[] like everything else. */
let undoStack=[], redoStack=[];

const $ = id => root.getElementById(id);
const mk = (w,h) => { const c=document.createElement("canvas"); c.width=Math.max(1,Math.round(w)); c.height=Math.max(1,Math.round(h)); return c; };
const widthMm = () => opts.sizeCustomMm || SIZE_MM[opts.sizeIn];
/* px per mm at FINISHED-CUT scale. The size chip measures the cut's longest
   edge, and dilation adds the border on every side, so the artwork's longest
   edge corresponds to (chip - 2 x border) mm. The old art.width/widthMm made
   borders on tall artwork physically thinner than the number on the slider. */
const artLongest = () => Math.max(art.width,art.height);
const pxPerMm = () => {
  /* 18 Oct 2026 (P215): in own-cut mode the size chip IS the customer's path's longest edge, no border formula */
  if(ownCut()) return cutLongestPx()/widthMm();
  const eff = opts.border ? Math.max(widthMm()-2*opts.borderMm, widthMm()*0.5) : widthMm()+2*softInsetMm();   /* SOFT EDGE: the cut is 2 x 1 mm inside the art */
  return artLongest()/eff;
};
/* 18 Oct 2026 (P215): the design is cut on the line from its own file. Shape and border do not apply then
   (opts.shape is held at die-cut, borderPx is 0, the controls are greyed and labelled). */
function ownCut(){ return opts.cutMode==="own" && !!custCut && !custCut.refused && !!custCut.bb && !!custCut.xf; }
function cutLongestPx(){ const b=custCut.bb, f=custCut.xf; return Math.max(b.w*f.sx, b.h*f.sy); }   /* exact, in art px */
/* EVERY FILE IMPORTS AS DIE-CUT (22 Sep 2026). Reading the image to decide it
   was a rectangle fired the corner picker and the label treatment on finished
   rounded stickers that already had their own border. Nothing is read on
   import now: die-cut traces the artwork, and the rectangle logic (fitted
   rectangle, Corners picker, the 90 degree label check) runs only when the
   customer picks the Corners shape. That shape is a traced cut too - it
   replaced the old fixed 3:2 box - so both share the die-cut pipeline. */
const traced = () => opts.shape==="custom" || opts.shape==="rect" || ownCut();   /* P215: own-cut is a die-cut */
const borderPx = () => (opts.border && !ownCut()) ? Math.max(2,Math.round(opts.borderMm*pxPerMm())) : 0;   /* P215: their line is the cut, no border round it */
function outName(suffix){ return artName+"-"+suffix; }

/* ================= authored: multi-artwork docs =================
   Doc = one artwork's saved copy of the state singletons above. docs[]
   holds every INACTIVE doc; the active one lives only in the globals until
   captureDoc() snapshots it back in, which happens right before switching
   away. Nothing here re-runs processSource() - that only happens once,
   when a file is first uploaded. */
function cloneOpts(o){ return Object.assign({}, o, {removeCols:(o.removeCols||[]).slice()}); }
/* ===== ONE SELECTION FOR THE PACK (v2.5, Thomas 12 Sep 17:35) ============
   "we need to make sure quantity and finish is locked per screen too. Like you
   cant select matte and then gloss for design 2... its one finish and quantity
   per add to cart."
   Finish and quantity were already ONE object (`sel`); SIZE rode inside each doc's opts, so
   switching slots changed the pack's size. It is held here, captured on every snapshot and
   re-applied over whatever a restored doc carried. Border and cut stay per design. */
let packSize=null;
function capturePackSize(){ packSize={ sizeIn:opts.sizeIn, sizeCustomMm:opts.sizeCustomMm }; }
function applyPackSize(){ if(packSize){ opts.sizeIn=packSize.sizeIn; opts.sizeCustomMm=packSize.sizeCustomMm; } }
/* the dilation cache entries of the design on screen at its current border (and border plus
   bleed), the two every scene and size readout uses */
function keepDilations(){
  const out={};
  try{
    const sPx=Math.round(opts.smoothMm*pxPerMm()), R=borderPx(), bl=Math.round(BLEED_MM*pxPerMm());
    (ownCut() ? ["own:0", "own:"+bl] : [dilKey(R,sPx), dilKey(R+bl,sPx)]).forEach(k=>{ if(dilCache[k]) out[k]=dilCache[k]; });   /* P215: own-cut keys */
  }catch(e){}
  return out;
}
function captureDoc(){
  capturePackSize();                         // before the guard: the pack's size exists with or without a doc
  if(activeIdx<0 || !docs[activeIdx]) return;
  const d=docs[activeIdx];
  d.artName=artName; d.srcImg=srcImg; d.art=art; d.trimRatio=trimRatio; d.mask0=mask0;
  d.svgSrc=svgSrc; d.svgInfo=svgInfo;
  d.srcIsVector=srcIsVector; d.artCx=artCx; d.artCy=artCy; d.artMaxRad=artMaxRad;
  /* 2 Oct 2026 (Studio slowness, perf.md fix A): each design keeps its own dilations, so a switch
     back does not rebuild them. Only the entries for its current border and border plus bleed are
     kept (about 19 MB each at 2200 px square), the rest go. They belong to THIS design's mask0. */
  d.dilCache=keepDilations(); d.dilPad=dilPad;
  d.palette=palette; d.paletteLight=paletteLight; d.baseScene=baseScene;
  /* innerRing was missing here: switching tabs left the PREVIOUS artwork's
     inner-bleed ring in place, so the wrong ring got composited on export. */
  d.innerRing=innerRing; d.eraseStrokes=eraseStrokes; d.trimOff=trimOff;
  /* v3.11 (6 Oct 2026, Thomas: "the cut line holds somewhat when i switch"): the cut path is per design. withDoc()
     (thumbnails, order scenes) rebuilds another design's scene, which overwrote the module cutStroke; loadDocGlobals
     put baseScene back but not the path, so the marching ants kept drawing the edited design's outline on this one. */
  d.cutStroke=cutStroke;
  d.custCut=custCut;   /* 18 Oct 2026 (P215): the cut line from its file is this design's own */
  d.opts=cloneOpts(opts);
  /* its grid thumbnail goes only when the design has changed since it was drawn (perf.md fix A) */
  { const k=art?sceneKey(opts,art,eraseStrokes,trimOff):""; if(!k || d.thumbKey!==k){ d.thumb=null; d.thumbKey=k; } }
  d.undoStack=undoStack; d.redoStack=redoStack;
}
/* a design's own copy of the four auto-bleed keys wins; one that has none (older design, older undo entry) gets
   them cleared, never the previous design's (review 28 Sep: stale bgEdge carried between designs) */
const AUTO_BLEED_KEYS=["bgEdge","bgAutoArmed","bgPicked","bgAutoPick"];
function clearAutoBleed(){ opts.bgEdge=null; opts.bgAutoArmed=false; opts.bgAutoPick=false; }
function loadDocGlobals(d){
  artName=d.artName; srcImg=d.srcImg; art=d.art; trimRatio=d.trimRatio; mask0=d.mask0;
  svgSrc=d.svgSrc||null; svgInfo=d.svgInfo||null;
  srcIsVector=d.srcIsVector; artCx=d.artCx; artCy=d.artCy; artMaxRad=d.artMaxRad;
  dilCache=d.dilCache||{}; dilPad=d.dilPad||0;   // 2 Oct: its own dilations come back with it (perf.md fix A)
  /* Export state belongs to ONE document. lastBleedMask/lastBleedBB/exportBB are
     module-level and used to survive a switch, so a batch export could re-apply
     the PREVIOUS artwork's hardened silhouette to the next one - destination-in
     with the wrong shape, which slices real artwork away and leaves the other
     design's outline behind. Found 26 Aug 2026 in four live customer cut files
     (order 1876201): each carried the outline of the file before it.
     AI/_rules/LAB-RULES.md rules 2 and 3. */
  lastBleedMask=null; lastBleedBB=null; exportBB=null; docStamp++;
  palette=d.palette; paletteLight=d.paletteLight; baseScene=d.baseScene; cutStroke=d.cutStroke||null;   /* v3.11 */
  custCut=d.custCut||null;   /* P215 */
  innerRing=d.innerRing||null; eraseStrokes=d.eraseStrokes||[]; trimOff=d.trimOff||{x:0,y:0}; plHist=[]; plRedo=[];
  setEraseMode(false); syncEraseBar();
  clearAutoBleed(); opts.bgPicked=false;
  Object.assign(opts, cloneOpts(d.opts));
  /* 2 Oct 2026 (Thomas: "i have 4 sizes of sticker, only 1 shows"): each design keeps its OWN size.
     v2.5 re-applied one pack size here on every switch, which turned every design into the last
     size set. The pack's size (packSize) is now only the size a NEW design starts at. */
  undoStack=d.undoStack||[]; redoStack=d.redoStack||[];
}
function activateDoc(i){
  if(i<0 || i>=docs.length) return;
  if(i===activeIdx){ renderDocTabs(); return; }
  captureDoc();
  activeIdx=i;
  loadDocGlobals(docs[i]);
  pickingRm=false; $("preview").style.cursor="";
  if(animRaf){ cancelAnimationFrame(animRaf); animRaf=0; }
  syncControlsFromOpts();
  $("drop").classList.add("hidden");
  $("preview").classList.remove("hidden");
  $("canvasTools").style.display="flex";
  $("zoomctl").style.display="flex";
  setZoom(1);
  ["dlProof","dlPrint","dlCut","dlZip"].forEach(id=>$(id).disabled=false);
  render();
  coverageHint();
  updateDpi();
  updateDims();
  renderDocTabs();
}
/* The button has to state its own scope. "Download order files" next to five
   tabs is ambiguous until it has already produced the wrong thing. */
function syncZipLabel(){
  const b=$("dlZip"); if(!b) return;
  const tx=b.querySelector(".dl__tx"); if(!tx) return;
  const n=docs.length;
  /* P170: the downloads page is for people's own printing, not an order */
  if(root.host && root.host.dataset.cart!=="1"){
    tx.innerHTML = (n>1
      ? stkEsc(stkFmt(stkT("stk.studio.dl.zip_all","Download all [designs] designs (ZIP)"),{designs:n}))
      : stkEsc(stkT("stk.studio.dl.zip","Download all files (ZIP)")))
      +"<small>"+stkEsc(stkT("stk.studio.dl.zip_note","Print PNG, cut SVG and mock up at your exact size"))+"</small>";
    return;
  }
  tx.innerHTML = n>1
    ? stkEsc(stkFmt(stkT("stk.studio.tool.dl_zip_all","Download order files for all [designs] designs (ZIP)"),{designs:n}))+"<small>"+stkEsc(stkT("stk.studio.tool.dl_zip_all_note","One folder per design · print PNG + cut SVG at each exact size"))+"</small>"
    : stkEsc(stkT("stk.studio.tool.dl_zip","Download order files (ZIP)"))+"<small>"+stkEsc(stkT("stk.studio.tool.dl_zip_note","Print PNG + cut SVG at your exact size · upload this one file with your order"))+"</small>";
}
/* FOUR SLOTS, SHOWN FROM THE START (v2.2, Thomas 12 Sep 20:30). The old strip
   only drew a tab once a file existed, so nothing on screen said four designs
   fit in one order. Now the four slots are always there: an uploaded one shows
   its own proof as a thumbnail, an empty one is a drop target drawn like the
   upload field, and the grid button that used to live at the end is gone -
   this IS the grid. */
/* v2.6: the count is the section's setting (data-max-designs, 1 to 4). Custom
   Magnets runs this same file at 1: no strip, no grid, one design. */
/* P170 (27 Sep 2026): data-max-designs="0" = no cap. Thomas: "we keep the file tabs and grid view as
   the 4 upload restriction is only for ordering". The downloads page draws the old lab's file tabs
   (one per design, +, grid view) instead of the four order slots; MAX_SLOTS is Infinity there, so
   every "one design" guard (MAX_SLOTS<2) and "several designs" guard (MAX_SLOTS>1) reads as before. */
const MAX_SLOTS=(function(){ const raw=(root.host&&root.host.dataset.maxDesigns)||"4"; const v=parseInt(raw,10); if(v===0) return Infinity; return (v>=1&&v<=4)?v:4; })();
const PL_TABS=!isFinite(MAX_SLOTS);
/* P170: the standalone page (no cart) is a tool for people's own printing; its files and README say so */
const PL_DOWNLOADS=!!(root.host && root.host.dataset.cart!=="1");
function renderDocTabs(){
  syncZipLabel();
  try{ root.host.dataset.plArt=docs.length?"1":"0"; }catch(e){}   /* v2.9.1: phones pin the canvas once a design exists */
  const host=$("docTabs"); if(!host) return;
  if(PL_TABS){
    host.classList.add("doctabs--tabs");
    if(docs.length<1){ host.classList.add("hidden"); host.innerHTML=""; if(window.__plDocsChanged) try{ window.__plDocsChanged(); }catch(e){} return; }
    host.classList.remove("hidden"); host.innerHTML="";
    try{ syncSaveState(); }catch(e){}
    docs.forEach((d,i)=>{
      const t=document.createElement("div");
      t.className="doctab"+(i===activeIdx?" on":"");
      const nm=document.createElement("span"); nm.className="doctab__name"; nm.textContent=d.artName; nm.title=d.artName;
      const x=document.createElement("span"); x.className="doctab__x"; x.textContent="×"; x.title=stkT("stk.studio.design.remove_aria","Remove this design");
      t.appendChild(nm); t.appendChild(x);
      t.addEventListener("click",e=>{ if(e.target===x) return; activateDoc(i); try{ if(root.host&&root.host.dataset&&root.host.dataset.plStep==="3") openStep(2); }catch(err){} });
      x.addEventListener("click",e=>{ e.stopPropagation(); closeDoc(i); });
      host.appendChild(t);
    });
    const add=document.createElement("button");
    add.type="button"; add.className="doctab__add"; add.title=stkT("stk.studio.tool.add_design","Add a design"); add.setAttribute("aria-label",stkT("stk.studio.tool.add_design","Add a design"));
    add.innerHTML='<span class="doctab__addicon" aria-hidden="true">+</span>';
    add.addEventListener("click",()=>{ if(docs.length && window.__plBeginAnother) window.__plBeginAnother(); $("file").click(); });
    host.appendChild(add);
    const grid=document.createElement("button");
    grid.type="button"; grid.className="doctab__grid"; grid.title=stkT("stk.studio.tool.all_designs","All designs"); grid.setAttribute("aria-label",stkT("stk.studio.tool.all_designs","All designs"));
    grid.innerHTML='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';
    grid.disabled=docs.length<2;
    grid.addEventListener("click",openDocGrid);
    host.appendChild(grid);
    if(window.__plDocsChanged) try{ window.__plDocsChanged(); }catch(e){}
    return;
  }
  if(MAX_SLOTS<2){
    /* one design per order: the strip is not drawn, but the ORDER panel is
       still told, because it counts designs through this call */
    host.classList.add("hidden"); host.innerHTML="";
    if(window.__plDocsChanged) try{ window.__plDocsChanged(); }catch(e){}
    return;
  }
  host.classList.remove("hidden");
  host.innerHTML="";
  try{ syncSaveState(); }catch(e){}
  /* THE FIRST BLOCK WAS BLANK (Thomas, 12 Sep 21:55): the ACTIVE design's artwork lives
     in the globals until captureDoc runs, so the `d.art` guard was false for the design on
     screen, and withDoc's captureDoc nulls the active thumb. Inactive docs first, the live
     one last and straight from the globals. */
  docs.forEach((d,i)=>{ if(!d.thumb && d.art && i!==activeIdx){ try{ withDoc(i,()=>{ d.thumb=docThumbPNG(); }); }catch(e){} } });
  if(activeIdx>=0 && docs[activeIdx] && !docs[activeIdx].thumb && art){
    try{ docs[activeIdx].thumb=docThumbPNG(); }catch(e){}
  }
  for(let i=0;i<MAX_SLOTS;i++){
    const d=docs[i];
    const slot=document.createElement("div");
    slot.className="dslot"+(d?" is-filled":" is-empty")+(i===activeIdx?" on":"");
    slot.setAttribute("data-slot",String(i));
    if(d){
      slot.title=d.artName;
      slot.innerHTML=
        '<span class="dslot__n">'+(i+1)+'</span>'+
        (d.thumb?'<img class="dslot__img" alt="" src="'+d.thumb+'">':'<span class="dslot__wait"></span>')+
        '<span class="dslot__name">'+String(d.artName||"").replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]))+'</span>'+
        /* v2.6 (item 8): the DPI readout is a caption on the ACTIVE slot, under
           its name, and nowhere else */
        (i===activeIdx?(function(){ const q=dpiInfo(); return q?'<span class="dslot__dpi '+q.cls+'" data-dslot-dpi>'+stkEsc(q.text)+'</span>':'<span class="dslot__dpi" data-dslot-dpi></span>'; })():'')+
        '<button type="button" class="dslot__x" aria-label="'+stkEsc(stkT("stk.studio.design.remove_aria","Remove this design"))+'"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      slot.addEventListener("click",e=>{
        if(e.target.closest(".dslot__x")){ e.stopPropagation(); closeDoc(i); return; }
        activateDoc(i);
        /* Thomas, 18 Sep: from ORDER a top tile "does nothing other than makes the sticker bigger",
           because activating a design there only changes which one the ORDER canvas emphasises. It
           should do what the 2x2 quarter does and open that design. On ARTWORK and DESIGN it stays
           as it was: switching between designs in place is the point there. */
        try{ if(root.host&&root.host.dataset&&root.host.dataset.plStep==="3") openStep(2); }catch(err){}
      });
    } else {
      slot.innerHTML=
        '<span class="dslot__n">'+(i+1)+'</span>'+
        '<span class="dslot__ic"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M17 8l-5-5-5 5"/><path d="M12 3v12"/></svg></span>'+
        '<span class="dslot__name">'+stkEsc(stkFmt(stkT("stk.studio.tool.add_design_n","Add design [n]"),{n:i+1}))+'</span>';
      slot.addEventListener("click",()=>{
        if(docs.length && window.__plBeginAnother) window.__plBeginAnother();
        $("file").click();
      });
      slot.addEventListener("dragover",e=>{ e.preventDefault(); slot.classList.add("over"); });
      slot.addEventListener("dragleave",()=>slot.classList.remove("over"));
      slot.addEventListener("drop",e=>{ e.preventDefault(); slot.classList.remove("over");
        if(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) loadFiles(e.dataTransfer.files); });
    }
    host.appendChild(slot);
  }
  /* THE ORDER PANEL FOLLOWS THE SLOTS (v2.4, Thomas 12 Sep 23:00: "why does it say 16
     quantity when i have 4 designs"). docs.length changes when a slot is OPENED, not when
     its artwork lands, so the panel is told from here - every load, switch and removal. */
  if(window.__plDocsChanged) try{ window.__plDocsChanged(); }catch(e){}
}
/* full empty-tool reset - shared by "Clear all" and closing the last tab */
function clearAllDocs(){
  srcImg=null; art=null; artName=DEFAULT_ART; srcIsVector=false; custCut=null; opts.cutMode="";   /* P215 */
  svgSrc=null; svgInfo=null;
  innerRing=null; eraseStrokes=[]; trimOff={x:0,y:0}; curErase=null; plHist=[]; plRedo=[]; setEraseMode(false);
  pickingRm=false; $("preview").style.cursor="";
  palette=[]; paletteLight=[]; opts.removeCols=[];
  if(animRaf){ cancelAnimationFrame(animRaf); animRaf=0; }
  $("preview").classList.add("hidden");
  $("drop").classList.remove("hidden");
  $("canvasTools").style.display="none";
  $("zoomctl").style.display="none";
  setZoom(1);
  $("canvasDims").classList.remove("show");
  ["dlProof","dlPrint","dlCut","dlZip"].forEach(id=>$(id).disabled=true);
  $("note").classList.remove("show");
  $("dpi").textContent=""; $("dpi").className="";
  renderSwatches(); renderRemoveChips();
  docs=[]; activeIdx=-1;
  undoStack=[]; redoStack=[];
  renderDocTabs();
  /* nothing left to design or download: back to step 1, the upload (Thomas, 28 Sep: removing the last photo on the
     DOWNLOADS screen left an empty screen with only NEXT). Both tools; the step ticks go with the designs. */
  try{
    STEP_IDS.forEach(n=>{ const el=stepEl(n); if(el) el.classList.remove("is-folded","is-done"); });
    if(typeof openStep==="function") openStep(1);
    /* and the design panes start again on Size, as on a fresh page */
    if(typeof window.__plSegReset==="function") window.__plSegReset();
  }catch(e){}
  syncUndoRedoButtons();
  $("docGrid").classList.add("hidden");
}
/* v2.9.3: drop the undo stash. clearAllDocs left closedDoc holding a design that could
   still come back 8s later. */
function purgeUndoStash(){
  if(closedTimer){ clearTimeout(closedTimer); closedTimer=0; }
  finalizeClosedDoc();
  const box=$("docToast"); if(box) box.classList.add("hidden");
}
/* A removal is FINAL when its toast ends or the pack is dropped: the design's AUTOSAVE
   record goes with it, or a deleted design sits on in MY DESIGNS. One he pressed SAVE on
   is his and is left alone (savedExplicit). */
function finalizeClosedDoc(){
  const st=closedDoc; closedDoc=null;
  if(!st || !st.doc || !st.doc.libId || st.doc.savedExplicit) return;
  try{ dbTx("readwrite",s=>s.delete(st.doc.libId)).then(()=>{ try{ renderSavedList(false); }catch(e){} }).catch(()=>{}); }catch(e){}
}
/* v2.9.3 (Thomas: "i click stickiply studio again to start again, the 4 are still
   there"). Everything the editor held goes: designs, undo stash, per-design quantities,
   folded steps, file input. The lab reopens on ARTWORK with four empty slots. */
function resetPack(){
  purgeUndoStash();
  try{ clearAllDocs(); }catch(e){}
  STEP_IDS.forEach(i=>{ const el=stepEl(i); if(el){ el.classList.remove("is-folded"); el.classList.remove("is-done"); } });
  try{ const f=$("file"); if(f) f.value=""; }catch(e){}
  try{ const ask=$("sameAsk"); if(ask) ask.hidden=true; }catch(e){}
  if(window.__plPackReset) try{ window.__plPackReset(); }catch(e){}   // the ORDER panel drops its quantities
  openStep(1);
  renderDocTabs();
}
function showDocToast(name){
  const box=$("docToast"); if(!box) return;
  $("docToastMsg").textContent=stkFmt(stkT("stk.studio.tool.doc_closed","“[name]” closed"),{name:name});
  box.classList.remove("hidden");
  closedTimer=setTimeout(()=>{ box.classList.add("hidden"); finalizeClosedDoc(); closedTimer=0; },8000);
}
function closeDoc(i){
  if(i<0 || i>=docs.length) return;
  if(closedTimer){ clearTimeout(closedTimer); closedTimer=0; closedDoc=null; }
  const wasActive=(i===activeIdx);
  if(wasActive) captureDoc();
  const removed=docs[i];
  /* 18 Oct 2026: the quantities as they stood, so Undo puts back the customer's own figures */
  let qtySnap=null; try{ if(typeof window.__plQtySnap==="function") qtySnap=window.__plQtySnap(); }catch(e){}
  closedDoc={doc:removed, index:i, wasActive, qty:qtySnap};
  docs.splice(i,1);
  if(i<activeIdx) activeIdx--;
  if(!docs.length){
    clearAllDocs();
  } else if(wasActive){
    activeIdx=-1;                            // force activateDoc to actually load, not skip
    activateDoc(Math.min(i,docs.length-1));
  } else {
    renderDocTabs();
  }
  showDocToast(removed.artName);
}
function undoCloseDoc(){
  if(!closedDoc) return;
  if(closedTimer){ clearTimeout(closedTimer); closedTimer=0; }
  const {doc,index,wasActive,qty}=closedDoc;
  closedDoc=null;
  $("docToast").classList.add("hidden");
  /* 18 Oct 2026: before the design is back in the pack, so the re-split that follows reads the old figures */
  try{ if(qty && typeof window.__plQtyRestore==="function") window.__plQtyRestore(qty, doc.id); }catch(e){}
  const at=Math.min(index,docs.length);
  docs.splice(at,0,doc);
  if(wasActive){
    activeIdx=-1;                            // force activateDoc to actually load
    activateDoc(at);
  } else {
    if(activeIdx>=at) activeIdx++;
    renderDocTabs();
  }
}

/* ================= authored: overview grid + batch apply/download =================
   Runs the pipeline against an INACTIVE Doc by swapping its state into the live globals
   (activateDoc's own primitives) and restoring what was active. proofCanvas/printCanvas/
   buildCutSVG never touch the DOM, so the visible stage is undisturbed. captureDoc runs on
   EVERY swap, not once per loop, because export state must not cross documents (26 Aug
   2026); the cost is the active doc's thumb being nulled and rebuilt each time. */
function withDoc(i, fn){
  const back=activeIdx;
  captureDoc();                 // save the live doc before its globals are overwritten
  loadDocGlobals(docs[i]); activeIdx=i;
  const out=fn();
  activeIdx=back;
  if(back>=0 && docs[back]) loadDocGlobals(docs[back]);
  return out;
}
function docThumbPNG(){
  if(!art) return null;
  /* ON WHITE, AT SOURCE (Thomas, 12 Sep 22:20: the NIMONA-METAL row was a blank
     square). proofCanvas() is deliberately TRANSPARENT - the PNG download wants
     it that way - and a transparent proof drawn on a white tile shows nothing
     but the tile. The same fault as the confirm window's black proof on 12 Sep
     11:15, and the same fix: fill white first. Every caller of docThumbPNG
     wants a picture, never a print file, so it belongs here and not at the
     call sites. */
  /* v2.9 (note 16): TRANSPARENT. The thumbnail sits on the slot tile and on the ORDER
     quarter's dotted ground, and an opaque white square hid both; the ground now shows
     through and the sticker's own white border reads against it. */
  try{ if(activeIdx>=0 && docs[activeIdx]) docs[activeIdx].thumbKey=sceneKey(opts,art,eraseStrokes,trimOff); }catch(e){}
  const full=proofCanvas();
  const MAXE=480;   /* P170: the grid squares show it large now (was 200 and blurred when enlarged) */
  const sc=Math.min(1, MAXE/Math.max(full.width,full.height));
  const t=mk(Math.max(1,Math.round(full.width*sc)), Math.max(1,Math.round(full.height*sc)));
  t.getContext("2d").drawImage(full,0,0,t.width,t.height);
  return t.toDataURL("image/png");
}
/* regenerate a thumbnail only for docs that don't have one - captureDoc()
   nulls a Doc's thumb whenever its state is captured (tab switch, batch
   apply), so this only ever redoes the ones that actually changed */
function ensureThumbs(){
  if(activeIdx>=0 && docs[activeIdx]) captureDoc();
  docs.forEach((d,i)=>{ if(!d.thumb) withDoc(i,()=>{ d.thumb=docThumbPNG(); }); });
}
/* P170: the grid's ticks outlive the grid (the downloads panel counts them, the design panel applies to
   them), so they are kept by design id, not read from checkboxes that re-render */
const plPicked=new Set();
function selectedTileIdxs(){
  const idx=[]; docs.forEach((d,i)=>{ if(d && plPicked.has(d.id)) idx.push(i); });
  return idx;
}
function updateGridBulkBar(){
  const n=selectedTileIdxs().length;
  $("docGridBulk").classList.toggle("hidden", n===0);
  $("docGridBulkCount").textContent=stkFmt(n===1?stkT("stk.studio.grid.selected.one","[count] design selected"):stkT("stk.studio.grid.selected.other","[count] designs selected"),{count:n});
  $("docGridApply").textContent=stkFmt(stkT("stk.studio.grid.apply_n","Apply settings to [designs]"),{designs:n});
  $("docGridZip").textContent=stkFmt(stkT("stk.studio.grid.download_n","Download [designs] as ZIP"),{designs:n});
  try{ if(typeof window.__plSelChanged==="function") window.__plSelChanged(n); }catch(e){}
}
function renderDocGrid(){
  const host=$("docGridScroll"); if(!host) return;
  host.innerHTML="";
  docs.forEach((d,i)=>{
    const t=document.createElement("div");
    t.className="doctile"+(i===activeIdx?" on":"");
    t.dataset.i=i;
    const chk=document.createElement("label"); chk.className="doctile__check"; chk.title=stkT("stk.studio.grid.select","Select");
    chk.addEventListener("click",e=>e.stopPropagation());
    const cb=document.createElement("input"); cb.type="checkbox"; cb.className="doctile__cb";
    cb.checked=plPicked.has(d.id);
    cb.addEventListener("change",()=>{ if(cb.checked) plPicked.add(d.id); else plPicked.delete(d.id); updateGridBulkBar(); });
    chk.appendChild(cb);
    const tw=document.createElement("div"); tw.className="doctile__thumbwrap";
    if(d.thumb){ const im=document.createElement("img"); im.className="doctile__thumb"; im.src=d.thumb; tw.appendChild(im); }
    const nm=document.createElement("div"); nm.className="doctile__name"; nm.textContent=d.artName; nm.title=d.artName;
    const ex=document.createElement("button"); ex.type="button"; ex.className="doctile__expand"; ex.title=stkT("stk.studio.grid.open","Open");
    ex.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="M9 21H3v-6"/><path d="M21 3l-7 7"/><path d="M3 21l7-7"/></svg>';
    ex.addEventListener("click",e=>{ e.stopPropagation(); closeDocGrid(); activateDoc(i); });
    /* the ORDER tile's x (Thomas, 28 Sep 02:05: "this is the X i want") */
    const x=document.createElement("button"); x.type="button"; x.className="doctile__x oq__x"; x.title=stkT("stk.studio.tool.close","Close"); x.setAttribute("aria-label",stkT("stk.studio.design.remove_aria","Remove this design"));
    x.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
    x.addEventListener("click",e=>{
      e.stopPropagation();
      closeDoc(i);
      if(docs.length<2) closeDocGrid(); else renderDocGrid();
    });
    t.appendChild(chk); t.appendChild(tw); t.appendChild(nm); t.appendChild(ex); t.appendChild(x);
    t.addEventListener("click",()=>{ closeDocGrid(); activateDoc(i); });
    host.appendChild(t);
  });
  const add=document.createElement("div");
  add.className="doctile doctile--add"; add.title=stkT("stk.studio.grid.add_artwork","Add artwork");
  /* the main field's own upload wording and icon (Thomas, 28 Sep 02:30: "why doesnt the field say upload
     or drag & drop etc"), and it takes dropped files like the field does */
  const dz=$("drop");
  add.innerHTML=dz?'<div class="doctile__drop">'+dz.innerHTML+'</div>':'<span class="doctile__plus">+</span>';
  add.addEventListener("click",()=>{ if(docs.length && window.__plBeginAnother) window.__plBeginAnother(); $("file").click(); });
  add.addEventListener("dragover",e=>{ e.preventDefault(); add.classList.add("over"); });
  add.addEventListener("dragleave",()=>add.classList.remove("over"));
  add.addEventListener("drop",e=>{ e.preventDefault(); e.stopPropagation(); add.classList.remove("over"); $("drop").classList.remove("over");   /* 2 Nov 2026: the stage behind the grid loaded the same files again */ if(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length){ closeDocGrid(); loadFiles(e.dataTransfer.files); } });
  host.appendChild(add);
  updateGridBulkBar();
}
function openDocGrid(){
  if(docs.length<(PL_DOWNLOADS?1:2)) return;
  ensureThumbs();
  renderDocGrid();
  $("docGrid").classList.remove("hidden");
  $("preview").classList.add("hidden");
  $("drop").classList.add("hidden");
  $("canvasTools").style.display="none";
  $("zoomctl").style.display="none";
  $("canvasDims").classList.remove("show");
}
function closeDocGrid(){
  $("docGrid").classList.add("hidden");
  if(!docs.length) return;                  // clearAllDocs() already reset the stage
  $("drop").classList.add("hidden");
  $("preview").classList.remove("hidden");
  $("canvasTools").style.display="flex";
  $("zoomctl").style.display="flex";
  render();
  coverageHint();
  updateDpi();
  updateDims();
}
/* the ZIP entries one artwork contributes - reused by the single-artwork
   "Download order files" button (dlZipRun) and the batch ZIP below */
/* Thomas, 18 Sep: "add the mock up of their sticker with the finish to the downloads they get. on a
   transparent background." It goes in the ZIP only, never in what is uploaded with the order: the
   print PNG and the cut SVG are the artwork and must not gain a neighbour. renderHolo leaves
   everything outside the sticker transparent, so the mock up drops onto any background. */
async function mockupFile(){
  if(!finishDrawable() || !baseScene) return null;
  try{
    const sz=(typeof cutSizeMm==="function" && cutSizeMm()) ? cutSizeMm() : null;
    const mm=sz ? Math.max(sz.w,sz.h) : 75;
    /* Thomas, 18 Sep: "the large exported mock up glitter looks micro compared to how it looked
       properly when it was the small preview." The sparkle is drawn at the right SIZE at any
       resolution, but a 2000 px export viewed fitted to a window is downscaled, and downscaling
       averages fine sparkle away. This file is for listings and product photos, not for printing,
       so it is exported at the size it was designed and approved at rather than at print
       resolution: what he tuned on screen is what lands in the ZIP. */
    const cap=1200;
    const ms=Math.min(1, cap/Math.max(baseScene.width, baseScene.height));
    const out=holoMod.renderHolo(cutScene(),{ finish:lookOf(orderFinish), borderPx:0, stickerWidthMm:mm, scale:ms });
    return { name:"PREVIEW-ONLY-"+outName(orderFinish+"-mockup")+".png", bytes:await canvasBytes(out) };
  }catch(e){ console.warn("[proof-lab] mockup failed:",e&&e.message); return null; }
}
async function buildArtworkFiles(){
  const enc=new TextEncoder();
  return [
    {name:outName("print-300dpi")+".png", bytes:await canvasBytes(printCanvas(false).out)},
    {name:outName("cutfile")+".svg", bytes:enc.encode(buildCutSVG())}
  ];
}
const APPLY_OWN_SKIP=["shape","borderMm","border","corner","fit","smoothMm","cornerMode","cornerAuto","labelApplied","labelAuto"];   /* P215 G6 */
const APPLY_KEYS=["shape","borderMm","border","corner","fit","sizeIn","sizeCustomMm","smoothMm","bgMode","bg","bgPicked","bgAutoArmed","bgFrom","bgTo","bgAngle","cornerMode","cornerAuto","labelApplied","labelAuto"];
function applySettingsToTicked(){
  const idxs=selectedTileIdxs();
  if(!idxs.length || activeIdx<0) return;
  captureDoc();
  const src=docs[activeIdx].opts;
  idxs.forEach(i=>{
    if(i===activeIdx || !docs[i]) return;
    const d=docs[i];
    if(!d.undoStack) d.undoStack=[];
    d.undoStack.push(cloneOpts(d.opts));
    if(d.undoStack.length>20) d.undoStack.shift();
    d.redoStack=[];
    /* 18 Oct 2026 (P215, guard G6): cutMode is not an APPLY key, and a design cut on its own file's line keeps its
       shape and border settings (they do not apply to it); size and colour still apply */
    const own=d.opts.cutMode==="own" && !!d.custCut && !d.custCut.refused;
    APPLY_KEYS.forEach(k=>{ if(own && APPLY_OWN_SKIP.indexOf(k)>=0) return; d.opts[k]=src[k]; });
    /* the source's auto colour is the SOURCE's edge; an armed target takes its own edge (or white) now, the same
       rule autoBleed applies when it is opened (review 28 Sep) */
    const o=d.opts;
    if(o.bgAutoArmed && !o.bgPicked && o.bgMode==="solid"){ const a=!o.border && !!o.bgEdge && o.shape==="custom"; o.bg = a ? printSafe(o.bgEdge) : "#ffffff"; o.bgAutoPick=a; }
    else o.bgAutoPick=false;
    d.dilCache={}; d.thumb=null;
  });
  renderDocGrid();
}
async function dlZipBatch(idxs){
  const enc=new TextEncoder();
  const files=[{name:"READ-ME.txt", bytes:enc.encode(
    /* i18n: file names stay English (the order pipeline reads them); a value's own line
       breaks become the README's \r\n */
    (PL_DOWNLOADS ? stkT("stk.studio.dl.readme_batch_title","STICKIPLY STUDIO FILES") : stkT("stk.studio.readme.batch_title","STICKIPLY BATCH ORDER FILES"))+"\r\n"+
    "============================\r\n\r\n"+
    stkFmt(stkT("stk.studio.readme.batch_intro","This ZIP has one folder per artwork ([designs] total). Each folder has:"),{designs:idxs.length})+"\r\n"+
    "  - print-300dpi.png  "+stkT("stk.studio.readme.print_desc","(finished sticker artwork, transparent)")+"\r\n"+
    "  - cutfile.svg  "+stkT("stk.studio.readme.cut_desc","(cut line + artwork with 1.5mm bleed)")+"\r\n"+
    "  - PREVIEW-ONLY-...proof.png  "+stkT("stk.studio.readme.proof_desc","(what it looks like - do not send as artwork)")+"\r\n\r\n"+
    (PL_DOWNLOADS ? stkT("stk.studio.dl.readme_batch_files","Print and cut them yourself, or hand the folders to any printer.") : stkT("stk.studio.readme.batch_upload","Upload the whole ZIP, or the individual folders, with your order."))+"\r\n\r\n"+
    String(stkT("stk.studio.readme.batch_sizing","Sizing note: each cut file includes a 1.5mm bleed on every side, so it\nmeasures 3mm larger than the finished cut size shown in the tool.\nThat's intentional and normal for print.")).replace(/\r?\n/g,"\r\n")+"\r\n")}];
  const back=activeIdx;
  if(back>=0 && docs[back]) captureDoc();
  // Two uploads can easily share a name ("image", "artwork", a phone camera's
  // IMG_0001). Identical folder names would collide inside the ZIP and most
  // unzippers silently keep only the last one - the customer would order from
  // files they never saw. Number the repeats instead.
  const used={};
  for(let k=0;k<idxs.length;k++){
    const i=idxs[k];
    $("spin").textContent=stkFmt(stkT("stk.studio.tool.building_n","BUILDING [n] OF [total]…"),{n:k+1,total:idxs.length});
    loadDocGlobals(docs[i]); activeIdx=i;
    const base=artName;
    used[base]=(used[base]||0)+1;
    const folder = used[base]>1 ? base+"-"+used[base] : base;
    (await buildArtworkFiles()).forEach(f=>files.push({name:folder+"/"+f.name, bytes:f.bytes}));
    { const mk2=await mockupFile(); if(mk2) files.push({name:folder+"/"+mk2.name, bytes:mk2.bytes}); }
    // Parity with the single-artwork ZIP: every folder carries its own proof, so
    // what the customer receives does not depend on how many tabs were open.
    files.push({name:folder+"/PREVIEW-ONLY-"+outName("proof")+".png", bytes:await canvasBytes(proofCanvas())});
  }
  activeIdx=back;
  if(back>=0 && docs[back]) loadDocGlobals(docs[back]);
  saveBlob(makeZip(files), "stickiply-batch-"+idxs.length+"-designs.zip");
}
function dlZipBatchGo(){
  const idxs=selectedTileIdxs();
  if(!idxs.length) return;
  const spinTxt=$("spin").textContent;
  $("spin").classList.add("show");
  setTimeout(async()=>{
    try{ await dlZipBatch(idxs); }
    catch(e){ showError(stkFmt(stkT("stk.studio.msg.zip_failed","Couldn't build the ZIP: [error]"),{error:(e.message||e)})); }
    $("spin").classList.remove("show");
    $("spin").textContent=spinTxt;
  },30);
}

/* ================= authored: undo/redo =================
   Settings only - snapshots are cloneOpts(opts), never art/mask0/baseScene/
   dilCache/palette. 20 deep, per doc; the active doc's stacks live in the
   undoStack/redoStack globals and swap via captureDoc()/loadDocGlobals()
   exactly like everything else Doc-shaped. */
function snapBefore(){ return activeIdx>=0 ? cloneOpts(opts) : null; }
function pushUndo(before){
  if(!before || activeIdx<0) return;
  if(JSON.stringify(before)===JSON.stringify(cloneOpts(opts))) return;   // no-op, nothing to undo
  undoStack.push(before);
  if(undoStack.length>20) undoStack.shift();
  redoStack=[];
  syncUndoRedoButtons();
}
function applyUndoEntry(entry){
  const svgChanged = JSON.stringify(entry.svgOff||[])!==JSON.stringify(opts.svgOff||[]) || JSON.stringify(entry.svgIn||[])!==JSON.stringify(opts.svgIn||[]);
  const bgChanged = entry.removeBg!==opts.removeBg || entry.removeTol!==opts.removeTol || !!entry.removeInner!==!!opts.removeInner
    || JSON.stringify(entry.removeCols)!==JSON.stringify(opts.removeCols);
  const cutChanged = (entry.cutMode||"")!==(opts.cutMode||"");   /* 18 Oct 2026 (P215): the switch is undoable */
  clearAutoBleed(); opts.bgPicked=false;
  Object.assign(opts, cloneOpts(entry));
  if(opts.cutMode===undefined) opts.cutMode="";
  if(cutChanged) cutModeImage();
  dilCache={}; dilPad=0;
  syncControlsFromOpts();          // also calls syncUndoRedoButtons()
  if(svgChanged && svgSrc){ plSvgApply(); return; }   /* 21 Oct 2026: a colour of the vector file on or off */
  if((bgChanged || cutChanged) && srcImg) processSource();
  else { render(); updateDims(); }
}
function doUndo(){
  if(activeIdx<0 || !undoStack.length) return;
  const entry=undoStack.pop();
  redoStack.push(cloneOpts(opts));
  if(redoStack.length>20) redoStack.shift();
  applyUndoEntry(entry);
}
function doRedo(){
  if(activeIdx<0 || !redoStack.length) return;
  const entry=redoStack.pop();
  undoStack.push(cloneOpts(opts));
  if(undoStack.length>20) undoStack.shift();
  applyUndoEntry(entry);
}
function syncUndoRedoButtons(){
  const u=$("ctoolUndo"), r=$("ctoolRedo"); if(!u||!r) return;
  u.classList.toggle("disabled", !(activeIdx>=0 && undoStack.length>0));
  r.classList.toggle("disabled", !(activeIdx>=0 && redoStack.length>0));
}

/* ================= authored: multi-colour background removal =================
   Flood from the canvas edges, lifting any pixel whose colour sits within the
   tolerance of ANY colour on the removal list (redmean distance). Enclosed
   areas of the same colour survive - only edge-connected background lifts. */
function colDist(r1,g1,b1,r2,g2,b2){
  const rm=(r1+r2)/2;
  const dr=r1-r2, dg=g1-g2, db=b1-b2;
  return Math.sqrt((2+rm/256)*dr*dr + 4*dg*dg + (2+(255-rm)/256)*db*db);
}
function safeHex(v, fallback){
  const t=String(v==null?"":v).trim();
  return /^#[0-9a-fA-F]{6}$/.test(t) ? t.toLowerCase() : fallback;
}
function hexRgb(hex){
  const m=/^#?([0-9a-f]{6})$/i.exec(hex); if(!m) return null;
  const n=parseInt(m[1],16);
  return [(n>>16)&255,(n>>8)&255,n&255];
}
/* cols: [{c:"#hex"}] - every colour floods in from the canvas border, so enclosed areas survive.
   SELECTIVE REMOVAL (21 Oct 2026, Thomas: "we don't want remove everywhere, we want selective removal"): the "everywhere" mode
   (all:true, a tap on the chip) is gone; a design saved with one opens edge-only; inner areas come off one by one with the wand. */
function removeBgMulti(c, cols, tol){
  const edge=cols.map(x=>hexRgb(x.c)).filter(Boolean), glob=[];
  if(!edge.length && !glob.length) return;
  const t=Math.max(0,Math.min(100, tol==null?45:tol))/100;
  // 0% must mean 0: the old floor of 26 kept keying near-white pixels with the
  // slider at zero, so "strength 0%" still ate parts of the customer's artwork.
  // Now 0% removes only exact matches to the picked colour; the 100% ceiling is
  // unchanged at 176. AI/_rules/LAB-RULES.md rule 3.
  const cut = t*176;               // redmean threshold: exact .. loose
  const ctx=c.getContext("2d");
  const {width:w,height:h}=c;
  const d=ctx.getImageData(0,0,w,h);
  const px=d.data;
  const near=(i,list)=>{
    const r=px[i*4],g=px[i*4+1],b=px[i*4+2];
    for(let k=0;k<list.length;k++){
      if(colDist(r,g,b,list[k][0],list[k][1],list[k][2])<cut) return true;
    }
    return false;
  };
  if(glob.length){
    for(let i=0;i<w*h;i++){
      if(px[i*4+3]>10 && near(i,glob)) px[i*4+3]=0;
    }
  }
  if(edge.length){
    const seen=new Uint8Array(w*h);
    const isBg=i=> px[i*4+3]<10 || near(i,edge);
    const stack=[];
    for(let x=0;x<w;x++){ stack.push(x,(h-1)*w+x); }
    for(let y=0;y<h;y++){ stack.push(y*w,y*w+w-1); }
    while(stack.length){
      const i=stack.pop();
      if(i<0||i>=w*h||seen[i]) continue;
      seen[i]=1;
      if(!isBg(i)) continue;
      px[i*4+3]=0;
      const x=i%w;
      stack.push(i-w,i+w);
      if(x>0) stack.push(i-1);
      if(x<w-1) stack.push(i+1);
    }
  }
  ctx.putImageData(d,0,0);
}
/* dominant colours around the canvas edge - the likely backgrounds */
/* builder audit row 21 (31 Oct 2026): a raster that is already see-through round its edge has no background to take
   off, so the Remove background switch is not offered there (Thomas, 22 Oct: "background removal absent on a transparent
   image"; options that do not apply are hidden) and a fresh file never starts with removal on. Measured on live, 30 Oct:
   on a transparent PNG the switch took the artwork's own orange (detectEdgeCols reads the opaque pixels that touch the
   frame), DPI 401 -> 235, sawtooth corners in the proof. The answer is cached per source image. */
let plClearSrc=null, plClearAns=false;
function plSrcClear(){
  if(!srcImg || srcIsVector || svgSrc) return false;
  if(plClearSrc===srcImg) return plClearAns;
  plClearSrc=srcImg; plClearAns=false;
  try{
    const W0=srcImg.naturalWidth||srcImg.width, H0=srcImg.naturalHeight||srcImg.height; if(!W0||!H0) return false;
    const s=Math.min(1,256/Math.max(W0,H0)), w=Math.max(8,Math.round(W0*s)), h=Math.max(8,Math.round(H0*s));
    const c=mk(w,h), x=c.getContext("2d"); x.drawImage(srcImg,0,0,w,h);
    const d=x.getImageData(0,0,w,h).data, b=Math.max(2,Math.round(Math.min(w,h)*0.02));
    let n=0, clear=0;
    for(let y=0;y<h;y++) for(let xx=0;xx<w;xx++){ if(y>=b && y<h-b && xx>=b && xx<w-b) continue; n++; if(d[(y*w+xx)*4+3]<16) clear++; }
    plClearAns = n>0 && clear/n>=0.25;
    c.width=0; c.height=0;
  }catch(e){ plClearAns=false; }
  return plClearAns;
}
/* the row is hidden while it does not apply; a removal the magic wand turned on keeps it on screen so it can be undone */
function plRmRowSync(){
  try{ const h=$("gRemoveBg"); if(!h) return; const hide=plSrcClear() && !opts.removeBg; h.classList.toggle("is-na", hide); h.style.display = hide ? "none" : ""; }catch(e){}
}
function detectEdgeCols(c){
  const ctx=c.getContext("2d");
  const {width:w,height:h}=c;
  const d=ctx.getImageData(0,0,w,h).data;
  const bins={};
  const tally=i=>{
    if(d[i*4+3]<200) return;
    const key=(d[i*4]>>4)<<8 | (d[i*4+1]>>4)<<4 | (d[i*4+2]>>4);
    let b=bins[key]; if(!b){ b=bins[key]=[0,0,0,0]; }
    b[0]+=d[i*4]; b[1]+=d[i*4+1]; b[2]+=d[i*4+2]; b[3]++;
  };
  const band=Math.max(2,Math.round(Math.min(w,h)*0.012));
  for(let y=0;y<h;y++){
    if(y<band||y>=h-band){ for(let x=0;x<w;x++) tally(y*w+x); }
    else { for(let x=0;x<band;x++){ tally(y*w+x); tally(y*w+w-1-x); } }
  }
  const total=Object.values(bins).reduce((s,b)=>s+b[3],0);
  if(!total) return [];
  const hex=n=>Math.max(0,Math.min(255,Math.round(n))).toString(16).padStart(2,"0");   /* clamp: an unclamped bin average of 257 wrote "101" and made a seven digit hex */
  return Object.values(bins)
    .filter(b=>b[3]/total>0.10)
    .sort((p,q)=>q[3]-p[3]).slice(0,3)
    .map(b=>"#"+hex(Math.round(b[0]/b[3]))+hex(Math.round(b[1]/b[3]))+hex(Math.round(b[2]/b[3])));
}
/* the working canvas before any removal - used for detection */
function PL_INLINE_PAGE(){ return !!(root && root.host && root.host.dataset && root.host.dataset.inline==="1"); }
/* The artwork's outer edge colour, for an untouched solid border (P170, 28 Sep 2026). Only the band of opaque pixels
   within ~2% of the artwork's own edge is read (the whole image averages to mud). Pixels are grouped by hue in 15-degree
   bins, a window of three neighbouring bins wins (so the shades of one colour count together); black, grey and white
   are their own groups. The winner must hold 45% of the band or the answer is white (null). Returns the mean colour of
   the winning group as #rrggbb. */
function edgeColour(c){
  try{
    const M=240, s=Math.min(1, M/Math.max(c.width,c.height));
    const w=Math.max(8,Math.round(c.width*s)), h=Math.max(8,Math.round(c.height*s));
    const t=mk(w,h), tx=t.getContext("2d"); tx.drawImage(c,0,0,w,h);
    const d=tx.getImageData(0,0,w,h).data, W=w+1;
    const T=new Uint32Array(W*(h+1));
    for(let y=0;y<h;y++){ let row=0; for(let x=0;x<w;x++){ row += d[(y*w+x)*4+3]<40?1:0; T[(y+1)*W+x+1]=T[y*W+x+1]+row; } }
    const r=Math.max(2,Math.round(Math.max(w,h)*0.02));
    const HB=24, bins=[]; for(let i=0;i<HB+3;i++) bins.push([0,0,0,0]);   /* 0..23 hue, 24 black, 25 grey, 26 white */
    let band=0;
    for(let y=0;y<h;y++) for(let x=0;x<w;x++){
      const i=(y*w+x)*4; if(d[i+3]<200) continue;
      const x0=Math.max(0,x-r), y0=Math.max(0,y-r), x1=Math.min(w,x+r+1), y1=Math.min(h,y+r+1);
      const atFrame = x<r || y<r || x>=w-r || y>=h-r;
      if(!atFrame && T[y1*W+x1]-T[y0*W+x1]-T[y1*W+x0]+T[y0*W+x0]===0) continue;
      const R=d[i]/255, G=d[i+1]/255, B=d[i+2]/255, mx=Math.max(R,G,B), mn=Math.min(R,G,B), l=(mx+mn)/2, ch=mx-mn;
      const sat = ch===0 ? 0 : ch/(1-Math.abs(2*l-1));
      let k;
      if(l<0.14 || (sat<0.18 && l<0.3)) k=HB;
      else if(l>0.9 || (sat<0.18 && l>0.75)) k=HB+2;
      else if(sat<0.18) k=HB+1;
      else { let hh = mx===R ? ((G-B)/ch)%6 : mx===G ? (B-R)/ch+2 : (R-G)/ch+4; hh*=60; if(hh<0) hh+=360; k=Math.floor(hh/15)%HB; }
      const e=bins[k]; e[0]++; e[1]+=d[i]; e[2]+=d[i+1]; e[3]+=d[i+2]; band++;
    }
    if(band<40) return null;
    let best=null, bestN=0;
    for(let k=0;k<HB;k++){ const n=bins[(k+HB-1)%HB][0]+bins[k][0]+bins[(k+1)%HB][0]; if(n>bestN){ bestN=n; best=[(k+HB-1)%HB,k,(k+1)%HB]; } }
    for(let k=HB;k<HB+3;k++) if(bins[k][0]>bestN){ bestN=bins[k][0]; best=[k]; }
    if(!best || bestN/band<0.45) return null;
    let n=0,sr=0,sg=0,sb=0; best.forEach(k=>{ n+=bins[k][0]; sr+=bins[k][1]; sg+=bins[k][2]; sb+=bins[k][3]; });
    const hx=v=>Math.max(0,Math.min(255,Math.round(v))).toString(16).padStart(2,"0");
    return "#"+hx(sr/n)+hx(sg/n)+hx(sb/n);
  }catch(e){ return null; }
}
/* the untouched solid colour follows the border switch (Proof Lab page and product Studio, 28 Sep 2026): border off =
   the artwork's edge colour (it is only the bleed), border on = white. Called on upload, whenever the border changes,
   and before the swatches draw. Only for a design ARMED by a fresh upload: a saved, re-ordered or older design keeps
   the colour it has, and a colour the customer picked is never touched. Mutates opts only; the caller re-renders. */
function autoBleed(){
  if(!art || !opts.bgAutoArmed || opts.bgPicked || opts.bgMode!=="solid") return;
  const auto = !opts.border && !!opts.bgEdge && opts.shape==="custom";
  opts.bg = auto ? printSafe(opts.bgEdge) : "#ffffff"; opts.bgAutoPick = auto;
}
/* SOFT EDGE (20 Oct 2026, Thomas: "when a gradient is detected, the edge mode should be automatically on stickers, and cut
   line be slightly inside by 1mm the artwork rather than on the edge"). An 18 Oct order (a die-cut with a soft yellow glow
   fading to transparent round a white keyline) printed white triangles in the bleed: the cut sat where the glow was already
   faint, over a solid bleed colour. softEdgeOf(c) measures the alpha ramp at the artwork's OUTER edge: the partly
   transparent pixels (alpha 8..239) reachable from the outside through partly transparent pixels only, per pixel of outline
   (transparent pixels touching the artwork). A crisp antialiased edge measures about 1 px; a glow or a soft shadow measures
   its own width. Returns { rampPx (art px), outline (px) } on a copy at most 1000 px; interior see-through ink is not counted. */
function softEdgeOf(c){
  try{
    const S=Math.min(1, 1000/Math.max(c.width,c.height));
    const w=Math.max(4,Math.round(c.width*S)), h=Math.max(4,Math.round(c.height*S));
    const t=mk(w,h), tx=t.getContext("2d"); tx.imageSmoothingQuality="high"; tx.drawImage(c,0,0,w,h);
    const d=tx.getImageData(0,0,w,h).data, N=w*h, A=new Uint8Array(N);
    for(let i=0;i<N;i++) A[i]=d[i*4+3];
    /* outside = transparent pixels connected to the frame */
    const out=new Uint8Array(N), q=new Int32Array(N); let qh=0, qt=0;
    const push=i=>{ q[qt++]=i; };
    for(let x=0;x<w;x++){ if(A[x]<8 && !out[x]){ out[x]=1; push(x); } const j=(h-1)*w+x; if(A[j]<8 && !out[j]){ out[j]=1; push(j); } }
    for(let y=0;y<h;y++){ const i=y*w, j=y*w+w-1; if(A[i]<8 && !out[i]){ out[i]=1; push(i); } if(A[j]<8 && !out[j]){ out[j]=1; push(j); } }
    while(qh<qt){ const i=q[qh++], x=i%w; const nb=[x>0?i-1:-1, x<w-1?i+1:-1, i-w, i+w];
      for(const k of nb){ if(k<0||k>=N||out[k]||A[k]>=8) continue; out[k]=1; push(k); } }
    /* the ramp: partly transparent pixels reached from the outside through partly transparent pixels */
    const ramp=new Uint8Array(N); qh=0; qt=0; let outline=0;
    for(let i=0;i<N;i++){ if(!out[i]) continue; const x=i%w; let touch=false;
      for(const k of [x>0?i-1:-1, x<w-1?i+1:-1, i-w, i+w]){ if(k<0||k>=N||out[k]) continue; touch=true; if(A[k]<240 && !ramp[k]){ ramp[k]=1; push(k); } }
      if(touch) outline++; }
    while(qh<qt){ const i=q[qh++], x=i%w; for(const k of [x>0?i-1:-1, x<w-1?i+1:-1, i-w, i+w]){ if(k<0||k>=N||out[k]||ramp[k]||A[k]>=240) continue; ramp[k]=1; push(k); } }
    let n=0; for(let i=0;i<N;i++) n+=ramp[i];
    if(outline<20) return { rampPx:0, outline };
    return { rampPx:(n/outline)/S, outline:Math.round(outline/S) };
  }catch(e){ return { rampPx:0, outline:0 }; }
}
const SOFT_EDGE_MIN_PX=4, SOFT_EDGE_MIN_MM=0.25, SOFT_INSET_MM=1.0;
function softOwn(){ try{ return typeof ownCut==="function" && ownCut(); }catch(e){ return false; } }
/* the inset in mm while it applies: a soft-edged design, border off, a traced die-cut, not the customer's own cut line */
function softInsetMm(){ return (opts.softInset>0 && !opts.border && !softOwn() && (opts.shape==="custom" || opts.shape==="rect")) ? opts.softInset : 0; }
function softInsetPx(){ const m=softInsetMm(); return m>0 ? Math.max(1,Math.round(m*pxPerMm())) : 0; }
function dilKey(R,sPx){ const i=softInsetPx(); return R+":"+sPx+(i?":in"+i:""); }
/* the mask shrunk by r px in place: the outside grown into it (dilateCanvas on the inverse), hardened */
function erodeMaskInPlace(m,r){
  const inv=mk(m.width,m.height), ix=inv.getContext("2d");
  ix.fillStyle="#fff"; ix.fillRect(0,0,inv.width,inv.height);
  ix.globalCompositeOperation="destination-out"; ix.drawImage(m,0,0);
  const grown=dilateCanvas(inv,r);
  const x=m.getContext("2d"); x.save(); x.globalCompositeOperation="destination-out"; x.drawImage(grown,0,0); x.restore();
  grown.width=0; grown.height=0; inv.width=0; inv.height=0;
  return hardenAlpha(m);
}
function hasAlpha(c){
  const x=c.getContext("2d"), w=c.width, h=c.height;
  let d; try{ d=x.getImageData(0,0,w,h).data; }catch(e){ return true; }
  for(let i=3;i<d.length;i+=4) if(d[i]<200) return true;
  return false;
}
function workCanvas(){
  const s=Math.min(1, WORK/Math.max(srcImg.width,srcImg.height));
  const c=mk(srcImg.width*s, srcImg.height*s);
  const cx=c.getContext("2d");
  cx.imageSmoothingQuality="high";
  cx.drawImage(srcImg,0,0,c.width,c.height);
  return c;
}

function processSource(cb){
  if(!srcImg) return;
  $("spin").classList.add("show");
  setTimeout(()=>{
    if(!srcImg){ $("spin").classList.remove("show"); return; }   /* builder audit X2: the design was closed or cleared before the timer */
    const c=workCanvas();
    const softFresh=!!opts.bgFresh;   /* SOFT EDGE: a new file (bgFresh is cleared below) */
    /* A NEW FILE PICKS ITS OWN BORDER MODE (Thomas, 11 Sep 2026: Auto "looks
       crazy for the customer on pngs"). Auto continues the outer pixels, which
       on a transparent PNG with a dark outline smears that outline out into
       the border. Transparent artwork therefore started on a solid white
       border and an opaque file kept Auto. 28 Sep 2026: every file starts on
       Solid, its colour read from the artwork (see THE BLEED COLOUR below).
       Only on load - the customer's later choice is never overridden. */
    let freshColour=false;
    if(opts.bgFresh){
      opts.bgFresh=false;
      /* builder audit row 21: a see-through file starts with no removal (a new design copies the last one's settings) */
      if(plSrcClear() && opts.removeBg){ opts.removeBg=false; opts.removeCols=[]; try{ $("rmBg").classList.remove("on"); syncTolVisibility(); }catch(e){} }
      /* every file imports as die-cut; a new design clones the last one's
         settings, so Corners or a label's border-off must not ride along */
      /* v3.6 (desktop shows the design options before any artwork): a shape or a colour mode the
         customer picked BEFORE the upload is theirs and is kept; only untouched ones take the defaults */
      if(!preArt.shape) opts.shape="custom";
      if(opts.labelAuto){
        opts.labelAuto=false; opts.cornerAuto=true;
        if(!opts.border){ opts.border=true; $("borderToggle").classList.add("on"); syncBorderVisibility(); }
      }
      [...$("shapeSeg").querySelectorAll("button")].forEach(b=>b.classList.toggle("on", b.dataset.v===opts.shape));
      syncGroups();
      freshColour=true;   /* the colour is decided below, once the artwork is final (after background removal) */
    }
    const plC0=(opts.removeBg || eraseStrokes.some(g=>g && g[0] && (g[0].w || g[0].f))) ? c.getContext("2d").getImageData(0,0,c.width,c.height).data : null, plCW=c.width, plCH=c.height;   /* the halo fix: the work canvas before anything is removed */
    if(opts.removeBg && opts.removeCols.length) removeBgMulti(c, opts.removeCols, opts.removeTol);
    // Only clean up alpha WE created - see AI/_rules/LAB-RULES.md rule 3.
    /* 18 Oct 2026 (P202): photo-edge dust goes too, BEFORE trim, or the dust becomes its own cut piece and trim
       grows the box to the photo's corners (Result B: a 4.5cm disk inside a 7.5cm order). Port of the Mac fix. */
    if(opts.removeBg && opts.removeCols.length){ despeckle(c); edgeDust(c); }
    else edgeDustRemoved=[];
    /* Replay the eraser BEFORE the trim, so erasing a stray in the corner
       actually shrinks the artwork rather than leaving dead space behind it. */
    applyEraseStrokes(c);
    const preW=c.width;
    /* 18 Oct 2026 (P215): srcImg px -> work px for the cut line from the file; in own-cut mode the artwork is cropped
       to the cut's box plus room for the bleed instead of to the ink, so the cut can sit outside the artwork */
    if(custCut && custCut.bb) custCut.xf={ sx:c.width/srcImg.width, sy:c.height/srcImg.height, ox:0, oy:0 };
    art = ownCut() ? cropToCut(c) : trim(c);
    if(custCut && custCut.xf){ custCut.xf.ox=-trimOff.x; custCut.xf.oy=-trimOff.y; }
    /* THE BLEED COLOUR (Thomas, 28 Sep: "When I uploaded an image to studio, I got auto bleed, not selected solid read
       from image"). A fresh file starts on Solid (a mode the customer chose before the upload is kept) and the colour
       is read from the finished artwork: the colour along its outer edge, next to the see-through area, or along the
       image's own frame when it has none. Read again whenever the artwork changes (background removal, erasing), so
       it follows what will actually be cut. Only while armed: a colour the customer picked is never replaced. */
    if(freshColour){
      clearAutoBleed();
      const armed = !(preArt.bg || opts.bgPicked);
      opts.bgEdge = edgeColour(plNoPaint(c));
      if(!preArt.bgMode){
        /* guard: an OPAQUE file with no single edge colour (a photo whose edges vary) keeps Auto, which continues the
           photo itself into the bleed, so a cut that drifts never shows a white sliver; every other file starts Solid */
        opts.bgMode = (!hasAlpha(c) && !opts.bgEdge) ? "auto" : "solid";
        if(opts.bgMode==="solid" && armed) opts.bg="#ffffff";
      }
      if(armed) opts.bgAutoArmed=true;
      preArt.shape=false; preArt.bgMode=false; preArt.bg=false;
    }
    if(opts.bgAutoArmed){ if(!freshColour) opts.bgEdge=edgeColour(plNoPaint(c)); autoBleed(); }
    if(freshColour){
      const seg=$("bgModeSeg");
      if(seg) [...seg.querySelectorAll("button")].forEach(b=>b.classList.toggle("on", b.dataset.v===opts.bgMode));
    }
    trimRatio=art.width/preW;
    mask0=hardenAlpha(silhouette(art,"#fff")); /* geometry copy hardened (>=96 alpha counts as ink) - a faint baked-in glow must not drag the cut line out; measured 27 Aug 2026 on order 8885, 8.7mm border at a 2.0mm setting before this */
    plClearPaint();   /* FILL BRUSH (21 Oct 2026): mask0 keeps the paint, the drawn artwork lets the border show */

    /* SOFT EDGE (20 Oct 2026): a NEW file whose outer edge fades out (a glow, a soft shadow) arms the 1 mm inset: when the
       customer turns the border off, the die-cut is traced 1 mm inside the artwork, so the cut never sits on a faint edge
       over a flat bleed colour (the 18 Oct order's white triangles). The file itself opens like any other, Add border on
       and the ordinary colour default (the owner, 20 Oct evening: "open own-edge files with Add border on by default";
       the first cut opened them border-off on Auto, which painted the border from thin edge text). Crisp art: softInset 0. */
    if(softFresh){
      let soft=false;
      if(!softOwn()){
        const se=softEdgeOf(art), mm=se.rampPx*widthMm()/Math.max(1,Math.max(art.width,art.height));
        soft = se.rampPx>=SOFT_EDGE_MIN_PX && mm>=SOFT_EDGE_MIN_MM;
      }
      opts.softInset = soft ? SOFT_INSET_MM : 0;   /* armed only; the border and the colour stay at their defaults */
    }
    // Build the inner-bleed ring ONCE, here, while the artwork is being ingested.
    // Doing it per scene build hung the tool: two full-canvas dilations plus an
    // invert on every render. It only depends on the artwork, so it belongs here.
    innerRing = buildInnerRing();
    measureArt();
    if(plC0){ try{ plDecontaminate(plC0, plCW, plCH); }catch(e){} }   /* the cut (mask0) is already taken: only the drawn edge changes */
    dilCache={}; dilPad=0;
    opts.offX=0; opts.offY=0;
    palette=extractPalette(art);
    paletteLight=palette.map(lighten);
    renderSwatches(); renderRemoveChips();
    try{ plSvgSyncUI(); }catch(e){}
    $("note").classList.remove("show");
    syncDustNote();
    syncOwnCutUI();   /* P215 */
    coverageHint();
    updateDpi();
    $("drop").classList.add("hidden");
    $("preview").classList.remove("hidden");
    $("canvasTools").style.display="flex";
    $("zoomctl").style.display="flex";
    setZoom(1);
    ["dlProof","dlPrint","dlCut","dlZip"].forEach(id=>$(id).disabled=false);
    render();
    updateDims();
    $("spin").classList.remove("show");
    if(cb) cb();
  },30);
}

/* ================= authored: solid / gradient fill ================= */
function bgFill(x,bb){
  if(opts.bgMode!=="gradient") return opts.bg;
  const a=(opts.bgAngle-90)*Math.PI/180;
  const cx=bb.x+bb.w/2, cy=bb.y+bb.h/2;
  const L=Math.max(1,(Math.abs(bb.w*Math.cos(a))+Math.abs(bb.h*Math.sin(a)))/2);
  const g=x.createLinearGradient(cx-Math.cos(a)*L, cy-Math.sin(a)*L, cx+Math.cos(a)*L, cy+Math.sin(a)*L);
  /* Thomas, 18 Sep, a sticker that drew nothing but its cut line: opts.bgFrom was "#101f9eb",
     seven hex digits, built by the auto palette before it clamped. addColorStop THROWS on a colour
     it cannot parse, which aborted the whole scene draw and left the artwork invisible. The palette
     is fixed above; this is the guard, because one bad colour must never cost the customer their
     artwork. Records already saved with a bad value are repaired here too. */
  g.addColorStop(0, printSafe(safeHex(opts.bgFrom, "#ffffff")));
  g.addColorStop(1, printSafe(safeHex(opts.bgTo, "#ffffff")));
  return g;
}
function maskBBox(c){
  const {width:w,height:h}=c;
  const a=c.getContext("2d").getImageData(0,0,w,h).data;
  let x0=w,x1=-1,y0=h,y1=-1;
  for(let y=0;y<h;y++)for(let x=0;x<w;x++){
    if(a[(y*w+x)*4+3]>128){
      if(x<x0)x0=x; if(x>x1)x1=x;
      if(y<y0)y0=y; if(y>y1)y1=y;
    }
  }
  if(x1<x0) return {x:0,y:0,w,h};
  return {x:x0,y:y0,w:x1-x0+1,h:y1-y0+1};
}
/* recolour a mask with the current background; gradient spans the mask's
   own bounding box so preview and cropped exports paint identically */
function recolourWith(maskCanvas,colour){
  const c=mk(maskCanvas.width,maskCanvas.height), x=c.getContext("2d");
  x.drawImage(maskCanvas,0,0); x.globalCompositeOperation="source-in"; x.fillStyle=colour; x.fillRect(0,0,c.width,c.height);
  return c;
}
function recolourBg(maskCanvas,bb){
  const c=mk(maskCanvas.width,maskCanvas.height), x=c.getContext("2d");
  x.drawImage(maskCanvas,0,0);
  x.globalCompositeOperation="source-in";
  x.fillStyle=bgFill(x, bb||maskBBox(maskCanvas));
  x.fillRect(0,0,c.width,c.height);
  return c;
}

/* SEAM UNDERLAY (P230, Thomas 15 Oct 2026, order 9836 postal rat, job 1983601).
   With the bleed colour read from the artwork's edge (bgAutoPick), the cut area is laid
   white first so holes and real gaps stay white. But the same white sat under two things
   that are not gaps: the artwork's own soft edge (her blue fades out over a few pixels;
   laid on white those printed 242,252,254 to pure white, a broken white line just inside
   the cut) and the pocket between the artwork and a cut line that rounds an inside corner
   (a white wedge by the bag). AI/_rules/LAB-RULES.md rule 1.
   Two rules, kept apart (Opus reviews 15 Oct: mixing them filled an antialiased i-gap and
   semi-transparent artwork):
   1. CLEAR pixels (art alpha < 24) inside the cut take the bleed colour only as a POCKET:
      a component of clear pixels that reaches the cut along ONE stretch, lies within D of
      the cut (D = 0.2mm + 0.6 x smoothing, capped at 0.8mm: the wedge a rounded inside
      corner leaves) and leads into nothing deeper. A gap the customer drew - an i's dot,
      a stencil channel - meets the cut at both ends; a counter, a slit or a bay is deeper.
   2. FAINT pixels (24-229, the artwork's own soft edge) get the bleed colour beneath them
      only in a thin band along the cut (0.15mm) or right beside a pocket. Never by component,
      so semi-transparent artwork away from the cut is laid on white exactly as before.
   Built once per cut mask, cropped to the sticker, cached with D; a render only draws it. */
const sliverCache = new WeakMap();
function pocketDepthPx(){
  const ppm=pxPerMm(), mm=Math.min(0.8, 0.2+0.6*Math.max(0,+opts.smoothMm||0));
  return Math.max(2, Math.round(mm*ppm));
}
function edgePockets(borderM){
  const D=pocketDepthPx();
  const hit=sliverCache.get(borderM);
  if(hit && hit.art===art && hit.D===D) return hit;
  const res={art, D, x0:0, y0:0, cut:null, m:null, bb:null, under:null, key:null};
  try {
    const W=borderM.width, H=borderM.height;
    /* the cut, hardened at 50% and cropped to the sticker: keepInk tabs leave borderM at
       alpha 1-120 OUTSIDE the cut, which laid a faint white over the bleed (review 1, item 5) */
    const full=mk(W,H); full.getContext("2d").drawImage(borderM,0,0); hardenAlpha(full,128);
    const bb=maskBBox(full); res.bb=bb;
    const x0=Math.max(0,bb.x-2), y0=Math.max(0,bb.y-2), x1=Math.min(W,bb.x+bb.w+2), y1=Math.min(H,bb.y+bb.h+2);
    const cw=x1-x0, ch=y1-y0, N=cw*ch;
    const cut=mk(cw,ch); cut.getContext("2d").drawImage(full,-x0,-y0); full.width=0; full.height=0;
    res.cut=cut; res.x0=x0; res.y0=y0;
    const inCut=new Uint8Array(N);
    { const d=cut.getContext("2d").getImageData(0,0,cw,ch).data; for(let i=0;i<N;i++) if(d[i*4+3]) inCut[i]=1; }
    const A=new Uint8Array(N);   /* artwork alpha inside the cut, 255 outside */
    { const t=mk(cw,ch), tx=t.getContext("2d"); tx.drawImage(art,dilPad-x0,dilPad-y0);
      const d=tx.getImageData(0,0,cw,ch).data; t.width=0; t.height=0;
      for(let i=0;i<N;i++) A[i]=inCut[i] ? d[i*4+3] : 255; }
    const out=(x,y)=>x<0||y<0||x>=cw||y>=ch||!inCut[y*cw+x];
    const atCut=(x,y)=>out(x-1,y)||out(x+1,y)||out(x,y-1)||out(x,y+1)||out(x-1,y-1)||out(x+1,y-1)||out(x-1,y+1)||out(x+1,y+1);
    const fill=new Uint8Array(N);
    /* rule 1: clear pockets */
    const dist=new Uint8Array(N).fill(255), q=[], Dc=Math.min(250,D);
    for(let y=0;y<ch;y++) for(let x=0;x<cw;x++){ const i=y*cw+x; if(inCut[i] && A[i]<24 && atCut(x,y)){ dist[i]=1; q.push(i); } }
    for(let h=0;h<q.length;h++){
      const i=q[h], dd=dist[i]; if(dd>Dc) continue;
      const x=i%cw, y=(i-x)/cw;
      for(let dy=-1;dy<=1;dy++) for(let dx=-1;dx<=1;dx++){
        const xx=x+dx, yy=y+dy; if(xx<0||yy<0||xx>=cw||yy>=ch) continue;
        const j=yy*cw+xx; if(inCut[j] && A[j]<24 && dist[j]===255){ dist[j]=dd+1; q.push(j); }
      }
    }
    const seen=new Uint8Array(N), st=[], comp=[];
    for(let h=0;h<q.length;h++){
      const s0=q[h]; if(seen[s0] || dist[s0]>Dc) continue;
      comp.length=0; st.push(s0); seen[s0]=1; let deep=false;
      while(st.length){
        const i=st.pop(); comp.push(i);
        const x=i%cw, y=(i-x)/cw;
        for(let dy=-1;dy<=1;dy++) for(let dx=-1;dx<=1;dx++){
          const xx=x+dx, yy=y+dy; if(xx<0||yy<0||xx>=cw||yy>=ch) continue;
          const j=yy*cw+xx; if(!inCut[j] || A[j]>=24) continue;
          if(dist[j]>Dc){ deep=true; continue; }
          if(!seen[j]){ seen[j]=1; st.push(j); }
        }
      }
      if(deep) continue;
      const contact=new Set(); comp.forEach(i=>{ if(dist[i]===1) contact.add(i); });
      let runs=0; const done=new Set();
      for(const c0 of contact){
        if(done.has(c0)) continue; if(++runs>1) break;
        const s2=[c0]; done.add(c0);
        while(s2.length){ const i=s2.pop(), x=i%cw, y=(i-x)/cw;
          for(let dy=-1;dy<=1;dy++) for(let dx=-1;dx<=1;dx++){ const xx=x+dx, yy=y+dy; if(xx<0||yy<0||xx>=cw||yy>=ch) continue;
            const j=yy*cw+xx; if(contact.has(j) && !done.has(j)){ done.add(j); s2.push(j); } } }
      }
      /* aspect gate (Opus review 3): a wedge left by a rounded inside corner is wider along the cut than it is
         deep (at least twice); a drawn gap sealed at one end (a soft shadow across an i) or a narrow drawn notch is not */
      let depth=0; for(const i of comp) if(dist[i]>depth) depth=dist[i];
      /* 2x: a 90-degree rounded corner is ~3.8x, a sealed letter gap ~1.4x (review 4). A speck no deeper than
         0.2mm is too shallow to be anything drawn, so it fills whatever its shape (single loose pixels) */
      if(runs===1 && (contact.size>=2*depth || depth<=Math.max(1,Math.round(0.2*pxPerMm())))) for(const i of comp) fill[i]=1;
    }
    /* rule 2: faint pixels in a thin band along the cut (straight-line distance to the edge pixel the walk
       started from, so the band is the same 0.15mm on a diagonal), or touching a filled pocket */
    const band=Math.max(2, Math.round(0.15*pxPerMm()));
    const bd=new Uint8Array(N).fill(255), src=new Int32Array(N).fill(-1), q2=[];
    for(let y=0;y<ch;y++) for(let x=0;x<cw;x++){ const i=y*cw+x; if(inCut[i] && atCut(x,y)){ bd[i]=1; src[i]=i; q2.push(i); } }
    for(let h=0;h<q2.length;h++){
      const i=q2[h], x=i%cw, y=(i-x)/cw, s0=src[i], sx=s0%cw, sy=(s0-sx)/cw;
      for(let dy=-1;dy<=1;dy++) for(let dx=-1;dx<=1;dx++){
        const xx=x+dx, yy=y+dy; if(xx<0||yy<0||xx>=cw||yy>=ch) continue;
        const j=yy*cw+xx; if(!inCut[j] || bd[j]!==255) continue;
        if(Math.hypot(xx-sx,yy-sy)+1>band) continue;
        bd[j]=1; src[j]=s0; q2.push(j);
      }
    }
    let n=0;
    for(let y=0;y<ch;y++) for(let x=0;x<cw;x++){
      const i=y*cw+x; if(!inCut[i]) continue;
      if(fill[i]===1){ n++; continue; }
      if(A[i]>=24 && A[i]<230){
        let near=bd[i]!==255;
        for(let dy=-2;dy<=2&&!near;dy++) for(let dx=-2;dx<=2&&!near;dx++){
          const xx=x+dx, yy=y+dy; if(xx<0||yy<0||xx>=cw||yy>=ch) continue;
          if(fill[yy*cw+xx]===1) near=true;
        }
        if(near){ fill[i]=2; n++; }
      }
    }
    if(n){
      const mc=mk(cw,ch), mcx=mc.getContext("2d"), md=mcx.createImageData(cw,ch), a=md.data;
      for(let i=0;i<N;i++) if(fill[i]){ a[i*4]=a[i*4+1]=a[i*4+2]=255; a[i*4+3]=255; }
      mcx.putImageData(md,0,0); res.m=mc;
    }
  } catch(e){ console.warn("seam underlay skipped:",e); res.m=null; res.cut=null; res.failed=true; }
  sliverCache.set(borderM,res);
  return res;
}
/* Lay the underlay for an edge-coloured bleed onto ctx, with the cut mask's origin at (ox,oy):
   white inside the (hardened) cut, bleed colour in the pockets and the soft edge band. The
   cropped result is cached per colour, so a render only draws it; the fill is laid in the
   cut mask's own coordinates, so a gradient lines up with the bleed it continues. */
function drawSeamUnderlay(ctx, borderM, ox, oy){
  let P=edgePockets(borderM);
  const key=[opts.bgMode,opts.bg,opts.bgFrom,opts.bgTo,opts.bgAngle].join("|");
  if(!(P.under && P.key===key) && !P.cut && !P.failed){ sliverCache.delete(borderM); P=edgePockets(borderM); }   /* a new colour: rebuild the geometry (it was released) */
  if(P.failed || (!P.cut && !P.under)){ ctx.drawImage(recolourWith(borderM,"#ffffff"),ox,oy); return; }
  if(!(P.under && P.key===key)){
    const c=recolourWith(P.cut,"#ffffff");
    if(P.m){
      const cx=c.getContext("2d");
      cx.globalCompositeOperation="source-over";   /* recolourWith leaves the context in source-in */
      const t=mk(P.m.width,P.m.height), tx=t.getContext("2d");
      tx.drawImage(P.m,0,0); tx.globalCompositeOperation="source-in";
      tx.translate(-P.x0,-P.y0); tx.fillStyle=bgFill(tx,P.bb); tx.fillRect(P.x0,P.y0,P.m.width,P.m.height);
      cx.drawImage(t,0,0); t.width=0; t.height=0;
    }
    if(P.under){ P.under.width=0; P.under.height=0; }
    P.under=c; P.key=key;
    /* keep ONE cropped canvas per design (packs keep every design's masks): the geometry is
       rebuilt in a few ms if the colour ever changes (Opus review 2, item 5) */
    if(P.cut){ P.cut.width=0; P.cut.height=0; P.cut=null; }
    if(P.m){ P.m.width=0; P.m.height=0; P.m=null; }
  }
  ctx.drawImage(P.under, ox+P.x0, oy+P.y0);
}

/* ================= authored: scene building & preview ================= */
function buildScene(){
  if(traced()){
    const R=borderPx();
    const bleedPx=Math.round(BLEED_MM*pxPerMm());
    ensurePad(scenePad());
    const borderM=dilateMask(R);
    baseScene=mk(borderM.width,borderM.height);
    const x=baseScene.getContext("2d");
    if(opts.bgMode==="auto")
      x.drawImage(autoBleedFill(borderM, R+Math.round(BLEED_MM*pxPerMm())+4),0,0);
    else if(opts.bgAutoPick)
      drawSeamUnderlay(x,borderM,0,0);   /* inside the cut: white as before, edge slivers in the bleed colour (P230); the edge colour is the bleed only */
    else
      x.drawImage(recolourBg(borderM,maskBBox(borderM)),0,0);
    /* 18 Oct 2026 (P215): in own-cut mode the artwork can run past the customer's line; the sticker shows it to the
       line and the 50% ghost shows the rest of it in the bleed */
    const own=ownCut();
    if(own) x.drawImage(clipToMask(art,borderM,dilPad),0,0);
    else x.drawImage(art,dilPad,dilPad);
    if(wantGhost) try{
      bleedGhost=null;
      const bm=dilateMask(R+bleedPx);
      bleedGhost = opts.bgMode==="auto" ? autoBleedFill(bm, R+bleedPx+4) : recolourBg(bm, maskBBox(borderM));
      if(own) bleedGhost.getContext("2d").drawImage(clipToMask(art,bm,dilPad),0,0);
      bleedGhostOff=[0,0];
    }catch(e){ bleedGhost=null; }
    if(own){ cutStroke={path:ownCutPath(dilPad,dilPad), ref:Math.max(baseScene.width,baseScene.height)}; return; }   /* their path; no trace, no refine */
    let pts=traceContour(borderM);
    pts=refineContour(pts, pxPerMm()).pts;
    const p=new Path2D();
    if(pts.length>2){
      p.moveTo(pts[0][0],pts[0][1]);
      for(let i=1;i<pts.length;i++) p.lineTo(pts[i][0],pts[i][1]);
      p.closePath();
    }
    cutStroke={path:p, ref:Math.max(baseScene.width,baseScene.height)};
  } else {
    const d=shapeDims();
    baseScene=mk(d.w,d.h);
    const x=baseScene.getContext("2d");
    x.imageSmoothingQuality="high";
    const sc=shapeScale(d);
    const artX=d.w/2-artCx*sc+opts.offX, artY=d.h/2-artCy*sc+opts.offY;
    if(wantGhost) try{
      bleedGhost=null;
      const bpx=Math.min(d.m-1, Math.round(BLEED_MM*(d.sw/widthMm())));
      if(bpx>0){
        const g=mk(d.w,d.h), gx=g.getContext("2d");
        if(opts.bgMode==="auto"){
          const Rs=Math.min(300,Math.ceil(Math.max(d.sw,d.sh)/(2*Math.max(0.01,sc))));   /* the main scene's radius: cache hit */
          gx.save(); tracePathOn(gx,d,bpx); gx.clip(); gx.fillStyle="#ffffff"; gx.fillRect(0,0,d.w,d.h);
          const La=autoBleedArt(Rs); gx.drawImage(La, artX-Rs*sc, artY-Rs*sc, La.width*sc, La.height*sc); gx.restore();
        } else { tracePathOn(gx,d,bpx); gx.fillStyle=bgFill(gx,{x:d.m,y:d.m,w:d.sw,h:d.sh}); gx.fill(); }
        bleedGhost=g; bleedGhostOff=[0,0];
      }
    }catch(e){ bleedGhost=null; }
    if(opts.bgMode==="auto"){
      // white base in case the dilation cannot reach a far corner, then the
      // edge-extended artwork clipped to the shape, then the artwork itself
      tracePathOn(x,d); x.fillStyle="#ffffff"; x.fill();
      const Rs=Math.min(300,Math.ceil(Math.max(d.sw,d.sh)/(2*Math.max(0.01,sc))));
      const L=autoBleedArt(Rs);
      x.save(); tracePathOn(x,d); x.clip();
      x.drawImage(L, artX-Rs*sc, artY-Rs*sc, L.width*sc, L.height*sc);
      x.restore();
    } else {
      tracePathOn(x,d); x.fillStyle=bgFill(x,{x:d.m,y:d.m,w:d.sw,h:d.sh}); x.fill();
    }
    x.save(); tracePathOn(x,d); x.clip();
    x.drawImage(art, artX, artY, art.width*sc, art.height*sc);
    x.restore();
    const p=new Path2D();
    tracePathOn(p,d);
    cutStroke={path:p, ref:d.sw};
  }
}
/* cut line preview: animated rainbow marching ants, as on the bookmark tool */
function rainbowConic(ctx,w,h,angle){
  if(ctx.createConicGradient){
    const g=ctx.createConicGradient(angle-Math.PI/2,w/2,h/2);
    RAINBOW.forEach((c,i)=>g.addColorStop(i/(RAINBOW.length-1),c));
    return g;
  }
  const g=ctx.createLinearGradient(0,0,w,h);
  RAINBOW.forEach((c,i)=>g.addColorStop(i/(RAINBOW.length-1),c));
  return g;
}
function drawFrame(target,tMs,withCut,onScreen){
  const x=target.getContext("2d");
  x.clearRect(0,0,target.width,target.height);
  if(onScreen && bleedGhost){ x.save(); x.globalAlpha=0.5; x.drawImage(bleedGhost,bleedGhostOff[0],bleedGhostOff[1]); x.restore(); }
  x.drawImage(baseScene,0,0);
  if(withCut && cutStroke){
    const angle=(tMs%6000)/6000*Math.PI*2;          // one rainbow revolution every 6s
    x.strokeStyle=rainbowConic(x,target.width,target.height,angle);
    x.lineWidth=Math.max(2.5,cutStroke.ref/300);
    const on=cutStroke.ref/55, off=cutStroke.ref/75;
    x.setLineDash([on,off]);
    x.lineDashOffset=-(tMs%100000)/1000*(on+off);   // marching ants
    x.stroke(cutStroke.path);
    x.setLineDash([]); x.lineDashOffset=0;
  }
}
/* ===== v2.9: THE ORDER CANVAS (Thomas, 17 Sep, notes 5 and 11) ==================
   On ORDER the canvas shows EVERY design in the pack together, each finished in the
   selected vinyl (matte, gloss, glitter) by holo-proof.js, with a static thin cut line
   and no marching ants. The renderer and its two textures load on the first ORDER
   open; until they arrive the plain scenes are drawn. Leaving ORDER puts the live
   design and its animated cut line back. */
let orderView=false, orderFinish="matte", holoMod=null, holoLoad=null, orderDrawing=false, orderRenderMs=0;
function holoReady(){
  if(holoLoad) return holoLoad;
  const h=(root.host&&root.host.dataset)||{};
  /* v2.9.2 (R6): behind the section setting. Off = nothing is imported or fetched; the plain scenes draw. */
  if(h.finishPreview!=="1" || !h.holoJs) return (holoLoad=Promise.resolve(null));
  /* the print response maps the artwork's screen colours to what the Epson actually prints on
     white vinyl before any film goes over it. Without it a preview is far too bright and too
     saturated: artwork 255,0,255 prints as 181,49,151. It is optional, so a finish still draws
     if the table is missing, just uncorrected. */
  holoLoad=import(h.holoJs).then(m=>Promise.all([
    m.loadHoloTextures(null,{ gloss:h.holoGloss, glitter:h.holoGlitter }),
    h.holoPrint ? m.loadPrintResponse(h.holoPrint).catch(e=>console.warn('[proof-lab] print response unavailable:',e&&e.message)) : null
  ]).then(()=>{
    /* a look's own texture (Oil Spill for magnets), beside holo-gloss.webp; if it fails only that
       look falls back to the plain artwork, the other finishes still draw */
    if(!FINISH_LOOK.holo || !h.holoGloss) return;
    return m.loadHoloTextures(null,{ oil:String(h.holoGloss).replace(/holo-gloss\.webp(\?[^#]*)?/, "holo-oil-spill.webp") })
      .catch(e=>console.warn("[proof-lab] oil spill texture unavailable:",e&&e.message));
  }).then(()=>{ holoMod=m; return m; }));
  holoLoad.catch(e=>console.warn("[proof-lab] finish renderer unavailable:",e&&e.message));
  return holoLoad;
}
/* A finish is drawn only when the renderer has a look for it (matte, gloss, glitter). Holographic
   (Custom Magnets) has none on the theme yet, so it shows the plain finished artwork, never another
   finish's look. */
function finishDrawable(){ return !!(holoMod && holoMod.HOLO_PRESETS && Object.prototype.hasOwnProperty.call(holoMod.HOLO_PRESETS, lookOf(orderFinish))); }
function setOrderView(on, finishId){
  if(finishId) orderFinish=finishId;
  const was=orderView; orderView=!!on;
  if(orderView){
    if(animRaf){ cancelAnimationFrame(animRaf); animRaf=0; }
    drawOrderPreview();
    if(!holoMod) holoReady().then(()=>{ if(orderView) drawOrderPreview(); }).catch(()=>{});
  } else if(was && art) render();
}
/* THE STICKER AS IT WILL BE CUT, for every mock-up (Thomas, 28 Sep: "I also selected 6mm rectangle border, and the mock
   up was the image, no corner rounded"). A traced shape (die-cut, Corners) draws its artwork and bleed square, and the
   cut line rounds the corners; the mock-ups showed the scene, not the cut. Clipped to the cut path here, so a rounded
   corner is rounded in the downloads mock-up, the order screen, its viewer and the Final check. Circle and square
   scenes are already drawn inside their shape. */
function cutScene(){
  if(!baseScene || !traced() || !cutStroke || !cutStroke.path) return baseScene;
  const c=mk(baseScene.width, baseScene.height), x=c.getContext("2d");
  x.save(); x.clip(cutStroke.path); x.drawImage(baseScene,0,0); x.restore();
  return c;
}
/* v2.9.1: each design's built scene is cached on its doc (key: options incl. pack size, artwork, erase, trim; render() drops it) so a finish change only re-runs renderHolo and the composite */
let artSeq=0;
function sceneKey(o,a,e,t){ return JSON.stringify(o,Object.keys(o).sort())+"|"+(a.__id||(a.__id=++artSeq))+"|"+(e?e.length:0)+"|"+(t?t.x+","+t.y:""); }
function docSceneKey(d){ return sceneKey(cloneOpts(d.opts||{}),d.art,d.eraseStrokes,d.trimOff); }   /* 2 Oct: a design's own size, never the pack's */
function sceneOf(d){
  if(!art) return null;
  const k=sceneKey(opts,art,eraseStrokes,trimOff);
  if(d&&d.orderScene&&d.orderScene.key===k) return d.orderScene;
  buildScene();
  const c=mk(baseScene.width,baseScene.height);
  c.getContext("2d").drawImage(cutScene(),0,0);
  const sc={ key:k, scene:c, cut:cutStroke?{ path:cutStroke.path, ref:cutStroke.ref }:null, mm:baseScene.width*sceneMmPerPx() };
  if(d) d.orderScene=sc;
  return sc;
}
function orderScenes(){
  const out=[];
  /* withDoc -> captureDoc nulls the ACTIVE design's thumbnail; nothing changed here, so it is kept */
  const keep=(activeIdx>=0&&docs[activeIdx])?docs[activeIdx].thumb:null;
  docs.forEach((d,i)=>{
    if(!(d&&(d.art||(i===activeIdx&&art)))) return;
    try{ const sc=(i===activeIdx)?sceneOf(d):(d.orderScene&&d.orderScene.key===docSceneKey(d))?d.orderScene:withDoc(i,()=>sceneOf(d)); if(sc){ sc.slot=i+1; out.push(sc); } }catch(e){ console.warn("[proof-lab] order scene failed for design "+(i+1),e); }
  });
  if(keep && activeIdx>=0 && docs[activeIdx] && !docs[activeIdx].thumb) docs[activeIdx].thumb=keep;
  return out;
}
function drawOrderBadge(x, n, dx, dy, cv, scene, f){
  /* v4.2 (Thomas: "the 1 is getting lost"): sized against the canvas's ON-SCREEN width, so it is 40 CSS
     px whatever the canvas zoom (it was scaled by the fit zoom, ~26px on a desktop ORDER screen), with a
     white ring so it reads on artwork and on the dotted ground */
  let per=1;
  try{ const r=cv.getBoundingClientRect(); if(r.width>0) per=cv.width/r.width; }catch(e){ per=1; }
  const R=20*per, ring=3*per;
  let cx=dx+R+2*per, cy=dy+R+2*per;
  /* v4.3 (Thomas: "clipping and too far away from artwork"): the box's corner is empty on a shaped
     sticker, so the badge walks the diagonal from that corner to the first opaque pixel and sits just
     outside it; then it is kept whole inside the canvas */
  try{
    if(scene && f>0){
      const sx=scene.getContext("2d"), sw=scene.width, sh=scene.height, L=Math.hypot(sw,sh)||1;
      for(let i=0;i<=60;i++){
        const t=i/120, px=Math.min(sw-1,Math.round(sw*t)), py=Math.min(sh-1,Math.round(sh*t));
        if(sx.getImageData(px,py,1,1).data[3]>24){
          const off=R+ring+6*per;
          cx=dx+px*f-(sw/L)*off; cy=dy+py*f-(sh/L)*off;
          break;
        }
      }
    }
  }catch(e){}
  const lim=R+ring+2*per;
  cx=Math.max(lim,Math.min(cv.width-lim,cx)); cy=Math.max(lim,Math.min(cv.height-lim,cy));
  x.save();
  x.beginPath(); x.arc(cx,cy,R+3*per,0,Math.PI*2); x.fillStyle="#ffffff"; x.fill();
  x.beginPath(); x.arc(cx,cy,R,0,Math.PI*2); x.fillStyle="#1fab63"; x.fill();
  x.fillStyle="#ffffff"; x.textAlign="center"; x.textBaseline="middle";
  x.font=Math.round(17*per)+"px Sapiens, 'SF Pro Text', -apple-system, sans-serif";
  x.fillText(String(n), cx, cy+0.5*per);
  x.restore();
}
window.addEventListener("resize",()=>{ if(orderView) try{ drawOrderPreview(); }catch(e){} });
function drawOrderPreview(){
  if(!orderView || orderDrawing) return;
  orderDrawing=true;
  try{
    let scenes=orderScenes(); if(!scenes.length) return;
    /* P170: on the downloads page the canvas shows the design on screen, big, in its finish */
    if(PL_DOWNLOADS){ const one=scenes.filter(sc=>sc.slot===activeIdx+1); if(one.length) scenes=one; else scenes=[scenes[0]]; }
    const cv=$("preview");
    let W=(baseScene&&baseScene.width)||scenes[0].scene.width, H=(baseScene&&baseScene.height)||scenes[0].scene.height;
    const n=scenes.length;
    let cols=n>1?2:1, rows=n>2?2:1;
    /* P170 (Thomas, 28 Sep 01:35, on DOWNLOADS: "why are they so small?"): the canvas was the shape of one
       design, so the stage fitted a small portrait box and the 2x2 grid filled a third of it. On the
       downloads page the canvas takes the stage's own shape and the designs take the layout (columns x
       rows) that gives each the biggest cell. */
    if(PL_DOWNLOADS){
      try{
        const st=$("stage"), r=st?st.getBoundingClientRect():null;
        if(r && r.width>80 && r.height>80){
          const aw=r.width-90, ah=r.height-90, L=Math.max(1400, W, H);
          if(aw>=ah){ W=L; H=Math.round(L*ah/aw); } else { H=L; W=Math.round(L*aw/ah); }
          let best=0;
          for(let c=1;c<=n;c++){ const rr=Math.ceil(n/c), cell=Math.min(W/c, H/rr); if(cell>best){ best=cell; cols=c; rows=rr; } }
        }
      }catch(e){}
    }
    if(cv.width!==W||cv.height!==H){ cv.width=W; cv.height=H; }
    cv.classList.remove("hidden");
    const x=cv.getContext("2d"); x.clearRect(0,0,W,H);
    const gap=n>1?Math.round(Math.min(W,H)*0.035):0;
    const cw=(W-gap*(cols+1))/cols, ch=(H-gap*(rows+1))/rows;
    const t0=performance.now();
    scenes.forEach((sc,k)=>{
      const c=k%cols, r=Math.floor(k/cols);
      const f=Math.min(cw/sc.scene.width, ch/sc.scene.height);
      const dw=sc.scene.width*f, dh=sc.scene.height*f;
      const dx=gap+c*(cw+gap)+(cw-dw)/2, dy=gap+r*(ch+gap)+(ch-dh)/2;
      let drawn=false;
      if(finishDrawable()){
        /* v2.9.1: render at the size the quarter is drawn (capped at 640), not always 640.
           v3.6 (Thomas: "why does the artwork get pixelated in order screen"): 640 was stretched to
           ~1900 device pixels on a desktop Retina canvas (x3). The cap is now the quarter's real size
           on screen in DEVICE pixels, 640 at least and 2048 at most (orderRenderMs is measured). */
        let shown=640;
        try{ const r=cv.getBoundingClientRect(); if(r.width>0) shown=Math.max(dw,dh)*(r.width/cv.width)*(window.devicePixelRatio||1); }catch(e){}
        const cap=Math.min(Math.max(dw,dh), Math.max(640, Math.min(2048, Math.round(shown))));
        const ms=Math.min(1, cap/Math.max(sc.scene.width,sc.scene.height));
        try{
          const out=holoMod.renderHolo(sc.scene,{ finish:lookOf(orderFinish), borderPx:0, stickerWidthMm:sc.mm, scale:ms });
          /* renderHolo pads its canvas by the border PLUS room for the contact shadow, which is
             (shadowMm + 3 x shadowSoft) millimetres and so depends on the depth settings. A fixed
             2 px crop drew the sticker smaller than its own scene rect while the cut line below is
             drawn at full scene scale, so the cut line sat wide of the colour (Thomas, 17 Sep: "the
             grey line is not even lined up"). Measure the pad from the canvas it actually returned,
             and place the SCENE rect on dx,dy,dw,dh so the shadow spills outside it rather than
             being cropped away. */
          const inW=Math.round(sc.scene.width*ms), inH=Math.round(sc.scene.height*ms);
          const padX=(out.width-inW)/2, padY=(out.height-inH)/2;
          const k2=dw/Math.max(1,inW);
          x.drawImage(out, dx-padX*k2, dy-padY*k2, out.width*k2, out.height*k2); drawn=true;
        }catch(e){ console.warn("[proof-lab] finish render failed:",e&&e.message); }
      }
      if(!drawn) x.drawImage(sc.scene,dx,dy,dw,dh);
      /* Thomas, 18 Sep: "they dont need any grey border, the 3d ness we applied is enough." The
         ORDER canvas is where he is looking at the finished product, so it shows the sticker as it
         will arrive: the bevel and the contact shadow give the edge. The cut line still draws on
         DESIGN, in colour, which is where the cut is actually being decided. */
      /* v2.9.2 (R12): the slot's green number at the design's top-left, 34 CSS px at any canvas scale; screen only */
      if(n>1) drawOrderBadge(x, sc.slot||(k+1), dx, dy, cv, sc.scene, dw/sc.scene.width);   /* one design: no number (P170) */
    });
    orderRenderMs=performance.now()-t0;
    root.host.dataset.orderRenderMs=orderRenderMs.toFixed(1);
    root.host.dataset.orderFinish=orderFinish+(finishDrawable()?"":"-plain");
    root.host.dataset.orderDesigns=String(n);
  } finally { orderDrawing=false; }
}
function render(){
  if(!art) return;
  if(orderView){ drawOrderPreview(); return; }
  if(activeIdx>=0&&docs[activeIdx]) docs[activeIdx].orderScene=null;
  wantGhost=true; try{ buildScene(); } finally{ wantGhost=false; }
  const cv=$("preview");
  cv.width=baseScene.width; cv.height=baseScene.height;
  cv.classList.toggle("draggable", !traced());
  if(animRaf) cancelAnimationFrame(animRaf);
  /* paint immediately so the preview exists even when rAF is throttled
     (background tab); the loop only drives the marching-ants animation */
  drawFrame(cv,0,opts.cut,true);
  const loop=ts=>{
    drawFrame(cv,ts,opts.cut,true);
    if(opts.cut && art && !document.hidden) animRaf=requestAnimationFrame(loop);
    else animRaf=0;
  };
  if(opts.cut) animRaf=requestAnimationFrame(loop);
}
document.addEventListener("visibilitychange",()=>{ if(!document.hidden && art && opts.cut) render(); });

/* view zoom: CSS transform on the centred canvas; drag pans when zoomed in */
function applyZoom(){
  const cv=$("preview");
  cv.style.transform="translate("+panX+"px,"+panY+"px) scale("+zoom+")";
  cv.classList.toggle("draggable", zoom>1 || !traced());
}
function setZoom(z){
  zoom=Math.max(0.35,Math.min(5,z));
  if(Math.abs(zoom-1)<0.01){ zoom=1; panX=0; panY=0; }
  applyZoom();
}

/* export scene: bg bleeds BLEED_MM past the cut, artwork may run into it.
   Cropped to the bleed extent so the document measures cut size + 1.5mm
   bleed per side (uncropped, the padded working canvas leaked into files -
   the same sizing bug fixed in the Bookmark Creator). exportBB is the crop
   offset in working-canvas px; cut geometry shifts by it in dlCut. */
let exportBB=null;
let lastBleedMask=null, lastBleedBB=null;   // the hardened silhouette, re-applied after the print rescale
/* which document that silhouette belongs to. A size match alone is not identity:
   two designs can trim to the same pixel box and silently swap masks. */
let docStamp=0, lastBleedStamp=-1;
let innerRing=null;                        // the band just inside the customer's own border edge
const INNER_BLEED_MM = 0.3;                // how far the bleed colour is carried inward
/* INNER BLEED. The hairline customers see is not at our bleed edge - it is at the
   edge of the border THEY drew into their own file. That border is antialiased, so its
   outermost pixels are near-white rather than white, they sit INSIDE the artwork where
   background removal cannot reach them at any strength, and against a flat bleed they
   read as a grey line. Measured on a real order: a ring of 246-254 greys, 29-45px deep.
   Carrying the bleed colour a short way inward covers it - the same technique Leonardo
   Design Studio documents, gated the same way, on the artwork's border being one colour.
   Built once at ingest; building it per render hung the browser. AI/_rules/LAB-RULES.md rule 2. */
function buildInnerRing(){
  if(!mask0) return null;
  const R = Math.max(2, Math.round(INNER_BLEED_MM*pxPerMm()));
  try {
    /* Build the ring from a HOLE-FILLED copy of the silhouette, never from mask0
       itself. mask0 traces every internal element, so the ring landed 0.3mm inside
       every stroke, star and letter as well as the outer edge - and a feature
       thinner than 2R has no inside left, so the ENTIRE feature became bleed
       colour. Measured on a real order 25 Aug 2026 (IMG_0349, an ornate line-art
       frame): 42% of the linework was narrower than 2R = 0.6mm and was painted out
       completely; the customer's pink background swallowed the design. Filling
       holes first makes a closed design one solid shape, so the ring lands only
       where the artwork meets our bleed - the seam rule 2 is actually about.
       AI/_rules/LAB-RULES.md rules 2 and 3. */
    const solid = mk(mask0.width, mask0.height);
    solid.getContext("2d").drawImage(mask0,0,0);
    fillHoles(solid);
    return ringInsideMask(solid, R);
  }
  catch(e){ console.warn("inner bleed skipped:", e); return null; }
}
/* The ring lying just INSIDE a mask's outline: mask minus mask-eroded-by-R.
   Erosion is invert -> dilate -> invert, the same trick smoothMask already uses. */
/* SEAM GATE. The inner bleed exists to hide ONE thing: the pale, antialiased
   fringe of a customer's own white-ish border showing as a grey line against our
   bleed. It must only fire where that is actually what is there. Carried
   blindly it paints the bleed colour over the artwork's own outline: on a real
   order 26 Aug 2026 (dinosaurs-doing-stuff-beefeater) it deleted 18,906 px of
   black keyline - the whole outline, horns, legs, feet and tail - while the
   preview and print PNG, which never run this path, were perfect.
   So: keep a ring pixel only where the artwork underneath is ALREADY within a
   whisker of the bleed colour. That is the "border is one colour" gate
   AI/_rules/LAB-RULES.md rule 2 describes and that was never implemented. */
const SEAM_TOL = 60;   // sum of |dR|+|dG|+|dB| still counted as "the same colour"
function gateRingToSeam(tintedRing, artCanvas){
  const c=mk(tintedRing.width,tintedRing.height), x=c.getContext("2d");
  x.drawImage(tintedRing,0,0);
  const rd=x.getImageData(0,0,c.width,c.height), d=rd.data;
  const a2=mk(c.width,c.height), ax=a2.getContext("2d");
  ax.drawImage(artCanvas,0,0);
  const ad=ax.getImageData(0,0,c.width,c.height).data;
  for(let i=0;i<d.length;i+=4){
    if(!d[i+3]) continue;
    if(ad[i+3]<24){ d[i+3]=0; continue; }              // no artwork here to cover
    const dist=Math.abs(ad[i]-d[i])+Math.abs(ad[i+1]-d[i+1])+Math.abs(ad[i+2]-d[i+2]);
    if(dist>SEAM_TOL) d[i+3]=0;                        // a real edge, not a seam
  }
  x.putImageData(rd,0,0);
  return c;
}
function ringInsideMask(maskCanvas, R){
  if(!maskCanvas || R<1) return null;
  const eroded = invert(dilateCanvas(invert(maskCanvas), R));
  const c = mk(maskCanvas.width, maskCanvas.height), x = c.getContext("2d");
  x.drawImage(maskCanvas,0,0);
  x.globalCompositeOperation="destination-out";
  x.drawImage(eroded,0,0);
  /* Survival gate: keep the ring only where something actually SURVIVED the
     erosion - i.e. where the shape is at least 2R thick and genuinely has an
     inside. Without it, anything thinner than 2R erodes to nothing, the
     "ring" is then the whole shape, and the bleed colour paints the shape out.
     A clean-up step must never consume something a human would call part of the
     design. AI/_rules/LAB-RULES.md rule 3. */
  x.globalCompositeOperation="destination-in";
  x.drawImage(dilateCanvas(eroded,R),0,0);
  x.globalCompositeOperation="source-over";
  return c;
}
function buildExportScene(){
  buildScene();
  if(traced()){
    const R=borderPx();
    const bleedPx=Math.round(BLEED_MM*pxPerMm());
    const borderM=dilateMask(R);
    // Harden ONCE, on the final outline only. Dilation stamps land at fractional
    // offsets and are bilinear-resampled, so the grown mask carries a multi-pixel
    // partial-alpha ramp; filled with the border colour that reads as a grey rim.
    // Hardening at every dilation step instead produces TWO hard steps - one at the
    // border radius, one at the bleed - which is a second visible line, not a fix.
    // AI/_rules/LAB-RULES.md rule 2.
    let bleedM=dilateCanvas(borderM,bleedPx);
    // Every addition below is wrapped: a download that throws leaves the spinner up
    // forever and the tool looks hung, which is far worse than the rim it fixes.
    try { bleedM=hardenAlpha(bleedM); } catch(e){ console.warn("harden skipped:",e); }

    const bb=maskBBox(bleedM);
    exportBB=bb;
    // Stash the hardened silhouette for the print rescale. This MUST sit after bb is
    // declared - it was above it, which threw "Cannot access 'bb' before initialization"
    // on every export and left the spinner running forever. The try/catch blocks around
    // the other additions did not help because the throw was outside them.
    lastBleedMask=bleedM; lastBleedBB=bb; lastBleedStamp=docStamp;
    const cutBB=maskBBox(borderM);
    const c=mk(bb.w,bb.h);
    const x=c.getContext("2d");
    if(opts.bgMode==="auto")
      x.drawImage(autoBleedFill(bleedM, R+bleedPx+4),-bb.x,-bb.y);
    else
      x.drawImage(recolourBg(bleedM,cutBB),-bb.x,-bb.y);
    if(opts.bgMode!=="auto" && opts.bgAutoPick) drawSeamUnderlay(x,borderM,-bb.x,-bb.y);   /* holes and gaps inside the cut stay white; edge slivers take the bleed colour (P230) */
    x.drawImage(art,dilPad-bb.x,dilPad-bb.y);
    try {
      /* Not after background removal. The overprint exists to blend a customer's
         own white-ish border into ours; once the background is keyed out, the
         artwork's outer edge is a clean cut edge with no fringe to hide, and
         carrying the bleed inward there just paints out their outline.
         Thomas, 26 Aug 2026. */
      if(innerRing && opts.bgMode!=="auto" && !opts.removeBg)
        x.drawImage(gateRingToSeam(recolourBg(innerRing,cutBB), art), dilPad-bb.x, dilPad-bb.y);
    }
    catch(e){ console.warn("inner bleed skipped:",e); }
    return c;
  }
  const d=shapeDims();
  const bleedPx=Math.round(BLEED_MM*(d.sw/widthMm()));
  const bb={x:Math.round(d.m-bleedPx), y:Math.round(d.m-bleedPx),
            w:Math.round(d.sw+2*bleedPx), h:Math.round(d.sh+2*bleedPx)};
  exportBB=bb;
  const c=mk(bb.w,bb.h);
  const x=c.getContext("2d");
  x.imageSmoothingQuality="high";
  x.translate(-bb.x,-bb.y);
  const sc=shapeScale(d);
  const artX=d.w/2-artCx*sc+opts.offX, artY=d.h/2-artCy*sc+opts.offY;
  let bleedFill="#ffffff";
  if(opts.bgMode==="auto"){
    tracePathOn(x,d,bleedPx); x.fillStyle="#ffffff"; x.fill();
    const Rs=Math.min(300,Math.ceil((Math.max(d.sw,d.sh)/2+bleedPx)/Math.max(0.01,sc)));
    const L=autoBleedArt(Rs);
    x.save(); tracePathOn(x,d,bleedPx); x.clip();
    x.drawImage(L, artX-Rs*sc, artY-Rs*sc, L.width*sc, L.height*sc);
    x.restore();
  } else {
    bleedFill=bgFill(x,{x:d.m,y:d.m,w:d.sw,h:d.sh});
    tracePathOn(x,d,bleedPx); x.fillStyle=bleedFill; x.fill();
  }
  x.save(); tracePathOn(x,d,bleedPx); x.clip();
  x.drawImage(art, artX, artY, art.width*sc, art.height*sc);
  x.restore();
  // Canvas clip() is antialiased and cannot be turned off, so along the bleed outline
  // the artwork blends with the fill beneath and leaves a ~1px grey rim, whatever the
  // two colours are. Clip to the same path and stroke it to lay the bleed colour back
  // over the blended pixels, inside only. AI/_rules/LAB-RULES.md rule 2.
  if(opts.bgMode!=="auto"){
    const ov=Math.max(2, bleedPx*0.1);
    x.save(); tracePathOn(x,d,bleedPx); x.clip();
    tracePathOn(x,d,bleedPx); x.lineWidth=2*ov; x.strokeStyle=bleedFill; x.stroke();
    x.restore();
  }
  x.setTransform(1,0,0,1,0,0);
  return c;
}

/* AUTO BLEED. Border and bleed grown from the artwork's own edge colours by
   true colour dilation - ring stamps of the artwork laid under itself with
   destination-over, so every edge pixel extends outward along the contour.
   Exact around die-cut shapes, unlike a strip smear. Cached per artwork+radius;
   invalidated automatically because the key carries both. Same feature shipped
   in Sticker Sheet Lab; keep the two in step (AI/_rules/LAB-RULES.md rule 6). */
let _autoBleed={key:null,c:null};
function autoBleedArt(Rpx){
  Rpx=Math.min(300,Math.max(2,Math.round(Rpx)));
  const key=art.width+"x"+art.height+":"+Rpx;
  if(_autoBleed.key===key) return _autoBleed.c;
  const c=mk(art.width+2*Rpx, art.height+2*Rpx), x=c.getContext("2d");
  /* Dilate from a HARDENED copy: the artwork's antialiased outer ring is
     semi-transparent, and stacking those faint dark pixels ring after ring
     produced black smears in the gaps between cut line and artwork. Only solid
     ink (alpha >= 200) may grow outward. Thomas, 26 Aug 2026. */
  const hardSrc=mk(art.width,art.height);
  hardSrc.getContext("2d").drawImage(art,0,0);
  try{ hardenAlpha(hardSrc,200); }catch(e){}
  x.drawImage(hardSrc,Rpx,Rpx);
  let rem=Rpx;
  while(rem>0){
    const st=Math.min(rem,6);
    const snap=mk(c.width,c.height); snap.getContext("2d").drawImage(c,0,0);
    x.globalCompositeOperation="destination-over";
    for(let k=0;k<16;k++){const a=k/16*Math.PI*2; x.drawImage(snap,Math.cos(a)*st,Math.sin(a)*st);}
    rem-=st;
  }
  x.globalCompositeOperation="source-over";
  _autoBleed={key,c};
  return c;
}
/* 18 Oct 2026 (P215): the traced scenes' Auto fill. A traced cut is never further from the ink than its border, so
   R + bleed reaches it; the customer's own line can be anywhere, so in own-cut mode the fill reaches the gap between
   the ink's box and the cut's box too, on white like the circle and square (a far corner it cannot reach is white,
   never see-through). Traced designs get exactly autoBleedMasked as before. */
function autoBleedFill(m,Rpx){
  if(!ownCut()) return autoBleedMasked(m,Rpx,dilPad,dilPad);
  const t=recolourWith(m,"#ffffff");
  t.getContext("2d").drawImage(autoBleedMasked(m,Rpx+ownGap(),dilPad,dilPad),0,0);
  return t;
}
function ownGap(){
  const f=custCut.xf; if(f.gap!=null) return f.gap;
  const ib=maskBBox(mask0), b=custCut.bb, x0=b.x*f.sx+f.ox, y0=b.y*f.sy+f.oy, x1=x0+b.w*f.sx, y1=y0+b.h*f.sy;
  f.gap=Math.ceil(Math.max(0, ib.x-x0, ib.y-y0, x1-(ib.x+ib.w), y1-(ib.y+ib.h)));
  return f.gap;
}
/* the dilated layer masked to a silhouette, for the custom-shape branches */
function autoBleedMasked(maskCanvas,Rpx,ox,oy){
  const layer=autoBleedArt(Rpx);
  const t=mk(maskCanvas.width,maskCanvas.height), tx=t.getContext("2d");
  tx.drawImage(layer, ox-Math.min(300,Math.max(2,Math.round(Rpx))), oy-Math.min(300,Math.max(2,Math.round(Rpx))));
  tx.globalCompositeOperation="destination-in";
  tx.drawImage(maskCanvas,0,0);
  return t;
}
/* ================= authored: size readout ================= */
function maskBBoxDims(maskCanvas){
  /* 2 Oct (perf.md fix A): a cached mask is measured once, not 35 times per size change */
  const bb0=maskCanvas.__bb;
  if(bb0 && bb0.cw===maskCanvas.width && bb0.ch===maskCanvas.height) return { w:bb0.w, h:bb0.h };
  const r=maskBBoxDims0(maskCanvas);
  try{ maskCanvas.__bb={ w:r.w, h:r.h, cw:maskCanvas.width, ch:maskCanvas.height }; }catch(e){}
  return r;
}
function maskBBoxDims0(maskCanvas){
  const {width:w,height:h}=maskCanvas;
  const a=maskCanvas.getContext("2d").getImageData(0,0,w,h).data;
  let x0=w,x1=-1,y0=h,y1=-1;
  for(let y=0;y<h;y++)for(let x=0;x<w;x++){
    if(a[(y*w+x)*4+3]>128){
      if(x<x0)x0=x; if(x>x1)x1=x;
      if(y<y0)y0=y; if(y>y1)y1=y;
    }
  }
  if(x1<x0) return {w:w,h:h};
  return {w:x1-x0+1, h:y1-y0+1};
}
/* THE FINISHED CUT SIZE IN MM - the same measurement TRUE SIZE prints under the
   canvas, factored out so the true-size quote asks about exactly the sticker the
   customer can see, not about the longest edge alone (v2.0, 12 Sep 2026). */
function cutSizeMm(){
  if(!art) return null;
  /* 2 Oct (perf.md fix A): padded as the scene is BEFORE anything is dilated, so a design measured
     off screen, or a new size measured before its render, is not dilated twice */
  if(traced()) ensurePad(scenePad());
  const mmpp=sceneMmPerPx();
  let wPx,hPx;
  if(ownCut()){ wPx=custCut.bb.w*custCut.xf.sx; hPx=custCut.bb.h*custCut.xf.sy; }   /* 18 Oct 2026 (P215): their path's exact box */
  else if(traced()){
    const d=maskBBoxDims(dilateMask(borderPx()));
    wPx=d.w; hPx=d.h;
  } else {
    const d=shapeDims();
    wPx=d.sw; hPx=d.sh;
  }
  const w=Math.round(wPx*mmpp*10)/10, h=Math.round(hPx*mmpp*10)/10;
  if(!(w>0&&h>0)) return null;
  return { w:w, h:h };
}
function updateDims(){
  try{ syncWH(); }catch(e){}
  plRmRowSync();   /* builder audit row 21 */
  const el=$("canvasDims");
  if(!art){ el.classList.remove("show"); return; }
  const d0=cutSizeMm();
  if(!d0){ el.classList.remove("show"); return; }
  /* v2.6: the readout names what the product is (data-noun), not always a sticker */
  const nounW=(function(){ const n=nounOne(String((root.host&&root.host.dataset.noun)||"sticker").trim())||nounOne("sticker"); return n.charAt(0).toUpperCase()+n.slice(1); })();
  /* builder audit row 15: TRUE SIZE in the active unit; the bleed stays in mm (a small width) */
  let dimsT=String(stkT("stk.studio.tool.dims","[noun] [w] × [h]cm · files add 1.5mm bleed"));
  if(sizeUnit==="in") dimsT=dimsT.replace("[h]cm","[h] "+plUnitLbl());
  $("dimText").textContent=stkFmt(dimsT,{noun:nounW,w:plLenTxt(d0.w),h:plLenTxt(d0.h)});
  el.querySelector("b").textContent=stkT("stk.studio.tool.true_size","TRUE SIZE");
  el.classList.add("show");
}

/* ================= authored: downloads ================= */
function proofCanvas(){
  buildScene();
  const c=mk(baseScene.width,baseScene.height);
  drawFrame(c,0,true);
  return c;
}
/* v1.5 fix, 12 Sep 2026. proofCanvas() keeps its transparency because the PNG
   download wants it. Every JPEG export must NOT: JPEG has no alpha, so a
   transparent sticker exported straight to image/jpeg comes back on BLACK.
   That is what the confirm window and the _Preview upload were showing. The lab
   canvas draws on white, so the proof does too. */
/* v2.9.2 (R8): the Final check proof draws the cut line as ORDER does - static, solid, thick enough at a quarter's size */
function proofCanvasCheck(){
  buildScene();
  /* Thomas, 18 Sep: "theres quite a delay now when pressing finish?" Each design's proof was built
     at PRINT resolution and then PNG encoded, and the encode is most of the cost: a 2000 px canvas
     is roughly ten times the work of a 640 px one, times four designs. This is a screen preview,
     so it is built at the size it is shown, which is also the size the finish is rendered at. */
  const capScale=Math.min(1, 640/Math.max(baseScene.width, baseScene.height));
  const cw=Math.max(1,Math.round(baseScene.width*capScale)), chh=Math.max(1,Math.round(baseScene.height*capScale));
  const c=mk(cw,chh);
  const x=c.getContext("2d");
  x.imageSmoothingQuality="high";
  /* Thomas, 18 Sep: "i clicked finish and the glitter finish isnt applied to the previews inside
     checker.. even if i zoom". The ORDER canvas rendered the finish and this did not, so the last
     thing a customer sees before paying was the only screen showing the wrong material. Same
     renderer, same alignment rule as drawOrderPreview: place the SCENE rect exactly and let the
     contact shadow spill outside it. Falls back to the plain scene if the renderer is not loaded. */
  let finished=false;
  if(finishDrawable()){
    try{
      const mm=(typeof cutSizeMm==="function" && cutSizeMm()) ? Math.max(cutSizeMm().w, cutSizeMm().h) : 75;
      /* Thomas, 18 Sep: "the finish checker finish of glitter is looking different to the order
         one? way way more subtle on finish check". The sparkle is drawn in millimetres, so its size
         in PIXELS depends on the resolution it is rendered at. ORDER renders the sticker capped at
         640 px and magnifies it; this was rendering at full print resolution, where a 0.07 mm point
         is about a quarter of a pixel and all but vanishes. Same cap here, then scale up, so the two
         screens show the same material rather than two readings of it. */
      const out=holoMod.renderHolo(cutScene(),{ finish:lookOf(orderFinish), borderPx:0, stickerWidthMm:mm, scale:capScale });
      const padX=(out.width-cw)/2, padY=(out.height-chh)/2;
      x.drawImage(out, -padX, -padY);
      finished=true;
    }catch(e){ console.warn("[proof-lab] final check finish failed:",e&&e.message); }
  }
  if(!finished) x.drawImage(cutScene(),0,0,cw,chh);
  /* Thomas, 18 Sep: "theres still a grey line around the previews in finish check". The cut line
     came off the ORDER canvas for the same reason and this is the other half of it: Final check is
     the last look at the finished product, so it shows the sticker, not the cut path. DESIGN still
     draws the cut line, in colour, which is where the cut is actually chosen. */
  return c;
}
function proofCanvasOnWhite(){
  const src=proofCanvas();
  const c=mk(src.width,src.height);
  const g=c.getContext("2d");
  g.fillStyle="#ffffff"; g.fillRect(0,0,c.width,c.height);
  g.drawImage(src,0,0);
  return c;
}
function dlProof(){
  proofCanvas().toBlob(b=>saveBlob(b,"PREVIEW-ONLY-"+outName("proof")+".png"),"image/png");
}
function dlPrint(){
  printCanvas(false).out.toBlob(b=>saveBlob(b,outName("print-300dpi")+".png"),"image/png");
}
function buildCutSVG(){
  const {out,scene,mmpp}=printCanvas(true);
  const W=(scene.width*mmpp).toFixed(2), H=(scene.height*mmpp).toFixed(2);
  const png=out.toDataURL("image/png");
  const stroke=`fill="none" stroke="${CUT_COLOUR}" stroke-opacity="1" stroke-width="${CUT_STROKE_MM}" style="stroke:${CUT_COLOUR}"`;
  let cut;
  const bb=exportBB||{x:0,y:0};
  if(ownCut()){
    /* 18 Oct 2026 (P215): the customer's own outer path, in absolute mm at the chosen size, not a re-trace */
    cut=`<path id="CutContour" d="${ownCutD(mmpp,bb.x,bb.y)}" ${stroke}/>`;
  } else if(traced()){
    const R=borderPx();
    cut=`<path id="CutContour" d="${svgPathFromMaskOff(dilateMask(R),mmpp,bb.x,bb.y)}" ${stroke}/>`;
  } else {
    const d=shapeDims();
    if(opts.shape==="circle"){
      cut=`<circle id="CutContour" cx="${((d.w/2-bb.x)*mmpp).toFixed(2)}" cy="${((d.h/2-bb.y)*mmpp).toFixed(2)}" r="${(d.sw/2*mmpp).toFixed(2)}" ${stroke}/>`;
    } else {
      const r=(Math.min(shapeCornerR(d),d.sw/2,d.sh/2)*mmpp).toFixed(2);
      cut=`<rect id="CutContour" x="${((d.m-bb.x)*mmpp).toFixed(2)}" y="${((d.m-bb.y)*mmpp).toFixed(2)}" width="${(d.sw*mmpp).toFixed(2)}" height="${(d.sh*mmpp).toFixed(2)}" rx="${r}" ${stroke}/>`;
    }
  }
  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${W}mm" height="${H}mm" viewBox="0 0 ${W} ${H}">
  <g id="Artwork">
    <image xlink:href="${png}" href="${png}" x="0" y="0" width="${W}" height="${H}"/>
  </g>
  <g id="Cut">${cut}</g>
</svg>`;
}
function dlCut(){
  $("spin").classList.add("show");
  setTimeout(()=>{
    saveBlob(new Blob([buildCutSVG()],{type:"image/svg+xml"}),outName("cutfile")+".svg");
    $("spin").classList.remove("show");
  },30);
}
function canvasBytes(c){
  return new Promise(res=>c.toBlob(async b=>res(new Uint8Array(await b.arrayBuffer())),"image/png"));
}
async function dlZipRun(){
  const files=[];
  const enc=new TextEncoder();
  files.push({name:"READ-ME.txt", bytes:enc.encode(
    (PL_DOWNLOADS ? stkT("stk.studio.dl.readme_title","STICKIPLY STUDIO FILES") : stkT("stk.studio.readme.single_title","STICKIPLY ORDER FILES"))+"\r\n"+
    "=====================\r\n\r\n"+
    (PL_DOWNLOADS ? stkT("stk.studio.dl.readme_files","YOUR FILES (print and cut them yourself, or hand them to any printer):") : stkT("stk.studio.readme.single_upload","UPLOAD WITH YOUR ORDER (or simply upload this whole ZIP):"))+"\r\n"+
    "  - "+outName("print-300dpi")+".png  "+stkT("stk.studio.readme.print_desc","(finished sticker artwork, transparent)")+"\r\n"+
    "  - "+outName("cutfile")+".svg  "+stkT("stk.studio.readme.cut_desc","(cut line + artwork with 1.5mm bleed)")+"\r\n\r\n"+
    stkT("stk.studio.readme.preview_head","PREVIEW ONLY - please don't send these as artwork:")+"\r\n"+
    "  - PREVIEW-ONLY-...-mockup.png  "+String(stkT("stk.studio.readme.mockup_desc","(your sticker in the finish you chose, on a\ntransparent background, for your own product photos and listings)")).replace(/\r?\n/g,"\r\n    ")+"\r\n"+
    "  - "+stkT("stk.studio.readme.preview_any","any file starting with PREVIEW-ONLY")+"\r\n\r\n"+
    String(stkT("stk.studio.readme.single_sizing","Sizing note: the cut file includes a 1.5mm bleed on every side, so it\nmeasures 3mm larger than the finished cut size shown in the tool.\nThat's intentional and normal for print.")).replace(/\r?\n/g,"\r\n")+"\r\n")});
  files.push(...await buildArtworkFiles());
  { const mk2=await mockupFile(); if(mk2) files.push(mk2); }
  /* the downloads page ships the mock up in the chosen finish instead of the proof (Thomas, 27 Sep) */
  if(!PL_DOWNLOADS) files.push({name:"PREVIEW-ONLY-"+outName("proof")+".png", bytes:await canvasBytes(proofCanvas())});
  saveBlob(makeZip(files), artName+(PL_DOWNLOADS?"-FILES.zip":"-ORDER-FILES.zip"));
}
/* "Download order files" means ALL the artwork that is open, not whichever tab
   happens to be in front. It used to call dlZipRun() unconditionally, so a
   customer with five designs open got a ZIP containing one and no warning that
   the other four had been left behind - a silent wrong order, the worst kind.
   The ticked-tiles ZIP in the grid overlay keeps its own meaning: that button
   sits next to the tickboxes, so there it is the selection that is intended. */
function dlZip(){
  const all = docs.length>1 ? docs.map((_,i)=>i) : null;
  const spinTxt=$("spin").textContent;
  $("spin").classList.add("show");
  setTimeout(async()=>{
    try{ all ? await dlZipBatch(all) : await dlZipRun(); }
    catch(e){ showError(stkFmt(stkT("stk.studio.msg.zip_failed","Couldn't build the ZIP: [error]"),{error:(e.message||e)})); }
    $("spin").classList.remove("show");
    $("spin").textContent=spinTxt;
  },30);
}

/* ================= authored: swatches / removal chips ================= */
/* P170 (Thomas, 28 Sep 00:15: "Auto should have some sort of visualisation"): each mode tile shows what
   it will paint: the solid colour, the gradient, and for Auto the artwork's own edge colours */
function paintModeSwatches(){
  try{
    const q=k=>root.querySelector('[data-modesw="'+k+'"]');
    const so=q("solid"), gr=q("gradient"), au=q("auto");
    if(so) so.style.background=opts.bg||"#ffffff";
    if(gr) gr.style.background="linear-gradient(135deg,"+(opts.bgFrom||"#ffc63c")+","+(opts.bgTo||"#f15a24")+")";
    if(au){ const cols=(palette&&palette.length)?palette.slice(0,6):["#f0513c","#f78d28","#ffc707","#5dba68","#4b8dc8","#5f4c9f"];
      au.style.background="conic-gradient("+cols.map((c,i)=>c+" "+Math.round(i*100/cols.length)+"% "+Math.round((i+1)*100/cols.length)+"%").join(",")+")"; }
  }catch(e){}
}
function renderSwatches(){
  try{ autoBleed(); }catch(e){}
  paintModeSwatches();
  const solid=opts.bgMode!=="gradient"&&opts.bgMode!=="auto";
  $("bgSolidWrap").style.display = solid ? "" : "none";
  $("bgGradWrap").style.display = opts.bgMode==="gradient" ? "" : "none";
  /* the auto bleed line is an (i) now (Thomas, 27 Sep 23:58: "centre and (i)") */
  /* plain apply - no undo push here. buildSwatchHost wraps these with the
     commit/live split: one push per click, but live re-render (no push) while
     the native colour picker's <input type=color> is being dragged. */
  if(solid){
    /* P172 (30 Sep 2026, Dutch tester: "the colour picker ... keeps resetting after picking a colour. Only on the solid
       colour option"): this pick called renderSwatches(), which rebuilt #bgHost, so the spectrum was replaced under the
       finger at pointerdown and the old one's pointerup read its detached canvas (a 0x0 box, so the top-left pixel,
       near white) and committed that. The pick now marks in place, as the gradient hosts have since 18 Sep. */
    buildSwatchHost($("bgHost"), opts.bg, c=>{
      opts.bg=c; opts.bgPicked=true; opts.bgAutoArmed=false; if(!art) preArt.bg=true;
      const host=$("bgHost");
      if(opts.bgAutoPick){ opts.bgAutoPick=false;
        host.querySelectorAll(".sw--autoadd,.swfoot__auto").forEach(el=>el.remove());
        host.querySelectorAll(".sw--auto").forEach(el=>el.classList.remove("sw--auto")); }
      markSwatch(host, c); paintModeSwatches(); render();
    }, true);
    /* the colour taken from the artwork shows as the chosen swatch, labelled Auto (P170, 28 Sep) */
    if(opts.bgAutoPick){
      try{
        const host=$("bgHost"), row=host.querySelector(".swatches");
        let sw=row && [...row.querySelectorAll(".sw:not(.custom)")].find(x=>x.classList.contains("on"));
        if(row && !sw){ sw=document.createElement("div"); sw.className="sw on sw--autoadd"; sw.style.background=opts.bg;
          sw.onclick=()=>{ opts.bgPicked=true; opts.bgAutoPick=false; opts.bgAutoArmed=false; renderSwatches(); render(); }; row.insertBefore(sw,row.firstChild); }
        if(sw) sw.classList.add("sw--auto");
        const foot=host.querySelector(".swfoot");
        if(foot){ const tag=document.createElement("span"); tag.className="swfoot__auto"; tag.textContent=stkT("stk.studio.tool.bg_auto_pick","Auto"); foot.insertBefore(tag,foot.firstChild); }
      }catch(e){}
    }
  } else {
    /* Thomas, 18 Sep: "when you select a colour in the colour picker safari menu, it closes
       immediately". renderSwatches() rebuilds these hosts, which destroys the very input Safari has
       open, so the picker shut on every pick. Redraw the sticker, mark the chosen swatch in place,
       and only rebuild the TO row (whose options depend on FROM) when FROM actually changes. */
    buildSwatchHost($("bgFromHost"), opts.bgFrom, c=>{
      const changed = c !== opts.bgFrom;
      opts.bgFrom=c; markSwatch($("bgFromHost"), c); render();
      if(changed) buildSwatchHost($("bgToHost"), opts.bgTo, toPick, true, opts.bgFrom);
    }, true);
    buildSwatchHost($("bgToHost"), opts.bgTo, toPick, true, opts.bgFrom);
  }
}
function addRemoveCol(c, all){
  c=c.toLowerCase();
  if(!opts.removeCols.some(x=>x.c===c)) opts.removeCols.push({c, all:false});   /* 21 Oct 2026: edge-only, always */
  renderRemoveChips();
  if(srcImg && opts.removeBg) processSource();
}
function renderRemoveChips(){
  const host=$("rmColsWrap"); if(!host) return;
  host.innerHTML="";
  const row=document.createElement("div"); row.className="swatches";
  opts.removeCols.forEach(col=>{
    const s=document.createElement("div");
    s.className="sw rmsw"; s.style.background=col.c;
    s.title=plEdgeTitle();   /* 21 Oct 2026: removed where it touches the background, nothing else */
    const x=document.createElement("span"); x.className="rmsw__x"; x.textContent="×";
    s.appendChild(x);
    s.onclick=(e)=>{
      const before=snapBefore();
      /* closest, not identity: the x has its own children on some browsers and
         an identity test also broke the moment it was made hit-testable. */
      opts.removeCols=opts.removeCols.filter(c=>c!==col);   /* 21 Oct 2026: the chip and its x both bring the colour back (no "everywhere" mode) */
      renderRemoveChips();
      /* Removing a colour has to redraw whether or not background removal is
         switched on, otherwise the chip vanishes and the artwork does not. */
      if(srcImg) processSource();
      pushUndo(before);
    };
    row.appendChild(s);
  });
  const eye=document.createElement("div");
  eye.className="sw eyedrop"+(pickingRm?" on":"");
  eye.title=stkT("stk.studio.tool.rm_pick_title","Pick a colour from your artwork to remove");
  eye.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m2 22 1-1h3l9-9"/><path d="M3 21v-3l9-9"/><path d="m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z"/></svg>';
  eye.onclick=()=>{
    if(!art){ showError(stkT("stk.studio.msg.rm_upload_first","Upload your artwork first, then pick the colour to remove.")); return; }
    pickingRm=!pickingRm;
    $("preview").style.cursor=pickingRm?"crosshair":"";
    renderRemoveChips();
  };
  row.appendChild(eye);
  host.appendChild(row);
  /* v3.7 (Thomas): the line carries an i and is centred */
  const hint=document.createElement("div"); hint.className="hint hint--i";
  const hintI=document.createElement("span"); hintI.className="hint__i"; hintI.setAttribute("aria-hidden","true"); hintI.textContent="i";
  const hintT=document.createElement("span");
  hint.appendChild(hintI); hint.appendChild(hintT);
  /* Thomas, 27 Sep 23:55 ("again over explaining for no reason"): the line shows only while the
     pipette is armed, when it tells the customer what the next tap does */
  hintT.textContent=stkT("stk.studio.tool.rm_hint_pick", "Tap the colour to remove.");
  if(pickingRm) host.appendChild(hint);
}

/* ================= authored: DPI + hints ================= */
/* v2.6: one reading, two places it is shown - the active slot's caption (four
   designs) or the ARTWORK card's line (one design, where there is no strip). */
function dpiInfo(){
  if(!srcImg) return null;
  const natW=ownCut() ? Math.max(custCut.bb.w,custCut.bb.h) : srcImg.width*trimRatio;   /* P215: the source px across their cut */
  let dpi=Math.round(natW/(widthMm()/25.4));
  /* v4.3: in a circle or square the artwork is printed at the fit times the size slider, not across the
     whole sticker, so its real resolution follows that width (a bigger artwork shows the lower DPI) */
  try{
    if(art && (opts.shape==="circle"||opts.shape==="square")){
      const d=shapeDims(), artMm=art.width*shapeScale(d)*widthMm()/d.sw;
      if(artMm>0) dpi=Math.round(natW/(artMm/25.4));
    }
  }catch(e){}
  let cls="ok", word=stkT("stk.studio.dpi.ok", "PRINT READY");
  if(dpi<150){ cls="bad"; word=stkT("stk.studio.dpi.low", "LOW QUALITY"); }
  else if(dpi<300){ cls="mid"; word=stkT("stk.studio.dpi.mid", "ACCEPTABLE"); }
  return { dpi:dpi, cls:cls, text:stkFmt(stkT(srcIsVector?"stk.studio.dpi.line_vector":"stk.studio.dpi.line",srcIsVector?"[dpi] DPI · [rating] · VECTOR":"[dpi] DPI · [rating]"),{dpi:dpi,rating:word})  /* P172 (2 Oct 2026): the line in the page language */ };
}
function updateDpi(){
  const el=$("dpi");
  const q=dpiInfo();
  if(!q){ el.textContent=""; el.className=""; }
  else { el.textContent=q.text; el.className=q.cls; }
  const cap=root.querySelector(".dslot.on [data-dslot-dpi]");
  if(cap){ cap.textContent=q?q.text:""; cap.className="dslot__dpi"+(q?" "+q.cls:""); }
}
function coverageHint(){
  if(!mask0) return;   /* builder audit X1: a size typed before any upload has no artwork to measure */
  const x=mask0.getContext("2d");
  const a=x.getImageData(0,0,mask0.width,mask0.height).data;
  let n=0; for(let i=3;i<a.length;i+=4) if(a[i]>10) n++;
  const cov=n/(mask0.width*mask0.height);
  const note=$("note");
  /* The "no transparency, so the outline is just a rectangle" nag is gone
     (Thomas, 7 Sep 2026: "i dont want this random message nor did i ask for
     it"). It fired on exactly the files the lab now handles properly - a
     label or a square sticker IS a rectangle, and the cut is snapped to a
     real one, so telling the customer to switch on background removal was
     advice against their own artwork. cov is still computed; nothing else
     reads it, and the note element stays for other messages. */
  note.classList.remove("show");
}

/* ================= authored: saved designs ================= */
function designThumb(){
  if(!baseScene) return null;
  const t=mk(64,64), tc=t.getContext("2d");
  const sc=Math.min(64/baseScene.width,64/baseScene.height);
  tc.drawImage(baseScene,(64-baseScene.width*sc)/2,(64-baseScene.height*sc)/2,baseScene.width*sc,baseScene.height*sc);
  return t.toDataURL("image/png");
}
/* v3.11 (6 Oct 2026, Thomas: "i also saved my designs but when opening them, my edits had gone"): a record kept only
   the source image and the options, so the eraser's work was lost on load. The strokes are stored as processSource
   replays them (work-canvas px, one group per stroke) and put back before the restored source is processed. */
function eraseSnapshot(){ return eraseStrokes.map(g=>g.map(s=>plPt(s))); }   /* + the fill / wand flags (21 Oct 2026) */
function eraseFromRecord(v){
  if(!Array.isArray(v)) return [];
  return v.map(g=>(Array.isArray(g)?g:[]).map(s=>plPt({x:+s.x||0,y:+s.y||0,r:+s.r||0,f:s.f,w:s.w,v:s.v,sx:s.sx,sy:s.sy})).filter(s=>s.r>0)).filter(g=>g.length);
}
/* v2.9.2 (R5): ONE library record per open design - SAVE and autosave put() to the doc's libId; a restored design keeps its record's id */
function libIdFor(d){
  if(!d) return CUST_ID+"-"+Date.now();
  if(!d.libId) d.libId=CUST_ID+"-"+String(d.id||"d")+"-"+Date.now();
  return d.libId;
}
async function saveDesign(){
  if(!srcImg){ showError(stkT("stk.studio.msg.save_first","Upload a design first, then save it.")); return; }
  const sc=mk(srcImg.width,srcImg.height);
  sc.getContext("2d").drawImage(srcImg,0,0);
  const snap={ id:libIdFor(docs[activeIdx]), owner:CUST_ID, name:artName,
               savedAt:new Date().toISOString(),
               o:Object.assign({},opts),
               art:{data:sc.toDataURL("image/png"), isVector:srcIsVector}, svg:svgSrc||null,
               erase:eraseSnapshot(),   /* v3.11 */
               cut:cutRecord(), srcAlt:cutAltData(),   /* 18 Oct 2026 (P215): the file's cut line, its own field */
               thumb:designThumb() };
  await dbTx("readwrite",st=>st.put(snap));
  /* v2.9.3: the customer asked for this one to be kept, so removing the design from the
     pack leaves the record alone (finalizeClosedDoc only clears autosaves). */
  if(docs[activeIdx]) docs[activeIdx].savedExplicit=true;
  markSaved();
  renderSavedList(true);
}
/* v2.9 (note 10): autosave on NEXT. The store already keys by id, so one record per open
   design is overwritten each time instead of a new row per press. Same IndexedDB store
   ("stickiply-proof-lab", per browser, owner = customer id or "guest"): nothing new. */
async function autoSaveDesign(){
  if(!srcImg || activeIdx<0 || !docs[activeIdx]) return;
  const d=docs[activeIdx];
  const sc=mk(srcImg.width,srcImg.height);
  sc.getContext("2d").drawImage(srcImg,0,0);
  const snap={ id:libIdFor(d), owner:CUST_ID, name:artName,
               savedAt:new Date().toISOString(),
               o:Object.assign({},opts),
               art:{data:sc.toDataURL("image/png"), isVector:srcIsVector}, svg:svgSrc||null,
               erase:eraseSnapshot(),   /* v3.11 */
               cut:cutRecord(), srcAlt:cutAltData(),   /* 18 Oct 2026 (P215): the file's cut line, its own field */
               thumb:designThumb() };
  await dbTx("readwrite",st=>st.put(snap));
  markSaved();
  renderSavedList(false);
}
let savedCount=0;
function markSaved(){ const d=docs[activeIdx]; if(d) d.savedAt=Date.now(); syncSaveState(); }
function syncSaveState(){
  const st=$("savedState"), cnt=$("savedCount"), hint=$("savedHint"); if(!st) return;
  const d=docs[activeIdx]; const t=(d&&d.savedAt)||0;
  let txt, ok=false;
  if(!art) txt=stkT("stk.studio.save.state_empty","Upload a design to save it");
  else if(!t) txt=stkT("stk.studio.save.state_unsaved","Not saved yet");
  else { const m=Math.round((Date.now()-t)/60000); ok=true;
    /* hour/hours keeps the English choice exactly (m<120 reads "hour" even at 2) */
    txt=m<1?stkT("stk.studio.save.just_now","Saved just now"):(m<60?stkFmt(m===1?stkT("stk.studio.save.minutes.one","Saved [count] minute ago"):stkT("stk.studio.save.minutes.other","Saved [count] minutes ago"),{count:m}):stkFmt(m<120?stkT("stk.studio.save.hour_ago","Saved [hours] hour ago"):stkT("stk.studio.save.hours_ago","Saved [hours] hours ago"),{hours:Math.round(m/60)})); }
  st.textContent=txt; st.classList.toggle("is-saved",ok);
  if(cnt) cnt.textContent=savedCount?stkFmt(savedCount===1?stkT("stk.studio.save.count.one","[count] saved design"):stkT("stk.studio.save.count.other","[count] saved designs"),{count:savedCount}):"";  /* P172 */
  /* v3.1 (Thomas, 24 Sep: "i dont see a way to 'sign in'"): the signed-out line carries the
     store's own login, and comes back to this page with Studio open */
  /* Thomas, 28 Sep 01:00 (his mock): the header carries it all: the count in green, then a person icon
     with SIGN IN (or the customer's name); the "saved just now" and "signed out" lines are gone */
  const who=$("savedWho");
  if(who){
    const PERSON='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></svg>';
    /* signed in = the store gave us a customer id (a first name can be empty) */
    const custId=(root.host&&root.host.dataset.custId)||"";
    if(custId){ who.innerHTML=PERSON+'<span>'+stkEsc(CUST_NAME?String(CUST_NAME).split(" ")[0]:stkT("stk.studio.save.signed_in_short","Signed in"))+'</span>'; who.href="/account"; who.classList.add("is-in"); }
    else {
      const lu=(root.host&&root.host.dataset.loginUrl)||"/account/login";
      const back=location.pathname+location.search+"#proof-lab";
      who.href=lu+"?return_url="+encodeURIComponent(back);
      who.innerHTML=PERSON+'<span class="signin">'+stkEsc(stkT("stk.studio.save.sign_in","Sign in"))+'</span>';
    }
    if(!who.dataset.wired){ who.dataset.wired="1"; who.addEventListener("click",e=>e.stopPropagation()); }
  }
  if(hint){
    if(CUST_NAME) hint.textContent=stkFmt(stkT("stk.studio.save.signed_in","Signed in as [name]. Saved on this device."),{name:CUST_NAME});
    else {
      const lu=(root.host&&root.host.dataset.loginUrl)||"/account/login";
      const back=location.pathname+location.search+"#proof-lab";
      hint.innerHTML=stkEsc(stkT("stk.studio.save.signed_out","Signed out: saved on this device only."))+' <a class="signin" href="'+lu+'?return_url='+encodeURIComponent(back)+'">'+stkEsc(stkT("stk.studio.save.sign_in","Sign in"))+'</a>';
    }
  }
}
setInterval(syncSaveState,30000);
function loadImageEl(src){ return new Promise((res,rej)=>{ const im=new Image(); im.onload=()=>res(im); im.onerror=rej; im.src=src; }); }
function syncControlsFromOpts(){
  $("borderW").value=opts.borderMm; $("borderVal").textContent=stkDec(opts.borderMm,1)+"mm"; try{ syncBorderTiles(); }catch(e){}
  $("smooth").value=opts.smoothMm; $("smoothVal").textContent=stkDec(opts.smoothMm,1)+"mm";
  { const ap=Number(opts.artPct)||100; $("artPct").value=ap; $("artPctVal").textContent=Math.round(ap)+"%"; try{ updateSeg($("artPct")); }catch(e){} }
  $("tol").value=opts.removeTol; $("tolVal").textContent=opts.removeTol+"%";
  syncDial();
  $("rmBg").classList.toggle("on",opts.removeBg);
  $("borderToggle").classList.toggle("on",opts.border);
  [...$("cornerSnapSeg").querySelectorAll("button")].forEach(b=>b.classList.toggle("on",b.dataset.v===opts.cornerMode));
  $("cutToggle").classList.toggle("on",opts.cut);
  $("ctoolCut").classList.toggle("on",opts.cut);
  [["sizeSeg",String(opts.sizeIn)],["shapeSeg",opts.shape],["fitSeg",opts.fit],
   ["cornerSeg",opts.corner],["bgModeSeg",opts.bgMode]].forEach(([id,v])=>{
    [...$(id).querySelectorAll("button")].forEach(b=>b.classList.toggle("on",b.dataset.v===v));
  });
  syncCustomSize();
  syncGroups(); syncTolVisibility(); syncBorderVisibility();
  renderSwatches(); renderRemoveChips();
  paintAllRanges();
  syncUndoRedoButtons();
}
async function restoreDesign(snap){
  { const g=$("docGrid"); if(g && !g.classList.contains("hidden")) closeDocGrid(); }   /* 2 Nov 2026: a saved design opened from the grid view, as loadFiles */
  $("spin").classList.add("show");
  try{
    addBlankDoc(snap.name||DEFAULT_ART);   // saved designs open alongside current work, not over it
    if(docs[activeIdx]) docs[activeIdx].libId=snap.id;   // v2.9.2 (R5): further saves update this record
    /* the saved colour is the customer's: disarmed, and only the record's own auto-bleed keys can re-arm it */
    clearAutoBleed(); opts.bgPicked=true;
    Object.assign(opts, snap.o);
    opts.removeInner=false;   /* the Remove inner white switch is gone (21 Oct 2026): that white opens kept; the magic wand takes each piece */
    /* a record saved before the palette clamp can hold a malformed colour; repair rather than draw nothing */
    opts.bg=safeHex(opts.bg,"#ffffff"); opts.bgFrom=safeHex(opts.bgFrom,"#ffc63c"); opts.bgTo=safeHex(opts.bgTo,"#f15a24");
    artName=snap.name||DEFAULT_ART;
    plHist=[]; plRedo=[]; eraseStrokes=eraseFromRecord(snap.erase); syncEraseBar();   /* v3.11: edits come back with the design */
    const im=await loadImageEl(snap.art.data);
    srcImg=im; srcIsVector=!!snap.art.isVector;
    svgSrc=snap.svg||null; svgInfo=svgSrc ? svgAnalyse(svgSrc) : null;   /* 21 Oct 2026: a vector file comes back as its text */
    /* 18 Oct 2026 (P215): the cut line from the file comes back as it was saved; a record without one is traced */
    custCut=null;
    if(snap.cut && snap.cut.kind){
      custCut=JSON.parse(JSON.stringify(snap.cut));
      if(custCut.kind==="candidate"){
        let alt=null; try{ if(snap.srcAlt) alt=await loadImageEl(snap.srcAlt); }catch(e){ alt=null; }
        if(alt){ if(snap.o && snap.o.cutMode==="own"){ custCut.imgStrip=im; custCut.imgFull=alt; } else { custCut.imgFull=im; custCut.imgStrip=alt; } }
        else if(snap.o && snap.o.cutMode==="own") custCut.kind="named";   /* no second render: the line is already out, keep it out */
        else custCut=null;                                                /* ...or still in, as plain artwork */
      }
    }
    opts.cutMode=(custCut && snap.o && snap.o.cutMode==="own") ? "own" : "";
    syncControlsFromOpts();
    if(svgSrc) plSvgApply(); else processSource();
  }catch(e){ showError(stkFmt(stkT("stk.studio.msg.load_failed","Couldn't load that design: [error]"),{error:(e.message||e)})); $("spin").classList.remove("show"); }
}
async function renderSavedList(show){
  const host=$("savedList"); if(!host) return;
  let all=[];
  try{ all=await dbTx("readonly",st=>st.getAll())||[]; }catch(e){}
  let mine=all.filter(d=>d.owner===CUST_ID).sort((a,b)=>String(b.savedAt||"").localeCompare(String(a.savedAt||"")));
  /* v2.9.2 (R5): duplicates of the same design (same name and artwork) collapse to the newest record */
  const seen={}, dupes=[];
  mine=mine.filter(d=>{
    const a=(d.art&&d.art.data)||""; let h=0; for(let i=0;i<a.length;i+=Math.max(1,Math.floor(a.length/512))) h=(h*31+a.charCodeAt(i))>>>0;
    const k=String(d.name||"")+"|"+a.length+"|"+h;
    if(seen[k]){ dupes.push(d.id); return false; } seen[k]=true; return true;
  });
  if(dupes.length){ try{ await dbTx("readwrite",st=>{ dupes.forEach(id=>st.delete(id)); }); }catch(e){} }
  host.innerHTML="";
  mine.forEach(d=>{
    const row=document.createElement("div"); row.className="layeritem";
    if(d.thumb){ const im=document.createElement("img"); im.src=d.thumb; im.style.cssText="width:30px;height:30px;object-fit:contain;border-radius:4px;flex-shrink:0"; row.appendChild(im); }
    const nm=document.createElement("span"); nm.className="layeritem__name";
    nm.textContent=d.name+" · "+stkDate(d.savedAt);
    row.appendChild(nm);
    const ctr=document.createElement("div"); ctr.className="layeritem__ctr";
    const load=document.createElement("button"); load.textContent="→"; load.title=stkT("stk.studio.save.load_title","Load this design");
    load.onclick=()=>restoreDesign(d);
    const del=document.createElement("button"); del.textContent="×"; del.className="del"; del.title=stkT("stk.studio.save.delete_title","Delete");
    del.onclick=async()=>{ await dbTx("readwrite",st=>st.delete(d.id)); renderSavedList(true); };
    ctr.appendChild(load); ctr.appendChild(del);
    row.appendChild(ctr);
    host.appendChild(row);
  });
  if(show) host.style.display="";
  try{ syncDesignsBtn(); }catch(e){}
  savedCount=mine.length;
  syncSaveState();
}

/* ================= authored: UI wiring ================= */
function segGroup(id,key,after){
  $(id).addEventListener("click",e=>{
    const b=e.target.closest("button"); if(!b) return;
    if(ownCut() && CUT_LOCKED.indexOf(id)>=0) return;   /* P215: set by the cut line in their file */
    if(!art && (key==="shape" || key==="bgMode")) preArt[key]=true;
    const before=snapBefore();
    [...$(id).querySelectorAll("button")].forEach(c=>c.classList.remove("on"));
    b.classList.add("on");
    opts[key]=b.dataset.v;
    if(after) after();
    render();
    updateDims();
    try{ updateDpi(); }catch(err){}   /* v4.3: shape and fit change how big the artwork prints */
    pushUndo(before);
  });
}
function toggle(id,key,after){
  $(id).addEventListener("click",()=>{
    if(ownCut() && CUT_LOCKED.indexOf(id)>=0) return;   /* P215 */
    const before=snapBefore();
    $(id).classList.toggle("on");
    opts[key]=$(id).classList.contains("on");
    if(after) after(); else render();
    pushUndo(before);
  });
}
function syncGroups(){
  const custom=traced();
  $("gBorder").classList.toggle("hidden",!custom);
  $("gSmooth").classList.toggle("hidden",!custom);
  $("gFit").classList.toggle("hidden",custom);
  $("gCorner").classList.toggle("hidden",opts.shape!=="square");
  if(opts.shape!=="rect") $("gSnap").style.display="none";
  try{ syncOwnCutUI(); }catch(e){}   /* P215 */
  try{ if(typeof window.__plSegSync==="function") window.__plSegSync(); }catch(e){}
}
function syncTolVisibility(){
  $("gTol").classList.toggle("hidden", !opts.removeBg);
}
function syncBorderVisibility(){
  const on=opts.border;
  $("gBorderW").style.display = on ? "" : "none";
  try{ if(art){ autoBleed(); renderSwatches(); } }catch(e){}
}
function paintRange(r){ segmentizeRange(r); updateSeg(r); }
function paintAllRanges(){ root.querySelectorAll('input[type=range]').forEach(paintRange); }

segGroup("shapeSeg","shape",()=>{ syncGroups(); try{ renderSwatches(); }catch(e){} });
segGroup("sizeSeg","sizeIn",()=>{
  opts.sizeIn=+opts.sizeIn;
  opts.sizeCustomMm=null;            // a preset wins over whatever was typed
  dilCache={}; dilPad=0;             // 2 Oct: before syncCustomSize measures the new size
  syncCustomSize();
  updateDpi();
  try{ if(ownCut()) syncOwnCutUI(); }catch(e){}   /* 20 Oct 2026: the note under the switch carries the new size */
});
/* Type-in size. Clamped on commit rather than on every keystroke, so typing
   "120" does not fight the user at "1" and then "12". */
function syncCustomSize(){
  const inp=$("sizeCustom"); if(!inp) return;
  const dp = sizeUnit==="in" ? 2 : 1;
  inp.step = sizeUnit==="in" ? "0.25" : "0.1";
  inp.min  = (+fromMm(SIZE_MIN_MM).toFixed(dp));
  inp.max  = (+fromMm(SIZE_MAX_MM).toFixed(dp));
  /* 20 Oct 2026 (the owner: a size chip "should populate the custom size field"): in own-cut mode the field always carries
     the size being ordered, a chip's figure included */
  inp.value = opts.sizeCustomMm ? String(+fromMm(opts.sizeCustomMm).toFixed(dp)) : (ownCut() ? String(+fromMm(widthMm()).toFixed(dp)) : "");
  /* v5.0: the true-size bar's cm / in is the product page's sliding switch (#sizeUnitSw, is-on / is-in);
     the flag-off box keeps its two buttons (#sizeUnitSeg, .on) */
  const us=$("sizeUnitSeg")||$("sizeUnitSw"), sw=us.id==="sizeUnitSw";
  [...us.querySelectorAll("button")].forEach(b=>{
    const on=b.dataset.u===sizeUnit;
    b.classList.toggle(sw?"is-on":"on", on); if(sw) b.setAttribute("aria-pressed", on?"true":"false");
  });
  if(sw) us.classList.toggle("is-in", sizeUnit==="in");
  { const ul=$("sizeUnitLbl"); if(ul) ul.textContent=plUnitLbl(); }   /* builder audit row 15 */
  paintSizeChips();
  [...$("sizeSeg").querySelectorAll("button")].forEach(b=>
    b.classList.toggle("on", !opts.sizeCustomMm && b.dataset.v===String(opts.sizeIn)));
  try{ syncWH(true); }catch(e){}
}
function commitCustomSize(){
  const inp=$("sizeCustom");
  const raw=inp.value.trim();
  const before=snapBefore();
  if(raw===""){ opts.sizeCustomMm=null; }
  else {
    const v=+raw;
    if(!isFinite(v)||v<=0){ opts.sizeCustomMm=null; }
    else { opts.sizeCustomMm=Math.max(SIZE_MIN_MM, Math.min(SIZE_MAX_MM, toMm(v))); }
  }
  dilCache={}; dilPad=0;   /* 2 Oct: cleared BEFORE syncCustomSize measures the new size, so that work is kept for the render */
  syncCustomSize();
  render(); updateDims(); updateDpi(); coverageHint();
  try{ if(ownCut()) syncOwnCutUI(); }catch(e){}   /* 20 Oct 2026: the note under the switch carries the new size */
  pushUndo(before);
}
$("sizeCustom").addEventListener("change",commitCustomSize);
/* builder audit row 15: the bar's one switch (and a switch in another Studio on the page) sets the unit here */
document.addEventListener("stk:lab-units",e=>{
  const u=e&&e.detail&&e.detail.unit; if((u!=="cm"&&u!=="in")||u===sizeUnit) return;
  sizeUnit=u;
  try{ syncCustomSize(); updateDims(); }catch(err){}
  try{ if(typeof window.__plRedrawCart==="function") window.__plRedrawCart(); }catch(err){}
});
/* the chips and the label show the start unit from the first paint (the template carries the full key) */
paintSizeChips(); { const ul=$("sizeUnitLbl"); if(ul) ul.textContent=plUnitLbl(); }
/* Switching units rewrites the box, never the sticker: the mm value is untouched. */
($("sizeUnitSeg")||$("sizeUnitSw")).addEventListener("click",e=>{
  const b=e.target.closest("button"); if(!b) return;
  sizeUnit=b.dataset.u;
  syncCustomSize();
});
$("sizeCustom").addEventListener("keydown",e=>{ if(e.key==="Enter"){ e.preventDefault(); commitCustomSize(); } });
/* ===== P128: WIDTH x HEIGHT (25 Sep 2026) ========================================================
   Thomas chose "per shape": a DIE-CUT follows its artwork, so typing either box sets the other from
   the artwork (the cut is the art plus the border on every side, so W = art width + 2 x border).
   CORNERS is traced from the artwork's own rectangle too (traced()), so it links the same way; a
   free-size rectangle with the art inside it would be a new shape, asked 25 Sep. CIRCLE and SQUARE
   are one number, shown in both. The boxes always show the real cut size. The
   limits are refused, never clamped, in his words, next to the disabled buttons (Custom Sticker
   Pricing, 25 Sep): under 10mm a side, or over 280 x 400mm. */
const SIZE_ERR_SMALL="The smallest we can cut is 1 cm on each side.";
const SIZE_ERR_LARGE="The largest we can make is 28 x 40 cm.";
/* P128 grid: there is no grid step above 28 cm, so a bigger side is refused, never clamped */
const SIZE_ERR_GRID="Over 28 cm? Email us and we will quote it.";
function sizeError(){
  if(!PL_TRUE_SIZE || !art) return null;
  const d=cutSizeMm(); if(!d) return null;
  const lo=Math.min(d.w,d.h), hi=Math.max(d.w,d.h);
  if(PL_MG) return lo<19.95 ? stkFmt(stkT("stk.pricing.err_min_side",SIZE_ERR_SMALL),{min:2}) : (hi>75.05 ? stkT("stk.studio.order.bands_too_big","That size is too big to make here. Email us and we will quote it.") : null);   /* magnets: 2 to 7.5 cm */
  if(lo<9.95) return stkFmt(stkT("stk.pricing.err_min_side",SIZE_ERR_SMALL),{min:1});
  if(PL_GRID) return hi>280.05 ? (PL_GRID.bands ? stkT("stk.studio.order.bands_too_big","That size is too big to make here. Email us and we will quote it.") : stkT("stk.studio.order.grid_too_big",SIZE_ERR_GRID)) : null;
  if(hi>400.05 || lo>280.05) return stkFmt(stkT("stk.pricing.err_max_size",SIZE_ERR_LARGE),{w:28,h:40});
  return null;
}
let lastSizeErr=null;
function syncWH(force){
  if(!PL_TRUE_SIZE) return;
  const iw=$("sizeW"), ih=$("sizeH"); if(!iw||!ih) return;
  const dp = sizeUnit==="in" ? 2 : 1;
  iw.step=ih.step = sizeUnit==="in" ? "0.01" : "0.1";
  const d=art?cutSizeMm():null;
  const fmt=mm=>String(+fromMm(mm).toFixed(dp));
  if(force || root.activeElement!==iw) iw.value = d ? fmt(d.w) : "";
  if(force || root.activeElement!==ih) ih.value = d ? fmt(d.h) : "";
  /* v4.9: the product page's bar reads W / H. 7 Oct 2026 (P212 audit 2): in the page language, the store's own
     short words (stk.labs.sheet.*_short: de B / H, fr L / H, es An / Al, it L / A, fi L / K ...), English W / H unchanged */
  iw.placeholder=stkT("stk.labs.sheet.width_short","W"); ih.placeholder=stkT("stk.labs.sheet.height_short","H");
  const err=sizeError(), el=$("sizeErr");
  if(el){ el.textContent=err||""; el.hidden=!err; }
  const ctl=iw.closest(".sizectl,.stkcq"); if(ctl) ctl.classList.toggle("is-bad",!!err);
  if(err!==lastSizeErr){ lastSizeErr=err; try{ if(typeof window.__plRedrawCart==="function") window.__plRedrawCart(); }catch(e){} }
}
function commitWH(which, typed){
  const iw=$("sizeW"), ih=$("sizeH"); if(!iw||!ih) return;
  const inp = which==="h" ? ih : iw;
  const raw=inp.value.trim();
  const d0=art?cutSizeMm():null, dp = sizeUnit==="in" ? 2 : 1;
  if(d0 && raw===String(+fromMm(which==="h"?d0.h:d0.w).toFixed(dp))){
    if(!typed || opts.sizeCustomMm) return;   /* nothing changed (Enter, then blur) */
    /* v5.2: a size typed into the bar is a custom size even when it is the size already on screen
       (7.1 x 7.6 on the 3in preset lit the 3in chip, and the Final check named the preset while the
       cart charged the Made to Size line). The same cut, now held as a custom size: no jump. */
    const before0=snapBefore();
    opts.sizeCustomMm=widthMm();
    dilCache={}; dilPad=0;   /* 2 Oct: before syncCustomSize measures it */
    syncCustomSize();
    render(); updateDims(); updateDpi(); coverageHint();
    syncWH(true);
    pushUndo(before0);
    try{ inp.dispatchEvent(new Event("change")); }catch(e){}   /* the ORDER panel re-reads the size on change */
    return;
  }
  let v=+raw;
  if(raw==="" || !isFinite(v) || v<=0){ syncWH(true); return; }
  v=Math.min(2000,toMm(v));
  const before=snapBefore();
  const b = (opts.border && !ownCut()) ? (+opts.borderMm||0) : 0;   /* P215: no border round their own line */
  let L=v, lo=v;
  if(opts.shape==="circle"||opts.shape==="square"){ L=v; }
  else if(d0){
    const aW=Math.max(0.1,d0.w-2*b), aH=Math.max(0.1,d0.h-2*b), art1=Math.max(0.1,v-2*b);
    const W = which==="w" ? v : art1*aW/aH+2*b, H = which==="h" ? v : art1*aH/aW+2*b;
    L=Math.max(W,H); lo=Math.min(W,H);
  }
  /* 2 Oct (iPhone: Studio reloaded and lost the upload): a side under 1 cm is refused BEFORE it is
     drawn. The dilation canvases grow with 1/size (4,460 px square at 1 cm, 8,884 px at 0.5 cm,
     measured), enough to kill the iOS page. The boxes go back to the size on screen. */
  if(PL_TRUE_SIZE && lo<9.95){
    syncWH(true);
    const el=$("sizeErr"); if(el){ el.textContent=stkFmt(stkT("stk.pricing.err_min_side",SIZE_ERR_SMALL),{min:1}); el.hidden=false; }
    return;
  }
  opts.sizeCustomMm=Math.max(1,Math.min(2000,L));
  dilCache={}; dilPad=0;   /* 2 Oct: before syncCustomSize measures the new size, so the render reuses it */
  syncCustomSize();
  render(); updateDims(); updateDpi(); coverageHint();
  syncWH(true);
  pushUndo(before);
}
if(PL_TRUE_SIZE){
  [["w","sizeW"],["h","sizeH"]].forEach(([k,id])=>{
    const el=$(id); if(!el) return;
    /* v5.2: typing the value already shown fires no change event, so a typed field commits on blur too */
    el.addEventListener("input",()=>{ el._plTyped=true; });
    el.addEventListener("change",()=>{ el._plTyped=false; commitWH(k,true); });
    el.addEventListener("keydown",e=>{ if(e.key==="Enter"){ e.preventDefault(); el._plTyped=false; commitWH(k,true); } });
    el.addEventListener("blur",()=>{ if(el._plTyped){ el._plTyped=false; commitWH(k,true); } });
  });
}
segGroup("fitSeg","fit",()=>{ opts.offX=0; opts.offY=0; });
segGroup("cornerSeg","corner");
segGroup("bgModeSeg","bgMode",renderSwatches);
toggle("cutToggle","cut",()=>{ $("ctoolCut").classList.toggle("on",opts.cut); render(); });
toggle("borderToggle","border",()=>{ syncBorderVisibility(); render(); updateDims(); });
segGroup("cornerSnapSeg","cornerMode",()=>{ opts.cornerAuto=false; dilCache={}; });
/* P170 (Thomas, 27 Sep 23:55: the drag hint "is a hint and should open from an (i) next to the shape") */
if($("bgInfo")) $("bgInfo").addEventListener("click",()=>{
  const p=$("bgAutoHint"), on=!p.classList.contains("show");
  p.classList.toggle("show",on); $("bgInfo").setAttribute("aria-expanded",String(on));
});
if($("fitInfo")) $("fitInfo").addEventListener("click",()=>{
  const p=$("fitInfoPop"), on=!p.classList.contains("show");
  p.classList.toggle("show",on); $("fitInfo").setAttribute("aria-expanded",String(on));
});
$("cornerInfo").addEventListener("click",()=>{
  const p=$("cornerInfoPop"), on=!p.classList.contains("show");
  p.classList.toggle("show",on); $("cornerInfo").setAttribute("aria-expanded",String(on));
});
/* 18 Oct 2026 (P202): ONE rule for every way of removing a background, as on the Mac (6 Oct): the colour picker
   turned removal on without it, so a border the customer had set to Auto stayed Auto and stretched the linework of
   a white-paper drawing round the border. Same text as the block that was in the Remove Background toggle. */
function removalTurnsOn(){
  if(!opts.border){
    opts.border=true;
    const t=$("borderToggle"); if(t) t.classList.add("on");
    syncBorderVisibility();
  }
  if(opts.bgMode==="auto"){
    opts.bgMode="solid";
    const seg=$("bgModeSeg");
    if(seg) for(const b of seg.children) b.classList.toggle("on", b.dataset.v==="solid");
    renderSwatches();
  }
}
toggle("rmBg","removeBg",()=>{
  syncTolVisibility(); plRmRowSync();
  if(opts.removeBg && srcImg && !opts.removeCols.length){
    opts.removeCols=detectEdgeCols(workCanvas()).map(c=>({c, all:false}));
    if(!opts.removeCols.length) opts.removeCols=[{c:"#ffffff", all:false}];
  }
  /* Taking the background out is exactly when a border becomes structural
     rather than decorative: the cut stops following a safe rectangle and starts
     following the artwork, where thin necks and detached parts snap (Thomas,
     8 Sep 2026). So switching removal ON switches the border on with it, and
     pins the colour to Solid - Auto samples the artwork's own edges, which is
     the thing that has just been deleted. Only ever turned ON, never off and
     never overridden afterwards: once it is on the customer owns it. */
  if(opts.removeBg) removalTurnsOn();
  renderRemoveChips();
  if(srcImg) processSource();
  updateDims();
});
$("ctoolCut").addEventListener("click",()=>{
  opts.cut=!opts.cut;
  $("ctoolCut").classList.toggle("on",opts.cut);
  $("cutToggle").classList.toggle("on",opts.cut);
  render();
});
$("zoomIn").onclick=()=>setZoom(zoom*1.3);
$("zoomOut").onclick=()=>setZoom(zoom/1.3);
$("zoomFit").onclick=()=>setZoom(1);
function setDark(v){
  darkMode=!!v;
  root.querySelector(".app").classList.toggle("dark", darkMode);
  const ct=$("ctoolStage"); if(ct) ct.classList.toggle("on", darkMode);
}
document.addEventListener("stk:lab-theme",e=>{
  /* the picker's colours are emitted inline, so the card has to be redrawn
     rather than restyled when the theme changes */
  setTimeout(()=>{ try{ if(typeof window.__plRedrawCart==="function") window.__plRedrawCart(); }catch(err){} },0);
  if(e&&e.detail&&e.detail.from==="tool") return;
  setDark(!!(e&&e.detail&&e.detail.dark));
});
$("ctoolUndo").addEventListener("click",doUndo);
$("ctoolRedo").addEventListener("click",doRedo);
/* Cmd/Ctrl+Z and Cmd/Ctrl+Shift+Z, only while focus is inside this tool */
document.addEventListener("keydown",e=>{
  if(!(e.metaKey||e.ctrlKey) || e.key.toLowerCase()!=="z") return;
  if(!root.activeElement) return;
  e.preventDefault();
  if(e.shiftKey) doRedo(); else doUndo();
});
$("borderW").addEventListener("input",e=>{
  $("borderVal").textContent=stkDec(+e.target.value,1)+"mm";
  updateSeg(e.target);
});
/* P170 (Thomas, 28 Sep 00:15: "add border section looks boring compared to shape and size"): four
   illustrated tiles in the Corners pattern set the width; the slider stays under them for the half steps */
function syncBorderTiles(){ const v=+$("borderW").value; const seg=$("borderWSeg"); if(!seg) return; seg.querySelectorAll("[data-bw]").forEach(b=>b.classList.toggle("on", Math.abs(+b.dataset.bw-v)<0.01)); }
if($("borderWSeg")) $("borderWSeg").addEventListener("click",e=>{
  const b=e.target.closest("[data-bw]"); if(!b) return;
  const r=$("borderW"); r.value=b.dataset.bw;
  r.dispatchEvent(new Event("input",{bubbles:true})); r.dispatchEvent(new Event("change",{bubbles:true}));
});
$("borderW").addEventListener("input",()=>syncBorderTiles());
$("borderW").addEventListener("change",e=>{
  const before=snapBefore();
  opts.borderMm=+e.target.value;
  $("borderVal").textContent=stkDec(opts.borderMm,1)+"mm";
  updateSeg(e.target);
  render(); updateDims();
  pushUndo(before);
});
/* v4.3: the artwork size slider (circle and square), wired like the others: the label follows the drag,
   the render and the undo step happen on release */
$("artPct").addEventListener("input",e=>{
  $("artPctVal").textContent=Math.round(+e.target.value)+"%";
  updateSeg(e.target);
});
$("artPct").addEventListener("change",e=>{
  const before=snapBefore();
  opts.artPct=+e.target.value;
  $("artPctVal").textContent=Math.round(opts.artPct)+"%";
  updateSeg(e.target);
  render(); updateDims(); try{ updateDpi(); }catch(err){}
  pushUndo(before);
});
$("smooth").addEventListener("input",e=>{
  $("smoothVal").textContent=stkDec(+e.target.value,1)+"mm";
  updateSeg(e.target);
});
$("smooth").addEventListener("change",e=>{
  const before=snapBefore();
  opts.smoothMm=+e.target.value;
  $("smoothVal").textContent=stkDec(opts.smoothMm,1)+"mm";
  updateSeg(e.target);
  render(); updateDims();
  pushUndo(before);
});
$("tol").addEventListener("input",e=>{
  $("tolVal").textContent=(+e.target.value)+"%";
  updateSeg(e.target);
});
$("tol").addEventListener("change",e=>{
  const before=snapBefore();
  opts.removeTol=+e.target.value;
  $("tolVal").textContent=opts.removeTol+"%";
  updateSeg(e.target);
  if(opts.removeBg && srcImg) processSource();
  pushUndo(before);
});
/* angle dial: drag the dot around the circle */
function syncDial(){
  const dot=$("gradDialDot"); if(!dot) return;
  const a=(opts.bgAngle-90)*Math.PI/180, R=21;
  dot.style.left=(50+Math.cos(a)*R/27*50)+"%";
  dot.style.top=(50+Math.sin(a)*R/27*50)+"%";
  $("gradAngleVal").textContent=Math.round(opts.bgAngle)+"°";
}
(()=>{
  const dial=$("gradDial"); if(!dial) return;
  let turning=false, raf=0, before=null;
  const setFromEvent=e=>{
    const r=dial.getBoundingClientRect();
    const dx=e.clientX-(r.left+r.width/2), dy=e.clientY-(r.top+r.height/2);
    if(!dx && !dy) return;
    let deg=Math.atan2(dy,dx)*180/Math.PI+90;
    deg=((Math.round(deg/5)*5)%360+360)%360;
    if(deg===opts.bgAngle) return;
    opts.bgAngle=deg;
    syncDial();
    if(!raf) raf=requestAnimationFrame(()=>{ raf=0; render(); });
  };
  dial.addEventListener("pointerdown",e=>{ turning=true; before=snapBefore(); try{dial.setPointerCapture(e.pointerId);}catch(_){} setFromEvent(e); });
  dial.addEventListener("pointermove",e=>{ if(turning) setFromEvent(e); });
  ["pointerup","pointercancel"].forEach(ev=>dial.addEventListener(ev,()=>{ turning=false; render(); pushUndo(before); before=null; }));
})();
$("slotArt").onclick=()=>$("file").click();
$("drop").onclick=()=>$("file").click();
$("file").onchange=e=>{ loadFiles(e.target.files); e.target.value=""; };
$("resetBtn").onclick=()=>{ clearAllDocs(); };
$("docToastUndo").addEventListener("click",undoCloseDoc);
$("docGridClose").addEventListener("click",closeDocGrid);
$("docGridApply").addEventListener("click",applySettingsToTicked);
$("docGridZip").addEventListener("click",dlZipBatchGo);
$("dlProof").onclick=dlProof;
$("dlPrint").onclick=dlPrint;
$("dlCut").onclick=dlCut;
$("dlZip").onclick=dlZip;
$("saveDesignBtn").addEventListener("click",saveDesign);
$("showDesignsBtn").addEventListener("click",()=>{
  const l=$("savedList");
  l.style.display = l.style.display==="none" ? "" : "none";
  renderSavedList();
  syncDesignsBtn();
});
/* v4.0 (Thomas: "it's also not obvious enough how to collapse design library once open"): while the
   list is open MY DESIGNS reads CLOSE DESIGNS with an up-chevron and takes the chosen look
   (.is-open, proof-lab.css); the same button closes it */
function syncDesignsBtn(){
  const b=$("showDesignsBtn"), l=$("savedList"); if(!b||!l) return;
  const open=l.style.display!=="none";
  if(!b.__shut) b.__shut=b.innerHTML;
  if(open===b.classList.contains("is-open")) return;
  b.classList.toggle("is-open",open);
  b.setAttribute("aria-expanded",open?"true":"false");
  b.innerHTML = open
    ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 15 6-6 6 6"/></svg>'+stkEsc(stkT("stk.studio.tool.close_designs","Close designs"))
    : b.__shut;
}

/* ===== THE THREE STEPS (v1.7, Thomas 12 Sep 16:20): 1 Artwork, 2 Design, 3 Order, one open
   at a time. The tick FOLDS a step into a green chip in the strip at the top of the panel and
   opens the next; the chip reopens it (its icon is the step's own, cloned). Step 3 appears
   once there is a design to order. */
const STEP_IDS=[1,2,3];
const stepEl=n=>root.getElementById("step"+n);
function stepOpenable(n){ const el=stepEl(n); return !!el && !el.hidden; }
function renderStepStrip(){
  const strip=root.getElementById("stepStrip"); if(!strip) return;
  const folded=STEP_IDS.map(stepEl).filter(el=>el&&el.classList.contains("is-folded"));
  strip.innerHTML="";
  strip.hidden=!folded.length;
  folded.forEach(el=>{
    const b=document.createElement("button");
    b.type="button"; b.className="stepchip";
    b.title=stkFmt(stkT("stk.studio.tool.reopen_step","Reopen [step]"),{step:(el.querySelector(".step__t")||{textContent:""}).textContent});
    const ic=document.createElement("span"); ic.className="stepchip__ic";
    const svg=el.querySelector(".step__ic svg");
    if(svg) ic.appendChild(svg.cloneNode(true));
    const t=document.createElement("span");
    t.textContent=(el.querySelector(".step__t")||{textContent:""}).textContent;
    b.appendChild(ic); b.appendChild(t);
    b.addEventListener("click",()=>openStep(+el.getAttribute("data-step")));
    strip.appendChild(b);
  });
}
function openStep(n){
  STEP_IDS.forEach(i=>{
    const el=stepEl(i); if(!el) return;
    if(i===n){ el.classList.remove("is-folded"); el.classList.remove("collapsed"); }
    else el.classList.add("collapsed");
  });
  renderStepStrip();
  try{ root.host.dataset.plStep=String(n); }catch(e){}
  if(n===2) try{ if(typeof window.__plSegReset==="function") window.__plSegReset(); }catch(e){}
  /* v2.9: the panel foot and the canvas follow the open step; registered by the cart module */
  try{ if(typeof window.__plStepChanged==="function") window.__plStepChanged(n); }catch(e){}
  /* v2.9: the sliding chip highlight is gone (static fill); this re-measure is kept for a lab that still has one */
  try{
    const cm=root.getElementById("cartMount");
    if(cm && window.LabCart && window.LabCart.picker){
      requestAnimationFrame(()=>window.LabCart.picker.placeChips(cm,false));
    }
  }catch(e){}
  const el=stepEl(n);
  /* P170 page (Thomas, 28 Sep, live: "When I upload an image it auto scrolls too far down it should stay where it is"):
     on the product page this scroll moves the Studio sheet's own panel; on the Proof Lab page the panel does not
     scroll (the tool fits its box), so scrollIntoView moved the whole PAGE and pushed the lab's title bar off screen.
     The page is left where it is. */
  const inlinePage = !!(root.host && root.host.dataset && root.host.dataset.inline==="1");
  if(el && el.scrollIntoView && !inlinePage) try{
    /* v3.0 (24 Sep 2026), phones: the preview is pinned over the top of the scrolling panel,
       so a step scrolled to the panel's top edge opened UNDER it. Measured at 390x844 after an
       upload: DESIGN's head at y125 and its SIZE row at y317, the pinned preview y62 to 399.
       The opened step now lands just below the preview, head first. */
    const sw=root.querySelector(".stagewrap");
    const r=sw?sw.getBoundingClientRect():null;
    let pin=(r && r.height>0 && getComputedStyle(sw).position==="sticky")?Math.round(r.height):0;
    /* v3.1: with no canvas (ORDER on a phone) the sheet's floating wordmark row is what covers the top */
    if(!pin){ try{ const bar=root.host.closest(".plx-panel")&&root.host.closest(".plx-panel").querySelector(".plx-bar");
      if(bar && getComputedStyle(bar).position==="absolute") pin=Math.round(bar.getBoundingClientRect().height); }catch(e){} }
    el.style.scrollMarginTop=pin?(pin+6)+"px":"";
    el.scrollIntoView({block:pin?"start":"nearest"});
  }catch(e){}
}
function foldStep(n){
  const el=stepEl(n); if(!el) return;
  /* v2.9 (note 10): every NEXT autosaves the open design (one autosave record per design, overwritten) */
  try{ if(art && typeof autoSaveDesign==="function") autoSaveDesign(); }catch(e){}
  el.classList.add("is-folded"); el.classList.add("collapsed");
  el.classList.add("is-done");                 // v2.6: the tick turns green and stays green when reopened
  renderStepStrip();
  /* open the next step that is available and not already put away */
  const next=STEP_IDS.filter(i=>i>n).find(i=>stepOpenable(i)&&!stepEl(i).classList.contains("is-folded"));
  if(next) openStep(next);
  else { const back=STEP_IDS.find(i=>stepOpenable(i)&&!stepEl(i).classList.contains("is-folded")); if(back) openStep(back); }
}
root.querySelectorAll(".step").forEach(el=>{
  const head=el.querySelector(".step__head"); if(!head) return;
  head.addEventListener("click",e=>{
    if(e.target.closest("[data-tick]")) return;      // the tick is not a toggle
    const n=+el.getAttribute("data-step");
    if(n) { if(el.classList.contains("collapsed")) openStep(n); else el.classList.add("collapsed"); }
    else el.classList.toggle("collapsed");           // any card that is not a numbered step
  });
  const tick=el.querySelector("[data-tick]");
  if(tick) tick.addEventListener("click",e=>{ e.stopPropagation(); foldStep(+el.getAttribute("data-step")); });
});
renderStepStrip();
/* the four slots are drawn at mount, not on the first upload: an empty strip
   said nothing about four designs fitting in one order */
renderDocTabs();

/* ARTWORK IS UPLOAD ONLY (Thomas, 12 Sep 18:05). Remove background is an
   artwork treatment, so it MOVES to DESIGN: the same nodes, the same listeners,
   the same ids, so every existing handler still works.
   v2.9 (Thomas, 17 Sep 14:40): SAVED DESIGNS is no longer buried in a step. It is a
   card at the TOP of the panel, above the step chips: the save state in words, the
   count, SAVE and MY DESIGNS as two clear buttons. Same nodes, same IndexedDB store.
   The FINISHED EDITING button is gone: the panel foot carries one green NEXT. */
{
  const s1b = root.getElementById("step1").querySelector(".step__body");
  const s2b = root.getElementById("step2").querySelector(".step__body");
  const rmRow = root.getElementById("rmBg") && root.getElementById("rmBg").closest(".row");
  const gTol  = root.getElementById("gTol");
  const saved = root.getElementById("savedGroup");
  if(s2b && rmRow){
    const holder = document.createElement("div");
    holder.className = "group"; holder.id = "gRemoveBg";
    holder.appendChild(rmRow);
    if(gTol) holder.appendChild(gTol);
    rmRow.style.marginTop = "0";
    s2b.insertBefore(holder, s2b.firstChild);
  }
  const strip = root.getElementById("stepStrip");
  if(saved && strip && strip.parentNode){
    const card = document.createElement("div"); card.className = "savecard"; card.id = "saveCard";
    /* v2.9.2 (R2): DESIGN LIBRARY, the same header as the ARTWORK and DESIGN steps (same tile, glyph size, type) */
    card.innerHTML = '<div class="step__head savecard__head"><span class="step__ic step__ic--g"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m16 6 4 14"/><path d="M12 6v14"/><path d="M8 8v12"/><path d="M4 4v16"/></svg></span><span class="step__t savecard__t">'+stkEsc(stkT("stk.studio.save.library","Design Library"))+'</span><span class="savecard__n" id="savedCount"></span><a class="savecard__who" id="savedWho" href="#"></a></div>'+
      '<div class="savecard__state" id="savedState">'+stkEsc(stkT("stk.studio.save.state_empty","Upload a design to save it"))+'</div>'+
      '<div class="savecard__acts" id="savedActs"></div>';
    const acts = card.querySelector("#savedActs");
    const sb = root.getElementById("saveDesignBtn"), mb = root.getElementById("showDesignsBtn");
    if(sb){ sb.removeAttribute("style"); sb.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"/><path d="M17 21v-8H7v8"/><path d="M7 3v5h8"/></svg>'+stkEsc(stkT("stk.studio.save.save","Save")); acts.appendChild(sb); }
    if(mb){ mb.removeAttribute("style"); mb.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>'+stkEsc(stkT("stk.studio.tool.my_designs","My designs")); acts.appendChild(mb); }
    const list = root.getElementById("savedList"), hint = root.getElementById("savedHint");
    if(list) card.appendChild(list);
    if(hint) card.appendChild(hint);
    strip.parentNode.insertBefore(card, strip);
    /* v2.9.3: A TAP HAS TO LATCH IT. On the phone ORDER step the card is collapsed to its
       header row, and the CSS opens it on :hover / :focus-within - which a touch screen
       fires on the first tap and drops on the next, so it could never be held open. The
       header toggles .savecard__head's card instead, and reports it for assistive tech. */
    const shead=card.querySelector(".savecard__head");
    if(shead){
      shead.setAttribute("role","button"); shead.setAttribute("tabindex","0"); shead.setAttribute("aria-expanded","false");
      const tog=()=>{ const on=card.classList.toggle("is-open"); shead.setAttribute("aria-expanded",on?"true":"false"); };
      shead.addEventListener("click",tog);
      shead.addEventListener("keydown",e=>{ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); tog(); } });
    }
    saved.remove();
  }

  const fromProduct = root.host && root.host.dataset.fromProduct === "1";
  const reset = root.getElementById("resetBtn");
  if(fromProduct && reset && s1b){ reset.classList.add("is-inpanel"); s1b.appendChild(reset); }
}

/* ===== v3.2 (24 Sep 2026): DESIGN IN FOUR PANES ON A PHONE =========================================
   v3.1 scrolled one long list to each segment; Thomas: "these sections should be separated on mobile
   and centred. no scrolling down." Each pane is shown alone, centred in the room left between the
   canvas and the foot: 1 Size / 2 Shape (corners, remove background) / 3 Border (width, smoothing) /
   4 Colour. Border and its colour were one segment in his note; together they are ~340px against the
   ~260px a phone has there, so colour is its own pane. The groups keep their DOM place, so desktop
   is unchanged; data-pane tags them and proof-lab.css shows the one in :host([data-seg]).
   NEXT walks the panes before it moves on to ORDER (window.__plSegNext). --pl-avail is the room the
   pane has; --pl-pin the pinned canvas's height. */
{
  const s2 = root.getElementById("step2"), b2 = s2 && s2.querySelector(".step__body");
  const gSize = root.getElementById("sizeSeg") && root.getElementById("sizeSeg").closest(".group");
  const gShape = root.getElementById("shapeSeg") && root.getElementById("shapeSeg").closest(".group");
  if(b2 && gSize && gShape){
    gSize.id = "gSize"; gShape.id = "gShape";
    /* SIZE LAST (Thomas, 21 Oct 2026: "size should be the last step, not first"): the last pane on a phone, the last group on desktop */
    const SEGS = [[stkT("stk.studio.tool.shape","Shape"),["gOwnCut","gShape","gSnap","gCorner","gFit","gRemoveBg"]],[stkT("stk.studio.tool.border","Border"),["gBorder","gSmooth"]],[stkT("stk.labs.bookmark.ui.colour","Colour"),["gBgBlock"]],[stkT("stk.studio.tool.size","Size"),["gSize"]]];  /* P172 (2 Oct 2026): the four names in the page language */
    SEGS.forEach((g,i)=>g[1].forEach(id=>{ const el = root.getElementById(id); if(el) el.setAttribute("data-pane", String(i)); }));
    b2.appendChild(gSize); gSize.style.order="98";   /* after Colour (the stylesheet orders the groups; ::after is 99) */
    { const st=document.createElement("style"); st.textContent="@media (min-width:768px){#gShape{border-top:0;padding-top:0}#gSize{padding-top:14px;border-top:1.5px solid var(--line)}.app.dark #gSize{border-top-color:#3a3a41}}"; root.appendChild(st); }   /* the hairline moves with it: above Size, none above the first group */
    const nav = document.createElement("div");
    nav.className = "segnav";
    nav.innerHTML = SEGS.map((g,i)=>'<button type="button" class="segnav__b'+(i?'':' on')+'" data-seg="'+i+'" title="'+stkEsc(g[0])+'"'+(i?'':' aria-current="step"')+'><span class="segnav__n">'+(i+1)+'</span>'+stkEsc(g[0])+'</button>').join("");
    b2.insertBefore(nav, b2.firstChild);
    const isPhone = ()=>!!(window.matchMedia && window.matchMedia("(max-width:767px)").matches);
    const box = ()=>(root.host && root.host.closest && root.host.closest(".plx-body")) || null;
    const sw = root.querySelector(".stagewrap");
    const pinH = ()=>{ if(!sw) return 0; const r = sw.getBoundingClientRect(); return (r.height>0 && getComputedStyle(sw).position==="sticky") ? r.height : 0; };
    /* v3.5 (Thomas: "in 1 2 and 3 the artwork field is the same size ... yet 4 colour minifies it",
       and a pane with blank space under it). ONE CANVAS SIZE ON A PHONE, on every step and pane: the
       sheet less the pane bar, a pane area sized for the tallest ordinary pane (Colour, 250px) and the
       foot, between a 200px floor (120 with the keyboard up) and the old 40% + 56px. A pane that is
       taller in an unusual state (background removal on, Corners, a gradient) scrolls up and down
       inside itself; the canvas never changes size between panes. */
    /* P170 page (Thomas, 28 Sep: "the artwork screen still isnt big enough"): the controls slot is sized for the
       Size and Shape panes (145 and 137px of controls, measured at 375 and 402 wide) with a little air, not for
       Colour; Border (218) and Colour (269) scroll inside their slot. The artwork takes everything else. */
    /* both tools since the Studio sync (Thomas, 28 Sep: "Apply all those differences to studio") */
    const PANE = 180;
    function fitOld(){   /* the layout before the sheet (21 Oct 2026): no artwork, not on DESIGN, or no sheet */
      try{
        if(!isPhone()) return;
        const sb = box(), pb = root.querySelector(".panel__body"); if(!sb || !pb) return;
        const sheet = sb.clientHeight;
        const navH = nav.getBoundingClientRect().height || 57;
        const foot = root.getElementById("cartFoot");
        const footH = (foot && foot.getBoundingClientRect().height) || 110;
        const reserve = Math.round(footH);
        const padTop = parseFloat(getComputedStyle(pb).paddingTop||0) || 0;
        const full = Infinity;
        const stageH = Math.max(200, Math.min(full, Math.round(sheet - navH - PANE - padTop - reserve - 2)));
        const hs = root.host.style;
        hs.setProperty("--pl-stageh", stageH+"px");
        hs.setProperty("--pl-footh", reserve+"px");
        /* the pinned block's real height (read after the new size applies), then whatever still makes
           the sheet itself scroll on DESIGN is measured and taken off the pane */
        const pin = Math.round(pinH()) || (stageH + 2);
        let avail = Math.max(120, Math.round(sheet - pin - padTop - reserve));
        hs.setProperty("--pl-avail", avail+"px");
        hs.setProperty("--pl-pin", pin+"px");
        /* v3.7 (Thomas: "that window of controls should go all the way down to the line"): measured
           from where the pane actually starts to the foot's top edge */
        const br = b2.getBoundingClientRect(), fr = foot && foot.getBoundingClientRect();
        if(br.height > 0 && fr && fr.height > 0){
          avail = Math.max(120, Math.round(fr.top - br.top));
          hs.setProperty("--pl-avail", avail+"px");
        }
        if(br.height > 0){
          const over = sb.scrollHeight - sb.clientHeight;
          if(over > 0){ avail = Math.max(120, avail - over); hs.setProperty("--pl-avail", avail+"px"); }
        }
      }catch(e){}
    }
    /* ===== THE PHONE SHEET (21 Oct 2026, Thomas: "the sticker studio didn't get the same update as the bookmark one where the
       options is a drawer that can be extended"). The bookmark Studio's sheet (bookmark-studio-2026-10-18/src/studio_layer.js
       v2.3, same constants, same gestures) on these panes: a grab bar heads the options with the pane dots under it; three
       snaps: collapsed (no pane, the canvas nearly the whole screen), default (the pane's controls, the canvas keeps about a
       third of the sheet), expanded (every control of the pane, a 130 px canvas). A vertical drag on the bar or the dots moves
       it (the direction locks after 8 px), on the controls too when they cannot scroll that way; a tap on the bar toggles; the
       canvas refits as it moves; the last snap is kept for the session. Only on a phone, on DESIGN, once there is artwork:
       otherwise the layout above (fitOld) is unchanged. Desktop draws no sheet. ===== */
    const SHEET_R=20, FLOOR=176, CANVAS_DEF=0.31, CANVAS_MIN=130;
    const sheetHead=document.createElement("div"); sheetHead.className="bmsheet"; sheetHead.id="plSheet";
    sheetHead.innerHTML='<button type="button" class="bmsheet__grab" id="plGrab" aria-label="'+stkEsc(stkT("stk.studio.bm.sheet","Show or hide the options"))+'" aria-expanded="true"><span></span></button>';
    const pbody=root.querySelector(".panel__body"); if(pbody) pbody.insertBefore(sheetHead, pbody.firstChild);
    const grab=sheetHead.querySelector("#plGrab");
    let snap="default", curA=0, lastCH=null, drag=null, overT=0, navHome=null, fitKey="";
    try{ const v=sessionStorage.getItem("pls-sheet"); if(v==="collapsed"||v==="default"||v==="expanded") snap=v; }catch(e){}
    const HS=()=>root.host;
    function headOn(){ return isPhone() && HS().dataset.plStep==="2" && !!art; }
    function syncHead(){
      const on=headOn(), v=on?"1":"0";
      if(HS().dataset.plHead!==v) HS().dataset.plHead=v;
      if(HS().dataset.plSheet!==snap) HS().dataset.plSheet=snap;
      /* the dots ride in the sheet's head while it is drawn, and go back to the pane when it is not */
      if(on && nav.parentNode!==sheetHead){ navHome=nav.parentNode; nav.classList.add("bmsheet__dots"); sheetHead.appendChild(nav); }
      else if(!on && nav.parentNode===sheetHead && b2){ nav.classList.remove("bmsheet__dots"); b2.insertBefore(nav, b2.firstChild); }
      return on;
    }
    function contentH(){
      const hs=HS().style, prev=hs.getPropertyValue("--pls-paneh"), keep=b2.scrollTop, sb=box(), keepSb=sb ? sb.scrollTop : 0;
      hs.setProperty("--pls-paneh","auto");
      const h=Math.ceil(b2.getBoundingClientRect().height);
      if(prev) hs.setProperty("--pls-paneh",prev); else hs.removeProperty("--pls-paneh");
      if(b2.scrollTop!==keep) b2.scrollTop=keep;
      if(sb && sb.scrollTop!==keepSb) sb.scrollTop=keepSb;
      return h;
    }
    function metrics(){
      const sb=box(), pb=root.querySelector(".panel__body"); const sheet=(sb && sb.clientHeight) || window.innerHeight;
      const headH=HS().dataset.plHead==="1" ? sheetHead.getBoundingClientRect().height : 0;
      const foot=root.getElementById("cartFoot"); const footH=(foot && foot.getBoundingClientRect().height) || 65;
      const padTop=pb ? (parseFloat(getComputedStyle(pb).paddingTop||0)||0) : 0;
      return { sheet:sheet, headH:headH, footH:footH, padTop:padTop, room:Math.max(0, sheet-headH-footH-padTop-2) };
    }
    function snapA(kind, m, ch){
      if(kind==="collapsed") return 0;
      if(kind==="expanded") return Math.max(0, Math.min(Math.max(ch, FLOOR), m.room-CANVAS_MIN));
      return Math.max(0, Math.min(Math.max(ch, FLOOR), m.room-Math.round(m.sheet*CANVAS_DEF)));
    }
    function apply(A, m){
      const hs=HS().style;
      const stageH=Math.max(120, Math.round(m.sheet - m.headH - A - m.footH - m.padTop - 2 + SHEET_R));   /* the rounded top overlaps the canvas by its radius */
      hs.setProperty("--pl-stageh", stageH+"px");
      hs.setProperty("--pls-paneh", Math.round(A)+"px");
      hs.setProperty("--pl-avail", Math.round(A)+"px");
      hs.setProperty("--pl-footh", Math.round(m.footH)+"px");
      hs.setProperty("--pl-pin", (stageH+2)+"px");
      return stageH;
    }
    function fit(remeasure){
      try{
        if(drag) return;   /* a finger has the sheet: it slides, nothing is laid out until it lets go */
        if(!isPhone()){ syncHead(); return fitOld(); }
        if(!syncHead()){ HS().style.removeProperty("--pls-paneh"); return fitOld(); }
        if(HS().dataset.kb==="1") return;   /* the keyboard: the sheet keeps its height */
        if(remeasure || lastCH==null) lastCH=contentH();
        const m=metrics();
        curA=snapA(snap, m, lastCH);
        /* nothing that shapes the sheet has changed (a resize observer echoing the last layout): that layout, with its overflow
           correction, stands - re-applying it un-corrected eased the canvas 3 px and back after every snap (21 Oct 2026) */
        const fk=[Math.round(curA), Math.round(m.sheet), Math.round(m.headH), Math.round(m.footH), Math.round(m.padTop), snap].join(",");
        if(!remeasure && fk===fitKey) return;
        fitKey=fk;
        let stageH=apply(curA, m);
        /* a drag's snap (21 Oct 2026): what would make the sheet scroll comes off the canvas now, in this one layout, not 280 ms
           later as a second resize */
        if(root.host.__settleOnce){ try{ const sb=box(), over=sb ? sb.scrollHeight-sb.clientHeight : 0; if(over>1){ stageH=Math.max(120, stageH-over); root.host.style.setProperty("--pl-stageh", stageH+"px"); root.host.style.setProperty("--pl-pin", (stageH+2)+"px"); } }catch(e){} }
        clearTimeout(overT);
        overT=setTimeout(()=>{ try{
          const sb=box(); if(!sb || drag || !headOn()) return;
          const over=sb.scrollHeight - sb.clientHeight;
          if(over>1){ stageH=Math.max(120, stageH-over); HS().style.setProperty("--pl-stageh", stageH+"px"); HS().style.setProperty("--pl-pin", (stageH+2)+"px"); }
        }catch(e){} }, 280);
        const fits=(lastCH<=curA+2) ? "1" : "0"; if(HS().dataset.plFits!==fits) HS().dataset.plFits=fits;
      }catch(e){}
    }
    function setSnap(k){
      snap=k;
      try{ sessionStorage.setItem("pls-sheet",k); }catch(e){}
      grab.setAttribute("aria-expanded", k==="collapsed"?"false":"true");
      fit(false);
    }
    function tapGrab(){
      const m=metrics(), ch=lastCH==null?contentH():lastCH;
      if(snap==="collapsed") setSnap("default");
      else if(snap==="expanded") setSnap("default");
      else setSnap(snapA("expanded",m,ch) > snapA("default",m,ch)+4 ? "expanded" : "collapsed");
    }
    /* THE DRAG SLIDES THE SHEET, NOT THE LAYOUT (21 Oct 2026, Thomas on live iPhone: "when dragging the tray up and down it
       vibrates or flickers badly"). Measured in WebKit at 390: the sticker sheet jumped back to its snap twice in a 600 ms drag
       (a resize observer re-applied the snap mid-drag) and every finger move re-laid out the page; the bookmark's canvas was
       resized on every move (35 in one drag). Now, while a finger holds the sheet: it slides with transform, one update per
       animation frame, transitions off, nothing laid out and the canvas untouched; the edit bar rides on the sheet's top and the
       tool / zoom columns keep to the middle of what shows. On release it eases to the snap, then the layout takes that snap in
       the frame the slide is cleared: the canvas is resized once. */
    let sdRaf=0;
    function plDragFlag(on){ try{ if(on) HS().dataset.plDrag="1"; else delete HS().dataset.plDrag; }catch(e){} }
    function sdMoves(){
      const out=[], add=(el,k)=>{ if(!el || !el.getClientRects().length) return; const cs=getComputedStyle(el); out.push([el,k,(cs.transform && cs.transform!=="none")?cs.transform:"",el.style.transform]); };
      const pnl=root.querySelector(".panel"), ft=root.getElementById("cartFoot");
      add(pnl,1);
      if(ft && pnl && pnl.contains(ft) && getComputedStyle(ft).position==="fixed"){
        /* the foot is fixed inside the sheet: a transform on the sheet makes the sheet its frame, so it is held where it was */
        const a=ft.getBoundingClientRect(), keep=pnl.style.transform; pnl.style.transform="translate3d(0,0,0)"; const b=ft.getBoundingClientRect(); pnl.style.transform=keep;
        out.push([ft,-1,"",ft.style.transform,Math.round(a.left-b.left),Math.round(a.top-b.top)]);
      }
      const bar=root.getElementById("eraseBar"); if(bar && erasing) add(bar, bar.parentElement && bar.parentElement.classList.contains("canvas-tools") ? 0.5 : 1);
      const ce=root.getElementById("ctoolErase"), ct=ce && ce.parentElement; add(ct,0.5); add(root.getElementById("zoomctl"),0.5);
      return out;
    }
    function sdMoveTo(list, off, ease){
      list.forEach(([el,k,base,_,dx,dy])=>{ el.style.transition=ease||"none"; el.style.transform=(base?base+" ":"")+"translate3d("+(dx||0)+"px,"+(Math.round(off*k)+(dy||0))+"px,0)"; });
    }
    function sdFill(on, list){
      /* what a slide uncovers is painted in the colours that will be there: the sheet's below it, the canvas's above it */
      try{
        const pnl=root.querySelector(".panel"), sw=root.querySelector(".stagewrap");
        if(on){ if(pnl) pnl.style.boxShadow="0 640px 0 0 "+getComputedStyle(pnl).backgroundColor; if(sw) sw.style.boxShadow="0 640px 0 0 "+getComputedStyle(sw).backgroundColor; }
        else { if(pnl) pnl.style.boxShadow=""; if(sw) sw.style.boxShadow=""; }
      }catch(e){}
    }
    function sdPaint(){ sdRaf=0; const d=drag; if(!d) return; sdMoveTo(d.moves, d.A0-curA, ""); }
    function dragStart(y){
      const m=metrics();
      drag={ y0:y, A0:curA, m:m, ch:lastCH==null?contentH():lastCH, lastY:y, lastT:performance.now(), v:0 };
      plDragFlag(true);
      drag.moves=sdMoves(); drag.moves.forEach(([el])=>{ el.style.willChange="transform"; });
      sdFill(true);
    }
    function dragMove(y){
      const d=drag; if(!d || d.done) return;
      const now=performance.now(), dt=Math.max(1, now-d.lastT);
      d.v=0.6*d.v + 0.4*((y-d.lastY)/dt); d.lastY=y; d.lastT=now;
      const maxA=Math.max(snapA("expanded", d.m, d.ch), snapA("default", d.m, d.ch));
      curA=Math.max(0, Math.min(maxA, d.A0-(y-d.y0)));
      if(!sdRaf) sdRaf=requestAnimationFrame(sdPaint);
    }
    function dragEnd(){
      const d=drag; if(!d || d.done) return; d.done=true;
      if(sdRaf){ cancelAnimationFrame(sdRaf); sdRaf=0; }
      const proj=curA - d.v*200;   /* a flick carries on in its direction */
      let best="default", bd=1e9;
      ["collapsed","default","expanded"].forEach(k=>{ const a=snapA(k, d.m, d.ch), dd=Math.abs(a-proj); if(dd<bd-0.5){ bd=dd; best=k; } });
      const A=snapA(best, d.m, d.ch), still=Math.abs(A-curA)<1;
      sdMoveTo(d.moves, d.A0-A, still ? "" : "transform .2s cubic-bezier(.2,.8,.2,1)");
      setTimeout(()=>{
        drag=null;
        d.moves.forEach(([el,k,base,inline])=>{ el.style.transition="none"; el.style.transform=inline||""; el.style.willChange=""; });
        /* 22 Oct 2026 (Thomas, live iPhone: the NEXT / ORDER foot mid-screen after a drag): iOS WebKit keeps a position:fixed
           descendant pinned to an ancestor that was transformed and is not any more (measured on the simulator: the foot's top
           650 -> 432 after one transform on the sheet; a display none / '' reflow puts it back, nothing else did). The foot (the
           -1 entry) gets that reflow once the sheet's transform is off. */
        try{ d.moves.forEach(([el,k])=>{ if(k===-1){ el.style.display="none"; void el.offsetHeight; el.style.display=""; } }); }catch(e){}
        sdFill(false);
        curA=A; apply(A, d.m);   /* the one layout: the pane and the canvas take the snap now (also with a field focused) */
        try{ root.host.__settleOnce=true; setSnap(best); }finally{ root.host.__settleOnce=false; }
        try{ plColsLayout(); }catch(e){}
        requestAnimationFrame(()=>{ d.moves.forEach(([el])=>{ el.style.transition=""; }); plDragFlag(false); });
      }, still ? 0 : 210);
    }
    const ownT=t=>{
      for(let el=t; el && el!==b2 && el!==sheetHead; el=el.parentElement){
        if(el.matches && el.matches('input,select,textarea,canvas,[role="slider"],.dial,.segslider,.swatches')) return true;
        const cs=getComputedStyle(el);
        if(cs.touchAction==="none") return true;
        if((cs.overflowX==="auto"||cs.overflowX==="scroll") && el.scrollWidth>el.clientWidth+2) return true;
      }
      return false;
    };
    const canScroll=dy=>{ const room=b2.scrollHeight-b2.clientHeight; if(room<=2) return false; return dy>0 ? b2.scrollTop>0 : b2.scrollTop<room-1; };
    /* sideways drags stay the panes' own swipe (above); this only ever takes a vertical one */
    function wire(el, isHead){
      let sx=0, sy=0, mode="off";
      el.addEventListener("touchstart", e=>{
        mode="off";
        if(!headOn() || e.touches.length!==1) return;
        if(!isHead && ownT(e.target)) return;
        sx=e.touches[0].clientX; sy=e.touches[0].clientY; mode="wait"; sheetHead.__dragged=false;
      }, {passive:true});
      el.addEventListener("touchmove", e=>{
        if(mode==="off" || mode==="scroll" || e.touches.length!==1) return;
        const x=e.touches[0].clientX, y=e.touches[0].clientY, dx=x-sx, dy=y-sy;
        if(mode==="wait"){
          if(Math.abs(dx)<8 && Math.abs(dy)<8) return;
          if(Math.abs(dy)>Math.abs(dx)){
            if(isHead || !canScroll(dy)){ mode="sheet"; sheetHead.__dragged=true; dragStart(sy); }
            else { mode="scroll"; return; }
          } else { mode="off"; return; }
        }
        if(mode==="sheet"){ if(e.cancelable) e.preventDefault(); dragMove(y); }
      }, {passive:false});
      el.addEventListener("touchend", ()=>{ if(mode==="sheet"){ dragEnd(); setTimeout(()=>{ sheetHead.__dragged=false; }, 30); } mode="off"; }, {passive:true});
      el.addEventListener("touchcancel", ()=>{ if(mode==="sheet") dragEnd(); mode="off"; }, {passive:true});
    }
    wire(sheetHead, true); wire(b2, false);
    /* a mouse on the bar (the Mac app's narrow window, a desktop browser at phone width): drag or click it */
    grab.addEventListener("pointerdown", e=>{
      if(e.pointerType==="touch" || !headOn()) return;
      const y0=e.clientY; let moved=false; try{ grab.setPointerCapture(e.pointerId); }catch(err){}
      const mv=ev=>{ if(!moved && Math.abs(ev.clientY-y0)<6) return; if(!moved){ moved=true; sheetHead.__dragged=true; dragStart(y0); } dragMove(ev.clientY); };
      const up=()=>{ grab.removeEventListener("pointermove",mv); grab.removeEventListener("pointerup",up); grab.removeEventListener("pointercancel",up); if(moved){ dragEnd(); setTimeout(()=>{ sheetHead.__dragged=false; }, 30); } };
      grab.addEventListener("pointermove",mv); grab.addEventListener("pointerup",up); grab.addEventListener("pointercancel",up);
    });
    sheetHead.addEventListener("click", e=>{ if(sheetHead.__dragged) return; if(e.target.closest("#plGrab")) tapGrab(); });
    if(window.ResizeObserver){ try{ const ro2=new ResizeObserver(()=>requestAnimationFrame(()=>{ if(!drag) fit(false); })); ro2.observe(sheetHead); }catch(e){} }
    window.addEventListener("resize", ()=>{ lastCH=null; fit(true); });
    { let hk=""; setInterval(()=>{ const k=(art?"1":"0")+(HS().dataset.plStep||"")+(isPhone()?"p":"d"); if(k!==hk){ hk=k; lastCH=null; fit(true); } }, 400); }
    window.__plSheet = (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role!=="main") ? { snap:()=>snap, A:()=>curA, set:setSnap, m:()=>metrics(), ch:()=>lastCH, fit:fit } : undefined;
    /* the bookmark Studio's sheet look (its CSS, here for this host): the rounded top with the hairline round the curve,
       the bar 8 px from the top, the dots tucked under it, the pane 3 px below */
    { const st=document.createElement("style"); st.textContent=
      ".bmsheet{display:none}"+
      "@media (max-width:767px){"+
      ":host(proof-lab-tool[data-pl-head=\"1\"]) .bmsheet{display:block;position:relative;z-index:7;padding:0;touch-action:none}"+
      ".bmsheet__grab{display:grid;place-items:start center;width:100%;height:13px;margin:0;padding:8px 0 0;box-sizing:content-box;border:0;background:none;cursor:grab;touch-action:none}"+
      ".bmsheet__grab:active{cursor:grabbing}"+
      ".bmsheet__grab span{display:block;width:40px;height:5px;border-radius:99px;background:#d6d6dc}"+
      ".bmsheet__grab:hover span{background:#c4c4cc}"+
      ".app.dark .bmsheet__grab span{background:#55555e}"+
      ".bmsheet .segnav.bmsheet__dots{position:relative !important;top:auto !important;display:flex !important;justify-content:center;align-items:center;margin:-5px 0 0 !important;padding:0 !important;min-height:0;background:none !important;border:0 !important;box-shadow:none !important;z-index:1}"+
      ":host(proof-lab-tool[data-pl-head=\"1\"]) #step2 .step__body{height:var(--pls-paneh,auto) !important;max-height:none !important;overflow-y:auto !important;padding-top:3px !important;transition:height .2s ease}"+
      ":host(proof-lab-tool[data-pl-sheet=\"collapsed\"][data-pl-head=\"1\"]) #step2 .step__body{padding-top:0 !important;padding-bottom:0 !important}"+
      ":host(proof-lab-tool[data-pl-drag]) .stage,:host(proof-lab-tool[data-pl-drag]) #step2 .step__body{transition:none !important}"+
      ":host(proof-lab-tool[data-pl-fits=\"1\"][data-pl-head=\"1\"]) #step2 .step__body{touch-action:none !important}"+
      ":host(proof-lab-tool[data-pl-head=\"1\"]) .stagewrap{border-bottom:0 !important}"+
      ":host(proof-lab-tool[data-pl-head=\"1\"]) .panel{position:relative;z-index:8 !important;margin-top:-20px;border:1px solid var(--line) !important;border-bottom:0 !important;border-radius:20px 20px 0 0;overflow:hidden}"+
      ":host(proof-lab-tool[data-pl-head=\"1\"]) .app.dark .panel{border-color:#3a3a41 !important}"+
      /* the columns keep clear of the rounded top and the corner buttons by plColsLayout (pl_fillwand.js) */

      "}";
      root.appendChild(st); }
    if(window.ResizeObserver){ try{ const ro = new ResizeObserver(()=>requestAnimationFrame(()=>fit()));   /* next frame: the sheet resizes what it observes */ if(sw) ro.observe(sw); const cf = root.getElementById("cartFoot"); if(cf) ro.observe(cf); }catch(e){} }
    window.addEventListener("resize", fit);
    let cur = 0;
    /* a pane with nothing to set is skipped and its dot hidden (Thomas, 28 Sep: a circle has no border settings, so
       NEXT landed on a blank Border pane). Border and cut smoothing exist for die-cut only. */
    const paneHas = k=>SEGS[k][1].some(id=>{ const el=root.getElementById(id); return !!el && !el.classList.contains("hidden") && el.style.display!=="none"; });
    const paneFrom = (k,dir)=>{ for(let j=k+dir;j>=0 && j<SEGS.length;j+=dir) if(paneHas(j)) return j; return -1; };
    function syncDots(){ nav.querySelectorAll(".segnav__b").forEach((b,k)=>{ b.hidden=!paneHas(k); }); }
    function show(i){
      i = Math.max(0, Math.min(SEGS.length-1, i));
      if(!paneHas(i)){ const f=paneFrom(i,1); i = f>=0 ? f : Math.max(0, paneFrom(i,-1)); }
      cur = i;
      syncDots();
      try{ root.host.dataset.seg = String(cur); }catch(e){}
      nav.querySelectorAll(".segnav__b").forEach((b,k)=>{ b.classList.toggle("on", k===cur); if(k===cur) b.setAttribute("aria-current","step"); else b.removeAttribute("aria-current"); });
      try{ if(typeof window.__plFootRefresh==="function") window.__plFootRefresh(); }catch(e){}
      fit(true); b2.scrollTop = 0;
      const sb = box(); if(sb && isPhone() && root.host.dataset.plStep==="2") sb.scrollTop = 0;
    }
    nav.addEventListener("click", e=>{ const b = e.target.closest("[data-seg]"); if(b) show(+b.getAttribute("data-seg")); });
    b2.addEventListener("click", ()=>{ setTimeout(()=>fit(true), 60); });
    show(0);
    /* P170 page on a phone (Thomas, 28 Sep: "swap them out for like 4 dots one green and 3 grey, and a swipe ... to go
       to the next"): the tabs are drawn as four dots (proof-lab.css) and a sideways swipe on the controls moves one
       pane either way. A drag that starts on a slider, a field, the canvas or a strip that scrolls sideways is left alone. */
    {
      let sx=0, sy=0, armed=false;
      const own = t=>{
        for(let el=t; el && el!==b2; el=el.parentElement){
          if(el.matches && el.matches('input,select,textarea,canvas,[role="slider"],.dial')) return true;
          const cs=getComputedStyle(el);
          if(cs.touchAction==="none") return true;   /* a control that owns its own drag (the gradient angle dial) */
          if((cs.overflowX==="auto"||cs.overflowX==="scroll") && el.scrollWidth>el.clientWidth+2) return true;
        }
        return false;
      };
      /* the last finger position is kept from touchmove, so a touch iOS cancels (it took the drag as a scroll) still
         counts; the controls take touch-action pan-y (proof-lab.css) so a sideways drag is never the browser's */
      let lx=0, ly=0;
      b2.addEventListener("touchstart", e=>{
        armed = isPhone() && e.touches.length===1 && !own(e.target);
        if(armed){ sx=lx=e.touches[0].clientX; sy=ly=e.touches[0].clientY; }
      }, {passive:true});
      b2.addEventListener("touchmove", e=>{ if(armed && e.touches.length===1){ lx=e.touches[0].clientX; ly=e.touches[0].clientY; } }, {passive:true});
      const swipeEnd = e=>{
        if(!armed) return; armed=false;
        const t=e.changedTouches && e.changedTouches[0];
        const ex=t ? t.clientX : lx, ey=t ? t.clientY : ly, dx=ex-sx, dy=ey-sy;
        if(Math.abs(dx)<48 || Math.abs(dx)<Math.abs(dy)*1.5) return;
        const to=paneFrom(cur, dx<0?1:-1); if(to<0) return;
        show(to);
      };
      b2.addEventListener("touchend", swipeEnd, {passive:true});
      b2.addEventListener("touchcancel", e=>{ if(!armed) return; swipeEnd({ changedTouches: null }); }, {passive:true});
    }
    /* v3.3: desktop has the panes too (Thomas, 24 Sep), so NEXT walks them wherever the bar is drawn */
    window.__plSegNext = function(){
      if(nav.getClientRects().length===0 || root.host.dataset.plStep!=="2") return false;
      const n=paneFrom(cur,1); if(n<0) return false;
      show(n); return true;
    };
    /* P170: the downloads page's single foot button reads NEXT while a pane is still to come */
    window.__plSegHasNext = function(){ return nav.getClientRects().length>0 && root.host.dataset.plStep==="2" && paneFrom(cur,1)>=0; };
    /* the shape decides which panes exist: re-check the dots, and leave a pane that has just emptied */
    window.__plSegSync = function(){ syncDots(); if(!paneHas(cur)) show(cur); try{ if(typeof window.__plFootRefresh==="function") window.__plFootRefresh(); }catch(e){} };
    window.__plSegReset = function(){ show(0); requestAnimationFrame(()=>requestAnimationFrame(fit)); };
  }
  /* v3.2 (Thomas: "when i clicked the custom size field ... i dont see the field or what im typing"):
     while the phone keyboard is up the pinned canvas and the foot step aside, and the field is brought
     to the middle of what is left. They come back when the keyboard goes. */
  let kbT = 0;
  const typing = el=>!!(el && el.tagName==="INPUT" && /^(text|number|search|tel|email|url)$/i.test(el.type||"text"));
  root.addEventListener("focusin", e=>{
    if(!(window.matchMedia && window.matchMedia("(max-width:767px)").matches) || !typing(e.target)) return;
    clearTimeout(kbT);
    try{ root.host.dataset.kb = "1"; }catch(err){}
    const el = e.target;
    setTimeout(()=>{ try{ el.scrollIntoView({ block:"nearest" }); }catch(err){} }, 400);
  });
  root.addEventListener("focusout", ()=>{
    clearTimeout(kbT);
    kbT = setTimeout(()=>{
      if(typing(root.activeElement)) return;
      try{ delete root.host.dataset.kb; }catch(err){}
      try{ const sb = root.host.closest(".plx-body"); if(sb && root.host.dataset.plStep==="2") sb.scrollTop = 0; }catch(err){}
    }, 150);
  });
}

/* "Add another design": back to step 1 with a fresh slot, and the one question
   worth asking before they upload. Yes is the default because addBlankDoc
   already clones the open design's settings - No resets them. */
{
  const ask=root.getElementById("sameAsk");
  const addAnother=root.getElementById("addAnother");
  /* Starting design 2, 3 or 4: the slot strip asks for the file, and everything
     else that used to hang off the Add another design button happens here, so
     the two routes cannot drift apart. */
  function beginAnotherDesign(){
    /* one design per order never asks: there is no second design to apply to */
    if(ask && docs.length>=1 && MAX_SLOTS>1){ fillSameTiles(); ask.hidden=false; }
    STEP_IDS.forEach(i=>{ const el=stepEl(i); if(el) el.classList.remove("is-folded"); });
    openStep(1);
    renderStepStrip();
  }
  window.__plBeginAnother=beginAnotherDesign;
  if(addAnother) addAnother.addEventListener("click",()=>{
    addBlankDoc(DEFAULT_ART);
    clearCanvasForNewDoc();
    beginAnotherDesign();
  });
  /* What "the same settings" actually are, said out loud before they are
     applied: the same tiles the proof window uses (Thomas, 12 Sep 20:30). */
  function fillSameTiles(){
    const host=root.getElementById("sameTiles"); if(!host) return;
    const SHAPE_T={custom:stkT("stk.studio.tool.shape_diecut","Die-cut"),circle:stkT("stk.studio.tool.shape_circle","Circle"),square:stkT("stk.studio.tool.shape_square","Square"),rect:stkT("stk.studio.tool.shape_rect","Corners")};
    /* v2.5: SIZE, FINISH and QUANTITY are the pack's, not this design's, so the
       prompt no longer offers them as a choice - offering a choice that is not
       taken is the same lie as taking one that was not offered. What is left is
       what really is per design: its shape and its border. */
    /* v2.6 (item 7, Thomas: "no icons and looks terrible"): Size, Shape and
       Border as three icon tiles in ONE row, the proof window's own tile - icon
       in a circle, label, value, centred. Size is the pack's and is shown so
       the customer sees what the new design will be cut at; it is not offered
       as a choice here, because it is not one. */
    const IC={
      size:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21 21 3"/><path d="M3 15v6h6"/><path d="M21 9V3h-6"/></svg>',
      shape:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 3c2.5 0 3 2.2 5 2.6 2 .5 4 1.6 3.4 3.9-.5 2.2 1 3-.4 5-1.3 1.9-1.4 4.6-3.8 4.9-2.3.3-2.7-1-4.2-1s-2.4 1.4-4.6 1c-2.3-.5-2.3-3-3.6-4.9C2.4 12.6 3.6 11.7 3.3 9.5 3 7.2 5 6.1 7 5.6c2-.4 2.5-2.6 5-2.6Z"/></svg>',
      border:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="4"/><rect x="7.5" y="7.5" width="9" height="9" rx="2"/></svg>'
    };
    const sizeTxt=opts.sizeCustomMm?stkDec(Number(opts.sizeCustomMm)/10,1)+"cm":(opts.sizeIn+"in");
    const tiles=[[stkT("stk.studio.tool.size","Size"),sizeTxt,IC.size],[stkT("stk.studio.tool.shape","Shape"),SHAPE_T[opts.shape]||opts.shape,IC.shape],
      [stkT("stk.studio.tool.border","Border"),opts.border?(stkDec(opts.borderMm,1)+"mm"):stkT("stk.studio.tool.none","None"),IC.border]];
    host.innerHTML=tiles.map(r=>'<div class="sametile"><span class="sametile__ic">'+r[2]+'</span><b>'+esc0(r[0])+'</b><span>'+esc0(String(r[1]))+'</span></div>').join("");
  }
  function esc0(s){ return String(s==null?"":s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c])); }
  /* CONFIRM means "nothing to design here", so DESIGN completes itself and
     ORDER opens - after the artwork lands, because an empty slot has no proof. */
  let skipDesign=false;
  if(ask) ask.addEventListener("click",e=>{
    const b=e.target.closest("[data-same]"); if(!b) return;
    if(b.getAttribute("data-same")==="0"){
      Object.assign(opts, JSON.parse(JSON.stringify(OPTS_DEFAULT)));
      applyPackSize();                       // v2.5: "Start over" restarts the DESIGN, not the pack's size
      syncControlsFromOpts();
      try{ render(); }catch(err){}
      skipDesign=false;
    } else {
      skipDesign=true;
      if(art) { foldStep(1); foldStep(2); }
    }
    ask.hidden=true;
  });
  window.__plSkipDesign=()=>{ const v=skipDesign; skipDesign=false; return v; };
}
/* the canvas has to go back to the drop state for the new, empty slot */
function clearCanvasForNewDoc(){
  try{
    if(animRaf){ cancelAnimationFrame(animRaf); animRaf=0; }
    $("preview").classList.add("hidden");
    $("drop").classList.remove("hidden");
    $("canvasTools").style.display="none";
    $("zoomctl").style.display="none";
    $("canvasDims").classList.remove("show");
    $("dpi").textContent=""; $("dpi").className="";
  }catch(e){}
}

/* ================= clean-up eraser =================
   Ported from Sticker Sheet Lab. Same idea - brush stray pixels off the artwork
   AND its silhouette so the cut line re-traces without them - but Proof Lab
   rebuilds `art` from `srcImg` on every settings change, so strokes CANNOT be
   stored against `art`. They are stored in work-canvas coordinates and replayed
   inside processSource, which is why changing removal colour or tolerance after
   erasing does not resurrect what was erased. AI/_rules/LAB-RULES.md rule 3: this is
   the eraser, the artwork's own pixels, never an algorithm guessing. */
const eraseRadiusPx = () => Math.max(1, (+$("eraseSize").value||2)*pxPerMm());
function punch(cnv,x,y,r){
  const c2=cnv.getContext("2d");
  c2.save(); c2.globalCompositeOperation="destination-out";
  c2.beginPath(); c2.arc(x,y,r,0,Math.PI*2); c2.fill(); c2.restore();
}
/* ================= FILL BRUSH + MAGIC WAND (21 Oct 2026) =================
   Thomas, on his Proof Lab (a black-and-white figure on a chair): "a brush next to the eraser that works in the same way but
   instead of removing pixels it fills the area with the background colour; those two gaps at the bottom would be better
   filled with white", and "some white needs to stay, other needs to go, so maybe a magic wand style toggle" (it replaces the
   Remove inner white switch of the same day). Both are edits in the eraser's ONE ordered list (eraseStrokes), so they replay
   in order inside processSource, ride in saved designs (snap.erase) and share the bar's Undo / Redo / Reset:
   - a fill stroke, stamps {x,y,r,f:1}: its discs join the silhouette (mask0), so the cut and the border take them in and a
     gap between two legs closes; they are cleared from the DRAWN artwork, so what shows there is whatever the border shows
     at that point (solid, gradient or auto), and it follows a later colour change;
   - a wand tap, one stamp {x,y,r:1,w:1}: the near-white region joined to that pixel (Remove background's own strength,
     measured to white) goes like removed background; a tap on a region the wand took brings it back. */
/* var, not let: setEraseMode can run before this line on the first load */
var editTool="erase", plPaint=null, plWandMap=null, plWandW=0, plWandH=0, plHist=[], plRedo=[];
function plIsEdit(g,k){ return !!(g && g[0] && g[0][k]); }
function plDisc(cnv,x,y,r,col){ const c2=cnv.getContext("2d"); c2.save(); c2.globalCompositeOperation="source-over"; c2.fillStyle=col||"#000"; c2.beginPath(); c2.arc(x,y,r,0,Math.PI*2); c2.fill(); c2.restore(); }
function plWandCut(){ return Math.max(0,Math.min(100, opts.removeTol==null?45:opts.removeTol))/100*176; }
function plIsWhite(px,i,cut){ return px[i*4+3]>=10 && colDist(px[i*4],px[i*4+1],px[i*4+2],255,255,255)<cut; }
/* THE TRUE MAGIC WAND (21 Oct 2026, Thomas: "magic wand seems to only work on white"): the region (4-connected) of the TAPPED
   pixel's colour, measured as Remove background measures (redmean distance under the strength's cut). White keeps its own
   test (distance to pure white), exactly as before; a see-through pixel or one the fill brush painted is never taken. */
function plWandRegion(px,w,h,seed,cut,skip){
  if(seed<0||seed>=w*h||px[seed*4+3]<10||(skip&&skip[seed*4+3])) return null;
  const white=plIsWhite(px,seed,cut), R0=white?255:px[seed*4], G0=white?255:px[seed*4+1], B0=white?255:px[seed*4+2];
  const ok=i=>px[i*4+3]>=10 && !(skip&&skip[i*4+3]) && colDist(px[i*4],px[i*4+1],px[i*4+2],R0,G0,B0)<cut;
  if(!ok(seed)) return null;
  const seen=new Uint8Array(w*h), out=[seed], st=[seed]; seen[seed]=1;
  while(st.length){
    const i=st.pop(), x=i%w;
    if(x>0 && !seen[i-1] && ok(i-1)){ seen[i-1]=1; st.push(i-1); out.push(i-1); }
    if(x<w-1 && !seen[i+1] && ok(i+1)){ seen[i+1]=1; st.push(i+1); out.push(i+1); }
    if(i>=w && !seen[i-w] && ok(i-w)){ seen[i-w]=1; st.push(i-w); out.push(i-w); }
    if(i<w*h-w && !seen[i+w] && ok(i+w)){ seen[i+w]=1; st.push(i+w); out.push(i+w); }
  }
  return out;
}
/* the edit list, replayed on the work canvas `c` in the order it was made (processSource, before the trim) */
function applyEraseStrokes(c){
  plPaint=null; plWandMap=null; plWandW=c.width; plWandH=c.height;
  const cut=plWandCut();
  eraseStrokes.forEach((grp,gi)=>{
    if(plIsEdit(grp,"v")) return;   /* a wand tap on a vector: taken when the SVG is drawn (plSvgApply) */
    if(plIsEdit(grp,"w")){
      const ctx=c.getContext("2d"), w=c.width, h=c.height, d=ctx.getImageData(0,0,w,h), px=d.data, s=grp[0];
      const skip=plPaint ? plPaint.getContext("2d").getImageData(0,0,w,h).data : null;
      const reg=plWandRegion(px,w,h,Math.round(s.y)*w+Math.round(s.x),cut,skip); if(!reg) return;
      if(!plWandMap) plWandMap=new Int32Array(w*h);
      for(let k=0;k<reg.length;k++){ px[reg[k]*4+3]=0; plWandMap[reg[k]]=gi+1; }
      ctx.putImageData(d,0,0);
      return;
    }
    if(plIsEdit(grp,"f")){
      if(!plPaint) plPaint=mk(c.width,c.height);
      for(const st of grp){ plDisc(c,st.x,st.y,st.r,"#000"); plDisc(plPaint,st.x,st.y,st.r,"#000"); }
      return;
    }
    for(const st of grp){ punch(c,st.x,st.y,st.r); if(plPaint) punch(plPaint,st.x,st.y,st.r); }
  });
}
/* the work canvas without the fill paint (its colour is only there to make the silhouette) */
function plNoPaint(c){
  if(!plPaint) return c;
  const k=mk(c.width,c.height), x=k.getContext("2d"); x.drawImage(c,0,0);
  x.globalCompositeOperation="destination-out"; x.drawImage(plPaint,0,0); return k;
}
/* after mask0 is taken: the paint leaves the drawn artwork (the border colour shows through it) */
function plClearPaint(){
  if(!plPaint || !art) return;
  const x=art.getContext("2d"); x.save(); x.globalCompositeOperation="destination-out"; x.drawImage(plPaint,-trimOff.x,-trimOff.y); x.restore();
}
/* tools: one at a time, a second tap on the active one puts it away */
function plTool(t){
  if(!art) return;
  if(erasing && editTool===t){ setEraseMode(false); return; }
  editTool=t; setEraseMode(true);
}
function plSyncTool(){
  if(!editTool) editTool="erase"; if(!plHist) plHist=[]; if(!plRedo) plRedo=[];
  [["ctoolErase","erase"],["ctoolFill","fill"],["ctoolWand","wand"]].forEach(([id,t])=>{ const b=$(id); if(!b) return; const on=erasing && editTool===t; b.classList.toggle("on",on); b.setAttribute("aria-pressed",String(on)); });
  const lbl=$("eraseLbl"); if(lbl) lbl.textContent = editTool==="fill" ? stkT("stk.studio.tool.fill_brush","Fill brush") : editTool==="wand" ? stkT("stk.studio.tool.wand","Magic wand") : stkT("stk.studio.tool.eraser","Eraser");
  const sz=$("eraseSize");
  if(sz){
    /* the wand has no size (Thomas, 21 Oct: the slider belongs to the eraser and the fill brush): it leaves the bar */
    const sw=(sz.closest && sz.closest(".segslider")) || sz; sw.style.display = editTool==="wand" ? "none" : "";
    sz.disabled=false; sz.style.opacity="";
    sz.setAttribute("aria-label", editTool==="erase" ? stkT("stk.studio.tool.eraser_size_aria","Eraser size in mm") : stkT("stk.studio.tool.brush_size_aria","Brush size in mm"));
  }
  const sv=$("eraseSizeVal"); if(sv){ sv.style.opacity=""; sv.style.display = editTool==="wand" ? "none" : ""; }
  { const bar=$("eraseBar"); if(bar) bar.style.justifyContent = editTool==="wand" ? "center" : ""; }
  requestAnimationFrame(()=>{ try{ plColsLayout(); }catch(e){} });
  /* a long tool name (fr "Pinceau de remplissage") must not push the bar past the canvas: the name gives way, the lit tile says which tool */
  if(lbl){ lbl.style.display=""; try{ const bar=$("eraseBar"), st=$("stage"); if(bar && st && erasing){ const br=bar.getBoundingClientRect(), sr=st.getBoundingClientRect(); if(br.width && br.right>sr.right-6) lbl.style.display="none"; } }catch(e){} }
}
window.addEventListener("resize",()=>{ try{ if(erasing) plSyncTool(); }catch(e){} });
/* history: every edit, its removal by a wand tap and a Reset can be undone and redone (the bar's Undo / Redo) */
function plApply(op,fwd){
  if(op.t==="add"){ if(fwd) eraseStrokes.splice(Math.min(op.i,eraseStrokes.length),0,op.g); else { const k=eraseStrokes.indexOf(op.g); if(k>=0) eraseStrokes.splice(k,1); } }
  else if(op.t==="del"){ if(fwd){ const k=eraseStrokes.indexOf(op.g); if(k>=0) eraseStrokes.splice(k,1); } else eraseStrokes.splice(Math.min(op.i,eraseStrokes.length),0,op.g); }
  else if(op.t==="reset"){ eraseStrokes.length=0; if(!fwd) op.prev.forEach(g=>eraseStrokes.push(g)); }
}
function plDo(op){ plApply(op,true); plHist.push(op); plRedo=[]; }
function plUndo(){
  if(plHist.length){ const op=plHist.pop(); plApply(op,false); plRedo.push(op); return true; }
  if(eraseStrokes.length){ const g=eraseStrokes.pop(); plRedo.push({t:"add",g,i:eraseStrokes.length}); return true; }   /* edits from a saved design */
  return false;
}
function plRedoOne(){ if(!plRedo.length) return false; const op=plRedo.pop(); plApply(op,true); plHist.push(op); return true; }
/* a wand tap: inside a region the wand took -> that region comes back; on near-white -> it goes */
function plWandTap(pt){
  if(!art || !srcImg) return;
  if(svgSrc && svgInfo){ plSvgWandTap(pt); return; }   /* 21 Oct 2026: on an SVG the wand takes the vector piece */
  const a=sceneToArt(pt.x,pt.y), x=Math.round(a.x+trimOff.x), y=Math.round(a.y+trimOff.y);
  if(plWandMap && x>=0 && y>=0 && x<plWandW && y<plWandH){
    const gi=plWandMap[y*plWandW+x];
    if(gi && eraseStrokes[gi-1]){ plDo({t:"del", g:eraseStrokes[gi-1], i:gi-1}); plReplay(); return; }
  }
  const ax=Math.round(a.x), ay=Math.round(a.y);
  if(ax<0||ay<0||ax>=art.width||ay>=art.height) return;
  const d=art.getContext("2d").getImageData(ax,ay,1,1).data;
  if(d[3]<10) return;   /* a see-through pixel: nothing for the wand to take */
  plDo({t:"add", g:[{x,y,r:1,w:1}], i:eraseStrokes.length}); plReplay();
}
/* rebuild from the source with the edits as they now stand, keeping the view (zoom, pan, the artwork's place) */
function plReplay(){
  syncEraseBar();
  if(!srcImg){ render(); return; }
  const z=zoom, px=panX, py=panY, ox=opts.offX, oy=opts.offY;
  (svgSrc ? plSvgApply : processSource)(()=>{ opts.offX=ox; opts.offY=oy; zoom=z; panX=px; panY=py; applyZoom(); setEraseMode(erasing); render(); updateDims(); });
}
/* THE STAGE COLUMNS (21 Oct 2026, Thomas on live iPhone): on a phone the tool column (left) and the zoom column (right) are each
   centred in the canvas area that is free on its side: below a button in that top corner (the designs grid, top right; his crop
   had "-" on it), above the edit bar when one shows (the bar sits on the canvas bottom, clear of the sheet's rounded top), and
   their tiles shrink together until they fit, so nothing overlaps at any snap or canvas height. Desktop keeps its rows. */
function plColsLayout(){
  try{
    const ce=$("ctoolErase"), ct=ce && ce.parentElement, zc=$("zoomctl"), st=(zc && zc.parentElement) || (ct && ct.parentElement) || $("stage"); if(!st) return;
    const cols=[ct,zc].filter(Boolean), bar=$("eraseBar");
    cols.forEach(c=>{ c.style.removeProperty("top"); c.style.removeProperty("bottom"); c.style.removeProperty("row-gap"); [...c.children].forEach(t=>{ if(t.style && t.style.zoom) t.style.zoom=""; }); });
    if(!(window.matchMedia && window.matchMedia("(max-width:767px)").matches)) return;
    const S=st.getBoundingClientRect(); if(!S.height) return;
    const hd=root.host.dataset, sheet=(hd.plHead||hd.bmsHead)==="1", base=sheet?30:10;
    const barOn=!!(bar && erasing && bar.getClientRects().length), bh=barOn ? (Math.round(bar.getBoundingClientRect().height)||38) : 0;
    const bottom=base+(barOn?bh+8:0);
    /* the buttons over the canvas's top corners: the designs grid (in the canvas), the Studio's back and light / dark (over it) */
    const cand=[...st.querySelectorAll(".gridbtn")];
    try{ document.querySelectorAll(".plx-back,.plx-theme").forEach(e=>cand.push(e)); }catch(e){}
    [...st.children].forEach(e=>{ if(cols.includes(e) || e===bar || !e.getClientRects().length || getComputedStyle(e).position!=="absolute") return; const r=e.getBoundingClientRect(); if(r.height<=80 && r.width<=120 && r.top-S.top<=60) cand.push(e); });
    const corner=right=>{ let b=-1; cand.forEach(e=>{ if(!e.getClientRects().length) return; const r=e.getBoundingClientRect(); if(r.bottom<=S.top || r.top>S.top+80 || r.right<=S.left || r.left>=S.right) return; if((r.left+r.width/2>S.left+S.width/2)===right) b=Math.max(b, r.bottom-S.top); }); return b; };
    cols.forEach(c=>{ const cr=c.getBoundingClientRect(), right=cr.left+cr.width/2>S.left+S.width/2, cb=corner(right);
      c.style.setProperty("top", (cb<0 ? 10 : Math.ceil(cb+8))+"px", "important"); c.style.setProperty("bottom", bottom+"px", "important"); });
    cols.forEach(c=>{ const cs=getComputedStyle(c); if(cs.flexDirection!=="column") return; const tiles=[...c.children].filter(t=>t!==bar && t.offsetWidth>0 && t.getClientRects().length); if(!tiles.length) return;
      const gap0=parseFloat(cs.rowGap)||0, H=c.clientHeight, need=tiles.reduce((n,t)=>n+t.offsetWidth,0)+gap0*(tiles.length-1);   /* square tiles: width = their own height */
      if(H>0 && need>H+0.5){ const k=Math.max(0.42, Math.floor(H/need*100)/100); tiles.forEach(t=>t.style.zoom=String(k)); c.style.setProperty("row-gap", (gap0*k).toFixed(1)+"px", "important"); } });
    if(barOn && typeof placeEraseBar==="function") placeEraseBar();
  }catch(e){}
}
setTimeout(()=>{ try{ const zc=$("zoomctl"), st=(zc && zc.parentElement) || $("stage"); if(st && window.ResizeObserver) new ResizeObserver(()=>requestAnimationFrame(plColsLayout)).observe(st); }catch(e){} }, 0);
window.addEventListener("resize",()=>requestAnimationFrame(plColsLayout));

/* EDGE DECONTAMINATION (21 Oct 2026, a customer's black heart "witchling" on white: after Remove background and the magic wand a
   thin white line stayed round the black, printing as a light halo on her red border). An antialiased edge pixel is part ink,
   part the colour that was removed; that removed share stays in it as white. For every kept pixel within `band` px of a region
   WE removed (by colour: background removal, the magic wand, a fill brush's cleared area - never the customer's own see-through
   areas): C = the removed colour next to it (the removed pixels' original colours within 2 px), F = the solid colour just inside
   (the nearest kept pixel deeper than the band, reached through the band); its share of ink a is where it sits on the line from C
   to F; it becomes F at a times its alpha, so the edge fades from ink straight into whatever is behind (the border colour).
   Guards: a pixel more than `band` from a removed region is never touched (white kept inside the design stays white); deeper
   band pixels only follow a shallower neighbour that is at least as removed-coloured (a white stroke behind a black outline is
   not an antialias step and is kept); an ink colour within 40 of C has nothing to separate (kept); a hairline with no solid
   colour behind it within the band is kept as it is. px is changed in place; returns the number of pixels changed. */
function decontaminateEdges(px, orig, removed, w, h, band){
  const N=w*h; band=band||3;
  const dist=new Int16Array(N).fill(-1), q=new Int32Array(N); let qh=0, qt=0;
  for(let i=0;i<N;i++) if(removed[i]){ dist[i]=0; q[qt++]=i; }
  if(!qt) return 0;
  while(qh<qt){
    const i=q[qh++], d=dist[i]; if(d>=band+3) continue; const x=i%w;
    const nb0=x>0?i-1:-1, nb1=x<w-1?i+1:-1, nb2=i>=w?i-w:-1, nb3=i<N-w?i+w:-1;
    for(const k of [nb0,nb1,nb2,nb3]){ if(k<0 || dist[k]>=0 || removed[k] || px[k*4+3]<10) continue; dist[k]=d+1; q[qt++]=k; }
  }
  /* the solid colour behind the edge: from the kept pixels just deeper than the band, spread into the band through the band */
  const near=new Int32Array(N).fill(-1); qh=0; qt=0;
  for(let i=0;i<N;i++) if(dist[i]>band && px[i*4+3]>=250){ near[i]=i; q[qt++]=i; }
  while(qh<qt){
    const i=q[qh++], x=i%w;
    const nb0=x>0?i-1:-1, nb1=x<w-1?i+1:-1, nb2=i>=w?i-w:-1, nb3=i<N-w?i+w:-1;
    for(const k of [nb0,nb1,nb2,nb3]){ if(k<0 || near[k]>=0 || dist[k]<1 || dist[k]>band) continue; near[k]=near[i]; q[qt++]=k; }
  }
  const aOf=new Float32Array(N).fill(-1);   /* each band pixel's removed-colour share, for the deeper ones to follow */
  let changed=0;
  for(let d=1; d<=band; d++){
    for(let i=0;i<N;i++){
      if(dist[i]!==d || near[i]<0) continue;
      const o=i*4; if(px[o+3]<10) continue;
      const x=i%w, y=(i-x)/w, R=d+1;
      let cr=0,cg=0,cb=0,cn=0;
      for(let yy=Math.max(0,y-R); yy<=Math.min(h-1,y+R); yy++) for(let xx=Math.max(0,x-R); xx<=Math.min(w-1,x+R); xx++){ const k=yy*w+xx; if(!removed[k]) continue; cr+=orig[k*4]; cg+=orig[k*4+1]; cb+=orig[k*4+2]; cn++; }
      if(!cn) continue;
      cr/=cn; cg/=cn; cb/=cn;
      const f=near[i]*4, fr=px[f], fg=px[f+1], fb=px[f+2];
      const dr=fr-cr, dg=fg-cg, db=fb-cb, L2=dr*dr+dg*dg+db*db;
      if(L2<1600) continue;
      let a=((px[o]-cr)*dr+(px[o+1]-cg)*dg+(px[o+2]-cb)*db)/L2; a=Math.max(0,Math.min(1,a));
      if(d>1){   /* deeper than the first ring: only as the continuation of a shallower antialias step */
        let ok=false; const nb=[x>0?i-1:-1, x<w-1?i+1:-1, i>=w?i-w:-1, i<N-w?i+w:-1];
        for(const k of nb){ if(k>=0 && dist[k]===d-1 && aOf[k]>=0 && aOf[k]<=a+0.05){ ok=true; break; } }
        if(!ok) continue;
      }
      aOf[i]=a;
      if(a>=0.985) continue;   /* already ink */
      px[o]=fr; px[o+1]=fg; px[o+2]=fb; px[o+3]=Math.round(px[o+3]*a); changed++;
    }
  }
  return changed;
}
/* the sticker's use of it: on the trimmed artwork, against the work canvas as it was before anything was removed (c0) */
function plDecontaminate(c0, cw, chh){
  if(!art || !c0) return 0;
  const w=art.width, h=art.height, ctx=art.getContext("2d"), d=ctx.getImageData(0,0,w,h), px=d.data;
  const orig=new Uint8ClampedArray(w*h*4), removed=new Uint8Array(w*h), ox=trimOff.x, oy=trimOff.y;
  for(let y=0;y<h;y++){ const cy=y+oy; if(cy<0||cy>=chh) continue; for(let x=0;x<w;x++){ const cx=x+ox; if(cx<0||cx>=cw) continue; const j=y*w+x, k=cy*cw+cx;
    orig[j*4]=c0[k*4]; orig[j*4+1]=c0[k*4+1]; orig[j*4+2]=c0[k*4+2]; orig[j*4+3]=c0[k*4+3]; if(c0[k*4+3]>=10 && px[j*4+3]<10) removed[j]=1; } }
  const n=decontaminateEdges(px, orig, removed, w, h, 3);
  if(n) ctx.putImageData(d,0,0);
  return n;
}
function plPt(s){ const o={x:s.x,y:s.y,r:s.r}; if(s.f) o.f=1; if(s.w) o.w=1; if(s.v){ o.v=1; o.sx=+s.sx||0; o.sy=+s.sy||0; } return o; }
/* preview-canvas pixel -> art pixel; the two spaces differ per shape mode */
function sceneToArt(sx,sy){
  if(traced()) return {x:sx-dilPad, y:sy-dilPad, sc:1};
  const d=shapeDims(), sc=shapeScale(d);
  return {x:(sx-(d.w/2-artCx*sc+opts.offX))/sc, y:(sy-(d.h/2-artCy*sc+opts.offY))/sc, sc};
}
function setEraseMode(on){
  erasing=!!on && !!art;
  if(erasing){ pickingRm=false; $("preview").style.cursor=""; }
  $("preview").classList.toggle("erasing",erasing);
  const b=$("ctoolErase");
  if(b){ b.classList.toggle("on",erasing); b.setAttribute("aria-pressed",String(erasing)); }
  const bar=$("eraseBar"); if(bar) bar.classList.toggle("show",erasing);
  plSyncTool();
}
function syncEraseBar(){
  const n=eraseStrokes.length;
  if($("eraseUndo")) $("eraseUndo").disabled=!(n || (plHist && plHist.length));
  if($("eraseRedo")) $("eraseRedo").disabled=!(plRedo && plRedo.length);
  if($("eraseClear")) $("eraseClear").disabled=!n;
}
/* One stamp mid-drag. baseScene is punched too so the pixels vanish under the
   brush immediately - the marching-ants loop repaints from baseScene every
   frame, so painting only the preview canvas would flicker straight back.
   The cut line is deliberately NOT re-traced here: dilateMask on every
   pointermove would crawl. It re-traces once on release, as in Sheet Lab. */
function eraseStampAt(sx,sy){
  if(!art||!curErase) return;
  const a=sceneToArt(sx,sy), r=eraseRadiusPx();
  if(a.x<-r||a.y<-r||a.x>art.width+r||a.y>art.height+r) return;
  if(editTool==="fill"){   /* FILL BRUSH: the drawn artwork clears (the border shows), the silhouette takes the disc */
    punch(art,a.x,a.y,r);
    if(mask0) plDisc(mask0,a.x,a.y,r,"#fff");
    if(baseScene) plDisc(baseScene,sx,sy,r*(a.sc||1), opts.bgMode==="solid" ? opts.bg : "#ffffff");
    curErase.push({x:a.x+trimOff.x, y:a.y+trimOff.y, r, f:1});
    return;
  }
  punch(art,a.x,a.y,r);
  if(mask0) punch(mask0,a.x,a.y,r);
  if(baseScene) punch(baseScene,sx,sy,r*(a.sc||1));
  curErase.push({x:a.x+trimOff.x, y:a.y+trimOff.y, r});
}
function finishErase(){
  if(!curErase){ return; }
  if(!curErase.length){ curErase=null; return; }
  plDo({t:"add", g:curErase, i:eraseStrokes.length}); curErase=null;
  dilCache={}; dilPad=0;               // the cut line must re-trace against the new mask
  innerRing=buildInnerRing();
  syncEraseBar(); render(); coverageHint(); updateDims();
}
/* Undo/Reset rebuild from source and replay whatever strokes remain. That is
   the cheap correct path - the live stamps above were destructive. */
function replayErase(){
  syncEraseBar();
  if(!srcImg){ render(); return; }
  processSource(()=>{ setEraseMode(erasing); render(); });
}
$("ctoolErase").addEventListener("click",()=>plTool("erase"));
$("ctoolFill").addEventListener("click",()=>plTool("fill"));
$("ctoolWand").addEventListener("click",()=>plTool("wand"));
/* P170 (Thomas, 27 Sep): "theres also a bar, which doesnt react to movement" - the eraser slider is
   segmentized like every other range but nothing repainted its fill; and "shouldnt the eraser options
   not just be next to the tool?" - the bar joins the canvas tool row, right after the eraser tile. */
$("eraseSize").addEventListener("input",e=>{ $("eraseSizeVal").textContent=stkDec(+e.target.value,1)+"mm"; try{ updateSeg(e.target); }catch(err){} });
try{ const ct=$("canvasTools"), eb=$("eraseBar"); if(ct&&eb){ ct.appendChild(eb); eb.classList.add("erase-bar--inline"); } }catch(e){}
/* Thomas, 28 Sep: "Eraser looks too big and funky on iPhone". On a phone the bar is one slim row the height of the tool
   tiles, BESIDE the eraser tile (his "next to the tool"), running to the zoom column; Undo and Reset are icon tiles
   (their words stay for desktop and for screen readers). Placed on open and on resize. */
try{
  const ICU='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg>';
  const ICR='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>';
  const ICRD='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13"/></svg>';
  [["eraseUndo",ICU],["eraseRedo",ICRD],["eraseClear",ICR]].forEach(([id,ic])=>{ const b=$(id); if(!b) return; const t=b.textContent.trim(); b.setAttribute("aria-label",t); b.title=t; b.innerHTML=ic+'<span class="eb__t" style="display:none">'+stkEsc(t)+'</span>'; const sv=b.querySelector("svg"); if(sv) sv.style.display="block"; });
}catch(e){}
function placeEraseBar(){
  try{
    const bar=$("eraseBar"), ct=$("canvasTools"), st=$("stage");
    if(!bar || !ct || !st) return;
    if(!(window.matchMedia && window.matchMedia("(max-width:767px)").matches)){ ["--eb-top","--eb-left","--eb-w"].forEach(k=>bar.style.removeProperty(k)); return; }
    /* centred at the bottom of the design field (the bar lives in the tool column, so it is placed against that box) */
    const sr=st.getBoundingClientRect(), cr=ct.getBoundingClientRect();
    const w=Math.round(Math.min(320, sr.width-16));
    bar.style.setProperty("--eb-w", w+"px");
    bar.style.setProperty("--eb-left", Math.round(sr.left+(sr.width-w)/2-cr.left)+"px");
    bar.style.setProperty("--eb-top", Math.round(sr.bottom-10-38-(root.host.dataset.plHead==="1"?20:0)-cr.top)+"px");   /* clear of the sheet's rounded top */
  }catch(e){}
}
window.addEventListener("resize",placeEraseBar);
["ctoolErase","ctoolFill","ctoolWand"].forEach(id=>$(id).addEventListener("click",()=>{ requestAnimationFrame(()=>{ placeEraseBar(); try{ window.dispatchEvent(new Event("resize")); }catch(e){} }); }));
$("eraseUndo").addEventListener("click",()=>{ if(plUndo()) plReplay(); });
$("eraseRedo").addEventListener("click",()=>{ if(plRedoOne()) plReplay(); });
$("eraseClear").addEventListener("click",()=>{ if(eraseStrokes.length){ plDo({t:"reset", prev:eraseStrokes.slice()}); plReplay(); } });

/* drag reposition for fixed shapes */
(()=>{
  const cv=$("preview");
  let dragging=false,lx=0,ly=0,dragBefore=null,brushing=false;
  const scenePt=e=>{
    const rect=cv.getBoundingClientRect();
    return {x:(e.clientX-rect.left)*cv.width/rect.width, y:(e.clientY-rect.top)*cv.height/rect.height};
  };
  /* P170 (Thomas, 27 Sep: "if i move my mouse across the screen even remotely fast, i get dots of
     erasure rather than a line"): pointermove fires every few px at most, so the brush is stamped
     along the path from the last point, half a radius apart, and reads as a continuous line. */
  let lastErase=null;
  function eraseTo(pt){
    if(!lastErase){ eraseStampAt(pt.x,pt.y); lastErase=pt; return; }
    const a=sceneToArt(0,0), sc=(a&&a.sc)||1, r=eraseRadiusPx()*sc;
    const dx=pt.x-lastErase.x, dy=pt.y-lastErase.y, dist=Math.hypot(dx,dy);
    const step=Math.max(1, r*0.5), n=Math.min(400, Math.ceil(dist/step));
    for(let i=1;i<=n;i++){ const t=i/n; eraseStampAt(lastErase.x+dx*t, lastErase.y+dy*t); }
    lastErase=pt;
  }
  cv.addEventListener("pointerdown",e=>{
    if(!art) return;
    if(erasing && editTool==="wand"){ plWandTap(scenePt(e)); return; }   /* MAGIC WAND: a tap, not a stroke */
    if(erasing){
      const pt=scenePt(e);
      brushing=true; curErase=[]; lastErase=null;
      cv.setPointerCapture(e.pointerId);
      eraseTo(pt);
      return;
    }
    if(pickingRm){
      const rect=cv.getBoundingClientRect();
      const sx=Math.round((e.clientX-rect.left)*cv.width/rect.width);
      const sy=Math.round((e.clientY-rect.top)*cv.height/rect.height);
      const d=baseScene.getContext("2d").getImageData(Math.max(0,Math.min(cv.width-1,sx)),Math.max(0,Math.min(cv.height-1,sy)),1,1).data;
      pickingRm=false;
      cv.style.cursor="";
      if(d[3]>50){
        const before=snapBefore();
        const hx="#"+[d[0],d[1],d[2]].map(v=>v.toString(16).padStart(2,"0")).join("");
        if(!opts.removeBg){ opts.removeBg=true; $("rmBg").classList.add("on"); syncTolVisibility(); removalTurnsOn(); }   /* 18 Oct 2026 (P202) */
        /* Edge-connected by DEFAULT. The pipette used to add every picked
           colour as "remove everywhere", which keys that colour out of the
           artwork as well as the background: white inside a boot and inside a
           horn vanished on a real order 26 Aug 2026. Enclosed areas are part of
           the design, so every colour is connected-to-the-outside only (21 Oct 2026:
           no "everywhere" mode at all); inner areas go one by one with the wand. */
        addRemoveCol(hx, false);
        pushUndo(before);
      } else renderRemoveChips();
      return;
    }
    if(zoom<=1 && traced()) return;
    dragBefore=snapBefore();
    dragging=true; lx=e.clientX; ly=e.clientY;
    cv.classList.add("dragging");
    cv.setPointerCapture(e.pointerId);
  });
  cv.addEventListener("pointermove",e=>{
    if(brushing){ eraseTo(scenePt(e)); return; }
    if(!dragging) return;
    if(zoom>1){
      panX+=e.clientX-lx; panY+=e.clientY-ly;
      lx=e.clientX; ly=e.clientY;
      applyZoom();
      return;
    }
    const rect=cv.getBoundingClientRect();
    const k=cv.width/rect.width;
    opts.offX+=(e.clientX-lx)*k;
    opts.offY+=(e.clientY-ly)*k;
    lx=e.clientX; ly=e.clientY;
    render();
  });
  ["pointerup","pointercancel"].forEach(ev=>cv.addEventListener(ev,()=>{
    if(brushing){ brushing=false; finishErase(); return; }
    dragging=false; cv.classList.remove("dragging");
    pushUndo(dragBefore); dragBefore=null;
  }));
  cv.addEventListener("dblclick",()=>{
    if(zoom>1){ setZoom(1); return; }
    if(traced()) return;
    const before=snapBefore();
    opts.offX=0; opts.offY=0;
    render();
    pushUndo(before);
  });
})();

const stage=$("stage");
["dragover","dragenter"].forEach(ev=>stage.addEventListener(ev,e=>{e.preventDefault();$("drop").classList.add("over");}));
["dragleave","drop"].forEach(ev=>stage.addEventListener(ev,e=>{e.preventDefault();$("drop").classList.remove("over");}));
stage.addEventListener("drop",e=>loadFiles(e.dataTransfer.files));

function svgPathFromMaskOff(maskCanvas,mmpp,dx,dy){
  let pts=traceContour(maskCanvas);
  if(pts.length<3) return "";
  const RC=refineContour(pts, pxPerMm());
  if(RC.rect){
    /* shift the fitted rectangle by the same offset, then emit real arcs:
       a polyline of chords would be re-smoothed downstream and lose the
       corners this whole thing exists to keep */
    const S=Object.assign({},RC.rect); S.cx-=dx; S.cy-=dy;
    return rectPathD(S, v=>(v*mmpp).toFixed(2));
  }
  /* Simplify (P136): curves fitted to the RAW trace. pts is still the
     traceContour output here (refineContour thinned a copy). mmpp is mm per
     px, so px per mm is 1/mmpp. Null falls through to the old polyline. */
  const segs=simplifyTrace(pts, 1/mmpp);
  if(segs) return simplifyPathD(segs, p=>[(p[0]-dx)*mmpp,(p[1]-dy)*mmpp], 2);
  pts=RC.pts;
  const f=(v,o)=>((v-o)*mmpp).toFixed(2);
  let d="M"+f(pts[0][0],dx)+" "+f(pts[0][1],dy);
  for(let i=1;i<pts.length;i++) d+="L"+f(pts[i][0],dx)+"L".slice(0,0)+" "+f(pts[i][1],dy);
  return d+"Z";
}
/* test hook (harmless in production) */
try{ root.host.__pl={get o(){return opts;}, render, buildExportScene,
  get docs(){return docs;}, get activeIdx(){return activeIdx;}, activateDoc, closeDoc, undoCloseDoc,
  get artName(){return artName;}, openDocGrid, closeDocGrid, applySettingsToTicked, dlZipBatch,
  get undoStack(){return undoStack;}, get redoStack(){return redoStack;}, doUndo, doRedo,
  get art(){return art;}, get mask0(){return mask0;}, get erasing(){return erasing;},
  get eraseStrokes(){return eraseStrokes;}, setEraseMode, eraseStampAt, finishErase,
  get curErase(){return curErase;}, set curErase(v){curErase=v;}, processSource,
  get cutStroke(){return cutStroke;}, get baseScene(){return baseScene;}, saveDesign, restoreDesign, dbTx}; }catch(e){}

/* initial paint */
syncDial();
syncGroups(); syncTolVisibility(); syncBorderVisibility();
renderSwatches(); renderRemoveChips();
paintAllRanges();
renderSavedList();


/* ================= engine (ported verbatim from Proof Lab v1) ================= */
function baseName(raw){
  let n=(raw||"").replace(/\.[^.]+$/,"");           // drop last extension
  n=n.replace(/[^\w\- ]+/g,"").trim().replace(/\s+/g,"-");
  n=n.replace(/-+/g,"-").slice(0,60);
  return n || DEFAULT_ART;
}
/* ================= THE COLOURS IN A VECTOR FILE (21 Oct 2026) =================
   Thomas, after his own test (the customer's "witchling" traced in SVG Lab and uploaded here: it "flattens back into pixels" and the
   white halo returns): "if an SVG is detected, instead of background removal you should be able to see the colours included in
   the design and click to remove." An SVG upload is kept as its text (svgSrc, per design) and drawn again from it: the Remove
   background block gives way to one swatch per fill / stroke colour in the file (near-identical colours grouped, largest area
   first, the hex on hover and on a long press). A background layer (one shape covering at least 98% of the artboard) starts
   removed, from OUTSIDE the artwork only. Since the evening of 21 Oct every colour goes that way (SELECTIVE REMOVAL below). The
   choice lives in opts.svgOff and the wand's pieces in the eraser's list, so undo / redo and saved designs carry them. */
var svgSrc=null, svgInfo=null;
const SVG_NS="http://www.w3.org/2000/svg", SVG_SHAPES="path,rect,circle,ellipse,polygon,polyline,line,text";
const SVG_NAMED={ white:"#ffffff", black:"#000000", red:"#ff0000", green:"#008000", blue:"#0000ff", yellow:"#ffff00", gray:"#808080", grey:"#808080", orange:"#ffa500", purple:"#800080", pink:"#ffc0cb" };
function svgHex(v){
  if(v==null) return null; v=String(v).trim().toLowerCase();
  if(!v || v==="none" || v==="transparent" || v.startsWith("url(")) return null;
  if(SVG_NAMED[v]) return SVG_NAMED[v];
  let m=/^#([0-9a-f]{3})$/.exec(v); if(m) return "#"+m[1].split("").map(c=>c+c).join("");
  m=/^#([0-9a-f]{6})/.exec(v); if(m) return "#"+m[1];
  m=/^rgba?\(\s*([\d.]+)%?\s*,\s*([\d.]+)%?\s*,\s*([\d.]+)%?/.exec(v); if(m) return "#"+[m[1],m[2],m[3]].map(n=>Math.max(0,Math.min(255,Math.round(+n)))).map(n=>n.toString(16).padStart(2,"0")).join("");
  return null;
}
function svgRules(doc){
  const out={};
  doc.querySelectorAll("style").forEach(st=>{ const t=st.textContent||""; let m; const re=/([^{}]+)\{([^}]*)\}/g;
    while((m=re.exec(t))){ const decl={}; m[2].split(";").forEach(kv=>{ const i=kv.indexOf(":"); if(i<0) return; decl[kv.slice(0,i).trim().toLowerCase()]=kv.slice(i+1).trim(); });
      m[1].split(",").forEach(sel=>{ const s=sel.trim(); const c=/^\.([\w-]+)$/.exec(s); if(c) out["."+c[1]]=Object.assign(out["."+c[1]]||{}, decl); else if(/^[a-z]+$/i.test(s)) out[s.toLowerCase()]=Object.assign(out[s.toLowerCase()]||{}, decl); }); } });
  return out;
}
function svgPaint(el, prop, rules){
  for(let e=el; e && e.nodeType===1; e=e.parentNode){
    const st=e.getAttribute && e.getAttribute("style");
    if(st){ const m=new RegExp("(?:^|;)\\s*"+prop+"\\s*:\\s*([^;]+)","i").exec(st); if(m) return m[1].trim(); }
    const cls=(e.getAttribute && e.getAttribute("class")||"").split(/\s+/).filter(Boolean);
    for(let i=cls.length-1;i>=0;i--){ const r=rules["."+cls[i]]; if(r && r[prop]!=null) return r[prop]; }
    const a=e.getAttribute && e.getAttribute(prop); if(a!=null && a!=="inherit") return a;
    const tr=rules[(e.nodeName||"").toLowerCase()]; if(tr && tr[prop]!=null) return tr[prop];
  }
  return prop==="fill" ? "#000000" : null;
}
function svgShapes(root){ return [...root.querySelectorAll(SVG_SHAPES)].filter(el=>!el.closest("defs,clipPath,mask,pattern,symbol,marker")); }
function svgViewBox(root){
  const vb=(root.getAttribute("viewBox")||"").trim().split(/[\s,]+/).map(Number);
  if(vb.length===4 && vb.every(isFinite) && vb[2]>0 && vb[3]>0) return vb;
  const w=parseFloat(root.getAttribute("width")), h=parseFloat(root.getAttribute("height"));
  return (w>0 && h>0) ? [0,0,w,h] : null;
}
function svgTransformed(el, root){ for(let e=el; e && e!==root; e=e.parentNode){ if(e.getAttribute && e.getAttribute("transform")) return true; } return false; }
/* the artboard-covering shape: a rect, or a path of straight segments only, whose box is at least 98% of the viewBox */
function svgIsBackground(el, vb, root){
  if(!vb || svgTransformed(el, root)) return false;
  const tag=el.nodeName.toLowerCase(); let x0,y0,x1,y1;
  if(el.parentNode && el.parentNode.closest && el.parentNode.closest("svg")!==root) return false;   /* inside a nested svg: that viewport, never the page (round 6) */
  if(tag==="rect"){ const g=(k,ref)=>{ const v=el.getAttribute(k)||"0"; return /%\s*$/.test(v) ? parseFloat(v)/100*ref : parseFloat(v); };   /* a % is of the viewport (round 4: a 100% x 100% page rect) */
    x0=g("x",vb[2]); y0=g("y",vb[3]); x1=x0+g("width",vb[2]); y1=y0+g("height",vb[3]); }
  else if(tag==="path"){ const d=el.getAttribute("d")||""; if(/[a-zCcSsQqTtAa]/.test(d.replace(/[eE][-+]?\d/g,""))) return false;   /* absolute straight segments only */
    const n=(d.match(/-?\d*\.?\d+(?:e[-+]?\d+)?/gi)||[]).map(Number); if(n.length<6 || n.length>40) return false;
    const xs=n.filter((_,i)=>i%2===0), ys=n.filter((_,i)=>i%2===1); x0=Math.min(...xs); x1=Math.max(...xs); y0=Math.min(...ys); y1=Math.max(...ys); }
  else return false;
  const ix=Math.max(0, Math.min(x1, vb[0]+vb[2])-Math.max(x0, vb[0])), iy=Math.max(0, Math.min(y1, vb[1]+vb[3])-Math.max(y0, vb[1]));
  return ix*iy >= 0.98*vb[2]*vb[3];
}
function svgAnalyse(txt){
  let doc; try{ doc=new DOMParser().parseFromString(txt,"image/svg+xml"); }catch(e){ return null; }
  const root=doc && doc.documentElement; if(!root || root.nodeName.toLowerCase()!=="svg" || doc.getElementsByTagName("parsererror").length) return null;
  const rules=svgRules(doc), vb=svgViewBox(root), shapes=svgShapes(root); if(!shapes.length) return null;
  const cols=[]; const add=hex=>{ if(!hex) return null; for(const c of cols){ const a=hexRgb(c.hex), b=hexRgb(hex); if(Math.abs(a[0]-b[0])+Math.abs(a[1]-b[1])+Math.abs(a[2]-b[2])<=12) return c.hex; } cols.push({hex, area:0}); return hex; };
  let bgIdx=-1, bgHex=null;
  shapes.forEach((el,i)=>{ const f=add(svgHex(svgPaint(el,"fill",rules))); add(svgHex(svgPaint(el,"stroke",rules)));
    if(bgIdx<0 && f && svgIsBackground(el, vb, root)){ bgIdx=i; bgHex=f; } });
  if(!cols.length) return null;
  return { vb, cols, bgIdx, bgHex, group:hex=>{ if(!hex) return null; for(const c of cols){ const a=hexRgb(c.hex), b=hexRgb(hex); if(Math.abs(a[0]-b[0])+Math.abs(a[1]-b[1])+Math.abs(a[2]-b[2])<=12) return c.hex; } return hex; } };
}
/* the outer outline of a path: its subpaths that lie inside no other of its subpaths (absolute commands only; else the whole path) */
function svgOuterD(d){
  if(/[a-z]/.test(d.replace(/[eE][-+]?\d/g,""))) return d;
  const subs=d.split(/(?=M)/).map(s=>s.trim()).filter(Boolean); if(subs.length<2) return d;
  const cx=mk(1,1).getContext("2d"), P=subs.map(s=>{ try{ return new Path2D(s); }catch(e){ return null; } });
  const keep=subs.filter((s,i)=>{ const m=/^M\s*(-?[\d.eE+-]+)[\s,]+(-?[\d.eE+-]+)/.exec(s); if(!m) return true; const x=+m[1], y=+m[2];
    for(let j=0;j<subs.length;j++){ if(j!==i && P[j] && cx.isPointInPath(P[j], x, y, "nonzero")) return false; } return true; });
  return keep.join(" ");
}
function svgTransformChain(el, root){ const t=[]; for(let e=el.parentNode; e && e!==root; e=e.parentNode){ const a=e.getAttribute && e.getAttribute("transform"); if(a) t.unshift(a); } return t.join(" "); }
/* the colours by area, from a small render (each pixel to its nearest file colour) */
function svgAreas(txt, info, cb){
  const W=240; renderSvgText(txt, W, Math.max(1, Math.round(W*info.vb[3]/info.vb[2])), c=>{
    try{ if(c){ const d=c.getContext("2d").getImageData(0,0,c.width,c.height).data, rgb=info.cols.map(x=>hexRgb(x.hex));
      for(let i=0;i<d.length;i+=4){ if(d[i+3]<128) continue; let b=0, bd=1e9; rgb.forEach((q,k)=>{ const dd=Math.abs(d[i]-q[0])+Math.abs(d[i+1]-q[1])+Math.abs(d[i+2]-q[2]); if(dd<bd){ bd=dd; b=k; } }); info.cols[b].area++; } } }catch(e){}
    info.cols.sort((a,b)=>b.area-a.area); cb && cb(); });
}
/* ===== SELECTIVE REMOVAL (21 Oct 2026, Thomas: "we don't want remove everywhere, we want selective removal") =====
   A colour taken off in the row goes only where it joins the outside: its shapes reached from the artboard's edge through the
   clear outside and through other colours that are off (the background colour: its layer, outside the artwork only, as before).
   A shape of that colour inside the artwork stays; the "inside too" switch is gone (a saved design that had it opens edge-only).
   Inner pieces come off one at a time with the magic wand, which on an SVG acts on the vector: a tap takes the piece under the
   finger (one connected area of one shape, or one hole the background colour shows through), cut along the file's own outline,
   and a tap on it again brings it back. How: a label render of the file (each shape's fill and stroke in its own colour, no
   anti-aliasing) says what is where, and the pieces to take are found on it; the artwork is then drawn layer by layer from the
   vector, a taken piece cut out with its own outline at its place in the stack (destination-out), so its edges stay as crisp as
   the file and nothing of a removed colour is left on them. */
var plSvgLab=null, plSvgLast=null, plSvgCutMap=null, plSvgCutRefs=[];
const SVG_DRAW=SVG_SHAPES+",use,image";
function svgSty(el, css){ el.setAttribute("style", (el.getAttribute("style")||"")+";"+css); }
function svgBgOff(info){ return !!(info && info.bgHex && (opts.svgOff||[]).map(info.group).includes(info.bgHex)); }
/* the chip title: the first clause of the existing key ("Removed where it touches the background"), in every language */
function plEdgeTitle(){ return String(stkT("stk.studio.tool.rm_edge_title","Removed where it touches the background")).split(" · ")[0]; }
function svgSize(info){ const vb=info.vb, s=VEC_TARGET/Math.max(vb[2],vb[3]); return {s, W:Math.round(vb[2]*s), H:Math.round(vb[3]*s)}; }
/* the file as drawn: every drawn element numbered (data-stk-i); the background layer, when off, hidden and drawn again inside
   the outer outline of every other filled shape, under them (white seen through the black stays white) */
function svgPrep(txt, info, bgOff){
  let doc; try{ doc=new DOMParser().parseFromString(txt,"image/svg+xml"); }catch(e){ return null; }
  const root=doc && doc.documentElement; if(!root || doc.getElementsByTagName("parsererror").length) return null;
  const rules=svgRules(doc), shapes=svgShapes(root), grp=info.group, no=v=>v==null || /^\s*none\s*$/i.test(String(v));
  const D=[...root.querySelectorAll(SVG_DRAW)].filter(el=>!el.closest("defs,clipPath,mask,pattern,symbol,marker"));
  const bgEl=info.bgIdx>=0 ? shapes[info.bgIdx] : null;
  const parts=D.map((el,i)=>{ el.setAttribute("data-stk-i", String(i)); const tag=el.nodeName.toLowerCase();
    if(tag==="use" || tag==="image") return {f:null, s:null, hf:false, hs:false};
    const fv=svgPaint(el,"fill",rules), sv=svgPaint(el,"stroke",rules);
    return {f:grp(svgHex(fv)), s:grp(svgHex(sv)), hf:!no(fv), hs:!no(sv)}; });
  let top=bgEl; if(top) while(top.parentNode && top.parentNode!==root) top=top.parentNode;
  /* under: the background layer and whatever is drawn before it (under the inner fill); everything after it is "above" */
  const under=D.map(el=>!!(top && (el===top || top.contains(el) || (el.compareDocumentPosition(top) & 4))));
  let inner=false;
  if(bgEl && bgOff){
    svgSty(bgEl,"fill:none"); bgEl.setAttribute("data-stk-off","1");   /* the label render must not draw it either */
    const kept=D.filter((el,i)=>el!==bgEl && parts[i].f);
    if(kept.length){
      const g=doc.createElementNS(SVG_NS,"g"); g.setAttribute("id","stk-inner-fill");
      kept.forEach(el=>{
        const c=el.cloneNode(false); ["class","id","style","stroke","data-stk-i"].forEach(a=>c.removeAttribute(a));
        if(c.nodeName.toLowerCase()==="path") c.setAttribute("d", svgOuterD(el.getAttribute("d")||""));
        c.setAttribute("fill", info.bgHex); c.setAttribute("fill-rule","nonzero"); c.setAttribute("stroke","none");
        const chain=svgTransformChain(el, root); if(chain){ const w=doc.createElementNS(SVG_NS,"g"); w.setAttribute("transform", chain); w.appendChild(c); g.appendChild(w); } else g.appendChild(c);
      });
      root.insertBefore(g, top.nextSibling); inner=true;
    }
  }
  return {doc, D, parts, under, inner, N:D.length, INNER:2*D.length+1};
}
function svgVariant(prep, fn){ const d=prep.doc.cloneNode(true); if(fn) fn(d, d.documentElement); return new XMLSerializer().serializeToString(d); }
/* one layer: only the elements in spec (i -> "b" both / "f" fill / "s" stroke); a punch layer draws them fully opaque */
function svgLayerText(prep, spec, inner, punch){
  return svgVariant(prep, (d, root)=>{
    d.querySelectorAll("[data-stk-i]").forEach(el=>{ const p=spec.get(+el.getAttribute("data-stk-i"));
      if(!p){ svgSty(el,"visibility:hidden"); return; }
      if(p==="f") svgSty(el,"stroke:none"); else if(p==="s") svgSty(el,"fill:none");
      if(punch){ svgSty(el,"opacity:1;fill-opacity:1;stroke-opacity:1"); for(let a=el.parentNode; a && a!==root && a.nodeType===1; a=a.parentNode) svgSty(a,"opacity:1"); } });
    const g=d.querySelector('[id="stk-inner-fill"]'); if(g && !inner) svgSty(g,"visibility:hidden");
  });
}
/* the label render: fill of element i = 2i+1, its stroke = 2i+2, the inner fill = 2N+1, 6 bits a channel (+2, so a colour
   managed +-1 still reads); no anti-aliasing, no opacity, no filters; an embedded picture reads as "unknown" (a wall) */
function svgLabCol(v){ return "#"+[(v>>12)&63,(v>>6)&63,v&63].map(c=>(c*4+2).toString(16).padStart(2,"0")).join(""); }
function svgLabelText(prep){
  return svgVariant(prep, (d, root)=>{
    root.setAttribute("shape-rendering","crispEdges");
    const st=d.createElementNS(SVG_NS,"style"); st.textContent="*{opacity:1!important;filter:none!important;shape-rendering:crispEdges!important}"; root.insertBefore(st, root.firstChild);
    d.querySelectorAll("[data-stk-i]").forEach(el=>{ const i=+el.getAttribute("data-stk-i"), q=prep.parts[i], tag=el.nodeName.toLowerCase();
      if(el.getAttribute("data-stk-off")){ svgSty(el,"visibility:hidden"); return; }
      if(tag==="image"){ const r=d.createElementNS(SVG_NS,"rect"); ["x","y","width","height","transform"].forEach(a=>{ const v=el.getAttribute(a); if(v!=null) r.setAttribute(a,v); }); r.setAttribute("fill","#000000"); el.parentNode.replaceChild(r, el); return; }
      if(tag==="use"){ svgSty(el,"fill:#000000;stroke:#000000"); return; }
      svgSty(el, "fill-opacity:1;stroke-opacity:1"+(q.hf ? ";fill:"+svgLabCol(2*i+1) : "")+(q.hs ? ";stroke:"+svgLabCol(2*i+2) : "")); });
    const g=d.querySelector('[id="stk-inner-fill"]'); if(g) g.querySelectorAll("path,rect,circle,ellipse,polygon,polyline,line,text").forEach(el=>svgSty(el,"fill:"+svgLabCol(prep.INNER)));
  });
}
function svgLabDecode(c, maxV){
  const w=c.width, h=c.height, d=c.getContext("2d").getImageData(0,0,w,h).data, lab=new Int32Array(w*h);
  for(let p=0, j=0; p<w*h; p++, j+=4){ if(d[j+3]<128) continue; const v=((d[j]>>2)<<12)|((d[j+1]>>2)<<6)|(d[j+2]>>2); lab[p]=(v>=1 && v<=maxV) ? v : -1; }
  return lab;
}
function plSvgEnsureLab(src, prep, info, bgOff, cb){
  const {s, W, H}=svgSize(info);
  if(plSvgLab && plSvgLab.src===src && plSvgLab.bgOff===bgOff && plSvgLab.W===W && plSvgLab.H===H){ cb(plSvgLab); return; }
  renderSvgText(svgLabelText(prep), W, H, c=>{
    if(!c){ cb(null); return; }
    plSvgLab={src, bgOff, W, H, s, vb:info.vb, lab:svgLabDecode(c, prep.INNER), under:prep.under.slice(), parts:prep.parts, N:prep.N, INNER:prep.INNER};
    cb(plSvgLab);
  });
}
/* 4-connected fill from the seeds through ok() pixels */
function svgFill(W, H, seeds, ok, visit){
  const T=W*H, seen=new Uint8Array(T), st=new Int32Array(T); let n=0;
  const push=p=>{ if(p>=0 && p<T && !seen[p] && ok(p)){ seen[p]=1; st[n++]=p; } };
  for(const p of seeds) push(p);
  while(n){ const p=st[--n], x=p%W; visit(p); if(x>0) push(p-1); if(x<W-1) push(p+1); push(p-W); push(p+W); }
}
/* grow a mask by n px (8 neighbours) into pixels ok() allows */
function svgGrow(m, W, H, ok, n){
  const T=W*H;
  for(let k=0;k<n;k++){ const nx=m.slice();
    for(let p=0;p<T;p++){ if(!m[p]) continue; const x=p%W;
      for(let dy=-1;dy<=1;dy++) for(let dx=-1;dx<=1;dx++){ const xx=x+dx, q=p+dy*W+dx; if((!dx && !dy) || xx<0 || xx>=W || q<0 || q>=T || nx[q] || !ok(q)) continue; nx[q]=1; } }
    m=nx; }
  return m;
}
/* what goes: the off colours' pieces reached from the edge, and each wand tap's piece. kill = pixels of "above" shapes cut out
   along their own outline; clear = pixels of the under layer (the inner fill, the background) cleared before the shapes above */
function svgPlan(L, OFFc, cuts){
  const W=L.W, H=L.H, T=W*H, lab=L.lab, INNER=L.INNER, isUnder=new Uint8Array(INNER+1), pass=new Uint8Array(INNER+1);
  for(let v=1; v<INNER; v++){ const i=(v-1)>>1, q=L.parts[i], col=((v-1)&1) ? q.s : q.f; isUnder[v]=L.under[i]?1:0; if(col && OFFc.has(col)) pass[v]=1; }
  isUnder[INNER]=1;
  const kill=new Uint8Array(T), cutMap=new Uint16Array(T), refs=[]; let clear=null;
  const clr=p=>{ (clear||(clear=new Uint8Array(T)))[p]=1; };
  if(OFFc.size){
    const seeds=[]; for(let x=0;x<W;x++) seeds.push(x,(H-1)*W+x); for(let y=0;y<H;y++) seeds.push(y*W, y*W+W-1);
    svgFill(W, H, seeds, p=>{ const v=lab[p]; return v===0 || (v>0 && pass[v]===1); }, p=>{ const v=lab[p]; if(v>0){ if(isUnder[v]) clr(p); else kill[p]=1; } });
  }
  cuts.forEach(c=>{
    const x=Math.floor((c.sx-L.vb[0])*L.s), y=Math.floor((c.sy-L.vb[1])*L.s); if(x<0||y<0||x>=W||y>=H) return;
    const p0=y*W+x, v0=lab[p0]; if(v0<=0) return;
    refs.push({sx:c.sx, sy:c.sy}); const r=refs.length;
    svgFill(W, H, [p0], p=>lab[p]===v0, p=>{ if(r<65535) cutMap[p]=r; if(isUnder[v0]) clr(p); else kill[p]=1; });
  });
  const PP=new Set(), keptOf=new Set();
  for(let p=0;p<T;p++){ const v=lab[p]; if(v>0 && kill[p]) PP.add(v); }
  if(PP.size) for(let p=0;p<T;p++){ const v=lab[p]; if(v>0 && !kill[p] && PP.has(v)) keptOf.add(v); }
  let km=null;
  if(PP.size){
    /* the cut-out mask: the pieces + 2 px into what is not a kept piece of the same shape (their anti-aliased rim) */
    km=svgGrow(kill, W, H, q=>!(lab[q]>0 && PP.has(lab[q]) && !kill[q]), 2);
    /* the inner fill shares a taken piece's OUTER outline: clear it there too, or its rim stays as a faint light line */
    const near=svgGrow(kill, W, H, q=>lab[q]===0, 2);
    for(let p=0;p<T;p++){
      if(near[p] && !kill[p]){ clr(p); continue; }
      if(!kill[p]) continue;
      const x=p%W; let o=false;
      for(let dy=-2; dy<=2 && !o; dy++) for(let dx=-2; dx<=2; dx++){ const xx=x+dx, q=p+dy*W+dx; if(xx<0||xx>=W||q<0||q>=T) continue; if(lab[q]===0){ o=true; break; } }
      if(o) clr(p);
    }
  }
  /* a cleared hole: 2 px into the shapes above round it, so their anti-aliased edge lies over nothing (crisp, no light rim) */
  if(clear) clear=svgGrow(clear, W, H, q=>{ const v=lab[q]; return v<0 || (v>0 && !isUnder[v]); }, 2);
  return {PP, keptOf, km, clear, cutMap, refs};
}
function svgMaskCanvas(m, W, H){ const c=mk(W,H), x=c.getContext("2d"), id=x.createImageData(W,H); for(let p=0;p<W*H;p++) if(m[p]) id.data[p*4+3]=255; x.putImageData(id,0,0); return c; }
/* draw: the under layer, its cleared holes, then the shapes above in file order, a taken piece cut out at its place */
function svgCompose(prep, plan, W, H, cb){
  if(!plan || (!plan.PP.size && !plan.clear)){ renderSvgText(svgVariant(prep), W, H, cb); return; }
  const underSpec=new Map(), runs=[]; let cur=null;
  const put=(mode,i,part)=>{ if(!cur || cur.mode!==mode){ cur={mode, spec:new Map()}; runs.push(cur); } const pr=cur.spec.get(i); cur.spec.set(i, pr && pr!==part ? "b" : part); };
  prep.D.forEach((el,i)=>{
    if(prep.under[i]){ underSpec.set(i,"b"); return; }
    const q=prep.parts[i]; let any=false;
    [["f",2*i+1,q.hf],["s",2*i+2,q.hs]].forEach(([part,v,has])=>{ if(!has) return; any=true;
      if(plan.PP.has(v)){ if(plan.keptOf.has(v)) put("paint",i,part); put("punch",i,part); } else put("paint",i,part); });
    if(!any) put("paint",i,"b");
  });
  const jobs=[];
  if(underSpec.size || prep.inner) jobs.push({mode:"paint", t:svgLayerText(prep, underSpec, true, false)});
  if(plan.clear && jobs.length) jobs.push({mode:"clear"});
  runs.forEach(r=>jobs.push({mode:r.mode, t:svgLayerText(prep, r.spec, false, r.mode==="punch")}));
  const C=mk(W,H), x=C.getContext("2d"), KM=plan.km ? svgMaskCanvas(plan.km, W, H) : null;
  let k=0;
  const next=()=>{
    if(k>=jobs.length){ cb(C); return; }
    const j=jobs[k++];
    if(j.mode==="clear"){ x.globalCompositeOperation="destination-out"; x.drawImage(svgMaskCanvas(plan.clear, W, H),0,0); x.globalCompositeOperation="source-over"; next(); return; }
    renderSvgText(j.t, W, H, c=>{
      if(!c){ cb(null); return; }
      if(j.mode==="punch"){ if(KM){ const lx=c.getContext("2d"); lx.globalCompositeOperation="destination-in"; lx.drawImage(KM,0,0); } x.globalCompositeOperation="destination-out"; }
      x.drawImage(c,0,0); x.globalCompositeOperation="source-over"; next();
    });
  };
  next();
}
/* draw the file with the current choice, at the vector size the engine prints from, and run it through as a new source */
function plSvgApply(cb){
  if(!svgSrc){ if(cb) cb(); return; }
  const src=svgSrc, info=svgInfo || (svgInfo=svgAnalyse(src)); if(!info){ if(cb) cb(); return; }
  const {W, H}=svgSize(info), OFF=new Set((opts.svgOff||[]).map(info.group)), bgOff=!!(info.bgHex && OFF.has(info.bgHex));
  const OFFc=new Set([...OFF].filter(h=>h!==info.bgHex));
  const cuts=[]; (eraseStrokes||[]).forEach(g=>{ if(g && g[0] && g[0].v) cuts.push({sx:+g[0].sx||0, sy:+g[0].sy||0}); });
  const key=JSON.stringify([[...OFF].sort(), cuts.map(c=>[c.sx,c.sy]), W, H]);
  const done=()=>{ plSvgSyncUI(); processSource(cb); };
  if(plSvgLast && plSvgLast.src===src && plSvgLast.key===key && plSvgLast.img===srcImg){ plSvgCutMap=plSvgLast.cutMap; plSvgCutRefs=plSvgLast.refs; done(); return; }
  const prep=svgPrep(src, info, bgOff); if(!prep){ if(cb) cb(); return; }
  $("spin").classList.add("show");
  const go=L=>{
    if(src!==svgSrc) return;   /* a newer file took over */
    const plan=L ? svgPlan(L, OFFc, cuts) : null;
    svgCompose(prep, plan, W, H, C=>{
      if(src!==svgSrc) return;
      if(!C){ $("spin").classList.remove("show"); if(cb) cb(); return; }
      const cm=plan ? plan.cutMap : null, refs=plan ? plan.refs : [];
      imgOfCanvas(C, im=>{ if(src!==svgSrc) return; if(im){ srcImg=im; srcIsVector=true; plSvgCutMap=cm; plSvgCutRefs=refs; plSvgLast={src, key, img:im, cutMap:cm, refs}; } done(); });
    });
  };
  if(OFFc.size || cuts.length) plSvgEnsureLab(src, prep, info, bgOff, go); else go(null);
}
/* keep the view (zoom, pan, the artwork's place) across a redraw, as plReplay does */
function plSvgKeep(cb){ const z=zoom, px=panX, py=panY, ox=opts.offX, oy=opts.offY; return ()=>{ opts.offX=ox; opts.offY=oy; zoom=z; panX=px; panY=py; applyZoom(); setEraseMode(erasing); render(); updateDims(); if(cb) cb(); }; }
/* THE WAND ON A VECTOR: the piece under the finger goes (one connected area of one shape, or the hole the background shows
   through), along the file's own outline; a tap on a piece the wand took brings it back. One edit {x,y,r:1,w:1,v:1,sx,sy}
   (sx, sy in the file's units) in the eraser's list, so Undo / Redo / Reset and saved designs carry it like any other. */
function plSvgWandTap(pt, n){
  n=(n|0)+1; if(n>3 || !art || !srcImg || !svgSrc || !svgInfo) return;
  const src=svgSrc, info=svgInfo, {s, W, H}=svgSize(info), vb=info.vb, bgOff=svgBgOff(info);
  if(!(plSvgLast && plSvgLast.src===src && plSvgLast.img===srcImg)){ plSvgApply(plSvgKeep(()=>plSvgWandTap(pt,n))); return; }
  if(!(plSvgLab && plSvgLab.src===src && plSvgLab.bgOff===bgOff && plSvgLab.W===W && plSvgLab.H===H)){ const prep=svgPrep(src, info, bgOff); if(!prep) return; plSvgEnsureLab(src, prep, info, bgOff, L=>{ if(L) plSvgWandTap(pt,n); }); return; }
  if(!plWandW || !plWandH) return;
  const a=sceneToArt(pt.x,pt.y), wx=a.x+trimOff.x, wy=a.y+trimOff.y;
  /* the work pixel the raster wand and the see-through check use (rounded), then its centre on the label render */
  const rx=Math.floor((Math.round(wx)+0.5)*W/plWandW), ry=Math.floor((Math.round(wy)+0.5)*H/plWandH); if(rx<0||ry<0||rx>=W||ry>=H) return;
  const p=ry*W+rx, m=plSvgCutMap ? plSvgCutMap[p] : 0;
  if(m && plSvgCutRefs[m-1]){
    const r=plSvgCutRefs[m-1], k=eraseStrokes.findIndex(g=>g && g[0] && g[0].v && g[0].sx===r.sx && g[0].sy===r.sy);
    if(k>=0){ plDo({t:"del", g:eraseStrokes[k], i:k}); plReplay(); return; }
  }
  const ax=Math.round(a.x), ay=Math.round(a.y); if(ax<0||ay<0||ax>=art.width||ay>=art.height) return;
  if(art.getContext("2d").getImageData(ax,ay,1,1).data[3]<10) return;   /* see-through: nothing for the wand to take */
  if(plSvgLab.lab[p]<=0) return;
  plDo({t:"add", g:[{x:Math.round(wx), y:Math.round(wy), r:1, w:1, v:1, sx:+(vb[0]+(rx+0.5)/s).toFixed(3), sy:+(vb[1]+(ry+0.5)/s).toFixed(3)}], i:eraseStrokes.length});
  plReplay();
}
/* the row: one swatch per colour; a tap takes that colour off where it joins the outside, or brings it back */
function plSvgSyncUI(){
  try{
    const holder=$("gRemoveBg"); if(!holder) return;
    let row=$("gSvgCols");
    const on=!!(svgSrc && svgInfo && svgInfo.cols.length);
    [...holder.children].forEach(ch=>{ if(ch.id!=="gSvgCols") ch.style.display = on ? "none" : ""; });
    if(!on){ if(row) row.style.display="none"; return; }
    if(!row){ row=document.createElement("div"); row.id="gSvgCols"; row.style.cssText="width:100%;text-align:center"; holder.insertBefore(row, holder.firstChild); }
    row.style.display="";
    const OFF=new Set((opts.svgOff||[]).map(svgInfo.group));
    const strike="linear-gradient(to top right, transparent calc(50% - 1.5px), #e5484d calc(50% - 1.5px), #e5484d calc(50% + 1.5px), transparent calc(50% + 1.5px))";
    row.innerHTML='<label class="lbl-sub" style="display:block;text-align:center">'+stkEsc(stkT("stk.studio.tool.remove_cols","Colours being removed"))+'</label>'+
      '<div class="svgcols" style="display:flex;flex-wrap:wrap;justify-content:center;gap:10px;margin-top:8px">'+
      svgInfo.cols.map(c=>{ const off=OFF.has(c.hex), title=c.hex.toUpperCase()+(off ? " · "+plEdgeTitle() : "");
        return '<button type="button" class="svgsw" data-hex="'+c.hex+'" aria-pressed="'+off+'" title="'+stkEsc(title)+'" aria-label="'+stkEsc(title)+'" style="width:36px;height:36px;border-radius:50%;border:1.5px solid var(--line,#d9d9df);padding:0;cursor:pointer;background:'+(off?strike+",":"")+c.hex+';box-sizing:border-box"></button>'; }).join("")+
      '</div><div class="hint" id="svgColsHex" style="text-align:center;min-height:16px;margin-top:6px"></div>';
    if(!row.__wired){ row.__wired=1;
      row.addEventListener("click",e=>{
        const b=e.target.closest(".svgsw"); if(!b) return; const hex=b.dataset.hex, before=snapBefore();
        const s=new Set(opts.svgOff||[]); if(s.has(hex)) s.delete(hex); else s.add(hex); opts.svgOff=[...s]; opts.svgIn=[];
        pushUndo(before); plSvgApply();
      });
      let lp=0; row.addEventListener("touchstart",e=>{ const b=e.target.closest(".svgsw"); if(!b) return; clearTimeout(lp); lp=setTimeout(()=>{ const h=$("svgColsHex"); if(h) h.textContent=b.dataset.hex.toUpperCase(); }, 450); }, {passive:true});
      row.addEventListener("touchend",()=>clearTimeout(lp), {passive:true});
      row.addEventListener("mouseover",e=>{ const b=e.target.closest(".svgsw"), h=$("svgColsHex"); if(h) h.textContent=b ? b.dataset.hex.toUpperCase() : ""; });
    }
  }catch(e){}
}
/* a new SVG: read its colours; a background layer starts removed (outside only) */
function plSvgIntake(txt, cb){
  const info=svgAnalyse(txt); if(!info){ return false; }
  svgSrc=txt; svgInfo=info; plSvgLab=null; plSvgLast=null; plSvgCutMap=null; plSvgCutRefs=[];
  opts.svgOff = info.bgHex ? [info.bgHex] : []; opts.svgIn=[];
  opts.removeBg=false; opts.removeCols=[];
  try{ const t=$("rmBg"); if(t) t.classList.remove("on"); syncTolVisibility(); }catch(e){}
  if(info.bgHex){ try{ removalTurnsOn(); }catch(e){} }
  svgAreas(txt, info, ()=>plSvgApply(cb));
  return true;
}
function loadFile(file,cb){
  if(!file) return;
  svgSrc=null; svgInfo=null; opts.svgOff=[]; opts.svgIn=[];   /* 21 Oct 2026: a vector file brings its own colours (loadSvg), any other none */
  plSvgLab=null; plSvgLast=null; plSvgCutMap=null; plSvgCutRefs=[];
  const name=(file.name||"").toLowerCase();
  const type=file.type||"";
  artName=baseName(file.name);
  opts.bgFresh=true;                       // a new file picks its own border mode, see processSource
  custCut=null; opts.cutMode="";           /* 18 Oct 2026 (P215): a new file brings its own cut line or none */
  if(type==="application/pdf" || name.endsWith(".pdf")){ loadPdf(file,cb); return; }
  if(name.endsWith(".ai") || type==="application/illustrator"){ loadAi(file,cb); return; }   /* 18 Oct 2026 (P215) */
  if(type==="image/svg+xml" || name.endsWith(".svg")){ loadSvg(file,cb); return; }
  if(/^image\//.test(type)){ loadRaster(file,cb); return; }
  showError(stkT("stk.studio.msg.file_type","That file type is not supported. Use PNG, JPEG, WEBP, SVG, PDF or AI."));
  if(cb) cb();
}
/* multiple files (drop or the file picker with multiple selected) become one
   new Doc each, loaded strictly one at a time - srcImg is a shared global
   while a file decodes, so starting the next before processSource() has
   captured this one's result into its Doc would clobber it. */
function loadFiles(fileList){
  let arr=Array.prototype.slice.call(fileList||[]).filter(Boolean), capMsg="";
  if(!arr.length) return;
  /* 2 Nov 2026 (Thomas: the grid's upload tile "did nothing"): files that arrive while the design grid is open close it
     first, so the new design shows instead of the grid as it was */
  { const g=$("docGrid"); if(g && !g.classList.contains("hidden")) closeDocGrid(); }
  /* v2.6: one design per order means a new upload REPLACES the design, as the
     product page's own upload field does. Only the first file is taken. */
  if(MAX_SLOTS<2){
    arr=arr.slice(0,1);
    if(docs.length){ try{ clearAllDocs(); }catch(e){} }
  } else if(isFinite(MAX_SLOTS)){
    /* 2 Oct 2026 (Thomas, iPhone: picked 10 photos, Studio "processed them all", ORDER then crashed): the
       iOS picker has no file limit, so only the free design slots are taken and the rest are named. */
    const free=Math.max(0, MAX_SLOTS-docs.length);
    if(arr.length>free){
      const dropped=arr.length-free;
      arr=arr.slice(0,free);
      capMsg=stkFmt(stkT("stk.studio.msg.files_capped","Up to [max] designs per order: [n] of your files were not added."),{max:MAX_SLOTS,n:dropped});
      if(!arr.length){ showError(capMsg); return; }
    }
  }
  let i=0;
  (function next(){
    if(i>=arr.length){
      /* v1.9: the upload worked, so ARTWORK has nothing left to ask. It ticks
         itself and DESIGN opens (Thomas, 12 Sep 18:05). Only ever forward, and
         only the first time: reopening ARTWORK by its chip and uploading again
         still folds it, which is the same thing the customer just asked for. */
      try{
        const s1=root.getElementById("step1");
        if(docs.length && s1 && !s1.classList.contains("is-folded")) foldStep(1);
        /* CONFIRM on "apply the same settings" was already given, so there is
           nothing to design: DESIGN completes itself and ORDER opens. */
        if(window.__plSkipDesign && window.__plSkipDesign()) foldStep(2);
        renderDocTabs();      // the new design now has a proof to show
      }catch(e){}
      if(capMsg) showError(capMsg);   // after processing, which clears the note
      return;
    }
    const f=arr[i++];
    addDoc(f);
    /* A DESIGN COUNTS FROM THE MOMENT ITS ARTWORK LANDS (v2.4). The active
       doc's artwork lives in the module globals until captureDoc() runs, and
       before v2.4 the only thing that ran it from a product page was the proof
       window - so the ORDER panel counted one design fewer than the slot strip
       showed. Capturing here makes docs[i].art the ONE truth the panel, the
       proof window and the cart all read. */
    loadFile(f,()=>{ try{ captureDoc(); }catch(e){} renderDocTabs(); next(); });
  })();
}
/* capture whatever's currently active (if anything), then open a fresh,
   empty Doc slot and activate it - the load*() functions below then run
   exactly as they do today, just writing into this new slot's globals.
   Shared by a fresh upload (addDoc) and loading a saved design
   (restoreDesign), so neither ever overwrites the doc that's already open. */
function addBlankDoc(name){
  captureDoc();
  const doc={ id:"doc"+(++docSeq), thumb:null,
    artName:name, srcImg:null, art:null, trimRatio:1, mask0:null,
    srcIsVector:false, artCx:0, artCy:0, artMaxRad:1, dilCache:{}, dilPad:0,
    palette:[], paletteLight:[], baseScene:null, cutStroke:null, opts:cloneOpts(opts),
    undoStack:[], redoStack:[] };
  docs.push(doc);
  activeIdx=docs.length-1;
  if(animRaf){ cancelAnimationFrame(animRaf); animRaf=0; }   // stop the outgoing doc's marching ants before nulling baseScene
  srcImg=null; art=null; artName=doc.artName; srcIsVector=false; custCut=null;   /* P215: a new slot has no file cut line */
  mask0=null; artCx=0; artCy=0; artMaxRad=1; dilCache={}; dilPad=0;
  innerRing=null; eraseStrokes=[]; trimOff={x:0,y:0}; curErase=null; plHist=[]; plRedo=[];
  palette=[]; paletteLight=[]; baseScene=null; cutStroke=null;
  undoStack=[]; redoStack=[];
  renderDocTabs();
  syncUndoRedoButtons();
}
function addDoc(file){ addBlankDoc(baseName(file.name)); }
/* THE PAGE IS NOT THE ARTWORK (Thomas, 22 Oct 2026, order 9955: four A4 pages with a small design on each - "the actual
   artwork quality comes out terrible"; the same design uploaded cropped "came out perfect"). workCanvas() scales the WHOLE
   upload to WORK px on its longest edge and only then trims the empty border, so a 50 mm design on an A4 page kept
   303 px where the cropped file kept 525, and the export upsampled it 3x (measured on the live page). Vector pages had
   the same fault through VEC_TARGET. So the artwork's own bounds are found first and the file is taken in at ITS size:
   a raster is cropped at source resolution before the SRC_MAX cap, a vector page is drawn again at VEC_TARGET on the
   artwork's own edge. A file whose artwork fills the page is untouched (null).
   How the bounds are found: a high-quality probe (<= 1024 px) gives a first box; then EVERY source pixel outside that
   box is read, in row strips, and any ink there widens the box - so a hairline, a dot or faint text far from the main
   piece can never be cut away (LAB-RULES rules 3 and 5; Opus reviews 22 Oct). "Ink" is alpha above 10, the same line
   trim() draws (residue at 1-10 never reaches the artwork, so it must not cancel the crop either), or, with a reference
   colour (a PDF's white page, an SVG's white page), any pixel that differs from it. Bounds come back in the source's
   pixels, padded so trim() still finds its 2 px. The scan stops as soon as the box is too big to crop. */
const ART_PAGE_SHARE = 0.92;   /* crop only when the artwork is at most this share of the page's longest edge */
function plArtBounds(src, w, h, ref){
  if(!(w>0 && h>0)) return null;
  const tol = ref ? (ref.tol||1) : 0;
  const on = ref
    ? (d,i)=> d[i+3]>10 && (Math.abs(d[i]-ref.rgb[0])>tol || Math.abs(d[i+1]-ref.rgb[1])>tol || Math.abs(d[i+2]-ref.rgb[2])>tol)
    : (d,i)=> d[i+3]>10;
  const P=1024, s=Math.min(1, P/Math.max(w,h)), pw=Math.max(1,Math.round(w*s)), ph=Math.max(1,Math.round(h*s));
  let x0=w, y0=h, x1=-1, y1=-1;
  const c=mk(pw,ph), x=c.getContext("2d",{willReadFrequently:true});
  try{
    x.imageSmoothingEnabled=true; x.imageSmoothingQuality="high";
    x.drawImage(src,0,0,pw,ph);
    const d=x.getImageData(0,0,pw,ph).data;
    for(let yy=0;yy<ph;yy++) for(let xx=0;xx<pw;xx++){
      if(!on(d,(yy*pw+xx)*4)) continue;
      if(xx<x0) x0=xx; if(xx>x1) x1=xx; if(yy<y0) y0=yy; if(yy>y1) y1=yy;
    }
  }catch(e){ c.width=0; c.height=0; return null; }
  c.width=0; c.height=0;
  if(x1<0) return null;
  const LIMIT=ART_PAGE_SHARE*Math.max(w,h);
  /* the probe's box in source pixels, then the exact scan of everything outside it */
  let X0=Math.max(0,Math.floor(x0/s)-1), Y0=Math.max(0,Math.floor(y0/s)-1);
  let X1=Math.min(w,Math.ceil((x1+1)/s)+1), Y1=Math.min(h,Math.ceil((y1+1)/s)+1);
  if(Math.max(X1-X0, Y1-Y0) > LIMIT) return null;
  try{
    const ROWS=256, sc=mk(1,1), sx=sc.getContext("2d",{willReadFrequently:true});
    const scan=(rx,ry,rw,rh)=>{   /* every ink pixel of the source rect widens the box */
      for(let yy=ry; yy<ry+rh; yy+=ROWS){
        const hh=Math.min(ROWS, ry+rh-yy); if(rw<=0||hh<=0) continue;
        sc.width=rw; sc.height=hh; sx.imageSmoothingEnabled=false;   /* a resize clears the context's state */
        sx.drawImage(src, rx,yy,rw,hh, 0,0,rw,hh);
        const d=sx.getImageData(0,0,rw,hh).data;
        for(let j=0;j<hh;j++) for(let i=0;i<rw;i++){
          if(!on(d,(j*rw+i)*4)) continue;
          const ax=rx+i, ay=yy+j;
          if(ax<X0) X0=ax; if(ax+1>X1) X1=ax+1; if(ay<Y0) Y0=ay; if(ay+1>Y1) Y1=ay+1;
        }
        if(Math.max(X1-X0, Y1-Y0) > LIMIT) throw 0;   /* too big to crop: stop reading */
      }
    };
    const bx0=X0, by0=Y0, bx1=X1, by1=Y1;
    scan(0,0,w,by0); scan(0,by1,w,h-by1); scan(0,by0,bx0,by1-by0); scan(bx1,by0,w-bx1,by1-by0);
    sc.width=0; sc.height=0;
  }catch(e){ return null; }
  const pad=10;
  X0=Math.max(0,X0-pad); Y0=Math.max(0,Y0-pad); X1=Math.min(w,X1+pad); Y1=Math.min(h,Y1+pad);
  if(Math.max(X1-X0, Y1-Y0) > LIMIT) return null;
  return {x:X0, y:Y0, w:X1-X0, h:Y1-Y0};
}
/* a paper page (A3 / A4 / A5 / Letter / Legal, either way round, within 4% so a page with 3 mm bleed still counts):
   the one case where a file's page is not the artwork. A label-sized artboard keeps its page, margins and all.
   w, h in points. */
function plSvgRootHasVb(txt){ const m=/<svg\b[^>]*>/i.exec(txt); return !!m && /\sviewBox\s*=/.test(m[0]); }   /* XML attributes are case-sensitive: viewbox= is nothing */
/* the cropped text drawn at the crop's own size next to the crop of the original render, both taken down to <= 96 px the same
   way; same = under 1% of probe pixels differ (premultiplied). A lost or moved element differs; anti-aliasing does not. */
function plSvgSameRender(txt,ref,cb){
  let done=false; const fin=v=>{ if(done) return; done=true; cb(v); };
  try{
    const u=URL.createObjectURL(new Blob([txt],{type:"image/svg+xml"})), im=new Image();
    const P=96, s=Math.min(1,P/Math.max(ref.width,ref.height)), pw=Math.max(1,Math.round(ref.width*s)), ph=Math.max(1,Math.round(ref.height*s));
    /* both sides take the same road down: halvings to under 2P, then one step to the probe (a direct draw at 96 px and a
       20x downscale differ at every anti-aliased edge; two identical downscales of two same-size draws do not) */
    const down=(src)=>{
      let cur=src, w=src.width, h=src.height;
      while(Math.max(w,h)>2*P){
        const nw=Math.max(1,Math.round(w/2)), nh=Math.max(1,Math.round(h/2)), n=mk(nw,nh), nx=n.getContext("2d");
        nx.imageSmoothingQuality="high"; nx.drawImage(cur,0,0,nw,nh);
        if(cur!==src){ cur.width=0; cur.height=0; } cur=n; w=nw; h=nh;
      }
      const f=mk(pw,ph), fx=f.getContext("2d",{willReadFrequently:true}); fx.imageSmoothingQuality="high"; fx.drawImage(cur,0,0,pw,ph);
      if(cur!==src){ cur.width=0; cur.height=0; }
      const d=fx.getImageData(0,0,pw,ph).data; f.width=0; f.height=0; return d;
    };
    im.onload=()=>{ URL.revokeObjectURL(u);
      let ok=false;
      try{
        const c3=mk(ref.width,ref.height); c3.getContext("2d").drawImage(im,0,0,ref.width,ref.height);
        const da=down(ref), db=down(c3); c3.width=0; c3.height=0;
        let bad=0;
        for(let i=0;i<da.length;i+=4){
          const pa=da[i+3]/255, pb=db[i+3]/255;
          if(Math.abs(da[i]*pa-db[i]*pb)>40 || Math.abs(da[i+1]*pa-db[i+1]*pb)>40 || Math.abs(da[i+2]*pa-db[i+2]*pb)>40 || Math.abs(da[i+3]-db[i+3])>40) bad++;
        }
        ok = bad <= 0.01*pw*ph;
      }catch(e){}
      fin(ok);   /* outside the try: what the caller does next is its own */
    };
    im.onerror=()=>{ URL.revokeObjectURL(u); fin(false); };
    im.src=u;
  }catch(e){ fin(false); }
}
function plPaperPage(w,h){
  const P=[[297,420],[210,297],[148,210],[215.9,279.4],[215.9,355.6]].map(p=>p.map(v=>v/25.4*72));
  const near=(a,b)=>Math.abs(a-b)<=0.04*b;
  return P.some(([pw,ph])=>(near(w,pw)&&near(h,ph))||(near(w,ph)&&near(h,pw)));
}
function loadRaster(file,cb){
  const url=URL.createObjectURL(file);
  const img=new Image();
  img.onload=()=>{
    URL.revokeObjectURL(url);
    $("spin").classList.add("show");
    const fail=()=>{ $("spin").classList.remove("show"); showError(stkT("stk.studio.msg.image_unreadable","That image could not be read.")); if(cb) cb(); };
    setTimeout(()=>{ try{
    /* 2 Oct 2026: every design keeps its source image for the print file, and a phone photo decoded whole
       is 50-190 MB (12-48 MP); a few of them crashed iOS Safari. The source is kept at most SRC_MAX px on
       its longest edge: 27 cm, the largest sticker, at 300 dpi. Smaller images are untouched. */
    const W0=img.naturalWidth||0, H0=img.naturalHeight||0;
    const crop=plArtBounds(img,W0,H0,null);   /* the page is not the artwork: see plArtBounds */
    const cw=crop?crop.w:W0, chh=crop?crop.h:H0;
    const SRC_MAX=3200, L=Math.max(cw,chh);
    if(crop || L>SRC_MAX){
      const s=Math.min(1,SRC_MAX/L), c=mk(Math.round(cw*s), Math.round(chh*s)), x=c.getContext("2d");
      x.imageSmoothingQuality="high";
      if(crop) x.drawImage(img,crop.x,crop.y,crop.w,crop.h,0,0,c.width,c.height); else x.drawImage(img,0,0,c.width,c.height);
      img.onload=null; img.onerror=null; img.src="";
      const done=(im)=>{ c.width=0; c.height=0; srcImg=im; srcIsVector=false; opts.labelApplied=false; processSource(cb); };
      const jpeg=/jpe?g/i.test(file.type||"") && !crop;   /* a cropped image keeps its transparency */
      c.toBlob((blob)=>{
        if(!blob){ const im=new Image(); im.onload=()=>done(im); im.onerror=fail; im.src=c.toDataURL(jpeg?"image/jpeg":"image/png",0.95); return; }
        const u2=URL.createObjectURL(blob), im=new Image();
        im.onload=()=>{ URL.revokeObjectURL(u2); done(im); };
        im.onerror=()=>{ URL.revokeObjectURL(u2); fail(); };
        im.src=u2;
      }, jpeg?"image/jpeg":"image/png", 0.95);
      return;
    }
    srcImg=img; srcIsVector=false; opts.labelApplied=false; processSource(cb);
    }catch(e){ fail(); }
    },0);
  };
  img.onerror=()=>{ URL.revokeObjectURL(url); showError(stkT("stk.studio.msg.image_unreadable","That image could not be read.")); if(cb) cb(); };
  img.src=url;
}
/* THE SVG REPAIR (21 Oct 2026, found by the SVG investigation): a file without xmlns got width="20" height="20" put in front of
   its own width / height - duplicate attributes, an invalid SVG, and the customer saw "That SVG could not be rendered" (in every
   proof-lab-order.js since 19 Sep). Now the namespace is added on its own, and a width or height the file lacks is taken from
   its viewBox (never 20 x 20); a file that has them keeps them. */
function plSvgRepair(t){
  const m=/<svg\b[^>]*>/i.exec(t); if(!m) return t;
  const tag=m[0]; let nt=tag;
  if(!/\sxmlns\s*=/.test(tag)) nt=nt.replace(/<svg\b/i,'<svg xmlns="http://www.w3.org/2000/svg"');
  const hasW=/\swidth\s*=/.test(tag), hasH=/\sheight\s*=/.test(tag);
  if(!hasW || !hasH){
    const vb=/viewBox\s*=\s*["']\s*(-?[\d.eE+-]+)[\s,]+(-?[\d.eE+-]+)[\s,]+([\d.eE+-]+)[\s,]+([\d.eE+-]+)/i.exec(tag);
    if(vb && +vb[3]>0 && +vb[4]>0){ if(!hasW) nt=nt.replace(/<svg\b/i,'<svg width="'+(+vb[3])+'"'); if(!hasH) nt=nt.replace(/<svg\b/i,'<svg height="'+(+vb[4])+'"'); }
  }
  return nt===tag ? t : t.replace(tag, nt);
}
/* THE PAGE IS NOT THE ARTWORK, for a vector: the root viewBox is moved to the artwork's bounds (b, in the page render's
   pixels), width / height scaled with it when they carry a size, so svgSize / the colour route / the wand's file units /
   a saved design all see the cropped file as one consistent thing. Declined (null) when the file cannot be cropped
   safely: no viewBox and no natural size; a viewBox letterboxed inside the size (preserveAspectRatio); a percentage
   length that would resolve against the new viewBox and move (a % on a gradient, filter, mask, clip or pattern in its
   default objectBoundingBox units stays put and is allowed; a page rect of 100% x 100% is written out in the page's
   own numbers so it keeps covering the page); any % inside a style, or a transform-origin. */
const SVG_PCT_ATTRS=["x","y","x1","y1","x2","y2","cx","cy","r","rx","ry","fx","fy","width","height","stroke-width","dx","dy","stroke-dasharray","stroke-dashoffset","textLength","fr"];
function plSvgCropText(txt, b, cw, ch, natW, natH){
  let doc; try{ doc=new DOMParser().parseFromString(txt,"image/svg+xml"); }catch(e){ return null; }
  const root=doc && doc.documentElement; if(!root || root.nodeName.toLowerCase()!=="svg" || doc.getElementsByTagName("parsererror").length) return null;
  const vbA=(root.getAttribute("viewBox")||"").trim().split(/[\s,]+/).map(Number);
  const hasVb = vbA.length===4 && vbA.every(isFinite) && vbA[2]>0 && vbA[3]>0;
  const vb = hasVb ? vbA : ((natW>0 && natH>0) ? [0,0,natW,natH] : null);   /* no viewBox: user units are CSS px */
  if(!vb) return null;
  const par=(root.getAttribute("preserveAspectRatio")||"").trim();
  if(hasVb && par!=="none" && Math.abs((vb[2]/vb[3])/(cw/ch)-1)>0.01) return null;
  const m=/<svg\b[^>]*>/i.exec(txt); const body=m ? txt.slice(m.index+m[0].length) : txt;
  if(/(?:style\s*=\s*["'][^"']*%|<style[\s>][\s\S]*?%[\s\S]*?<\/style|transform-origin)/i.test(body)) return null;
  /* viewport units read the viewport too (round 7); tested with data: URIs and comments taken out, or an embedded photo's base64
     matches by chance (round 8: a 300 KB image 99% of the time) */
  if(/\d(?:\.\d+)?(?:[sld]?v(?:w|h|i|b|min|max)|cq(?:w|h|i|b|min|max))\b/i.test(body.replace(/<!--[\s\S]*?-->/g,"").replace(/<(i:pgf|metadata)\b(?:[^>]*\/>|[^>]*>[\s\S]*?<\/\1\s*>)/gi,"").replace(/\bdata:[^"')]*/gi,""))) return null;   /* Illustrator's editing blob and metadata are base64 too (round 10) */
  /* a % inside a bbox-relative coordinate system does not move with the crop; everything else does. A gradient's, mask's, pattern's
     or filter's OWN x/y/width/height are bbox-relative unless *Units="userSpaceOnUse"; a clipPath's are userSpaceOnUse unless said
     otherwise; and the CONTENT of a clipPath / mask / pattern / filter follows clipPathUnits / maskContentUnits / patternContentUnits /
     primitiveUnits, all userSpaceOnUse by default (round 4: a 100% clip rect moved with the crop and clipped the artwork away). */
  const BBOX=/^(linearGradient|radialGradient|filter|mask|clipPath|pattern)$/i,
    OWN={lineargradient:"gradientUnits",radialgradient:"gradientUnits",filter:"filterUnits",mask:"maskUnits",clippath:"clipPathUnits",pattern:"patternUnits"},
    CONTENT={clippath:"clipPathUnits",mask:"maskContentUnits",pattern:"patternContentUnits",filter:"primitiveUnits"};
  const bboxRel=el=>{ for(let e=el; e && e!==root; e=e.parentNode){ const n=(e.nodeName||"").toLowerCase(); if(!BBOX.test(n)) continue;
    if(e===el){ const u=e.getAttribute(OWN[n]); return n==="clippath" ? u==="objectBoundingBox" : (!u || u!=="userSpaceOnUse"); }
    return e.getAttribute(CONTENT[n]||"")==="objectBoundingBox"; } return false; };
  /* implicit regions read the viewport too (round 6): a userSpaceOnUse mask / filter with no region is -10% / 120% of it, a nested
     svg or a use with no size is 100% of it. Written out in the OLD viewport's user units (from user-space 0, like the browser) they stay put. */
  const n4=v=>String(+v.toFixed(4));
  for(const e of root.querySelectorAll("mask,filter")){
    const n=e.nodeName.toLowerCase(); if(e.getAttribute(n==="mask"?"maskUnits":"filterUnits")!=="userSpaceOnUse") continue;
    const d={x:-0.1*vb[2], y:-0.1*vb[3], width:1.2*vb[2], height:1.2*vb[3]};
    for(const a in d) if(!e.hasAttribute(a)) e.setAttribute(a,n4(d[a]));
  }
  for(const e of root.querySelectorAll("svg,use")){
    if(e===root) continue;
    if(!e.hasAttribute("width")) e.setAttribute("width",n4(vb[2]));
    if(!e.hasAttribute("height")) e.setAttribute("height",n4(vb[3]));
  }
  for(const e of root.querySelectorAll("linearGradient,radialGradient")){   /* round 7: a userSpaceOnUse gradient's defaults (x2 100%, cx cy r 50%) read the viewport too */
    if(e.getAttribute("gradientUnits")!=="userSpaceOnUse") continue;
    const d=e.nodeName.toLowerCase()==="lineargradient" ? {x2:vb[2]} : {cx:0.5*vb[2], cy:0.5*vb[3], r:0.5*Math.sqrt((vb[2]*vb[2]+vb[3]*vb[3])/2)};
    const miss=Object.keys(d).filter(a=>!e.hasAttribute(a));
    if(!miss.length) continue;
    if(e.hasAttribute("href")||e.hasAttributeNS("http://www.w3.org/1999/xlink","href")) return null;   /* inherits its geometry from another gradient: not resolvable here */
    for(const a of miss) e.setAttribute(a,n4(d[a]));
  }
  for(const el of root.querySelectorAll("*")){
    const pct=SVG_PCT_ATTRS.filter(a=>/%/.test(el.getAttribute(a)||""));
    if(!pct.length) continue;
    if(bboxRel(el)) continue;
    /* inside a nested svg a % is of THAT viewport: fixed once the nested svg has a numeric size (every one has, see above) */
    const vp=el.parentNode && el.parentNode.closest ? el.parentNode.closest("svg") : root;
    if(vp && vp!==root){ if(!/%/.test((vp.getAttribute("width")||"")+(vp.getAttribute("height")||""))) continue; return null; }
    const isPage = el.nodeName.toLowerCase()==="rect" && /^\s*100%\s*$/.test(el.getAttribute("width")||"") && /^\s*100%\s*$/.test(el.getAttribute("height")||"")
      && !(parseFloat(el.getAttribute("x")||"0")) && !(parseFloat(el.getAttribute("y")||"0")) && pct.every(a=>a==="width"||a==="height"||a==="x"||a==="y");
    if(!isPage) return null;
    /* the page's size in user units; x and y stay where the browser drew them (user-space 0, not the viewBox origin; a "0%" becomes 0) */
    if(/%/.test(el.getAttribute("x")||"")) el.setAttribute("x","0"); if(/%/.test(el.getAttribute("y")||"")) el.setAttribute("y","0");
    el.setAttribute("width",String(vb[2])); el.setAttribute("height",String(vb[3]));
  }
  const fx=b.x/cw, fy=b.y/ch, fw=b.w/cw, fh=b.h/ch;
  const r=v=>+v.toFixed(4);
  root.setAttribute("viewBox", [r(vb[0]+vb[2]*fx), r(vb[1]+vb[3]*fy), r(vb[2]*fw), r(vb[3]*fh)].join(" "));
  for(const [a,f] of [["width",fw],["height",fh]]){
    const v=root.getAttribute(a); if(v==null) continue;
    const mm=/^\s*([\d.]+)\s*([a-z]*)\s*$/i.exec(v);
    if(!mm){ root.removeAttribute(a); continue; }
    root.setAttribute(a, r(parseFloat(mm[1])*f)+mm[2]);
  }
  try{ return new XMLSerializer().serializeToString(doc); }catch(e){ return null; }
}
function loadSvg(file,cb){
  $("spin").classList.add("show");
  const reader=new FileReader();
  reader.onload=()=>{
    let txt=reader.result;
    /* guarantee an xmlns so the blob renders as an image */
    txt=plSvgRepair(txt);   /* 21 Oct 2026: the namespace only; a missing size from the viewBox */
    const blob=new Blob([txt],{type:"image/svg+xml"});
    const url=URL.createObjectURL(blob);
    const img=new Image();
    img.onload=()=>{
      URL.revokeObjectURL(url);
      /* an SVG <image> may report 0 size if it had no width/height; fall back */
      let w=img.naturalWidth||img.width||0, h=img.naturalHeight||img.height||0;
      if(!w||!h){ w=VEC_TARGET; h=VEC_TARGET; }
      const natW=img.naturalWidth||img.width||0, natH=img.naturalHeight||img.height||0;
      const s=VEC_TARGET/Math.max(w,h);
      let c=mk(w*s,h*s);
      c.getContext("2d").drawImage(img,0,0,c.width,c.height);
      /* 18 Oct 2026 (P215): a file with its own cut line goes through svgCutIntake; every other SVG as before */
      if(svgCutIntake(txt,c,cb)) return;
      /* the page is not the artwork: the viewBox goes to the artwork's bounds, and the render with it. A white page
         background (svgAnalyse's bgHex) counts as the page only on a paper-sized file with a real viewBox; a coloured
         background, or one on a label-sized artboard, is part of the design and stays */
      let i0=null, bgRef=null;
      try{
        i0=svgAnalyse(txt);
        const rgb=i0 && i0.bgHex ? hexRgb(i0.bgHex) : null;
        if(rgb && Math.min(rgb[0],rgb[1],rgb[2])>=235 && plSvgRootHasVb(txt) && (plPaperPage(natW*0.75,natH*0.75) || plPaperPage(natW,natH))) bgRef={rgb, tol:1};   /* a paper page at 96 or 72 dpi */
      }catch(e){ i0=null; bgRef=null; }
      const b=plArtBounds(c,c.width,c.height,bgRef);
      if(b){
        let t2=plSvgCropText(txt,b,c.width,c.height,natW,natH);
        /* a crop must not turn an artwork shape into a "background" the colour route would switch off */
        if(t2 && !(i0 && i0.bgHex)){ try{ const i2=svgAnalyse(t2); if(i2 && i2.bgHex) t2=null; }catch(e){ t2=null; } }
        if(t2){
          const k=VEC_TARGET/Math.max(b.w,b.h), c2=mk(Math.round(b.w*k),Math.round(b.h*k));
          c2.getContext("2d").drawImage(img,-b.x*k,-b.y*k,c.width*k,c.height*k);
          /* PROVED BY RENDERING (round 6): the cropped text must draw what the original drew inside the box. Anything that still
             reads the viewport (a % the guard missed, an implicit region, a construct nobody listed) shows up here, and the file
             takes the path it took before this fix. */
          plSvgSameRender(t2,c2,(same)=>{
            if(same){ c.width=0; c.height=0; c=c2; txt=t2; } else { c2.width=0; c2.height=0; }
            if(plSvgIntake(txt,cb)) return;   /* 21 Oct 2026: its colours, drawn from the vector */
            rasterImgFromCanvas(c,cb);
          });
          return;
        }
      }
      if(plSvgIntake(txt,cb)) return;   /* 21 Oct 2026: its colours, drawn from the vector */
      rasterImgFromCanvas(c,cb);
    };
    img.onerror=()=>{ URL.revokeObjectURL(url); $("spin").classList.remove("show"); showError(stkT("stk.studio.msg.svg_render","That SVG could not be rendered. Flatten it to PNG and try again.")); if(cb) cb(); };
    img.src=url;
  };
  reader.onerror=()=>{ $("spin").classList.remove("show"); showError(stkT("stk.studio.msg.svg_read","That SVG could not be read.")); if(cb) cb(); };
  reader.readAsText(file);
}
function loadPdf(file,cb){
  $("spin").classList.add("show");
  loadPdfJs().then(function(pdfjsLib){
    const reader=new FileReader();
    reader.onload=function(){
      const data=new Uint8Array(reader.result);
      let pdfDoc=null, pdfPage=null, pdfVp=null;
      /* 18 Oct 2026 (review): isEvalSupported:false, so a crafted font cannot make pdf.js build code with new Function */
      pdfjsLib.getDocument({data:data, isEvalSupported:false}).promise.then(function(pdf){
        pdfDoc=pdf;
        return pdf.getPage(1);
      }).then(function(page){
        const vp1=page.getViewport({scale:1});
        const scale=VEC_TARGET/Math.max(vp1.width,vp1.height);
        const vp=page.getViewport({scale:scale});
        pdfPage=page; pdfVp=vp;
        const c=mk(vp.width,vp.height);
        const ctx=c.getContext("2d");
        /* PDFs have no transparency; paint white so removeWhite can lift it */
        ctx.fillStyle="#ffffff"; ctx.fillRect(0,0,c.width,c.height);
        return page.render({canvasContext:ctx,viewport:vp,intent:"print"}).promise.then(function(){ return c; });
      }).then(function(c){
        /* 18 Oct 2026 (P215): a PDF or .ai with its own cut line goes through pdfCutIntake; every other PDF as before */
        return pdfCutIntake(pdfjsLib,pdfDoc,pdfPage,pdfVp,c,file,cb).then(function(taken){
          if(taken) return;
          /* the page is not the artwork, when the page is a sheet of paper (pdf.js paints it white) */
          const vp1=pdfPage.getViewport({scale:1});
          const b=plPaperPage(vp1.width,vp1.height) ? plArtBounds(c,c.width,c.height,{rgb:[255,255,255],tol:1}) : null;
          if(!b){ rasterImgFromCanvas(c,cb); return; }
          const k=VEC_TARGET/Math.max(b.w,b.h);
          const vp2=pdfPage.getViewport({scale:pdfVp.scale*k, offsetX:-b.x*k, offsetY:-b.y*k});
          const c2=mk(Math.round(b.w*k),Math.round(b.h*k)), x2=c2.getContext("2d");
          x2.fillStyle="#ffffff"; x2.fillRect(0,0,c2.width,c2.height);
          return pdfPage.render({canvasContext:x2,viewport:vp2,intent:"print"}).promise
            .then(function(){ c.width=0; c.height=0; rasterImgFromCanvas(c2,cb); })
            .catch(function(){ rasterImgFromCanvas(c,cb); });
        });
      }).catch(function(err){
        console.error(err);
        $("spin").classList.remove("show");
        showError(stkT("stk.studio.msg.pdf_render","That PDF could not be rendered. Export it as PNG and try again."));
        if(cb) cb();
      });
    };
    reader.onerror=function(){ $("spin").classList.remove("show"); showError(stkT("stk.studio.msg.pdf_read","That PDF could not be read.")); if(cb) cb(); };
    reader.readAsArrayBuffer(file);
  }).catch(function(err){
    console.error(err);
    $("spin").classList.remove("show");
    showError(stkT("stk.studio.msg.pdf_reader","The PDF reader could not load. Check your connection and try again."));
    if(cb) cb();
  });
}
/* 18 Oct 2026 (P215): an Illustrator file is read by its first 1 KB, never its name. Saved with "Create PDF Compatible
   File" it is a PDF inside (%PDF-) and takes the PDF route, cut line and all; without it (%!PS) no browser can draw it. */
function loadAi(file,cb){
  const rd=new FileReader();
  rd.onload=()=>{
    const u=new Uint8Array(rd.result||new ArrayBuffer(0)); let h=""; for(let i=0;i<u.length;i++) h+=String.fromCharCode(u[i]);
    if(h.indexOf("%PDF-")>=0){ loadPdf(file,cb); return; }
    showError(/%!PS/.test(h) ? stkT("stk.studio.msg.ai_not_pdf","This Illustrator file cannot be opened here. In Illustrator, save it again with Create PDF Compatible File ticked, or upload a PDF or SVG.")
                             : stkT("stk.studio.msg.file_type","That file type is not supported. Use PNG, JPEG, WEBP, SVG, PDF or AI."));
    if(cb) cb();
  };
  rd.onerror=()=>{ showError(stkT("stk.studio.msg.pdf_read","That PDF could not be read.")); if(cb) cb(); };
  rd.readAsArrayBuffer(file.slice(0,1024));
}
function rasterImgFromCanvas(c,cb){
  const img=new Image();
  img.onload=()=>{ srcImg=img; srcIsVector=true; opts.labelApplied=false; processSource(cb); };
  img.onerror=()=>{ $("spin").classList.remove("show"); showError(stkT("stk.studio.msg.file_prepare","Could not prepare that file.")); if(cb) cb(); };
  img.src=c.toDataURL("image/png");
}
/* ================= 18 Oct 2026 (P215): THE CUT LINE FROM THE CUSTOMER'S FILE =================
   Order 9670: loadSvg drew the whole file into pixels, so the customer's die line PRINTED and a generic cut was
   traced 2mm outside it. A file can now carry its own cut:
   - S1, named: an element, or an ancestor, whose id / data-name / inkscape:label / serif:id is a die-line name
     (Sheet Builder's PDF_DIE_NAME word for word, so all three tools agree; Illustrator _xNN_ escapes decoded). It
     leaves the print and becomes the cut, own-cut mode ON. Perf / crease / score / reg marks leave the print too
     but are never the cut.
   - S2, no name: a closed magenta stroke (within 40 of #EC008C or #FF00FF), no fill, 2pt or less. Never removed for
     the customer (LAB-RULES, guard G1): the switch starts OFF and the print is untouched until they turn it on.
   G5: the customer's SVG is parsed in a DETACHED DOMParser document and never reaches the page (measured: 6 of 9
   hostile handlers ran in the live DOM, 0 detached). What renders is the serialised text through the same Image
   route as before. G2: the cut is geometry only, next to the artwork; the artwork loses the removed vector element
   and nothing else. A file with no cut line takes exactly the old route. */
/* 18 Oct 2026 (review): the WHOLE name must be the die-line term (an optional perf / crease / score in front, an
   optional number after, space _ - between), so "Diecut_sticker_art" or "My dieline art" is artwork, not a cut.
   Sheet Builder (sheet-builder.html 6890) still has the loose word-for-word form: it now finds more names than this. */
const PDF_DIE_NAME=/die.?line|die.?cut|cut.?contour|contour.?cut|thru.?cut|through.?cut|kiss.?cut|^cut(ting)?(.?line|.?path)?$/i;   /* sheet-builder.html 6890, word for word; 18 Oct 2026 (review): the anchored form dropped 'Dieline', 'Kiss Cut Line', 'Die Line Layer'; cutOneClosed, the clean check and G3 cover the artwork-named-like-a-cut case */
const CUT_NOT_CUT=/perf|crease|score|reg.?mark/i;
const cutName=v=>String(v==null?"":v).replace(/_x([0-9a-f]{2})_/gi,(m,h)=>String.fromCharCode(parseInt(h,16))).trim();
const SVG_NO_DRAW=/^(defs|clipPath|mask|pattern|symbol|marker|linearGradient|radialGradient|filter|metadata|title|desc|style|script)$/;
const svgNum=(v,d)=>{ const n=parseFloat(v); return isFinite(n)?n:d; };
/* an absolute length in CSS px; null for %, em or nothing */
function svgLenPx(v){
  const m=/^\s*([-+]?(?:\d*\.\d+|\d+\.?)(?:e[-+]?\d+)?)\s*(px|pt|pc|mm|cm|in|q)?\s*$/i.exec(String(v==null?"":v)); if(!m) return null;
  return +m[1]*({px:1,pt:96/72,pc:16,mm:96/25.4,cm:96/2.54,in:96,q:96/101.6})[(m[2]||"px").toLowerCase()];
}
const mxMul=(A,B)=>[A[0]*B[0]+A[2]*B[1], A[1]*B[0]+A[3]*B[1], A[0]*B[2]+A[2]*B[3], A[1]*B[2]+A[3]*B[3], A[0]*B[4]+A[2]*B[5]+A[4], A[1]*B[4]+A[3]*B[5]+A[5]];
/* the transform attribute by hand: getCTM would add the viewBox-to-viewport scale (Result D) */
function svgXform(str){
  let M=[1,0,0,1,0,0]; const re=/(matrix|translate|scale|rotate|skewX|skewY)\s*\(([^)]*)\)/gi; let r;
  while((r=re.exec(str||""))){
    const a=(r[2].match(/[-+]?(?:\d*\.\d+|\d+\.?)(?:e[-+]?\d+)?/gi)||[]).map(Number), D=Math.PI/180; let t=[1,0,0,1,0,0];
    switch(r[1].toLowerCase()){
      case "matrix": if(a.length===6) t=a; break;
      case "translate": t=[1,0,0,1,a[0]||0,a[1]||0]; break;
      case "scale": { const x=a.length?a[0]:1; t=[x,0,0,a.length>1?a[1]:x,0,0]; break; }
      case "rotate": { const q=(a[0]||0)*D, c=Math.cos(q), s=Math.sin(q), cx=a[1]||0, cy=a[2]||0; t=[c,s,-s,c,cx-c*cx+s*cy,cy-s*cx-c*cy]; break; }
      case "skewx": t=[1,0,Math.tan((a[0]||0)*D),1,0,0]; break;
      case "skewy": t=[1,Math.tan((a[0]||0)*D),0,1,0,0]; break;
    }
    M=mxMul(M,t);
  }
  return M;
}
function segsXform(segs,M){
  return segs.map(g=>{ if(g.c==="Z") return g; const p=[]; for(let i=0;i<g.p.length;i+=2) p.push(M[0]*g.p[i]+M[2]*g.p[i+1]+M[4], M[1]*g.p[i]+M[3]*g.p[i+1]+M[5]); return {c:g.c,p}; });
}
/* SVG arc to cubics (SVG 1.1 F.6) */
function arcCubics(x1,y1,rx,ry,phi,fa,fs,x2,y2,out){
  if(x1===x2 && y1===y2) return;
  rx=Math.abs(rx); ry=Math.abs(ry);
  if(!rx || !ry){ out.push({c:"L",p:[x2,y2]}); return; }
  const r=phi*Math.PI/180, co=Math.cos(r), si=Math.sin(r);
  const dx=(x1-x2)/2, dy=(y1-y2)/2, xp=co*dx+si*dy, yp=-si*dx+co*dy;
  let L=xp*xp/(rx*rx)+yp*yp/(ry*ry); if(L>1){ L=Math.sqrt(L); rx*=L; ry*=L; }
  const nu=rx*rx*ry*ry-rx*rx*yp*yp-ry*ry*xp*xp, de=rx*rx*yp*yp+ry*ry*xp*xp;
  let k=de?Math.sqrt(Math.max(0,nu/de)):0; if(fa===fs) k=-k;
  const cxp=k*rx*yp/ry, cyp=-k*ry*xp/rx, cx=co*cxp-si*cyp+(x1+x2)/2, cy=si*cxp+co*cyp+(y1+y2)/2;
  const ang=(ux,uy,vx,vy)=>Math.atan2(ux*vy-uy*vx, ux*vx+uy*vy);
  const t1=ang(1,0,(xp-cxp)/rx,(yp-cyp)/ry);
  let dt=ang((xp-cxp)/rx,(yp-cyp)/ry,(-xp-cxp)/rx,(-yp-cyp)/ry);
  if(!fs && dt>0) dt-=2*Math.PI; else if(fs && dt<0) dt+=2*Math.PI;
  const n=Math.max(1,Math.ceil(Math.abs(dt)/(Math.PI/2)-1e-9)), h=dt/n, kk=4/3*Math.tan(h/4);
  const P=(ex,ey)=>[cx+rx*ex*co-ry*ey*si, cy+rx*ex*si+ry*ey*co];
  for(let j=0;j<n;j++){
    const a0=t1+j*h, a1=a0+h, c0=Math.cos(a0), s0=Math.sin(a0), c1=Math.cos(a1), s1=Math.sin(a1);
    const p1=P(c0-kk*s0, s0+kk*c0), p2=P(c1+kk*s1, s1-kk*c1), p3=j===n-1?[x2,y2]:P(c1,s1);
    out.push({c:"C",p:[p1[0],p1[1],p2[0],p2[1],p3[0],p3[1]]});
  }
}
/* path data to absolute M/L/C/Z (H/V to L, S/Q/T/A to cubics). After a Z a new subpath starts with its own M. */
function svgPathSegs(d){
  const s=String(d||""), out=[], NUM=/[-+]?(?:\d*\.\d+|\d+\.?)(?:[eE][-+]?\d+)?/y;
  let i=0, cmd="", x=0, y=0, sx=0, sy=0, cx=0, cy=0, qx=0, qy=0, prev="", open=false;
  const ws=()=>{ while(i<s.length && /[\s,]/.test(s[i])) i++; };
  const num=()=>{ ws(); NUM.lastIndex=i; const m=NUM.exec(s); if(!m) return null; i=NUM.lastIndex; return +m[0]; };
  const flag=()=>{ ws(); const c=s[i]; if(c==="0"||c==="1"){ i++; return +c; } return null; };
  const start=()=>{ if(!open){ out.push({c:"M",p:[x,y]}); sx=x; sy=y; open=true; } };
  for(let guard=0; guard<5e6; guard++){
    ws(); if(i>=s.length) break;
    if(/[a-z]/i.test(s[i])){ cmd=s[i]; i++; } else if(!cmd) return null;
    const rel=cmd!==cmd.toUpperCase(), C=cmd.toUpperCase(), ox=rel?x:0, oy=rel?y:0;
    if(C==="Z"){ if(open){ out.push({c:"Z"}); x=sx; y=sy; open=false; } prev="Z"; cmd=""; continue; }
    if(C==="M"){ const a=num(), b=num(); if(a==null||b==null) return null; x=a+ox; y=b+oy; open=false; start(); cmd=rel?"l":"L"; prev="M"; continue; }
    if(C==="L"){ const a=num(), b=num(); if(a==null||b==null) return null; start(); x=a+ox; y=b+oy; out.push({c:"L",p:[x,y]}); }
    else if(C==="H"){ const a=num(); if(a==null) return null; start(); x=a+ox; out.push({c:"L",p:[x,y]}); }
    else if(C==="V"){ const a=num(); if(a==null) return null; start(); y=a+oy; out.push({c:"L",p:[x,y]}); }
    else if(C==="C"||C==="S"){
      let x1,y1;
      if(C==="C"){ x1=num(); y1=num(); if(x1==null||y1==null) return null; x1+=ox; y1+=oy; }
      else { x1=(prev==="C")?2*x-cx:x; y1=(prev==="C")?2*y-cy:y; }
      const x2=num(), y2=num(), x3=num(), y3=num(); if(x2==null||y2==null||x3==null||y3==null) return null;
      start(); cx=x2+ox; cy=y2+oy; out.push({c:"C",p:[x1,y1,cx,cy,x3+ox,y3+oy]}); x=x3+ox; y=y3+oy; prev="C"; continue;
    }
    else if(C==="Q"||C==="T"){
      let q1,q2;
      if(C==="Q"){ q1=num(); q2=num(); if(q1==null||q2==null) return null; q1+=ox; q2+=oy; }
      else { q1=(prev==="Q")?2*x-qx:x; q2=(prev==="Q")?2*y-qy:y; }
      const x3=num(), y3=num(); if(x3==null||y3==null) return null;
      start(); const ex=x3+ox, ey=y3+oy;
      out.push({c:"C",p:[x+2/3*(q1-x), y+2/3*(q2-y), ex+2/3*(q1-ex), ey+2/3*(q2-ey), ex, ey]});
      qx=q1; qy=q2; x=ex; y=ey; prev="Q"; continue;
    }
    else if(C==="A"){
      const rx=num(), ry=num(), ph=num(), fa=flag(), fs=flag(), a=num(), b=num();
      if(rx==null||ry==null||ph==null||fa==null||fs==null||a==null||b==null) return null;
      start(); arcCubics(x,y,rx,ry,ph,fa,fs,a+ox,b+oy,out); x=a+ox; y=b+oy;
    }
    else return null;
    prev=C;
  }
  return out;
}
/* rect / circle / ellipse / line / polyline / polygon / path to segments; null for anything that is not a shape.
   A detached document has no getTotalLength on the primitives (Result D), so they are converted here. */
function svgShapeSegs(el){
  const g=k=>svgNum(el.getAttribute(k),0), K=0.5522847498;
  const ell=(cx,cy,rx,ry)=>[{c:"M",p:[cx+rx,cy]},{c:"C",p:[cx+rx,cy+K*ry,cx+K*rx,cy+ry,cx,cy+ry]},{c:"C",p:[cx-K*rx,cy+ry,cx-rx,cy+K*ry,cx-rx,cy]},
    {c:"C",p:[cx-rx,cy-K*ry,cx-K*rx,cy-ry,cx,cy-ry]},{c:"C",p:[cx+K*rx,cy-ry,cx+rx,cy-K*ry,cx+rx,cy]},{c:"Z"}];
  switch(el.localName){
    case "path": return svgPathSegs(el.getAttribute("d"));
    case "circle": { const r=g("r"); return r>0?ell(g("cx"),g("cy"),r,r):[]; }
    case "ellipse": { const rx=g("rx"), ry=g("ry"); return (rx>0&&ry>0)?ell(g("cx"),g("cy"),rx,ry):[]; }
    case "line": return [{c:"M",p:[g("x1"),g("y1")]},{c:"L",p:[g("x2"),g("y2")]}];
    case "polyline": case "polygon": {
      const n=(String(el.getAttribute("points")||"").match(/[-+]?(?:\d*\.\d+|\d+\.?)(?:e[-+]?\d+)?/gi)||[]).map(Number), o=[];
      for(let i=0;i+1<n.length;i+=2) o.push({c:i?"L":"M",p:[n[i],n[i+1]]});
      if(o.length && el.localName==="polygon") o.push({c:"Z"});
      return o;
    }
    case "rect": {
      const x=g("x"), y=g("y"), w=g("width"), h=g("height"); if(!(w>0&&h>0)) return [];
      let rx=el.getAttribute("rx"), ry=el.getAttribute("ry");
      rx=rx==null?(ry==null?0:svgNum(ry,0)):svgNum(rx,0); ry=ry==null?rx:svgNum(ry,0);
      rx=Math.min(Math.max(0,rx),w/2); ry=Math.min(Math.max(0,ry),h/2);
      if(!rx||!ry) return [{c:"M",p:[x,y]},{c:"L",p:[x+w,y]},{c:"L",p:[x+w,y+h]},{c:"L",p:[x,y+h]},{c:"Z"}];
      return [{c:"M",p:[x+rx,y]},{c:"L",p:[x+w-rx,y]},{c:"C",p:[x+w-rx+K*rx,y,x+w,y+ry-K*ry,x+w,y+ry]},{c:"L",p:[x+w,y+h-ry]},
        {c:"C",p:[x+w,y+h-ry+K*ry,x+w-rx+K*rx,y+h,x+w-rx,y+h]},{c:"L",p:[x+rx,y+h]},{c:"C",p:[x+rx-K*rx,y+h,x,y+h-ry+K*ry,x,y+h-ry]},
        {c:"L",p:[x,y+ry]},{c:"C",p:[x,y+ry-K*ry,x+rx-K*rx,y,x+rx,y]},{c:"Z"}];
    }
  }
  return null;
}
/* the <style> rules that can style a line: .class, #id and element selectors (Illustrator's Internal CSS mode) */
function svgRules(doc){
  const rules=[];
  doc.querySelectorAll("style").forEach(st=>{
    const t=String(st.textContent||"").replace(/\/\*[\s\S]*?\*\//g,""), re=/([^{}]+)\{([^}]*)\}/g; let m;
    while((m=re.exec(t))){
      const decl={}; m[2].split(";").forEach(kv=>{ const k=kv.indexOf(":"); if(k>0) decl[kv.slice(0,k).trim().toLowerCase()]=kv.slice(k+1).replace(/!important/i,"").trim(); });
      m[1].split(",").forEach(sel=>{ sel=sel.trim(); if(/^[.#]?[\w-]+$/.test(sel)) rules.push({sel,decl}); });
    }
  });
  return rules;
}
/* one element's own value for a property: style attribute, then the strongest matching rule, then the attribute */
function svgOwn(el,name,rules){
  const st=el.getAttribute("style");
  if(st){ const m=new RegExp("(?:^|;)\\s*"+name+"\\s*:\\s*([^;]+)","i").exec(st); if(m) return m[1].replace(/!important/i,"").trim(); }
  const id=el.getAttribute("id"), cls=String(el.getAttribute("class")||"").split(/\s+/);
  let best=null, sp=-1;
  for(const r of rules){
    if(!(name in r.decl)) continue;
    const s=r.sel, k = s[0]==="#" ? (s.slice(1)===id?2:-1) : s[0]==="." ? (cls.indexOf(s.slice(1))>=0?1:-1) : (s===el.localName?0:-1);
    if(k>=0 && k>=sp){ sp=k; best=r.decl[name]; }
  }
  if(best!=null) return best;
  const a=el.getAttribute(name); return a==null?null:a.trim();
}
/* a property resolved along the element's chain (itself, then its <use>, then its ancestors) */
function svgProp(chain,name,rules,dflt){
  for(const n of chain){ const v=svgOwn(n,name,rules); if(v!=null && v!=="" && v!=="inherit") return v; }
  return dflt;
}
function svgRGB(v){
  v=String(v||"").trim().toLowerCase();
  if(!v || v==="none" || v==="transparent") return null;
  if(v==="magenta"||v==="fuchsia") return [255,0,255];
  let m=/^#([0-9a-f]{3})$/.exec(v); if(m) return m[1].split("").map(h=>parseInt(h+h,16));
  m=/^#([0-9a-f]{6})/.exec(v); if(m){ const n=parseInt(m[1],16); return [n>>16,(n>>8)&255,n&255]; }
  m=/^rgba?\(\s*([\d.]+)(%?)[\s,]+([\d.]+)(%?)[\s,]+([\d.]+)(%?)/.exec(v); if(m) return [1,3,5].map(i=>Math.round(m[i+1]?m[i]*2.55:+m[i]));
  return [0,0,0];   /* any other paint (a name, a gradient): a colour, and not magenta */
}
const nearRGB=(a,b,t)=>!!a && Math.abs(a[0]-b[0])<=t && Math.abs(a[1]-b[1])<=t && Math.abs(a[2]-b[2])<=t;
/* every drawn shape under el, in root user units. host = what to take out of the file for it (the <use>, if any). */
function svgCollect(el,M,chain,doc,out,depth,host,want){   /* want(chain): parse only the shapes it accepts */
  const n=el.localName;
  if(!n || SVG_NO_DRAW.test(n)) return;
  const M2=el===doc.documentElement ? M : mxMul(M, svgXform(el.getAttribute("transform"))), ch=[el].concat(chain);   /* the root's own transform is not read, here or in anc() */
  if(n==="use"){
    if(depth>4) return;
    const id=String(el.getAttribute("href")||el.getAttributeNS("http://www.w3.org/1999/xlink","href")||"").replace(/^#/,"");
    const t=id?doc.getElementById(id):null;
    if(!t || t===el || t.contains(el)) return;
    if(t.localName==="symbol" || t.localName==="svg"){ out.push({art:true, el:host||el}); return; }
    svgCollect(t, mxMul(M2,[1,0,0,1,svgNum(el.getAttribute("x"),0),svgNum(el.getAttribute("y"),0)]), ch, doc, out, depth+1, host||el, want);
    return;
  }
  if((n==="svg" && el!==doc.documentElement) || n==="image" || n==="text" || n==="foreignObject" || n==="switch"){ out.push({art:true, el:host||el}); return; }
  if(/^(path|rect|circle|ellipse|line|polyline|polygon)$/.test(n) && want && !want(ch)) return;
  const segs=svgShapeSegs(el);
  if(segs){ if(segs.length) out.push({el:host||el, tag:n, segs:segsXform(segs,M2), M:M2, chain:ch}); return; }
  for(const k of el.children) svgCollect(k, M2, ch, doc, out, depth, host, want);
}
/* viewBox -> viewport, with preserveAspectRatio */
function vbMap(vb,W,H,par){
  const sx=W/vb[2], sy=H/vb[3], p=String(par||"").trim().split(/\s+/), al=(p[0]==="defer"?p[1]:p[0])||"xMidYMid";
  if(al==="none") return [sx,0,0,sy,-vb[0]*sx,-vb[1]*sy];
  const s=p.indexOf("slice")>=0?Math.max(sx,sy):Math.min(sx,sy);
  const ax=/xMax/.test(al)?1:/xMin/.test(al)?0:0.5, ay=/YMax/.test(al)?1:/YMin/.test(al)?0:0.5;
  return [s,0,0,s,-vb[0]*s+ax*(W-vb[2]*s), -vb[1]*s+ay*(H-vb[3]*s)];
}
/* Find the cut in an SVG's text. cw x ch is the live render's canvas. Returns null when the file has none (the old
   route then runs unchanged), else {kind, segs in that canvas's px, text = the file without the cut, sized to
   cw x ch, mmPerPx, clean, label, colour}. */
function svgFindCut(txt,cw,ch){
  if(!window.DOMParser || !window.XMLSerializer) return null;
  const doc=new DOMParser().parseFromString(txt,"image/svg+xml"), R=doc.documentElement;
  if(!R || R.localName!=="svg" || doc.getElementsByTagName("parsererror").length) return null;
  const rules=svgRules(doc), INK="http://www.inkscape.org/namespaces/inkscape", SERIF="http://www.serif.com/";
  const inNoDraw=el=>{ for(let p=el.parentNode; p && p!==R && p.nodeType===1; p=p.parentNode) if(SVG_NO_DRAW.test(p.localName)) return true; return false; };
  const cutR=[], techR=[];
  for(const el of R.querySelectorAll("*")){
    if(SVG_NO_DRAW.test(el.localName) || inNoDraw(el)) continue;
    let hit=null;
    for(const v of [el.getAttributeNS(INK,"label"), el.getAttribute("inkscape:label"), el.getAttributeNS(SERIF,"id"), el.getAttribute("data-name"), el.getAttribute("id")]){
      const nm=cutName(v); if(nm && PDF_DIE_NAME.test(nm)){ hit=nm; break; }
    }
    if(!hit) continue;
    let up=false; for(let p=el.parentNode; p && p!==R; p=p.parentNode) if(cutR.some(r=>r.el===p) || techR.some(r=>r.el===p)){ up=true; break; }
    if(!up) (CUT_NOT_CUT.test(hit)?techR:cutR).push({el, name:hit});   /* document order: an ancestor is always met first */
  }
  /* user units -> the live render's px, and -> mm when the file states a physical size (px at 96 per inch) */
  const vbA=String(R.getAttribute("viewBox")||"").trim().split(/[\s,]+/).map(Number);
  const hasVB=vbA.length===4 && vbA.every(isFinite) && vbA[2]>0 && vbA[3]>0;
  const Wpx=svgLenPx(R.getAttribute("width")), Hpx=svgLenPx(R.getAttribute("height"));
  const vb=hasVB ? vbA : [0,0, Wpx||300, Hpx||150];
  const par=R.getAttribute("preserveAspectRatio")||"xMidYMid meet";
  const PX=vbMap(vb,cw,ch,par);
  let mmU=null;
  if(Wpx || Hpx){
    if(!hasVB) mmU=25.4/96;
    else { const Wv=Wpx||Hpx*vb[2]/vb[3], Hv=Hpx||Wpx*vb[3]/vb[2]; mmU=vbMap(vb,Wv,Hv,par)[0]*25.4/96; }
  }
  const mmPerPx = mmU ? mmU/PX[0] : null;
  /* 18 Oct 2026 (review): the order is sized from the file only when its width / height carry a physical unit.
     px or no unit keeps the customer's size: Illustrator writes 1px = 1pt, so 96 per inch would cut 25% small.
     mmPerPx still sets the 0.5mm gap and the 2pt stroke tests. */
  const PHYS=/^\s*[-+]?(?:\d*\.\d+|\d+\.?)(?:e[-+]?\d+)?\s*(mm|cm|in|pt|pc|q)\s*$/i;
  const sized=PHYS.test(String(R.getAttribute("width")||"")) || PHYS.test(String(R.getAttribute("height")||""));
  const anc=el=>{ const a=[], c=[]; for(let p=el.parentNode; p && p.nodeType===1 && p!==R; p=p.parentNode){ a.unshift(p); c.push(p); } c.push(R);
    let M=[1,0,0,1,0,0]; for(const p of a) M=mxMul(M,svgXform(p.getAttribute("transform"))); return {M, c, nested:a.some(p=>p.localName==="svg")}; };
  const geom=list=>{ const out=[]; list.forEach(r=>{ const A=anc(r.el); if(A.nested){ out.push({art:true, el:r.el}); return; } svgCollect(r.el, A.M, A.c, doc, out, 0, null); }); return out; };
  const noFill=g=>g.tag==="line" || svgRGB(svgProp(g.chain,"fill",rules,"black"))===null || +svgProp(g.chain,"fill-opacity",rules,"1")===0;   /* a <line> has nothing to fill */
  const colourOf=g=>svgRGB(svgProp(g.chain,"stroke",rules,"none"));
  const tech=geom(techR), techClean=tech.every(g=>!g.art && noFill(g));
  let kind=null, cutG=[], label="", rm=[];
  if(cutR.length){
    kind="named"; cutG=geom(cutR); rm=cutR.map(r=>r.el);
    label=(cutR[0].el.localName==="g"?"layer ":"shape ")+cutR[0].name;
  } else {
    /* S2: a closed magenta stroke, no fill, up to 2pt, shown and drawn (inside a technical layer it is already out) */
    const magenta=chn=>{ const c=svgRGB(svgProp(chn,"stroke",rules,"none")); return nearRGB(c,[236,0,140],40) || nearRGB(c,[255,0,255],40); };
    const all=[]; svgCollect(R,[1,0,0,1,0,0],[],doc,all,0,null,magenta);
    const inTech=el=>{ for(let p=el; p && p!==R; p=p.parentNode) if(techR.some(r=>r.el===p)) return true; return false; };
    for(const g of all){
      if(g.art || inTech(g.el) || !noFill(g)) continue;
      if(g.chain.some(n=>/^\s*none\s*$/i.test(svgOwn(n,"display",rules)||"")) || /^(hidden|collapse)$/i.test(svgProp(g.chain,"visibility",rules,"visible"))) continue;
      const col=colourOf(g);
      if(!(nearRGB(col,[236,0,140],40) || nearRGB(col,[255,0,255],40))) continue;
      if(+svgProp(g.chain,"stroke-opacity",rules,"1")===0) continue;
      const sw=svgNum(svgProp(g.chain,"stroke-width",rules,"1"),1)*Math.sqrt(Math.abs(g.M[0]*g.M[3]-g.M[1]*g.M[2]))*(mmU||25.4/96);
      if(sw>2*PT_TO_MM+1e-6) continue;
      const sh=cutShape(segsXform(g.segs,PX), mmPerPx);
      if(sh.err) continue;   /* an open magenta line is artwork */
      cutG.push(g);
    }
    if(cutG.length){ kind="candidate"; rm=cutG.map(g=>g.el); label="magenta outline"; }
  }
  if(!kind && !(techR.length && techClean)) return null;
  const clean = !cutG.some(g=>g.art) && cutG.every(noFill) && techClean;
  const segs=[]; cutG.forEach(g=>{ if(g.segs) segsXform(g.segs,PX).forEach(q=>segs.push(q)); });
  /* the file without the cut (and technical lines), sized to the live render so both renders line up pixel for pixel */
  rm.concat(techClean?techR.map(r=>r.el):[]).forEach(el=>{ if(el.parentNode) el.parentNode.removeChild(el); });
  if(!hasVB) R.setAttribute("viewBox", vb.join(" "));
  R.setAttribute("width", String(cw)); R.setAttribute("height", String(ch));
  const gc=cutG.find(g=>g.chain), col=gc?colourOf(gc):null;
  return { kind: kind||"tech", segs, text:new XMLSerializer().serializeToString(doc), mmPerPx, sized, clean, label, colour:col };
}
/* flattened points of a segment list (n per cubic) */
function segsFlat(segs,n){
  const o=[]; let x=0,y=0,sx=0,sy=0; n=n||12;
  for(const g of segs){
    const q=g.p;
    if(g.c==="M"){ x=sx=q[0]; y=sy=q[1]; o.push([x,y]); }
    else if(g.c==="L"){ x=q[0]; y=q[1]; o.push([x,y]); }
    else if(g.c==="C"){ for(let k=1;k<=n;k++){ const t=k/n, u=1-t; o.push([u*u*u*x+3*u*u*t*q[0]+3*u*t*t*q[2]+t*t*t*q[4], u*u*u*y+3*u*u*t*q[1]+3*u*t*t*q[3]+t*t*t*q[5]]); } x=q[4]; y=q[5]; }
    else { x=sx; y=sy; o.push([x,y]); }
  }
  return o;
}
/* the exact box of a segment list (cubic extremes from the derivative's roots) */
function segsBBox(segs){
  let x0=Infinity,y0=Infinity,x1=-Infinity,y1=-Infinity,px=0,py=0;
  const add=(x,y)=>{ if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; };
  const roots=(p0,p1,p2,p3)=>{ const a=-p0+3*p1-3*p2+p3, b=2*(p0-2*p1+p2), c=p1-p0, r=[];
    if(Math.abs(a)<1e-12){ if(Math.abs(b)>1e-12) r.push(-c/b); }
    else { const D=b*b-4*a*c; if(D>=0){ const q=Math.sqrt(D); r.push((-b+q)/(2*a),(-b-q)/(2*a)); } }
    return r.filter(t=>t>0&&t<1); };
  for(const g of segs){
    const q=g.p;
    if(g.c==="M"||g.c==="L"){ add(q[0],q[1]); px=q[0]; py=q[1]; }
    else if(g.c==="C"){
      add(q[4],q[5]);
      roots(px,q[0],q[2],q[4]).concat(roots(py,q[1],q[3],q[5])).forEach(t=>{ const u=1-t;
        add(u*u*u*px+3*u*u*t*q[0]+3*u*t*t*q[2]+t*t*t*q[4], u*u*u*py+3*u*u*t*q[1]+3*u*t*t*q[3]+t*t*t*q[5]); });
      px=q[4]; py=q[5];
    }
  }
  return {x:x0, y:y0, w:x1-x0, h:y1-y0};
}
function segsPath(segs,f){
  const p=new Path2D();
  for(const g of segs){
    const q=g.p;
    if(g.c==="M"){ const a=f(q[0],q[1]); p.moveTo(a[0],a[1]); }
    else if(g.c==="L"){ const a=f(q[0],q[1]); p.lineTo(a[0],a[1]); }
    else if(g.c==="C"){ const a=f(q[0],q[1]), b=f(q[2],q[3]), c=f(q[4],q[5]); p.bezierCurveTo(a[0],a[1],b[0],b[1],c[0],c[1]); }
    else p.closePath();
  }
  return p;
}
/* The shape rules (spec section 1): every subpath closed (a gap of 0.5mm or less, or 0.5% of its length in a file
   with no units, is closed for them; more is refused); ONE outer shape (several are refused: one sticker per file);
   inner subpaths are not cut (counted, so the customer is told). Returns {outer, inner} or {err}. */
function cutShape(segs,mmPerPx){
  const subs=[]; let cur=null;
  for(const g of segs){ if(g.c==="M"){ cur=[g]; subs.push(cur); } else if(cur) cur.push(g); }
  const ok=[];
  for(const s of subs){
    const pts=segsFlat(s,12); if(pts.length<3) continue;
    let len=0; for(let i=1;i<pts.length;i++) len+=Math.hypot(pts[i][0]-pts[i-1][0], pts[i][1]-pts[i-1][1]);
    let area=0; for(let i=0,j=pts.length-1;i<pts.length;j=i++) area+=(pts[j][0]+pts[i][0])*(pts[j][1]-pts[i][1]);
    area=Math.abs(area/2);
    if(!(len>0) || !(area>0)) continue;
    const z=s[s.length-1].c==="Z", a=pts[0], b=pts[pts.length-1], gap=Math.hypot(b[0]-a[0], b[1]-a[1]);
    const tol = mmPerPx ? 0.5/mmPerPx : 0.005*len;
    if(!z && gap>tol) return {err:"open"};
    ok.push({segs: z ? s : s.concat([{c:"Z"}]), pts, area});
  }
  if(!ok.length) return {err:"open"};
  const inside=(p,poly)=>{ let c=false; for(let i=0,j=poly.length-1;i<poly.length;j=i++){ const a=poly[i], b=poly[j];
    if(((a[1]>p[1])!==(b[1]>p[1])) && p[0]<(b[0]-a[0])*(p[1]-a[1])/(b[1]-a[1])+a[0]) c=!c; } return c; };
  const outer=ok.filter(A=>!ok.some(B=>B!==A && B.area>A.area && inside(A.pts[0],B.pts)));
  if(outer.length!==1) return {err:"several"};
  return {outer:outer[0].segs, inner:ok.length-1};
}
/* On the render WITHOUT the cut (source px): how much of the inside is ink (under 2% = the line does not go round
   the design), and guard G4: pixels in the cut's own colour (within 24) within 1mm of the line must be 0, or the
   line was not cleanly removed and is not used. */
function cutRasterCheck(cut,cs,opaque,allSegs){
  const w=cs.width, h=cs.height, m=mk(w,h), mx=m.getContext("2d");
  mx.fillStyle="#fff"; mx.fill(segsPath(cut.segs,(x,y)=>[x,y]));
  const A=mx.getImageData(0,0,w,h).data;
  const mmPx = cut.mmPerPx ? 1/cut.mmPerPx : Math.max(cut.bb.w,cut.bb.h)/widthMm();
  mx.clearRect(0,0,w,h); mx.strokeStyle="#fff"; mx.lineWidth=2*mmPx; mx.lineJoin="round"; mx.stroke(segsPath(allSegs||cut.segs,(x,y)=>[x,y]));
  const B=mx.getImageData(0,0,w,h).data, S=cs.getContext("2d").getImageData(0,0,w,h).data, col=cut.colour;
  let inside=0, ink=0, g4=0;
  for(let i=0;i<A.length;i+=4){
    const on=S[i+3]>10 && (!opaque || !(S[i]>245 && S[i+1]>245 && S[i+2]>245));
    if(A[i+3]>127){ inside++; if(on) ink++; }
    if(col && B[i+3]>0 && S[i+3]>10 && Math.abs(S[i]-col[0])<=24 && Math.abs(S[i+1]-col[1])<=24 && Math.abs(S[i+2]-col[2])<=24) g4++;
  }
  m.width=0; m.height=0;
  return { ink: inside ? ink/inside : 0, g4 };
}
/* 18 Oct 2026 (review): the named content is one closed path and nothing else (no art, no fill, no second subpath) */
function cutOneClosed(f){
  if(!f || !f.clean || !f.segs || !f.segs.length) return false;
  if(f.segs.filter(g=>g.c==="M").length!==1) return false;
  const sh=cutShape(f.segs, f.mmPerPx);
  return !sh.err && !sh.inner;
}
/* the cut record from what was found. refused: "open" | "several" | "around" | "unusable" (G3/G4 or a named layer
   that also holds artwork: the full render is kept and nothing leaves the print) */
function cutFromFound(f,cs,opaque){
  const cut={ kind:f.kind, src:f.src||"svg", label:f.label, colour:f.colour, mmPerPx:f.mmPerPx, srcW:cs.width, srcH:cs.height,
    refused:null, inner:0, segs:null, bb:null, fileMm:null };
  if(!f.clean){ cut.refused="unusable"; return cut; }
  const sh=cutShape(f.segs, f.mmPerPx);
  if(sh.err){ cut.refused=sh.err; return cut; }
  cut.segs=sh.outer; cut.inner=sh.inner; cut.bb=segsBBox(sh.outer);
  if(!(cut.bb.w>0 && cut.bb.h>0)){ cut.refused="open"; cut.segs=null; cut.bb=null; return cut; }
  if(f.mmPerPx && f.sized!==false) cut.fileMm={ w:cut.bb.w*f.mmPerPx, h:cut.bb.h*f.mmPerPx };   /* 18 Oct 2026 (review): a px / unitless SVG has sized:false */
  const chk=cutRasterCheck(cut, cs, opaque, f.segs);
  cut.ink=+chk.ink.toFixed(4); cut.g4=chk.g4;
  if(chk.g4>0) cut.refused="unusable";
  else if(chk.ink<0.02) cut.refused="around";
  return cut;
}
function cutMsg(code){
  return ({
    open: stkT("stk.studio.cut.err_open","The cut line in your file is not a closed shape, so we made a new cut line round your design."),
    several: stkT("stk.studio.cut.err_several","Your file has more than one cut shape. Please upload each sticker as its own file. For now we made one cut line round everything."),
    around: stkT("stk.studio.cut.err_around","The cut line in your file does not go round your design, so we made a new cut line."),
    unusable: stkT("stk.studio.cut.err_unusable","We found a cut line but could not use it. It will print as part of your design unless you remove it and upload again.")
  })[code]||"";
}
function imgOfCanvas(c,cb){ const im=new Image(); im.onload=()=>cb(im); im.onerror=()=>cb(null); im.src=c.toDataURL("image/png"); }
function renderSvgText(t,w,h,cb){
  const url=URL.createObjectURL(new Blob([t],{type:"image/svg+xml"})), im=new Image();
  im.onload=()=>{ URL.revokeObjectURL(url); const c=mk(w,h); try{ c.getContext("2d").drawImage(im,0,0,c.width,c.height); }catch(e){ cb(null); return; } cb(c); };
  im.onerror=()=>{ URL.revokeObjectURL(url); cb(null); };
  im.src=url;
}
/* The file's size, clamped to what we cut (10-285mm); the note shows the file's own figure, so a clamp is visible */
function applyFileSize(){
  if(!custCut || !custCut.fileMm || !PL_CUSTOM) return;
  opts.sizeCustomMm=Math.max(SIZE_MIN_MM, Math.min(SIZE_MAX_MM, Math.max(custCut.fileMm.w, custCut.fileMm.h)));
  try{ syncCustomSize(); }catch(e){}
}
/* own-cut ON: die-cut, the file's size */
function ownCutOn(){
  opts.cutMode="own"; opts.shape="custom";
  const seg=$("shapeSeg"); if(seg) [...seg.querySelectorAll("button")].forEach(b=>b.classList.toggle("on", b.dataset.v==="custom"));
  applyFileSize();
}
/* a magenta candidate prints in full until the switch is on; a named line never prints */
function cutModeImage(){
  if(!custCut || custCut.kind!=="candidate" || !custCut.imgFull || !custCut.imgStrip) return;
  srcImg = opts.cutMode==="own" ? custCut.imgStrip : custCut.imgFull;
}
/* the SVG route. c = the live render. Returns false when the file has no cut line, and the old route runs. */
function svgCutIntake(txt,c,cb){
  let f=null;
  try{ f=svgFindCut(txt, c.width, c.height); }catch(e){ console.warn("[proof-lab] cut line read skipped:",e); f=null; }
  if(!f) return false;
  const fail=()=>{ rasterImgFromCanvas(c,cb); };
  renderSvgText(f.text, c.width, c.height, cs=>{
    if(!cs){ fail(); return; }
    cutAdopt(f, c, cs, false, cb, fail);
  });
  return true;
}
/* shared by the SVG and PDF routes (18 Oct 2026, step 3: moved out of svgCutIntake, same text). c = the full render,
   cs = the render without the cut (and technical lines); opaque = white counts as no ink (a PDF is drawn on white). */
function cutAdopt(f,c,cs,opaque,cb,fail){
  if(f.kind==="tech"){   /* only perf / crease / score lines, named: off the print, the cut is traced as before */
    if(!f.clean){ fail(); return; }
    imgOfCanvas(cs, im=>{ if(!im){ fail(); return; } srcImg=im; srcIsVector=true; opts.labelApplied=false; processSource(cb); });
    return;
  }
  let cut=null;
  try{ cut=cutFromFound(f, cs, opaque); }catch(e){ console.warn("[proof-lab] cut line check failed:",e); cut=null; }
  if(!cut || (cut.kind==="candidate" && cut.refused)){ fail(); return; }   /* a magenta line we cannot use is just artwork */
  if(f.g3!=null) cut.g3=f.g3;
  const done=()=>{ if(cut.refused) showError(cutMsg(cut.refused)); if(cb) cb(); };
  if(cut.kind==="candidate"){
    imgOfCanvas(cs, imS=>imgOfCanvas(c, imF=>{
      if(!imS || !imF){ fail(); return; }
      cut.imgStrip=imS; cut.imgFull=imF; custCut=cut; opts.cutMode="";
      srcImg=imF; srcIsVector=true; opts.labelApplied=false; processSource(done);
    }));
    return;
  }
  /* named: used, the line stays off the print. 18 Oct 2026 (review): refused, it leaves the print only when the named
     content is exactly one closed path (plus perf / crease / score lines); open, several or anything else named
     prints in full, as "unusable" always did (nothing leaves the print unless proven to be the cut line) */
  const keep = cut.refused && (cut.refused==="unusable" || !cutOneClosed(f));
  imgOfCanvas(keep ? c : cs, im=>{
    if(!im){ fail(); return; }
    custCut=cut;
    if(cut.refused) opts.cutMode=""; else ownCutOn();
    srcImg=im; srcIsVector=true; opts.labelApplied=false; processSource(done);
  });
}
/* ----- 18 Oct 2026 (P215 step 3): the cut line in a PDF or a PDF-compatible .ai -----
   Today loadPdf painted page 1 whole (intent "print"), so a die line printed, and pdf.js 3.11 even paints a layer
   Illustrator marks non-printing. Best first (spec section 2):
   - P2, a LAYER (optional content group) with a die-line name: pdf.js only, no library. The cut is the strokes
     between BDC /OC and EMC in the operator list (CTM tracked); the artwork is the page drawn with that layer hidden.
   - P1, a SPOT COLOUR (/Separation) with a die-line name: found by a raw byte scan with no library; only on a hit
     pdf-lib is loaded, an own tokenizer finds the strokes painted in that colour (CTM, CS, q/Q, Do forms), their
     paint operator becomes a no-paint one (S/s -> n, B/b -> f / h f), and pdf.js draws the cleaned bytes.
   - P3, no name: a closed stroke-only path in magenta (within 24 of 251,49,153 / 236,0,140 / 255,0,255), 2pt or
     less. Offered behind the switch, OFF (guard G1); its print-free render is made the P1 way.
   Guard G3: the two renders are compared; a pixel that changed further than 2px + the stroke width from the removed
   lines means more than the line went, so own-cut mode is refused ("could not use") and the artwork stays whole.
   A PDF with none of these takes exactly the old route: the live render, untouched. */
const PDF_MAGENTA=[[251,49,153],[236,0,140],[255,0,255]];
const pdfCutKind=v=>{ const nm=cutName(v); return nm && PDF_DIE_NAME.test(nm) ? (CUT_NOT_CUT.test(nm) ? "tech" : "cut") : ""; };
const pdfMul=(m,n)=>[m[0]*n[0]+m[1]*n[2], m[0]*n[1]+m[1]*n[3], m[2]*n[0]+m[3]*n[2], m[2]*n[1]+m[3]*n[3], m[4]*n[0]+m[5]*n[2]+n[4], m[4]*n[1]+m[5]*n[3]+n[5]];
const pdfAp=(m,x,y)=>[m[0]*x+m[2]*y+m[4], m[1]*x+m[3]*y+m[5]];
const pdfDet=m=>Math.sqrt(Math.abs(m[0]*m[3]-m[1]*m[2]));
/* bytes -> a string of the same length, one char per byte (TextDecoder "latin1" is windows-1252 in browsers) */
function pdfB2S(u){ let s=""; for(let i=0;i<u.length;i+=0x8000) s+=String.fromCharCode.apply(null,u.subarray(i,i+0x8000)); return s; }
function pdfRead(file){ return new Promise((res,rej)=>{ const r=new FileReader(); r.onload=()=>res(new Uint8Array(r.result)); r.onerror=()=>rej(r.error); r.readAsArrayBuffer(file); }); }
/* the operator list (pdf.js 3.11) as paths in PDF user space: [{op:"stroke"|"fillStroke", segs, rgb, lwPt, oc:[ids]}] */
function pdfOpPaths(lib,ol){
  const O=lib.OPS, out=[], st=[], mc=[];
  let M=[1,0,0,1,0,0], lw=1, sc=null, path=[], cur=null, lx=0, ly=0, ann=0;
  const close=()=>{ if(cur && cur.length && cur[cur.length-1].c!=="Z") cur.push({c:"Z"}); };
  for(let i=0;i<ol.fnArray.length;i++){
    const fn=ol.fnArray[i], a=ol.argsArray[i];
    if(fn===O.save) st.push([M,lw,sc]);
    else if(fn===O.restore){ if(st.length){ const t=st.pop(); M=t[0]; lw=t[1]; sc=t[2]; } }
    else if(fn===O.transform) M=pdfMul(a,M);
    else if(fn===O.paintFormXObjectBegin){ st.push([M,lw,sc]); if(a && a[0]) M=pdfMul(a[0],M); }
    else if(fn===O.paintFormXObjectEnd){ if(st.length){ const t=st.pop(); M=t[0]; lw=t[1]; sc=t[2]; } }
    else if(fn===O.beginAnnotation) ann++;
    else if(fn===O.endAnnotation) ann=Math.max(0,ann-1);
    else if(fn===O.setLineWidth) lw=a[0];
    else if(fn===O.setStrokeRGBColor) sc=a && a.length>=3 ? [a[0],a[1],a[2]] : null;
    else if(fn===O.setStrokeColorN || fn===O.setStrokeColor) sc=null;
    else if(fn===O.beginMarkedContentProps){ const p=a && a[0]==="OC" ? a[1] : null; mc.push(p ? (p.id ? [p.id] : (p.ids||[])) : []); }
    else if(fn===O.beginMarkedContent) mc.push([]);
    else if(fn===O.endMarkedContent) mc.pop();
    else if(fn===O.constructPath){
      const ops=a[0], co=a[1]; let k=0;
      for(const op of ops){
        if(op===O.moveTo){ cur=[{c:"M",p:pdfAp(M,co[k],co[k+1])}]; path.push(cur); lx=co[k]; ly=co[k+1]; k+=2; }
        else if(op===O.lineTo){ if(cur) cur.push({c:"L",p:pdfAp(M,co[k],co[k+1])}); lx=co[k]; ly=co[k+1]; k+=2; }
        else if(op===O.curveTo){ if(cur) cur.push({c:"C",p:pdfAp(M,co[k],co[k+1]).concat(pdfAp(M,co[k+2],co[k+3]),pdfAp(M,co[k+4],co[k+5]))}); lx=co[k+4]; ly=co[k+5]; k+=6; }
        else if(op===O.curveTo2){ if(cur) cur.push({c:"C",p:pdfAp(M,lx,ly).concat(pdfAp(M,co[k],co[k+1]),pdfAp(M,co[k+2],co[k+3]))}); lx=co[k+2]; ly=co[k+3]; k+=4; }
        else if(op===O.curveTo3){ if(cur) cur.push({c:"C",p:pdfAp(M,co[k],co[k+1]).concat(pdfAp(M,co[k+2],co[k+3]),pdfAp(M,co[k+2],co[k+3]))}); lx=co[k+2]; ly=co[k+3]; k+=4; }
        else if(op===O.closePath) close();
        else if(op===O.rectangle){ const x=co[k],y=co[k+1],w=co[k+2],h=co[k+3];
          path.push([{c:"M",p:pdfAp(M,x,y)},{c:"L",p:pdfAp(M,x+w,y)},{c:"L",p:pdfAp(M,x+w,y+h)},{c:"L",p:pdfAp(M,x,y+h)},{c:"Z"}]); cur=null; lx=x; ly=y; k+=4; }
      }
    }
    else if(fn===O.stroke || fn===O.closeStroke || fn===O.fillStroke || fn===O.eoFillStroke || fn===O.closeFillStroke || fn===O.closeEOFillStroke){
      if(fn===O.closeStroke || fn===O.closeFillStroke || fn===O.closeEOFillStroke) close();
      if(!ann && path.length) out.push({op:(fn===O.stroke||fn===O.closeStroke)?"stroke":"fillStroke", segs:[].concat(...path), rgb:sc, lwPt:lw*pdfDet(M), oc:[].concat(...mc)});
      path=[]; cur=null;
    }
    else if(fn===O.fill || fn===O.eoFill || fn===O.endPath){ path=[]; cur=null; }
  }
  return out;
}
/* P1 without a library: every /Separation name in the file, zlib streams inflated (images skipped). Traps measured
   in research D: Illustrator's zlib headers are 0x48/0x58 too, and WebKit's DecompressionStream refuses the end of
   line before "endstream" (0-2 bytes trimmed). null = this browser cannot inflate, so the names are unknown. */
async function pdfInflate(u8){
  const ds=new DecompressionStream("deflate"), w=ds.writable.getWriter(); w.write(u8).catch(()=>{}); w.close().catch(()=>{});
  const r=ds.readable.getReader(), parts=[]; let n=0;
  for(;;){ const x=await r.read(); if(x.done) break; parts.push(x.value); n+=x.value.length; }
  const o=new Uint8Array(n); let k=0; for(const p of parts){ o.set(p,k); k+=p.length; } return o;
}
async function pdfSpotNames(bytes){
  const txt=pdfB2S(bytes), names=new Set();
  const grab=t=>{ const r=/\/Separation\s*\/([^\s\/\[\]<>(){}%]+)/g; let m; while((m=r.exec(t))) names.add(m[1].replace(/#([0-9a-f]{2})/gi,(x,h)=>String.fromCharCode(parseInt(h,16)))); };
  grab(txt);
  if(typeof DecompressionStream==="undefined") return names.size ? [...names] : null;
  const re=/stream\r?\n/g; let m;
  while((m=re.exec(txt))){
    if(txt.slice(m.index-3,m.index)==="end") continue;
    const s=m.index+m[0].length, e=txt.indexOf("endstream",s); if(e<0) break;
    const hd=txt.slice(Math.max(0,m.index-2000),m.index), o=hd.lastIndexOf(" obj");
    if(!/\/Subtype\s*\/Image/.test(o>=0?hd.slice(o):hd) && (bytes[s]&0x0f)===8 && (((bytes[s]<<8)|bytes[s+1])%31)===0){
      for(const t of [0,1,2]){ try{ grab(pdfB2S(await pdfInflate(bytes.subarray(s,e-t)))); break; }catch(_){} }
    }
    re.lastIndex=e;
  }
  return [...names];
}
/* a content-stream tokenizer that keeps each token's byte offsets, so a paint operator can be swapped in place and
   every other byte (text strings, inline images, comments) stays exactly as the customer saved it */
function pdfToks(s){
  const n=s.length, T=[], WS=" \t\r\n\f\0", DL="()<>[]{}/%"; let i=0;
  while(i<n){
    const c=s[i];
    if(WS.indexOf(c)>=0){ i++; continue; }
    if(c==="%"){ while(i<n && s[i]!=="\n" && s[i]!=="\r") i++; continue; }
    const a=i;
    if(c==="/"){ let j=i+1; while(j<n && WS.indexOf(s[j])<0 && DL.indexOf(s[j])<0) j++; T.push({t:"name",v:s.slice(i+1,j).replace(/#([0-9a-f]{2})/gi,(x,h)=>String.fromCharCode(parseInt(h,16))),a}); i=j; continue; }
    if(c==="("){ let d=1,j=i+1; while(j<n && d){ const ch=s[j]; if(ch==="\\"){ j+=2; continue; } if(ch==="(") d++; else if(ch===")") d--; j++; } T.push({t:"str",a}); i=j; continue; }
    if(c==="<" && s[i+1]==="<"){ T.push({t:"<<",a}); i+=2; continue; }
    if(c===">" && s[i+1]===">"){ T.push({t:">>",a}); i+=2; continue; }
    if(c==="<"){ const j=s.indexOf(">",i); T.push({t:"str",a}); i=j<0?n:j+1; continue; }
    if("[]{}>)".indexOf(c)>=0){ T.push({t:c,a}); i++; continue; }
    let j=i; while(j<n && WS.indexOf(s[j])<0 && DL.indexOf(s[j])<0) j++;
    const w=s.slice(i,j);
    if(/^[+\-]?(\d+\.?\d*|\.\d+)$/.test(w)) T.push({t:"num",v:parseFloat(w),a});
    else {
      T.push({t:"op",v:w,a,b:j});
      if(w==="BI"){   /* inline image: its binary data runs to EI */
        let k=s.indexOf("ID",j); if(k<0){ i=n; continue; }
        let e=s.indexOf("EI",k+3); while(e>0 && !(WS.indexOf(s[e-1])>=0 && (e+2>=n || WS.indexOf(s[e+2])>=0))) e=s.indexOf("EI",e+2);
        if(e<0){ i=n; continue; }
        T.push({t:"op",v:"EI",a:e,b:e+2}); j=e+2;
      }
    }
    i=j;
  }
  return T;
}
/* pdf-lib: walk page 1 (and its form XObjects) and list every stroke: {ri (which stream), op, a/b (operator bytes),
   sep (its spot colour name, if any), segs (user space), lwPt}. recs[ri] = {ref, so, u8 (decoded bytes)}. */
function pdfLibWalk(PL,doc){
  const ctx=doc.context, N=n=>PL.PDFName.of(n), L=o=>(o==null ? o : ctx.lookup(o));
  const D=(d,k)=>(d && d.get ? L(d.get(N(k))) : undefined);
  const nm=o=>(o && o.decodeText ? o.decodeText() : o && o.asString ? String(o.asString()).replace(/^\//,"") : undefined);
  const num=o=>(o && o.asNumber ? o.asNumber() : NaN);
  const bytesOf=so=>(so instanceof PL.PDFRawStream ? (D(so.dict,"Filter") ? PL.decodePDFRawStream(so).decode() : so.contents) : (so && so.getContents ? so.getContents() : new Uint8Array(0)));
  const csOf=(res,name)=>{
    if(/^(Device(Gray|RGB|CMYK)|Pattern)$/.test(name)) return {k:name};
    const cd=D(res,"ColorSpace"), arr=cd && cd.get ? L(cd.get(N(name))) : null;
    if(!(arr instanceof PL.PDFArray) || arr.size()<2) return {k:"?"};
    return nm(L(arr.get(0)))==="Separation" ? {k:"Separation", sep:nm(L(arr.get(1)))} : {k:nm(L(arr.get(0)))||"?"};
  };
  const page=doc.getPages()[0], node=page.node, recs=[], evs=[];
  const cont=L(node.get(N("Contents")));
  let parts=[];
  if(cont instanceof PL.PDFArray){ for(let i=0;i<cont.size();i++) parts.push(bytesOf(L(cont.get(i)))); }
  else if(cont) parts.push(bytesOf(cont));
  let tot=0; parts.forEach(p=>tot+=p.length+1);
  const u8=new Uint8Array(tot); let o=0; parts.forEach(p=>{ u8.set(p,o); o+=p.length; u8[o++]=10; });
  recs.push({ref:null, so:null, u8});
  const run=(ri,res,M0,depth)=>{
    const T=pdfToks(pdfB2S(recs[ri].u8)), st=[], args=[];
    let M=M0.slice(), lw=1, scs={k:"DeviceGray"}, path=[], cur=null, lx=0, ly=0;
    const close=()=>{ if(cur && cur.length && cur[cur.length-1].c!=="Z") cur.push({c:"Z"}); };
    for(let k=0;k<T.length;k++){
      const t=T[k]; if(t.t!=="op"){ args.push(t); continue; }
      const v=args.filter(x=>x.t==="num").map(x=>x.v), op=t.v;
      switch(op){
        case "q": st.push([M,lw,scs]); break;
        case "Q": if(st.length){ const q=st.pop(); M=q[0]; lw=q[1]; scs=q[2]; } break;
        case "cm": if(v.length===6) M=pdfMul(v,M); break;
        case "w": if(v.length) lw=v[0]; break;
        case "CS": scs=args[0] && args[0].t==="name" ? csOf(res,args[0].v) : {k:"?"}; break;
        case "G": scs={k:"DeviceGray"}; break;
        case "RG": scs={k:"DeviceRGB"}; break;
        case "K": scs={k:"DeviceCMYK"}; break;
        case "m": cur=[{c:"M",p:pdfAp(M,v[0],v[1])}]; path.push(cur); lx=v[0]; ly=v[1]; break;
        case "l": if(cur) cur.push({c:"L",p:pdfAp(M,v[0],v[1])}); lx=v[0]; ly=v[1]; break;
        case "c": if(cur) cur.push({c:"C",p:pdfAp(M,v[0],v[1]).concat(pdfAp(M,v[2],v[3]),pdfAp(M,v[4],v[5]))}); lx=v[4]; ly=v[5]; break;
        case "v": if(cur) cur.push({c:"C",p:pdfAp(M,lx,ly).concat(pdfAp(M,v[0],v[1]),pdfAp(M,v[2],v[3]))}); lx=v[2]; ly=v[3]; break;
        case "y": if(cur) cur.push({c:"C",p:pdfAp(M,v[0],v[1]).concat(pdfAp(M,v[2],v[3]),pdfAp(M,v[2],v[3]))}); lx=v[2]; ly=v[3]; break;
        case "h": close(); break;
        case "re": { const [x,y,w,h]=v; path.push([{c:"M",p:pdfAp(M,x,y)},{c:"L",p:pdfAp(M,x+w,y)},{c:"L",p:pdfAp(M,x+w,y+h)},{c:"L",p:pdfAp(M,x,y+h)},{c:"Z"}]); cur=null; lx=x; ly=y; break; }
        case "S": case "s": case "B": case "B*": case "b": case "b*":
          if(op==="s" || op==="b" || op==="b*") close();
          if(path.length) evs.push({ri, op, a:t.a, b:t.b, sep:scs.k==="Separation" ? scs.sep : null, segs:[].concat(...path), lwPt:lw*pdfDet(M)});
          path=[]; cur=null; break;
        case "f": case "F": case "f*": case "n": path=[]; cur=null; break;
        case "Do": {
          const xo=D(res,"XObject"), ref=xo && xo.get && args[0] ? xo.get(N(args[0].v)) : null, so=L(ref);
          if(depth<8 && so && so.dict && nm(D(so.dict,"Subtype"))==="Form"){
            const mat=D(so.dict,"Matrix"), m=mat instanceof PL.PDFArray && mat.size()===6 ? [0,1,2,3,4,5].map(z=>num(L(mat.get(z)))) : [1,0,0,1,0,0];
            const key=ref instanceof PL.PDFRef ? ref.toString() : null;
            let rj=key ? recs.findIndex(r=>r.key===key) : -1;
            if(rj<0){ recs.push({key, ref:ref instanceof PL.PDFRef ? ref : null, so, u8:bytesOf(so)}); rj=recs.length-1; }
            run(rj, D(so.dict,"Resources")||res, pdfMul(m.every(isFinite)?m:[1,0,0,1,0,0],M), depth+1);
          }
          break;
        }
      }
      args.length=0;
    }
  };
  run(0, node.Resources ? node.Resources() : D(node,"Resources"), [1,0,0,1,0,0], 0);
  return {recs, evs};
}
/* swap the paint operator of each hit for one that paints no stroke, save, and return the new bytes (null = cannot) */
async function pdfLibStrip(PL,doc,W,hits){
  const NEW={S:"n", s:"n", B:"f", "B*":"f*", b:"h f", "b*":"h f*"}, by={};
  hits.forEach(e=>{ (by[e.ri]=by[e.ri]||[]).push(e); });
  const ctx=doc.context;
  for(const ri of Object.keys(by)){
    const r=W.recs[ri], ed=by[ri].sort((x,y)=>x.a-y.a), chunks=[]; let at=0, len=0;
    for(const e of ed){ if(e.a<at) continue; chunks.push(r.u8.subarray(at,e.a)); const rep=NEW[e.op]; const u=new Uint8Array(rep.length); for(let i=0;i<rep.length;i++) u[i]=rep.charCodeAt(i); chunks.push(u); at=e.b; }
    chunks.push(r.u8.subarray(at));
    chunks.forEach(c=>len+=c.length);
    const out=new Uint8Array(len); let o=0; chunks.forEach(c=>{ out.set(c,o); o+=c.length; });
    const ns=ctx.flateStream(out);
    if(+ri===0){ doc.getPages()[0].node.set(PL.PDFName.of("Contents"), ctx.register(ns)); }
    else {
      if(!r.ref) return null;   /* a form written inline cannot be replaced on its own */
      for(const [k,v] of r.so.dict.entries()){ const kn=k.asString(); if(kn!=="/Filter" && kn!=="/DecodeParms" && kn!=="/Length") ns.dict.set(k,v); }
      ctx.assign(r.ref, ns);
    }
  }
  return doc.save({updateFieldAppearances:false, addDefaultPage:false});
}
/* page 1 of a PDF drawn exactly as loadPdf draws it (white, intent print), optionally with some layers hidden */
async function pdfDraw(page,vp,occ){
  const c=mk(vp.width,vp.height), x=c.getContext("2d");
  x.fillStyle="#ffffff"; x.fillRect(0,0,c.width,c.height);
  const p={canvasContext:x, viewport:vp, intent:"print"}; if(occ) p.optionalContentConfigPromise=Promise.resolve(occ);
  await page.render(p).promise;
  return c;
}
/* guard G3: pixels that changed further than 2px + the stroke width from the removed lines (g3 0 = only the line
   went), and the colour the line printed in: the commonest colour on the line where the two renders differ (null =
   it did not print, e.g. a layer that is off, so guard G4 has nothing to look for) */
function cutRemovalCheck(c,cs,removed,swPx,line){
  const w=c.width, h=c.height; if(cs.width!==w || cs.height!==h) return {g3:Infinity, colour:null};
  const m=mk(w,h), mx=m.getContext("2d");
  mx.strokeStyle="#fff"; mx.lineWidth=2*(2+swPx); mx.lineJoin="round"; mx.lineCap="round"; mx.stroke(segsPath(removed,(x,y)=>[x,y]));
  const B=mx.getImageData(0,0,w,h).data, P=c.getContext("2d").getImageData(0,0,w,h).data, Q=cs.getContext("2d").getImageData(0,0,w,h).data;
  m.width=0; m.height=0;
  let g3=0;
  for(let i=0;i<P.length;i+=4){ if(B[i+3]>0) continue; if(Math.abs(P[i]-Q[i])>2 || Math.abs(P[i+1]-Q[i+1])>2 || Math.abs(P[i+2]-Q[i+2])>2 || Math.abs(P[i+3]-Q[i+3])>2) g3++; }
  const n={};
  segsFlat(line,24).forEach(p=>{ const x=Math.round(p[0]), y=Math.round(p[1]); if(x<0||y<0||x>=w||y>=h) return; const i=(y*w+x)*4;
    if(Math.abs(P[i]-Q[i])>24 || Math.abs(P[i+1]-Q[i+1])>24 || Math.abs(P[i+2]-Q[i+2])>24){ const k=(P[i]>>3)+","+(P[i+1]>>3)+","+(P[i+2]>>3); (n[k]=n[k]||[]).push([P[i],P[i+1],P[i+2]]); } });
  let best=null; for(const k in n) if(!best || n[k].length>best.length) best=n[k];
  const med=j=>best.map(q=>q[j]).sort((a,b)=>a-b)[best.length>>1];
  return {g3, colour: best ? [med(0),med(1),med(2)] : null};
}
/* 18 Oct 2026 (review): guard G4 when the two renders do not tell the line's colour (a second copy of the die line in
   an unnamed layer, or a DeviceCMYK magenta copy beside the spot one, prints the same pixels either way): pixels in
   any of cols (within 24) within 1mm of the line on the render WITHOUT the cut. Over 0 = the line still prints. */
function cutColourNear(cs,segs,cols,mmPx){
  const w=cs.width, h=cs.height, m=mk(w,h), mx=m.getContext("2d");
  mx.strokeStyle="#fff"; mx.lineWidth=2*mmPx; mx.lineJoin="round"; mx.lineCap="round"; mx.stroke(segsPath(segs,(x,y)=>[x,y]));
  const B=mx.getImageData(0,0,w,h).data, S=cs.getContext("2d").getImageData(0,0,w,h).data;
  m.width=0; m.height=0;
  let n=0;
  for(let i=0;i<B.length;i+=4){
    if(!B[i+3] || S[i+3]<=10) continue;
    for(const q of cols) if(Math.abs(S[i]-q[0])<=24 && Math.abs(S[i+1]-q[1])<=24 && Math.abs(S[i+2]-q[2])<=24){ n++; break; }
  }
  return n;
}
/* Find the cut in page 1. Returns null when the file has none (the old route then runs unchanged), else the same
   record svgFindCut gives ({kind, segs in the render's px, mmPerPx, clean, label, colour}) plus cs, the render
   without the cut. A named line pdf-lib could not take out comes back clean:false (the full render is kept). */
async function pdfFindCut(lib,pdf,page,vp,olP,c,file){
  const T=vp.transform, px=(x,y)=>[T[0]*x+T[2]*y+T[4], T[1]*x+T[3]*y+T[5]];
  const toPx=segs=>segs.map(g=>g.c==="Z" ? {c:"Z"} : {c:g.c, p:g.p.reduce((o,v,k)=>{ if(k%2) o.push(...px(g.p[k-1],v)); return o; },[])});
  const scale=Math.hypot(T[0],T[1])||Math.hypot(T[2],T[3]), mmPerPx=PT_TO_MM/scale;
  const swOf=list=>Math.max(1, ...list.map(e=>e.lwPt*scale));
  /* the same path in the op list and in pdf-lib's walk (same points, within 0.02pt) */
  const same=(a,b)=>{ if(a.length!==b.length) return false; for(let i=0;i<a.length;i++){ if(a[i].c!==b[i].c) return false; const p=a[i].p||[], q=b[i].p||[]; if(p.length!==q.length) return false; for(let k=0;k<p.length;k++) if(Math.abs(p[k]-q[k])>0.02) return false; } return true; };
  let P=null;
  /* G3, then the line's colour for G4. own = the cut's own strokes; when the renders do not give the colour, their
     op-list colour (pdf.js's RGB of a spot's alternate) is looked for instead, or the three magentas */
  const finish=async(f,removed,cs,own)=>{
    f.cs=cs; f.mmPerPx=mmPerPx; f.src="pdf";
    const rs=[].concat(...removed.map(e=>toPx(e.segs))), line=f.segs.length?f.segs:rs;
    const chk=cutRemovalCheck(c,cs,rs,swOf(removed),line);
    f.g3=chk.g3; f.colour=chk.colour;
    if(f.g3>0) f.clean=false;
    else if(!f.colour && f.kind!=="tech" && line.length){
      const cols=[];
      (own||[]).forEach(e=>{ let rgb=e.rgb; if(!rgb && P){ const m=P.find(q=>same(q.segs,e.segs)); rgb=m && m.rgb; }
        if(rgb && !cols.some(q=>nearRGB(q,rgb,2))) cols.push(rgb); });
      f.g4=cutColourNear(cs, line, cols.length?cols:PDF_MAGENTA, 1/mmPerPx);
      if(f.g4>0) f.clean=false;
    }
    return f;
  };
  /* P2: a layer. Without one, the byte scan for P1 runs while the pdf.js worker builds the op list (42 MB: 1.46 s
     one after the other). 18 Oct 2026 (review): over 25 MB the scan waits for the op list and runs only when it holds
     a stroke-only path (a die line is always one) */
  let occ=null; try{ occ=await pdf.getOptionalContentConfig(); }catch(e){ occ=null; }
  const groups=(occ && occ.getGroups && occ.getGroups())||{}, cutIds=[], techIds=[];
  Object.keys(groups).forEach(id=>{ const k=pdfCutKind(groups[id] && groups[id].name); if(k==="cut") cutIds.push(id); else if(k==="tech") techIds.push(id); });
  const big=!!(file && file.size>25*1024*1024);
  const scanOf=()=>pdfRead(file).then(b=>pdfSpotNames(b).then(n=>({bytes:b, names:n})));
  const scanP=(cutIds.length || techIds.length || big) ? null : scanOf();
  if(scanP) scanP.catch(()=>{});
  P=pdfOpPaths(lib, await olP);
  const inIds=(e,ids)=>e.oc.some(id=>ids.indexOf(id)>=0);
  const layCut=P.filter(e=>inIds(e,cutIds)), layTech=P.filter(e=>inIds(e,techIds));
  let layT=null;   /* a perf / crease layer and no cut layer */
  if(layCut.length || layTech.length){
    const occ2=await pdf.getOptionalContentConfig();
    cutIds.concat(techIds).forEach(id=>occ2.setVisibility(id,false));
    const cs=await pdfDraw(page,vp,occ2), nm=layCut.length ? cutName(groups[cutIds.find(id=>layCut.some(e=>e.oc.indexOf(id)>=0))].name) : "";
    const f={kind:layCut.length?"named":"tech", label:"layer "+nm, clean:true, segs:[].concat(...layCut.map(e=>toPx(e.segs)))};
    if(layCut.length) return finish(f, layCut.concat(layTech), cs, layCut);
    layT={f, removed:layTech, cs};   /* 18 Oct 2026 (review): the cut may still be a spot colour (P1), so it is looked for */
  }
  const techOnly=()=>layT ? finish(layT.f, layT.removed, layT.cs, null) : null;
  /* P1 (a spot colour) and P3 (a magenta outline) both need the file's bytes; P3 is looked for first in the op list */
  const strokes=P.filter(e=>e.op==="stroke" && !(layT && inIds(e,techIds)));
  const tol=e=>e.rgb && PDF_MAGENTA.some(m=>nearRGB(e.rgb,m,24));
  const cand=layT ? [] : strokes.filter(e=>tol(e) && e.lwPt<=2+1e-6 && !cutShape(toPx(e.segs),mmPerPx).err);
  if(big && !strokes.length) return techOnly();
  const sc=await (scanP || scanOf()), bytes=sc.bytes, names=sc.names;
  const spot=names===null ? null : names.filter(n=>pdfCutKind(n));
  if(spot && !spot.length && !cand.length) return techOnly();
  /* 18 Oct 2026 (review): a browser that cannot inflate (names null) loads pdf-lib only when the op list holds a
     stroke-only CLOSED path, never for every PDF */
  if(spot===null && !cand.length && !strokes.some(e=>!cutShape(toPx(e.segs),mmPerPx).err)) return techOnly();
  if(layT && spot && !spot.some(n=>pdfCutKind(n)==="cut")) return techOnly();   /* perf layer + perf spot: as before */
  let PL=null, doc=null, W=null;
  const named=spot===null || spot.some(n=>pdfCutKind(n)==="cut");
  const refusedSpot=nm=>({kind:"named", src:"pdf", label:"spot colour "+nm, clean:false, segs:[], mmPerPx, cs:c, colour:null});
  try{
    PL=await loadPdfLib();
    doc=await PL.PDFDocument.load(bytes,{ignoreEncryption:true, updateMetadata:false, throwOnInvalidObject:false});
    if(doc.isEncrypted) throw new Error("encrypted");
    W=pdfLibWalk(PL,doc);
  }catch(e){
    console.warn("[proof-lab] PDF cut line read skipped:",e);
    if(spot && spot.length && named) return refusedSpot(spot.find(n=>pdfCutKind(n)==="cut")||spot[0]);
    return techOnly();   /* a magenta outline we cannot take out is just artwork */
  }
  const sCut=W.evs.filter(e=>e.sep && pdfCutKind(e.sep)==="cut"), sTech=W.evs.filter(e=>e.sep && pdfCutKind(e.sep)==="tech");
  /* hideLayers: also hide every die-named layer (the perf layer of a file whose cut is a spot colour) */
  const redraw=async(hits,hideLayers)=>{ const out=await pdfLibStrip(PL,doc,W,hits); if(!out) return null;
    const d2=await lib.getDocument({data:out, isEvalSupported:false}).promise;
    try{
      const p2=await d2.getPage(1); let o2=null;
      if(hideLayers){ o2=await d2.getOptionalContentConfig(); const g2=(o2 && o2.getGroups && o2.getGroups())||{};
        Object.keys(g2).forEach(id=>{ if(pdfCutKind(g2[id] && g2[id].name)) o2.setVisibility(id,false); }); }
      return await pdfDraw(p2, p2.getViewport({scale:scale, rotation:vp.rotation}), o2);
    } finally { try{ d2.destroy(); }catch(e){} } };
  /* 18 Oct 2026 (review, spec G3): a cut-named spot colour in the file that no stroke we can take out is painted in
     (set outside a form, DeviceN, an annotation): "could not use", the full render is kept */
  const spotCut=spot && spot.find(n=>pdfCutKind(n)==="cut");
  if(spotCut && !sCut.length) return refusedSpot(spotCut);
  if(layT && !sCut.length) return techOnly();
  if(sCut.length || sTech.length){
    const hits=sCut.concat(sTech); let cs=null;
    try{ cs=await redraw(hits, !!layT); }catch(e){ console.warn("[proof-lab] PDF cut line strip failed:",e); cs=null; }
    const f={kind:sCut.length?"named":"tech", label:"spot colour "+cutName(sCut.length?sCut[0].sep:sTech[0].sep), clean:!!cs, segs:[].concat(...sCut.map(e=>toPx(e.segs)))};
    if(!cs){ if(!sCut.length) return null; f.cs=c; f.mmPerPx=mmPerPx; f.src="pdf"; f.colour=null; return f; }
    return finish(f, layT ? hits.concat(layT.removed) : hits, cs, sCut);
  }
  if(!cand.length) return null;
  /* P3: the op list's magenta outlines, matched to their operators by shape */
  const hits=[]; for(const e of cand){ const h=W.evs.find(w=>(w.op==="S"||w.op==="s") && hits.indexOf(w)<0 && same(w.segs,e.segs)); if(!h) return null; hits.push(h); }
  let cs=null; try{ cs=await redraw(hits, false); }catch(e){ cs=null; }
  if(!cs) return null;
  const f={kind:"candidate", label:"magenta outline", clean:true, segs:[].concat(...cand.map(e=>toPx(e.segs)))};
  return finish(f, cand, cs, cand);
}
/* the PDF route. c = the live render, which every PDF without a cut line keeps. Resolves false = take the old route. */
async function pdfCutIntake(lib,pdf,page,vp,c,file,cb){
  let f=null;
  try{ f=await pdfFindCut(lib,pdf,page,vp,page.getOperatorList({intent:"print"}),c,file); }catch(e){ console.warn("[proof-lab] PDF cut line read skipped:",e); f=null; }
  if(!f) return false;
  try{ cutAdopt(f, c, f.cs||c, true, cb, ()=>rasterImgFromCanvas(c,cb)); }catch(e){ console.warn("[proof-lab] PDF cut line skipped:",e); return false; }
  return true;
}
/* ----- the switch row: "Use the cut line from my file" ----- */
const CUT_LOCKED=["shapeSeg","borderToggle","borderW","borderWSeg","smooth","cornerSnapSeg","gSnap","fitSeg","artPct","cornerSeg"];   /* 18 Oct 2026 (review): + the gSnap wrapper (its i button) */
function syncOwnCutUI(){
  const g=$("gOwnCut"); if(!g) return;
  const has=!!custCut, on=ownCut(), usable=has && !custCut.refused;
  g.classList.toggle("hidden", !has);
  const t=$("ownCutToggle"), note=$("ownCutNote");
  if(t){
    t.classList.toggle("on", on);
    t.style.opacity = (has && !usable) ? ".35" : ""; t.style.pointerEvents = (has && !usable) ? "none" : "";
    t.setAttribute("aria-disabled", (has && !usable) ? "true" : "false");
  }
  let msg="";
  if(has){
    if(custCut.refused) msg=cutMsg(custCut.refused);
    else if(on){
      /* 18 Oct 2026 (review): the size being ordered; the file's own figure only when it was clamped to 10-285mm */
      let fm=null; try{ fm=cutSizeMm(); }catch(e){ fm=null; }
      fm=fm||custCut.fileMm;
      if(fm) msg=stkFmt(stkT("stk.studio.cut.found","Using the cut line from your file ([w] × [h] mm)."),{w:stkDec(fm.w,1),h:stkDec(fm.h,1)});
      const ff=custCut.fileMm, fl=ff ? Math.max(ff.w,ff.h) : 0;
      if(ff && (fl>SIZE_MAX_MM+0.05 || fl<SIZE_MIN_MM-0.05)) msg+=" "+stkFmt(stkT("stk.studio.cut.clamped","Your file is [w] × [h] mm, so we scaled it to a size we can make."),{w:stkDec(ff.w,1),h:stkDec(ff.h,1)});
      if(custCut.inner) msg+=" "+stkT("stk.studio.cut.inner","Inner cut lines in your file are not cut, only the outer one.");
    }
    else if(custCut.kind==="candidate") msg=stkT("stk.studio.cut.candidate","This magenta line may be your cut line. Turn this on to cut along it and leave it off the print.");
  }
  if(note){ note.textContent=msg; note.style.display=msg?"":"none"; }
  root.querySelectorAll("[data-cutlock]").forEach(el=>{ el.style.display = on ? "" : "none"; });
  /* 18 Oct 2026 (review): greyed and labelled, never hidden (spec): Corners, Artwork fit and Rounded corners show in
     own-cut mode too; syncGroups hides them again by shape when it is off */
  if(on){ ["gFit","gCorner"].forEach(id=>{ const g=$(id); if(g) g.classList.remove("hidden"); }); const gs=$("gSnap"); if(gs) gs.style.display=""; const sn=$("snapNote"); if(sn) sn.style.display="none"; }
  CUT_LOCKED.forEach(id=>{
    const el=$(id); if(!el) return;
    const inLocked=CUT_LOCKED.some(o=>o!==id && $(o) && $(o)!==el && $(o).contains(el));   /* cornerSnapSeg in gSnap: greyed once */
    el.style.opacity = ""; el.style.pointerEvents = on ? "none" : "";
    /* 20 Oct 2026 (the owner: the greyed controls "look broken, others black"): one flat locked look (.cutlocked, in the
       CSS) on the control, its row and its group's label, instead of 35% opacity over the live tints */
    try{ const grp=el.closest(".group"); [el, el.closest(".row"), grp && grp.querySelector(".lbl-sub"), el.nextElementSibling && el.nextElementSibling.matches(".range-meta") ? el.nextElementSibling : null, el.type==="range" ? el.parentElement : null]
         .forEach(m=>{ if(m) m.classList.toggle("cutlocked", on); }); }catch(e){}
    [el].concat([...el.querySelectorAll("button,input")]).forEach(b=>{
      if(!("disabled" in b) || b.tagName==="DIV") return;
      if(on && !b.disabled){ b.disabled=true; b.dataset.p215dis="1"; }
      else if(!on && b.dataset.p215dis==="1"){ b.disabled=false; delete b.dataset.p215dis; }
    });
  });
}
if($("ownCutToggle")) $("ownCutToggle").addEventListener("click",()=>{
  if(!custCut || custCut.refused || !srcImg) return;
  const before=snapBefore();
  if(opts.cutMode==="own") opts.cutMode=""; else ownCutOn();
  cutModeImage();
  dilCache={}; dilPad=0;
  syncGroups();
  processSource(()=>{ try{ updateDpi(); }catch(e){} });
  pushUndo(before);
});
/* the hidden "_Cut source" line property, only when a design's file had a cut line (other orders unchanged) */
const cutSrcClean=v=>String(v==null?"":v).replace(/[\u0000-\u001f\u007f-\u009f]/g," ").trim().slice(0,60);   /* 18 Oct 2026 (review): as Artwork Upload */
function cutSourceProp(plan){
  if(!plan.some(pl=>pl.cutSrc)) return "";
  return plan.length===1 ? plan[0].cutSrc : plan.map((pl,k)=>(k+1)+": "+(pl.cutSrc||"traced")).join("; ");
}
/* a saved design keeps its cut as its own record field (never inside opts); a candidate keeps its other render */
function cutRecord(){
  if(!custCut) return null;
  const c=custCut, r={ kind:c.kind, src:c.src, label:c.label, colour:c.colour, mmPerPx:c.mmPerPx, srcW:c.srcW, srcH:c.srcH,
    refused:c.refused, inner:c.inner, segs:c.segs, bb:c.bb, fileMm:c.fileMm };
  return JSON.parse(JSON.stringify(r));
}
function cutAltData(){
  if(!custCut || custCut.kind!=="candidate" || !custCut.imgFull || !custCut.imgStrip) return null;
  const im = srcImg===custCut.imgStrip ? custCut.imgFull : custCut.imgStrip, sc=mk(im.width,im.height);
  sc.getContext("2d").drawImage(im,0,0);
  return sc.toDataURL("image/png");
}
function showError(msg){
  const note=$("note");
  note.textContent=msg;
  note.classList.add("show");
}
function despeckle(c){
  const ctx=c.getContext("2d");
  const {width:w,height:h}=c;
  const d=ctx.getImageData(0,0,w,h);
  const a=d.data;
  const lab=new Int32Array(w*h);
  // Speck threshold: only true dust. The old 0.04%-of-area rule scaled to
  // hundreds of px on a normal upload and silently deleted small text.
  // Matched to sticker-sheet-lab.liquid. See AI/_rules/LAB-RULES.md rule 3.
  const minKeep=Math.max(6, w*h*0.00001);
  let n=0;
  for(let i=0;i<w*h;i++){
    if(a[i*4+3]>10 && !lab[i]){
      n++;
      const members=[];
      const st=[i];
      while(st.length){
        const j=st.pop();
        if(j<0||j>=w*h||lab[j]||a[j*4+3]<=10) continue;
        lab[j]=n; members.push(j);
        const xx=j%w;
        st.push(j-w,j+w);
        if(xx>0) st.push(j-1);
        if(xx<w-1) st.push(j+1);
      }
      if(members.length<minKeep){
        for(const j of members) a[j*4+3]=0;
      }
    }
  }
  ctx.putImageData(d,0,0);
}
/* 18 Oct 2026 (P202): ported from the Mac Proof Lab. */
/* PHOTO-EDGE DUST (6 Oct 2026, order 9624). A photographed drawing carries
   scanner dust in the photo's margins - a hairline and a speck in two corners,
   invisible at normal size. Bigger than despeckle's dust size, so they stayed;
   the 2mm border then grew each into its own island and Sheet Builder refused
   two drawings that are one piece (Thomas: "none of them have any separate
   elements"), and trim() took the whole photo as the artwork's box.
   LAB-RULES rule 3 says under-delete, so a mark only goes when ALL hold:
   it is small (under 0.5% of the main artwork's ink), it sits in the outer 6%
   band of the photo, and no ink of the main artwork lies within 3% of the
   photo of it. Art cropped tight to its edges therefore keeps everything. Only runs
   after OUR background removal, and every removal is reported, never silent. */
let edgeDustRemoved=[];
function edgeDust(c){
  edgeDustRemoved=[];
  const ctx=c.getContext("2d"), w=c.width, h=c.height;
  const d=ctx.getImageData(0,0,w,h), a=d.data;
  const lab=new Int32Array(w*h), comps=[null];
  for(let i=0;i<w*h;i++){
    if(a[i*4+3]<=10||lab[i]) continue;
    const id=comps.length, st=[i]; lab[i]=id;
    let n=0,x0=w,y0=h,x1=0,y1=0;
    while(st.length){
      const j=st.pop(); n++;
      const x=j%w, y=(j-x)/w;
      if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y;
      if(x>0   && !lab[j-1] && a[(j-1)*4+3]>10){ lab[j-1]=id; st.push(j-1); }
      if(x<w-1 && !lab[j+1] && a[(j+1)*4+3]>10){ lab[j+1]=id; st.push(j+1); }
      if(y>0   && !lab[j-w] && a[(j-w)*4+3]>10){ lab[j-w]=id; st.push(j-w); }
      if(y<h-1 && !lab[j+w] && a[(j+w)*4+3]>10){ lab[j+w]=id; st.push(j+w); }
    }
    comps.push({n,x0,y0,x1,y1});
  }
  if(comps.length<3) return;                       // one piece: nothing to judge
  let big=0; for(let k=1;k<comps.length;k++) big=Math.max(big,comps[k].n);
  const small=big*0.005;
  /* where the main artwork's INK is, on a coarse grid (a box is not enough:
     a drawing that fills the photo diagonally has an empty corner inside its
     box). Every piece that is not small counts as the artwork. */
  const g=0.03*Math.max(w,h), bx=0.06*w, by=0.06*h;
  const cs=Math.max(1,Math.floor(g/2)), gw=Math.ceil(w/cs), gh=Math.ceil(h/cs);
  const occ=new Uint8Array(gw*gh);
  for(let i=0;i<w*h;i++){ const k=lab[i]; if(k&&comps[k].n>=small){ const x=i%w; occ[((i-x)/w/cs|0)*gw+(x/cs|0)]=1; } }
  const nearArt=q=>{
    const gx0=Math.max(0,Math.floor((q.x0-g)/cs)), gx1=Math.min(gw-1,Math.floor((q.x1+g)/cs));
    const gy0=Math.max(0,Math.floor((q.y0-g)/cs)), gy1=Math.min(gh-1,Math.floor((q.y1+g)/cs));
    for(let y=gy0;y<=gy1;y++) for(let x=gx0;x<=gx1;x++) if(occ[y*gw+x]) return true;
    return false;
  };
  const drop=new Uint8Array(comps.length);
  for(let k=1;k<comps.length;k++){
    const q=comps[k];
    if(q.n>=small) continue;
    const L=q.x1<bx, R=q.x0>w-bx, T=q.y1<by, B=q.y0>h-by;
    if(!(L||R||T||B)) continue;                    // not in the photo's margin
    if(nearArt(q)) continue;                       // within 3% of the photo of real ink
    drop[k]=1;
    edgeDustRemoved.push((T?"top":B?"bottom":"")+((T||B)&&(L||R)?"-":"")+(L?"left":R?"right":"")+((T||B)&&(L||R)?" corner":" edge"));
  }
  if(!edgeDustRemoved.length) return;
  for(let i=0;i<w*h;i++) if(lab[i]&&drop[lab[i]]) a[i*4+3]=0;
  ctx.putImageData(d,0,0);
}
/* 18 Oct 2026 (P202): the Mac edgeDust above, pasted word for word (proof-lab.html 3050-3111, v12.16). The web has
   no Sheet Builder to read edgeDustRemoved, so the customer is told here, under the removal colours (Thomas's
   default, 18 Oct: removed dust is told). Turning removal off brings the marks back; the eraser cannot. */
function syncDustNote(){
  const n=$("dustNote"); if(!n) return;
  const k=edgeDustRemoved.length;
  n.textContent = k ? stkFmt(stkT("stk.studio.msg.edge_dust","Tiny marks removed at the edge of your photo: [n]. To keep them, turn Remove background off."),{n:k}) : "";
  n.style.display = k ? "" : "none";
}
function trim(c){
  const ctx=c.getContext("2d");
  const {width:w,height:h}=c;
  const a=ctx.getImageData(0,0,w,h).data;
  let x0=w,y0=h,x1=0,y1=0,found=false;
  for(let y=0;y<h;y++)for(let x=0;x<w;x++){
    if(a[(y*w+x)*4+3]>10){ found=true;
      if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; }
  }
  if(!found){ trimOff={x:0,y:0}; return c; }
  const p=2, out=mk(x1-x0+1+2*p, y1-y0+1+2*p);
  /* Remember where the crop happened. Erase strokes are stored in WORK-canvas
     coordinates (deterministic from srcImg) rather than art coordinates,
     because art is rebuilt and re-trimmed whenever removal settings change -
     strokes stored in art space would drift every time. */
  trimOff={x:x0-p, y:y0-p};
  out.getContext("2d").drawImage(c, x0,y0,x1-x0+1,y1-y0+1, p,p,x1-x0+1,y1-y0+1);
  return out;
}
function silhouette(srcCanvas,color){
  const c=mk(srcCanvas.width,srcCanvas.height), x=c.getContext("2d");
  x.drawImage(srcCanvas,0,0);
  x.globalCompositeOperation="source-in";
  x.fillStyle=color; x.fillRect(0,0,c.width,c.height);
  return c;
}
function measureArt(){
  const x=art.getContext("2d");
  const {width:w,height:h}=art;
  const a=x.getImageData(0,0,w,h).data;
  let sx=0,sy=0,n=0;
  for(let y=0;y<h;y+=2)for(let xx=0;xx<w;xx+=2){
    if(a[(y*w+xx)*4+3]>10){ sx+=xx; sy+=y; n++; }
  }
  artCx=n? sx/n : w/2; artCy=n? sy/n : h/2;
  let m=1;
  for(let y=0;y<h;y+=2)for(let xx=0;xx<w;xx+=2){
    if(a[(y*w+xx)*4+3]>10){
      const d=(xx-artCx)*(xx-artCx)+(y-artCy)*(y-artCy);
      if(d>m) m=d;
    }
  }
  artMaxRad=Math.sqrt(m);
}
/* the pad every scene dilates on: the widest border plus the bleed */
function scenePad(){ if(ownCut()) return 4; return Math.round(BORDER_MAX_MM*pxPerMm())+Math.round(BLEED_MM*pxPerMm())+4; }   /* P215: own-cut art is already cropped with the bleed round it */
function ensurePad(maxR){
  if(dilPad >= maxR+8) return;
  dilPad = maxR+8;
  dilCache = {};
}
function dilateCanvas(src,R){
  const c=mk(src.width,src.height), x=c.getContext("2d");
  x.drawImage(src,0,0);
  let remaining=Math.max(0,Math.round(R));
  /* 2 Oct (iPhone, Studio closing itself): ONE scratch canvas for every pass, released at the end. A new
     full-size canvas per 6 px pass left dozens of buffers for the GC (measured 6 cm: 560 -> 317 MB,
     2 cm: 2.3 GB -> 609 MB). Same draws, same output. */
  const snap=remaining>0 ? mk(c.width,c.height) : null, sx=snap && snap.getContext("2d");
  while(remaining>0){
    const s=Math.min(remaining,6);
    sx.clearRect(0,0,snap.width,snap.height);
    sx.drawImage(c,0,0);
    for(let k=0;k<16;k++){
      const a=(k/16)*Math.PI*2;
      x.drawImage(snap, Math.cos(a)*s, Math.sin(a)*s);
    }
    remaining-=s;
  }
  if(snap){ snap.width=0; snap.height=0; }
  x.globalCompositeOperation="source-in";
  x.fillStyle="#fff"; x.fillRect(0,0,c.width,c.height);
  return c;   // NOT hardened here - see hardenAlpha, it must run ONCE at the end
}
/* Each dilation stamp above is drawn at a FRACTIONAL offset (cos/sin * s), so the
   browser bilinear-resamples it and its edge lands half-transparent. Stacking 16 of
   them, repeatedly, leaves a multi-pixel partial-alpha ramp at the outer edge rather
   than a clean edge. Filled with the border colour that ramp is white-at-partial-alpha,
   which over any darker page reads as a grey rim - measured at 4px, 8% of rows, exactly
   at border+bleed depth. Hardening the alpha gives the shape a definite edge.
   AI/_rules/LAB-RULES.md rule 2. */
function hardenAlpha(c, cut){
  cut = cut==null ? 96 : cut;          // ~38% coverage counts as inside
  const x=c.getContext("2d");
  const d=x.getImageData(0,0,c.width,c.height), a=d.data;
  for(let i=3;i<a.length;i+=4) a[i] = a[i]>=cut ? 255 : 0;
  x.putImageData(d,0,0);
  return c;
}
function invert(src){
  const c=mk(src.width,src.height), x=c.getContext("2d");
  x.fillStyle="#fff"; x.fillRect(0,0,c.width,c.height);
  x.globalCompositeOperation="destination-out";
  x.drawImage(src,0,0);
  return c;
}
function padCanvas(src,p){
  const c=mk(src.width+2*p,src.height+2*p);
  c.getContext("2d").drawImage(src,p,p);
  return c;
}
function cropCanvas(src,p,w,h){
  const c=mk(w,h);
  c.getContext("2d").drawImage(src,-p,-p);
  return c;
}
function closing(src,K){
  const p=K+4;
  let c=padCanvas(src,p);
  /* P170 (27 Sep 2026, Thomas: "the cutline with no border doesnt follow the artwork"): each
     dilation stamp leaves a soft ramp, and eroding through invert() took off less than the
     dilation added, so every closing grew the whole mask by a few px. MEASURED on his SLAM
     die-cut, border off, smoothing 0: the cut mask sat 0.28 mm outside the ink all round
     (93 mm2), filled with the background colour. Hardening at 50% after each pass makes
     dilate and erode symmetric: concavities still close, straight edges stay where the ink is. */
  c=hardenAlpha(dilateCanvas(c,K),128);
  c=invert(hardenAlpha(dilateCanvas(invert(c),K),128));
  return cropCanvas(c,p,src.width,src.height);
}
function fillHoles(c){
  const x=c.getContext("2d");
  const {width:w,height:h}=c;
  const d=x.getImageData(0,0,w,h);
  const a=d.data;
  const outside=new Uint8Array(w*h);
  const stack=[];
  for(let i=0;i<w;i++){ stack.push(i,(h-1)*w+i); }
  for(let i=0;i<h;i++){ stack.push(i*w,i*w+w-1); }
  while(stack.length){
    const i=stack.pop();
    if(i<0||i>=w*h||outside[i]) continue;
    if(a[i*4+3]>120) continue;
    outside[i]=1;
    const xx=i%w;
    stack.push(i-w,i+w);
    if(xx>0) stack.push(i-1);
    if(xx<w-1) stack.push(i+1);
  }
  for(let i=0;i<w*h;i++){
    if(!outside[i]){
      a[i*4]=255; a[i*4+1]=255; a[i*4+2]=255; a[i*4+3]=255;
    }
  }
  x.putImageData(d,0,0);
}
function countComponents(c){
  const ds=4;
  const w=Math.max(1,Math.floor(c.width/ds)), h=Math.max(1,Math.floor(c.height/ds));
  const t=mk(w,h);
  t.getContext("2d").drawImage(c,0,0,w,h);
  const a=t.getContext("2d").getImageData(0,0,w,h).data;
  const lab=new Int32Array(w*h);
  let n=0;
  const minSize=Math.max(6, w*h*0.002);
  for(let i=0;i<w*h;i++){
    if(a[i*4+3]>120 && !lab[i]){
      n++; let size=0;
      const st=[i];
      while(st.length){
        const j=st.pop();
        if(j<0||j>=w*h||lab[j]||a[j*4+3]<=120) continue;
        lab[j]=n; size++;
        const xx=j%w;
        st.push(j-w,j+w);
        if(xx>0) st.push(j-1);
        if(xx<w-1) st.push(j+1);
      }
      if(size<minSize) n--;
    }
  }
  return Math.max(1,n);
}
function boxPassH(src,dst,w,h,r){
  const win=2*r+1;
  for(let y=0;y<h;y++){
    const row=y*w;
    let sum=0;
    for(let x=-r;x<=r;x++) sum+=x>=0&&x<w? src[row+x]:0;
    for(let x=0;x<w;x++){
      dst[row+x]=sum/win;
      const add=x+r+1, sub=x-r;
      sum+=(add<w? src[row+add]:0)-(sub>=0? src[row+sub]:0);
    }
  }
}
function boxPassV(src,dst,w,h,r){
  const win=2*r+1;
  for(let x=0;x<w;x++){
    let sum=0;
    for(let y=-r;y<=r;y++) sum+=y>=0&&y<h? src[y*w+x]:0;
    for(let y=0;y<h;y++){
      dst[y*w+x]=sum/win;
      const add=y+r+1, sub=y-r;
      sum+=(add<h? src[add*w+x]:0)-(sub>=0? src[sub*w+x]:0);
    }
  }
}
function smoothMask(c,K){
  K=Math.round(K);
  if(K<1) return c;
  const p=K+6;
  const padded=padCanvas(c,p);
  const {width:w,height:h}=padded;
  const px=padded.getContext("2d").getImageData(0,0,w,h);
  let a=new Float32Array(w*h), b=new Float32Array(w*h);
  for(let i=0;i<w*h;i++) a[i]=px.data[i*4+3];
  const r=Math.max(1,Math.round(K/2));
  for(let t=0;t<3;t++){ boxPassH(a,b,w,h,r); boxPassV(b,a,w,h,r); }
  const out=mk(w,h);
  const od=out.getContext("2d").createImageData(w,h);
  for(let i=0;i<w*h;i++){
    if(a[i]>=128){
      od.data[i*4]=255; od.data[i*4+1]=255; od.data[i*4+2]=255; od.data[i*4+3]=255;
    }
  }
  out.getContext("2d").putImageData(od,0,0);
  return cropCanvas(out,p,c.width,c.height);
}
function connectComponents(c,base){
  if(countComponents(c)<=1) return c;
  for(let K=10;K<=200;K+=16){
    const joined=closing(c,K);
    if(countComponents(joined)===1){ c=joined; break; }
    if(K+16>200) c=joined;
  }
  const x=c.getContext("2d");
  x.globalCompositeOperation="source-over";
  x.drawImage(base,0,0);
  x.globalCompositeOperation="source-in";
  x.fillStyle="#fff"; x.fillRect(0,0,c.width,c.height);
  fillHoles(c);
  return c;
}
/* 18 Oct 2026 (P215): own-cut mode. The mask IS the customer's outer path, filled, under its own cache key; a larger R
   (the bleed) grows it. cutSizeMm, cutBBoxPx, buildExportScene, the bleed mask and the print re-trim all follow it. */
function dilateMask(R){
  R=Math.max(0,Math.round(R));
  if(ownCut()){
    const key="own:"+R;
    if(dilCache[key]) return dilCache[key];
    let c=dilCache["own:0"];
    if(!c){
      c=mk(art.width+2*dilPad, art.height+2*dilPad);
      const x=c.getContext("2d"); x.fillStyle="#fff"; x.fill(ownCutPath(dilPad,dilPad));
      dilCache["own:0"]=c;
    }
    if(R>0){ c=dilateCanvas(c,R); dilCache[key]=c; }
    return c;
  }
  const sPx=Math.round(opts.smoothMm*pxPerMm());
  const key=dilKey(R,sPx);   /* SOFT EDGE: the inset is part of the key */
  if(dilCache[key]) return dilCache[key];
  const base=mk(art.width+2*dilPad, art.height+2*dilPad);
  base.getContext("2d").drawImage(mask0, dilPad, dilPad);
  { const sIn=softInsetPx(); if(sIn>0) erodeMaskInPlace(base,sIn); }   /* SOFT EDGE: traced 1 mm inside the artwork */
  let c=dilateCanvas(base,R);
  fillHoles(c);
  c=connectComponents(c,base);
  if(sPx>0){
    c=smoothMask(c,sPx);
    fillHoles(c);
    c=connectComponents(c,base);
    /* 27 Sep 2026: the blur-and-threshold smoothing erased thin ink (a hand-written
       signature beside a circle, TOE_BEAN) and connectComponents only puts the ink back
       when the mask has split, so the cut ran straight through the customer's artwork.
       Whatever the smoothing removed comes back with a tab round it wide enough to cut. */
    c=keepInk(c, base, Math.max(2, Math.round(sPx*0.35)), 2*sPx);   /* 0.35 x smoothing: clears a letter, no fat tab */
  }
  dilCache[key]=c;
  return c;
}
/* P215: the customer's outer path in scene px (art px plus dx, dy) */
function ownCutPath(dx,dy){
  const f=custCut.xf;
  return segsPath(custCut.segs, (x,y)=>[x*f.sx+f.ox+dx, y*f.sy+f.oy+dy]);
}
/* P215: the art cropped to the cut's box plus the widest bleed it can need (1.5mm at the 10mm smallest size), not to
   the ink: their line can sit well outside the artwork, or run off the page (the bleed there takes the background). */
function cropToCut(c){
  const f=custCut.xf, b=custCut.bb, L=Math.max(b.w*f.sx, b.h*f.sy), m=Math.ceil(L*BLEED_MM/SIZE_MIN_MM)+4;
  const x0=Math.floor(b.x*f.sx)-m, y0=Math.floor(b.y*f.sy)-m;
  const out=mk(Math.ceil((b.x+b.w)*f.sx)+m-x0, Math.ceil((b.y+b.h)*f.sy)+m-y0);
  out.getContext("2d").drawImage(c,-x0,-y0);
  trimOff={x:x0, y:y0};
  return out;
}
/* P215: the art in scene px, kept only inside a mask (the sticker to the line, or the line plus the bleed) */
function clipToMask(a,m,off){
  const c=mk(m.width,m.height), x=c.getContext("2d");
  x.drawImage(a,off,off);
  x.globalCompositeOperation="destination-in"; x.drawImage(m,0,0);
  return c;
}
/* P215: the cut file's path. Their outer path in absolute mm (M/L/C/Z) at the chosen size. Over 2,000 nodes it is
   thinned with rdp at 0.03mm, the ColorCut's own buffer limit (lab-tools-cut-tracing). */
function ownCutD(mmpp,dx,dy){
  const f=custCut.xf, T=(x,y)=>[(x*f.sx+f.ox+dilPad-dx)*mmpp, (y*f.sy+f.oy+dilPad-dy)*mmpp], n=v=>v.toFixed(3);
  const segs=custCut.segs;
  if(segs.length>2000){
    const pts=segsFlat(segs,8).map(p=>T(p[0],p[1]));
    let k=0, far=0; pts.forEach((p,i)=>{ const d=Math.hypot(p[0]-pts[0][0],p[1]-pts[0][1]); if(d>far){ far=d; k=i; } });
    const q=rdp(pts.slice(0,k+1),0.03).concat(rdp(pts.slice(k),0.03).slice(1));   /* a closed ring is split at its far point: rdp needs two distinct ends */
    return "M"+q.map(p=>n(p[0])+" "+n(p[1])).join("L")+"Z";
  }
  let d="";
  for(const g of segs){
    if(g.c==="Z"){ d+="Z"; continue; }
    const a=[]; for(let i=0;i<g.p.length;i+=2){ const t=T(g.p[i],g.p[i+1]); a.push(n(t[0]),n(t[1])); }
    d+=g.c+a.join(" ");
  }
  return d;
}
/* the mask must contain every ink pixel of base; lost ink returns with an r px envelope.
   Ink within 1 px of the cut is the blur's half-pixel shift, not a loss: without that
   allowance the antialiased rim of a plain circle grew four tabs at the compass points.
   reach: ink this close to a loss belongs to the same feature and gets the envelope too. */
function keepInk(c, base, r, reach){
  const w=c.width, h=c.height;
  if(base.width!==w || base.height!==h) return c;
  const cx=c.getContext("2d"), ca=dilateCanvas(c,1).getContext("2d").getImageData(0,0,w,h).data;
  const ba=base.getContext("2d").getImageData(0,0,w,h).data;
  const lost=mk(w,h), lx=lost.getContext("2d"), ld=lx.createImageData(w,h);
  let n=0;
  for(let i=0;i<w*h;i++){
    if(ba[i*4+3]>128 && ca[i*4+3]<=128){ ld.data[i*4]=255; ld.data[i*4+1]=255; ld.data[i*4+2]=255; ld.data[i*4+3]=255; n++; }
  }
  if(!n) return c;
  lx.putImageData(ld,0,0);
  /* Only REAL features come back. Smoothing also shaves hair tips, fringe and single-pixel teeth
     off every outline; wrapping each of those in a tab put a 0.5-1 mm band round 31% of a die-cut's
     edge (Thomas, 27 Sep 21:30, his SLAM file, border off: "the cutline with no border doesnt
     follow the artwork, its following those random pieces"). Lost pixels are grouped (3 px), and
     a group counts only when it is at least the smoothing radius across: a letter or a star is,
     a shaved hair tip is not. */
  const grp=dilateCanvas(lost, 3);
  const ga=grp.getContext("2d").getImageData(0,0,w,h).data, lab=new Uint8Array(w*h), st=new Int32Array(w*h);
  const sPx=reach ? reach/2 : r/0.6;
  /* a feature: at least the smoothing radius across AND at least half a square smoothing-radius of
     lost ink (a 3 mm letter is thousands of px; a shaved hair tip is a 1-2 px sliver, tens of px) */
  const minSide=Math.max(6, Math.round(sPx)), minLost=Math.max(60, Math.round(0.5*sPx*sPx));
  const keep=mk(w,h), kx=keep.getContext("2d"), kd=kx.createImageData(w,h);
  let kept=0;
  for(let i=0;i<w*h;i++){
    if(lab[i] || ga[i*4+3]<=128) continue;
    let sp=0, cnt=0, lostN=0, x0=w, y0=h, x1=-1, y1=-1; const px=[]; st[sp++]=i; lab[i]=1;
    while(sp){ const p=st[--sp]; px.push(p); cnt++; if(ld.data[p*4+3]>0) lostN++; const x=p%w, y=(p/w)|0; if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y;
      if(x>0&&!lab[p-1]&&ga[(p-1)*4+3]>128){lab[p-1]=1;st[sp++]=p-1;} if(x<w-1&&!lab[p+1]&&ga[(p+1)*4+3]>128){lab[p+1]=1;st[sp++]=p+1;}
      if(p>=w&&!lab[p-w]&&ga[(p-w)*4+3]>128){lab[p-w]=1;st[sp++]=p-w;} if(p<w*h-w&&!lab[p+w]&&ga[(p+w)*4+3]>128){lab[p+w]=1;st[sp++]=p+w;} }
    if(Math.max(x1-x0+1, y1-y0+1) < minSide || lostN < minLost) continue;
    kept++; for(const p of px){ kd.data[p*4]=255; kd.data[p*4+1]=255; kd.data[p*4+2]=255; kd.data[p*4+3]=255; }
  }
  if(!kept) return c;
  kx.putImageData(kd,0,0);
  /* the kept feature and the ink within r of it (the rest of the letters, which the blur had merely
     brought level with the line) get the envelope, so the cut clears the whole word */
  const near=dilateCanvas(keep, Math.max(r, reach||0)), nx=near.getContext("2d");
  nx.globalCompositeOperation="destination-in"; nx.drawImage(base,0,0);
  const tab=dilateCanvas(near, r);
  cx.globalCompositeOperation="source-over"; cx.drawImage(tab,0,0);
  cx.globalCompositeOperation="source-in"; cx.fillStyle="#fff"; cx.fillRect(0,0,w,h);
  cx.globalCompositeOperation="source-over";
  fillHoles(c);
  return connectComponents(c,base);
}
function extractPalette(c){
  const x=c.getContext("2d");
  const {width:w,height:h}=c;
  const a=x.getImageData(0,0,w,h).data;
  const bins={};
  const step=Math.max(1,Math.floor(Math.sqrt(w*h/18000)));
  for(let y=0;y<h;y+=step)for(let xx=0;xx<w;xx+=step){
    const i=(y*w+xx)*4;
    if(a[i+3]<200) continue;
    const key=(a[i]>>4)<<8 | (a[i+1]>>4)<<4 | (a[i+2]>>4);
    let b=bins[key]; if(!b){b=bins[key]=[0,0,0,0];}
    b[0]+=a[i]; b[1]+=a[i+1]; b[2]+=a[i+2]; b[3]++;
  }
  const hex=n=>Math.max(0,Math.min(255,Math.round(n))).toString(16).padStart(2,"0");   /* clamp: an unclamped bin average of 257 wrote "101" and made a seven digit hex */
  return Object.values(bins)
    .sort((p,q)=>q[3]-p[3]).slice(0,6)
    .map(b=>"#"+hex(Math.round(b[0]/b[3]))+hex(Math.round(b[1]/b[3]))+hex(Math.round(b[2]/b[3])));
}
function shapeDims(){
  const aw=art.width, ah=art.height;
  const base=Math.max(aw,ah);
  let sw,sh;
  if(opts.shape==="circle"||opts.shape==="square"){ sw=sh=base*1.16; }
  else if(aw>=ah){ sw=Math.max(aw*1.12, ah*1.5); sh=sw/1.5; }
  else { sh=Math.max(ah*1.12, aw*1.5); sw=sh/1.5; }
  const m=Math.round(base*0.04)+6;
  return {sw,sh,m,w:sw+2*m,h:sh+2*m};
}
function shapeCornerR(d){
  const ppm=d.sw/widthMm();
  return Math.max(MIN_CORNER_MM*ppm, CORNER_F[opts.corner]*Math.min(d.sw,d.sh));
}
function shapeScale(d){
  const k=Math.max(0.5,Math.min(1.5,(Number(opts.artPct)||100)/100));   /* v4.3: the artwork size slider */
  return shapeScaleFit(d)*k;
}
function shapeScaleFit(d){
  const aw=art.width, ah=art.height;
  if(opts.shape==="circle"){
    const edgeSc=(d.sw/2-1)/artMaxRad;
    if(opts.fit==="fill") return Math.max(d.sw/aw,d.sh/ah);
    if(opts.fit==="edge") return edgeSc;
    return edgeSc*0.86;
  }
  const contain=Math.min(d.sw/aw,d.sh/ah);
  if(opts.fit==="fill") return Math.max(d.sw/aw,d.sh/ah);
  if(opts.fit==="edge") return contain;
  return contain*0.85;
}
function tracePathOn(x,d,grow){
  grow=grow||0;
  if(typeof x.beginPath==="function") x.beginPath();
  if(opts.shape==="circle") x.arc(d.w/2,d.h/2,d.sw/2+grow,0,Math.PI*2);
  else {
    const r=Math.min(shapeCornerR(d),d.sw/2,d.sh/2)+grow;
    const px=d.m-grow, py=d.m-grow, w=d.sw+2*grow, h=d.sh+2*grow;
    x.moveTo(px+r,py);
    x.arcTo(px+w,py,px+w,py+h,r);
    x.arcTo(px+w,py+h,px,py+h,r);
    x.arcTo(px,py+h,px,py,r);
    x.arcTo(px,py,px+w,py,r);
    x.closePath();
  }
}
/* ================= STRAIGHT-EDGED RECTANGLE SNAPPING =================
   traceContour returns a pixel staircase, so rdp+chaikin rounds every corner and cannot
   tell a real one from a jagged one: measured 7 Sep 2026, a sharp 3in square lost 2.86mm
   off each corner. So: fit the rectangle the customer drew, MEASURE the fit, and use it
   only when their outline is within tolerance everywhere (a heart, star or circle never
   snaps - tested). The radius is fitted from the artwork. The snapped outline is emitted
   with real ARCS, so Sheet Builder's smoothCutD leaves the straight edges alone. */
function convexHull(pts){
  const p=pts.slice().sort((a,b)=>a[0]-b[0]||a[1]-b[1]);
  if(p.length<3) return p;
  const cr=(o,a,b)=>(a[0]-o[0])*(b[1]-o[1])-(a[1]-o[1])*(b[0]-o[0]);
  const lo=[],up=[];
  for(const q of p){ while(lo.length>=2&&cr(lo[lo.length-2],lo[lo.length-1],q)<=0) lo.pop(); lo.push(q); }
  for(let i=p.length-1;i>=0;i--){ const q=p[i]; while(up.length>=2&&cr(up[up.length-2],up[up.length-1],q)<=0) up.pop(); up.push(q); }
  lo.pop(); up.pop(); return lo.concat(up);
}
function polyArea(p){ let a=0; for(let i=0;i<p.length;i++){ const b=p[(i+1)%p.length]; a+=p[i][0]*b[1]-b[0]*p[i][1]; } return Math.abs(a)/2; }
function minAreaRect(h){
  let best=null;
  for(let i=0;i<h.length;i++){
    const a=h[i], b=h[(i+1)%h.length];
    const ang=Math.atan2(b[1]-a[1], b[0]-a[0]);
    const c=Math.cos(-ang), s=Math.sin(-ang);
    let x0=1e18,y0=1e18,x1=-1e18,y1=-1e18;
    for(const p of h){
      const x=p[0]*c-p[1]*s, y=p[0]*s+p[1]*c;
      if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y;
    }
    const w=x1-x0, ht=y1-y0, area=w*ht;
    if(!best||area<best.area){
      const mx=(x0+x1)/2, my=(y0+y1)/2;
      best={area,ang,w,h:ht,cx:mx*c+my*s,cy:-mx*s+my*c};
    }
  }
  return best;
}
function sdRoundBox(u,v,a,b,r){
  const qx=Math.abs(u)-(a-r), qy=Math.abs(v)-(b-r);
  return Math.hypot(Math.max(qx,0),Math.max(qy,0))+Math.min(Math.max(qx,qy),0)-r;
}
function detectRect(pts,tolPx){
  /* 4, not 8. A perfectly clean rectangle simplifies to five points (four
     corners plus the close), and the old guard threw exactly that away: with
     cut smoothing at 0.0mm Thomas's label came through as 5 points, fill
     1.0000, deviation 0.00, and was rejected as too few points to judge.
     The fit test below is what decides; this only needs to stop degenerate
     input that cannot form a hull. */
  if(pts.length<4) return null;
  const h=convexHull(pts); if(h.length<4) return null;
  const R=minAreaRect(h); if(!R||R.w<8||R.h<8) return null;
  const fill=polyArea(pts)/R.area;
  if(fill<0.90) return null;              // a circle is 0.785, an octagon 0.828
  const a=R.w/2, b=R.h/2, mn=Math.min(R.w,R.h);
  const c=Math.cos(-R.ang), s=Math.sin(-R.ang);
  const loc=pts.map(p=>{ const dx=p[0]-R.cx, dy=p[1]-R.cy; return [dx*c-dy*s, dx*s+dy*c]; });
  let bestR=0, bestDev=Infinity;
  for(let i=0;i<=48;i++){                 // fit the radius to THEIR corners
    const r=i/48*Math.min(a,b);
    let dev=0;
    for(let j=0;j<loc.length;j++){
      const d=Math.abs(sdRoundBox(loc[j][0],loc[j][1],a,b,r));
      if(d>dev){ dev=d; if(dev>=bestDev) break; }
    }
    if(dev<bestDev){ bestDev=dev; bestR=r; }
  }
  const tol=tolPx!==undefined?tolPx:Math.max(2.5,0.018*mn);
  if(bestDev>tol) return null;
  return {cx:R.cx,cy:R.cy,w:R.w,h:R.h,ang:R.ang,r:bestR,dev:bestDev,fill:fill};
}
function rectPolygon(R,seg){
  seg=seg||10;
  const a=R.w/2, b=R.h/2, r=Math.min(R.r,a,b);
  const c=Math.cos(R.ang), s=Math.sin(R.ang);
  const out=[], corner=[[a-r,b-r,0],[-(a-r),b-r,Math.PI/2],[-(a-r),-(b-r),Math.PI],[a-r,-(b-r),-Math.PI/2]];
  for(let ci=0;ci<4;ci++){
    const ox=corner[ci][0], oy=corner[ci][1], base=corner[ci][2];
    if(r<=0.01){ out.push([ox,oy]); continue; }
    for(let i=0;i<=seg;i++){ const t=base+i/seg*(Math.PI/2); out.push([ox+r*Math.cos(t), oy+r*Math.sin(t)]); }
  }
  return out.map(p=>[R.cx+p[0]*c-p[1]*s, R.cy+p[0]*s+p[1]*c]);
}
function rectPathD(R,f){
  const a=R.w/2, b=R.h/2, r=Math.min(R.r,a,b);
  const c=Math.cos(R.ang), s=Math.sin(R.ang);
  const P=(u,v)=>[R.cx+u*c-v*s, R.cy+u*s+v*c];
  if(r<=0.01){
    const q=[P(-a,-b),P(a,-b),P(a,b),P(-a,b)];
    return "M"+q.map(p=>f(p[0])+" "+f(p[1])).join("L")+"Z";
  }
  const k=[P(-(a-r),-b),P(a-r,-b),P(a,-(b-r)),P(a,b-r),P(a-r,b),P(-(a-r),b),P(-a,b-r),P(-a,-(b-r))];
  const A=p=>"A"+f(r)+" "+f(r)+" 0 0 1 "+f(p[0])+" "+f(p[1]);
  return "M"+f(k[0][0])+" "+f(k[0][1])+"L"+f(k[1][0])+" "+f(k[1][1])+A(k[2])
       + "L"+f(k[3][0])+" "+f(k[3][1])+A(k[4])
       + "L"+f(k[5][0])+" "+f(k[5][1])+A(k[6])
       + "L"+f(k[7][0])+" "+f(k[7][1])+A(k[0])+"Z";
}
/* ONE entry point for every traced cut path in this lab, so the three call
   sites cannot drift apart. Returns the points to draw AND the rectangle when
   one was found, so the SVG writer can emit arcs instead of a polyline.
   The corner radius is the customer's, in real millimetres, from the Corners
   picker. */
var CORNER_MM = {sq:0, r4:4, r65:6.5, r8:8};
function refineContour(pts, pxPerMmVal){
  const simple = rdp(pts, 1.6);
  const R = opts.shape==="rect" ? detectRect(simple) : null;
  showSnapGroup(!!R, R);
  if(R){
    /* The corner is picked in real millimetres. 90 degrees is a true right angle for
       labels (the FB780/790-T cuts square off the crosshair; measured 7 Sep, keeping the
       fitted radius still gave 0.79mm). Until they choose, the picker follows their own
       artwork: the nearest of 4 / 6.5 / 8mm to the measured radius, never 90 by default -
       a square-cornered sticker lifts and catches. A bordered sticker cannot be square
       anyway: the border rounds the corner by about its own width. */
    const rMm = CORNER_MM[opts.cornerMode];
    R.r = Math.min((rMm===undefined?4:rMm)*(pxPerMmVal||0), R.w/2, R.h/2);
    return { pts: rectPolygon(R, 10), rect: R };
  }
  /* corners cut back at most 0.25 mm: pixel staircases still round, real corners stay */
  return { pts: chaikin(simple, 2, Math.max(2, 0.25*(pxPerMmVal||0))), rect: null };
}
function showSnapGroup(on, R){
  const g = $("gSnap");
  if(!g) return;
  /* shown whenever the customer picked Corners, never otherwise; if their
     artwork is not a rectangle, say so and grey the corners rather than hide them */
  const asked = opts.shape==="rect";
  /* 18 Oct 2026 (P215 review): in own-cut mode it stays shown, greyed and labelled by syncOwnCutUI */
  if(ownCut()){ g.style.display=""; const nt=$("snapNote"); if(nt) nt.style.display="none"; return; }
  g.style.display = asked ? "" : "none";
  const note = $("snapNote");
  if(!on || !R){
    if(asked){
      [...$("cornerSnapSeg").querySelectorAll("button")].forEach(b=>{
        b.disabled = true;
        b.title = stkT("stk.studio.tool.not_rect_title","Your artwork is not a rectangle, so the cut follows its outline");
      });
      if(note){ note.textContent = stkT("stk.studio.tool.not_rect_note","Not a rectangle, so the cut follows your artwork's outline."); note.style.display = ""; }
    }
    return;
  }
  if(note) note.style.display = "none";
  const px = Math.max(1e-6, pxPerMm());
  const minSideMm = Math.min(R.w, R.h) / px;
  /* A radius over a third of the short side stops being a rounded corner and
     becomes a stadium. Grey those out with the reason rather than letting
     someone pick 6.5mm on a 14.7mm-tall label. */
  const maxRMm = minSideMm / 3;
  const btns = [...$("cornerSnapSeg").querySelectorAll("button")];
  btns.forEach(b=>{
    const tooBig = CORNER_MM[b.dataset.v] > maxRMm;
    b.disabled = tooBig;
    b.title = tooBig
      ? stkFmt(stkT("stk.studio.tool.too_round","Too round for a piece this size ([mm]mm across the short side)"), {mm:stkDec(minSideMm,1)})
      : "";
  });
  labelCheck(R, px);
  /* until the customer picks, follow their own artwork, and never land on 90
     by itself - a square corner is a deliberate choice */
  if(!opts.cornerAuto) return;
  const rMm = R.r / px;
  let best = null, bd = Infinity;
  for(const k of ["r4","r65","r8"]){
    if(CORNER_MM[k] > maxRMm) continue;
    const d = Math.abs(CORNER_MM[k] - rMm);
    if(d < bd){ bd = d; best = k; }
  }
  if(!best) best = "sq";              // nothing roundable fits, so cut it square
  if(opts.cornerMode !== best){
    opts.cornerMode = best;
    btns.forEach(b=>b.classList.toggle("on", b.dataset.v===best));
  }
}
/* A LABEL ANNOUNCES ITSELF BY ITS OWN CORNERS. If the uploaded artwork has
   true right angles it is a label, not a sticker, so select 90 and switch the
   border off (Thomas, 7 Sep 2026). The border has to go: growing it rounds the
   corner by roughly its own width, measured at 1.59mm on a 2mm border, so a
   bordered label cannot have square corners at all.
   Measured from mask0, the artwork itself - the radius of the BORDERED outline
   is the border's, not the customer's. Runs once per document; after that their
   choices win. */
function labelCheck(R, px){
  if(opts.labelApplied || !mask0) return;
  opts.labelApplied = true;
  let art0 = null;
  try{ art0 = detectRect(rdp(traceContour(mask0), 1.6)); }catch(e){ return; }
  const artPx = Math.max(1e-6, Math.max(mask0.width, mask0.height) / widthMm());
  const isLabel = !!art0 && art0.r / artPx <= 1.0;
  if(!isLabel){
    /* Dropping a sticker onto a label's document used to inherit the label
       treatment: border off, corners square. That was OUR decision about the
       previous file, not the customer's, so it is undone here. Their own
       choices are untouched - labelAuto is only set when we applied it. */
    if(opts.labelAuto){
      opts.labelAuto = false;
      setTimeout(()=>{
        opts.cornerAuto = true;
        if(!opts.border){
          opts.border = true;
          $("borderToggle").classList.add("on");
          syncBorderVisibility();
        }
        dilCache = {}; render(); updateDims();
      }, 0);
    }
    return;
  }
  setTimeout(()=>{                      // after this render, not during it
    opts.cornerMode = "sq"; opts.cornerAuto = false; opts.labelAuto = true;
    [...$("cornerSnapSeg").querySelectorAll("button")]
      .forEach(b=>b.classList.toggle("on", b.dataset.v==="sq"));
    if(opts.border){
      opts.border = false;
      $("borderToggle").classList.remove("on");
      syncBorderVisibility();
    }
    dilCache = {}; render(); updateDims();
  }, 0);
}
/* ---------- SIMPLIFY (P136, 17 Sep 2026) ----------
   Illustrator's Simplify for traced cut lines: keep the shape, keep only the nodes needed,
   join them with CURVES. rdp+chaikin joined nodes with straight segments ("octagon", Thomas
   17 Sep) and rounded real corners. Fitted to the RAW trace, never to a thinned polyline.
   Measured on his fish artwork: 92 straight nodes -> 25 curve nodes within 0.15mm (Adobe
   15-33). v2: straight edges are emitted as exact lines and the corner between two edges is
   a true arc sized to the trace (19 nodes bowing 0.18mm off a circle -> 9 nodes, 3 arcs).
   Shared verbatim by Sticker Sheet Lab, Proof Lab and Bookmark Lab. */
const SIMPLIFY_SMOOTH_MM = 0.3;   /* moving average over the trace: removes pixel noise, not shape */
const SIMPLIFY_TOL_MM    = 0.15;  /* max distance from the traced outline; blade is 0.25mm */
const smpSub=(a,b)=>[a[0]-b[0],a[1]-b[1]], smpAdd=(a,b)=>[a[0]+b[0],a[1]+b[1]],
      smpScl=(a,s)=>[a[0]*s,a[1]*s], smpDot=(a,b)=>a[0]*b[0]+a[1]*b[1],
      smpLen=a=>Math.hypot(a[0],a[1]),
      smpNorm=a=>{ const l=smpLen(a); return l>1e-12?[a[0]/l,a[1]/l]:[0,0]; };
const smpBez=(ctrl,t)=>{ let p=ctrl.map(q=>q.slice()); while(p.length>1){ const n=[]; for(let i=0;i<p.length-1;i++) n.push([p[i][0]+(p[i+1][0]-p[i][0])*t, p[i][1]+(p[i+1][1]-p[i][1])*t]); p=n; } return p[0]; };
function smpFitOpen(pts, err, tStart, tEnd){
  /* open polyline -> cubic segments [p0,c1,c2,p3]; err = max deviation, mm */
  const p=[];
  for(const q of pts) if(!p.length||q[0]!==p[p.length-1][0]||q[1]!==p[p.length-1][1]) p.push(q);
  if(p.length<2) return [];
  const errSq=err*err, iterSq=errSq*4, out=[];
  const chordParam=(a,b)=>{
    const u=[0];
    for(let i=a+1;i<=b;i++) u.push(u[i-a-1]+smpLen(smpSub(p[i],p[i-1])));
    const tot=u[u.length-1]||1;
    return u.map(v=>v/tot);
  };
  const genBezier=(a,b,u,t1,t2)=>{
    /* least-squares alphas along the fixed end tangents */
    let c00=0,c01=0,c11=0,x0=0,x1=0;
    for(let i=a;i<=b;i++){
      const t=u[i-a], w=1-t;
      const A0=smpScl(t1,3*t*w*w), A1=smpScl(t2,3*t*t*w);
      c00+=smpDot(A0,A0); c01+=smpDot(A0,A1); c11+=smpDot(A1,A1);
      const tmp=smpSub(p[i],smpAdd(smpScl(p[a],w*w*w+3*t*w*w),smpScl(p[b],t*t*t+3*t*t*w)));
      x0+=smpDot(A0,tmp); x1+=smpDot(A1,tmp);
    }
    const det=c00*c11-c01*c01, chord=smpLen(smpSub(p[b],p[a]));
    let a1=det?(x0*c11-x1*c01)/det:0, a2=det?(c00*x1-c01*x0)/det:0;
    /* degenerate least squares: fall back to the Wu-Barsky heuristic */
    if(!isFinite(a1)||!isFinite(a2)||a1<1e-6*chord||a2<1e-6*chord||a1>chord*3||a2>chord*3) a1=a2=chord/3;
    return [p[a],smpAdd(p[a],smpScl(t1,a1)),smpAdd(p[b],smpScl(t2,a2)),p[b]];
  };
  const maxErr=(a,b,bz,u)=>{
    let m=0, split=(a+b)>>1;
    for(let i=a+1;i<b;i++){
      const e=smpSub(smpBez(bz,u[i-a]),p[i]), d2=smpDot(e,e);
      if(d2>m){ m=d2; split=i; }
    }
    return [m,split];
  };
  const reparam=(a,b,u,bz)=>{
    /* one newton-raphson step per point toward the closest curve parameter */
    const d1=[0,1,2].map(i=>smpScl(smpSub(bz[i+1],bz[i]),3));
    const d2=[0,1].map(i=>smpScl(smpSub(d1[i+1],d1[i]),2));
    return u.map((t,i)=>{
      const diff=smpSub(smpBez(bz,t),p[a+i]);
      const q1=smpBez(d1,t), q2=smpBez(d2,t);
      const den=smpDot(q1,q1)+smpDot(diff,q2);
      return den?Math.max(0,Math.min(1,t-smpDot(diff,q1)/den)):t;
    });
  };
  let spacing=0;
  const fit=(a,b,t1,t2,depth)=>{
    if(b-a===1){
      const d3=smpLen(smpSub(p[b],p[a]))/3;
      out.push([p[a],smpAdd(p[a],smpScl(t1,d3)),smpAdd(p[b],smpScl(t2,d3)),p[b]]);
      return;
    }
    let u=chordParam(a,b);
    let bz=genBezier(a,b,u,t1,t2);
    let [e,split]=maxErr(a,b,bz,u);
    if(e<=errSq){ out.push(bz); return; }
    if(e<=iterSq){ /* close enough that reparameterising may rescue one cubic */
      for(let i=0;i<4;i++){
        u=reparam(a,b,u,bz);
        bz=genBezier(a,b,u,t1,t2);
        [e,split]=maxErr(a,b,bz,u);
        if(e<=errSq){ out.push(bz); return; }
      }
    }
    if(depth>40){ out.push(bz); return; }
    /* split at the worst point; tangent there from its neighbours */
    /* tangent at the split from about 0.4mm either side, not the immediate
       neighbours: on a dense trace one-point tangents are noise, and noisy
       tangents are what made straight edges wander (Thomas, 17 Sep) */
    const kw=Math.max(1,Math.min(split-a,b-split,Math.round(0.4/(spacing||0.4))));
    const tc=smpNorm(smpSub(p[split-kw],p[split+kw]));
    fit(a,split,t1,tc,depth+1);
    fit(split,b,smpScl(tc,-1),t2,depth+1);
  };
  for(let i=1;i<p.length;i++) spacing+=smpLen(smpSub(p[i],p[i-1])); spacing/=Math.max(1,p.length-1);
  fit(0,p.length-1, tStart||smpNorm(smpSub(p[1],p[0])), tEnd||smpNorm(smpSub(p[p.length-2],p[p.length-1])), 0);
  return out;
}
function smpFitClosed(pts, err){
  /* closed ring (start not repeated) -> closed loop of cubic segments */
  const p=[];
  for(const q of pts) if(!p.length||q[0]!==p[p.length-1][0]||q[1]!==p[p.length-1][1]) p.push(q);
  while(p.length>1&&p[0][0]===p[p.length-1][0]&&p[0][1]===p[p.length-1][1]) p.pop();
  const n=p.length;
  if(n<3) return [];
  /* turn angle measured two points out so single-pixel jitter can't fake a corner */
  const turn=i=>{
    const a=smpNorm(smpSub(p[i],p[(i-2+n)%n])), b=smpNorm(smpSub(p[(i+2)%n],p[i]));
    return Math.acos(Math.max(-1,Math.min(1,smpDot(a,b))));
  };
  const SHARP=Math.PI/3;
  /* a pixel trace smears one corner over a few points: cluster neighbouring
     hits and keep the sharpest of each cluster */
  const corners=[];
  for(let i=0;i<n;i++){
    const a=turn(i);
    if(a<=SHARP) continue;
    const last=corners[corners.length-1];
    if(last&&i-last[0]<=2){ if(a>last[1]){ last[0]=i; last[1]=a; } }
    else corners.push([i,a]);
  }
  if(corners.length>1){
    const f=corners[0], l=corners[corners.length-1];
    if(f[0]+n-l[0]<=2){ if(l[1]>f[1]){ f[0]=l[0]; f[1]=l[1]; } corners.pop(); }
  }
  if(!corners.length){
    /* no true corner: seam anywhere - the end tangents agree, so the join stays smooth */
    return smpFitOpen(p.concat([p[0]]),err);
  }
  /* seam at the sharpest corner, split at every corner: corners stay corners */
  const rot=corners.reduce((m,c)=>c[1]>m[1]?c:m)[0];
  const q=p.slice(rot).concat(p.slice(0,rot));
  const idxs=corners.map(c=>(c[0]-rot+n)%n).sort((x,y)=>x-y);
  const out=[];
  for(let k=0;k<idxs.length;k++){
    const a=idxs[k], b=k+1<idxs.length?idxs[k+1]:n;
    const run=[];
    for(let i=a;i<=b;i++) run.push(q[i%n]);
    out.push(...smpFitOpen(run,err));
  }
  return out;
}


const SIMPLIFY_LINE_MIN_MM = 5;     /* shortest run treated as a straight edge. Shorter "straight" pieces are
                                       usually chords of a gentle curve: at 1.5mm a 25mm-radius curve became a
                                       chain of flats (50 nodes, octagon again). Short real edges fit fine as curves */
const SIMPLIFY_LINE_TOL_MM = 0.04;  /* how far a point may sit off that edge */
const SIMPLIFY_LINE_BOW_MM = 0.012; /* mean signed offset: a real edge scatters both sides, a curve bows one way */
function smpFillet(A1,d1,A2,B2,d2,pts,err){
  /* A perfect circular corner between two straight edges, radius fitted to the
     traced corner - "treated like we treat labels, a perfectly smooth corner
     radius, fit to size" (Thomas, 17 Sep). Growing a border around a straight-
     edged shape makes exactly this: edges joined by circular arcs. Returns
     {T1,T2,seg} or null when no arc fits within err (then a free curve is used). */
  const cr=d1[0]*d2[1]-d1[1]*d2[0], dt=Math.max(-1,Math.min(1,smpDot(d1,d2)));
  const th=Math.acos(dt);
  if(Math.abs(cr)<1e-6 || th<15*Math.PI/180 || th>150*Math.PI/180) return null;
  /* V = where the two edge lines meet */
  const w=smpSub(A2,A1), s1=(w[0]*d2[1]-w[1]*d2[0])/cr, V=smpAdd(A1,smpScl(d1,s1));
  const side=cr>0?1:-1, n1=[-d1[1]*side, d1[0]*side];
  const tanH=Math.tan(th/2);
  const shape=r=>{ const tl=r*tanH, T1=smpSub(V,smpScl(d1,tl)), T2=smpAdd(V,smpScl(d2,tl)), C=smpAdd(T1,smpScl(n1,r)); return {tl,T1,T2,C}; };
  const dev=(r)=>{ const {T1,T2,C}=shape(r); let m=0;
    for(const p of pts){
      const s1p=smpDot(smpSub(p,T1),d1), s2p=smpDot(smpSub(p,T2),d2);
      let d;
      if(s1p<=0){ const v=smpSub(p,T1); d=Math.abs(v[0]*d1[1]-v[1]*d1[0]); }
      else if(s2p>=0){ const v=smpSub(p,T2); d=Math.abs(v[0]*d2[1]-v[1]*d2[0]); }
      else d=Math.abs(smpLen(smpSub(p,C))-r);
      if(d>m) m=d; }
    return m; };
  /* the radius can't run past either edge's own start */
  /* the arc may not run back past either edge's far end */
  const rLim=Math.max(0,Math.min(smpDot(smpSub(V,A1),d1), smpDot(smpSub(B2,V),d2)))/tanH;
  if(!(rLim>0)) return null;
  let lo=0, hi=rLim;
  for(let k=0;k<60;k++){ const m1=lo+(hi-lo)/3, m2=hi-(hi-lo)/3; if(dev(m1)<=dev(m2)) hi=m2; else lo=m1; }
  const r=(lo+hi)/2, e=dev(r);
  if(!(e<=err) || !(r>1e-4)) return null;
  const {T1,T2}=shape(r), h=(4/3)*Math.tan(th/4)*r;
  return {T1,T2,r,dev:e,seg:[T1, smpAdd(T1,smpScl(d1,h)), smpSub(T2,smpScl(d2,h)), T2]};
}
function smpFitClosedLines(P, err){
  /* STRAIGHT EDGES FIRST, CORNERS AS TRUE ARCS (Thomas, 17 Sep: "look at these
     edges"; "any 90 degree angle ... a perfectly smooth corner radius, fit to
     size"). Curves had been fitted straight across the join between an edge and
     its corner, so edges wandered 0.1mm and corners bowed. Now: find every
     straight run and emit it as an exact line; between two runs try a circular
     fillet tangent to both; only if no arc fits, fit free curves with their end
     tangents pinned to the edges. */
  const n=P.length;
  if(n<16) return smpFitClosed(P,err);
  let per=0; for(let i=0;i<n;i++) per+=smpLen(smpSub(P[(i+1)%n],P[i]));
  const sp=per/n, w=Math.max(2,Math.round(0.5/sp));
  let r0=0, best=-1;
  for(let i=0;i<n;i++){
    const a=smpNorm(smpSub(P[i],P[(i-w+n)%n])), b=smpNorm(smpSub(P[(i+w)%n],P[i]));
    const t=1-smpDot(a,b); if(t>best){ best=t; r0=i; }
  }
  const Q=P.slice(r0).concat(P.slice(0,r0));
  const offLine=(i,j)=>{
    const A=Q[i], D=smpSub(Q[j],A), L=smpLen(D); if(L<1e-9) return 0;
    let m=0, sum=0; for(let k=i+1;k<j;k++){ const v=smpSub(Q[k],A), sd=(v[0]*D[1]-v[1]*D[0])/L; sum+=sd; m=Math.max(m,Math.abs(sd)); }
    const bow=j-i>1?Math.abs(sum/(j-i-1)):0;
    return bow>SIMPLIFY_LINE_BOW_MM ? Infinity : m;
  };
  const runs=[];
  const minPts=Math.max(4,Math.round(SIMPLIFY_LINE_MIN_MM/sp));
  let i=0;
  while(i<n-minPts){
    let j=i+minPts;
    if(offLine(i,j)>SIMPLIFY_LINE_TOL_MM){ i++; continue; }
    let step=minPts;
    while(step>=1){ const t=j+step; if(t<n && offLine(i,t)<=SIMPLIFY_LINE_TOL_MM) j=t; else step>>=1; }
    runs.push([i,j]); i=j+1;
  }
  for(let k=runs.length-1;k>0;k--){
    const a=runs[k-1], b=runs[k];
    if(b[0]-a[1]<=Math.max(3,Math.round(0.3/sp)) && offLine(a[0],b[1])<=SIMPLIFY_LINE_TOL_MM){ a[1]=b[1]; runs.splice(k,1); }
  }
  if(!runs.length) return smpFitClosed(P,err);
  const R=runs.length;
  const dir=r=>smpNorm(smpSub(Q[r[1]],Q[r[0]]));
  const curvePts=k=>{ const r=runs[k], nx=runs[(k+1)%R], to=(k+1<R)?nx[0]:nx[0]+n, c=[]; for(let q=r[1];q<=to;q++) c.push(Q[q%n]); return c; };
  /* decide every corner first, because a fillet moves the ends of both edges */
  const corner=[];
  for(let k=0;k<R;k++){
    const r=runs[k], nx=runs[(k+1)%R];
    corner.push(smpFillet(Q[r[0]],dir(r),Q[nx[0]],Q[nx[1]],dir(nx),curvePts(k),err));
  }
  /* an edge must still have positive length after both its corners trim it */
  for(let k=0;k<R;k++){
    const pv=corner[(k-1+R)%R], cu=corner[k], r=runs[k], d=dir(r), A=Q[r[0]];
    const s0=pv?smpDot(smpSub(pv.T2,A),d):0, s1=cu?smpDot(smpSub(cu.T1,A),d):smpDot(smpSub(Q[r[1]],A),d);
    if(s1-s0<0.05){ if(cu&&(!pv||cu.r>=pv.r)) corner[k]=null; else corner[(k-1+R)%R]=null; }
  }
  const out=[];
  for(let k=0;k<R;k++){
    const r=runs[k], nx=runs[(k+1)%R], pv=corner[(k-1+R)%R], cu=corner[k], d=dir(r);
    const S=pv?pv.T2:Q[r[0]], E=cu?cu.T1:Q[r[1]], L=smpLen(smpSub(E,S));
    out.push([S, smpAdd(S,smpScl(d,L/3)), smpSub(E,smpScl(d,L/3)), E]);
    if(cu){ out.push(cu.seg); continue; }
    const cur=curvePts(k);
    if(cur.length<2) continue;
    if(cur.length===2){ const a=cur[0], b=cur[1], dd=smpLen(smpSub(b,a))/3;
      out.push([a, smpAdd(a,smpScl(d,dd)), smpSub(b,smpScl(dir(nx),dd)), b]); continue; }
    for(const sg of smpFitOpen(cur, err, d, smpScl(dir(nx),-1))) out.push(sg);
  }
  return out;
}
function simplifyTrace(ptsPx, pxPerMm){
  /* closed traced contour in pixels -> cubic segments [[p0,c1,c2,p3],...] in pixels */
  const n=ptsPx.length;
  if(n<8) return null;
  /* a zero or non-finite scale makes the smoothing window infinite and the loop never ends */
  if(!(pxPerMm>0) || !isFinite(pxPerMm)) return null;
  const mm=ptsPx.map(p=>[p[0]/pxPerMm,p[1]/pxPerMm]);
  let per=0; for(let i=1;i<n;i++) per+=smpLen(smpSub(mm[i],mm[i-1]));
  const h=Math.max(1,Math.round(SIMPLIFY_SMOOTH_MM/(per/n)/2));
  const sm=mm.map((_,i)=>{ let x=0,y=0; for(let k=-h;k<=h;k++){ const q=mm[(i+k+n)%n]; x+=q[0]; y+=q[1]; } return [x/(2*h+1),y/(2*h+1)]; });
  const segs=smpFitClosedLines(sm,SIMPLIFY_TOL_MM);
  if(!segs||!segs.length) return null;
  return segs.map(s=>s.map(p=>[p[0]*pxPerMm,p[1]*pxPerMm]));
}
function simplifyPathD(segs, map, dp){
  /* map: [x,y] px -> [X,Y] output units; dp: decimals */
  const f=v=>v.toFixed(dp==null?2:dp);
  const P=p=>{ const q=map(p); return f(q[0])+" "+f(q[1]); };
  let d="M"+P(segs[0][0]);
  for(const s of segs) d+=" C"+P(s[1])+" "+P(s[2])+" "+P(s[3]);
  return d+" Z";
}
/* ---------- /SIMPLIFY ---------- */
function traceContour(maskCanvas){
  const {width:w,height:h}=maskCanvas;
  const a=maskCanvas.getContext("2d").getImageData(0,0,w,h).data;
  const solid=(x,y)=> x>=0&&y>=0&&x<w&&y<h&&a[(y*w+x)*4+3]>128;
  let sx=-1,sy=-1;
  outer:
  for(let y=0;y<h;y++)for(let x=0;x<w;x++){
    if(solid(x,y)){ sx=x; sy=y; break outer; }
  }
  if(sx<0) return [];
  const dirs=[[-1,0],[-1,-1],[0,-1],[1,-1],[1,0],[1,1],[0,1],[-1,1]];
  const pts=[];
  let cx=sx, cy=sy, bi=0;
  const maxSteps=w*h*4;
  for(let step=0;step<maxSteps;step++){
    pts.push([cx,cy]);
    let found=false;
    for(let k=1;k<=8;k++){
      const di=(bi+k)%8;
      const nx=cx+dirs[di][0], ny=cy+dirs[di][1];
      if(solid(nx,ny)){
        bi=(di+6)%8;
        cx=nx; cy=ny;
        found=true;
        break;
      }
    }
    if(!found) break;
    if(cx===sx&&cy===sy&&pts.length>2) break;
  }
  return pts;
}
function rdp(pts,eps){
  if(pts.length<3) return pts;
  const keep=new Uint8Array(pts.length);
  keep[0]=keep[pts.length-1]=1;
  const stack=[[0,pts.length-1]];
  while(stack.length){
    const [i,j]=stack.pop();
    const [x1,y1]=pts[i],[x2,y2]=pts[j];
    const dx=x2-x1, dy=y2-y1;
    const len=Math.hypot(dx,dy)||1e-9;
    let mi=-1, md=0;
    for(let k=i+1;k<j;k++){
      const d=Math.abs(dy*pts[k][0]-dx*pts[k][1]+x2*y1-y2*x1)/len;
      if(d>md){ md=d; mi=k; }
    }
    if(md>eps){ keep[mi]=1; stack.push([i,mi],[mi,j]); }
  }
  return pts.filter((_,i)=>keep[i]);
}
/* maxCut (px, optional): the most a corner may be cut back along each edge. Plain
   chaikin cuts a quarter of EVERY edge, so a die-cut of a rectangular photo (border
   off, 5 points after rdp) lost 19 x 28 mm off each corner (27 Sep 2026, IMG_0329).
   Capped, long straight edges keep their corners and short pixel-staircase edges
   round exactly as before. */
function chaikin(pts,iter,maxCut){
  let p=pts;
  for(let t=0;t<iter;t++){
    const q=[];
    for(let i=0;i<p.length;i++){
      const A=p[i], B=p[(i+1)%p.length];
      let f=0.25;
      if(maxCut>0){ const len=Math.hypot(B[0]-A[0],B[1]-A[1]); if(len>0) f=Math.min(0.25, maxCut/len); }
      q.push([A[0]+(B[0]-A[0])*f, A[1]+(B[1]-A[1])*f]);
      q.push([A[0]+(B[0]-A[0])*(1-f), A[1]+(B[1]-A[1])*(1-f)]);
    }
    p=q;
  }
  return p;
}
function maskBBoxLongest(maskCanvas){
  const {width:w,height:h}=maskCanvas;
  const a=maskCanvas.getContext("2d").getImageData(0,0,w,h).data;
  let x0=w,x1=-1,y0=h,y1=-1;
  for(let y=0;y<h;y++)for(let x=0;x<w;x++){
    if(a[(y*w+x)*4+3]>128){
      if(x<x0)x0=x; if(x>x1)x1=x;
      if(y<y0)y0=y; if(y>y1)y1=y;
    }
  }
  if(x1<x0) return Math.max(w,h);
  return Math.max(x1-x0+1, y1-y0+1);
}
function saveBlob(blob,name){
  /* P170 (Thomas, 28 Sep, iPhone: "downloads are showing like this and I want it to show the image"): iPhone Safari
     sends every <a download> to its file screen (a grey PNG icon, "Open in..."). On an iPhone or iPad a PNG or JPEG is
     shown in the lab instead, full screen, with Save image (the share sheet: Save Image puts it in Photos). Cut files
     (SVG) and ZIPs still download as files; every other device downloads as before. */
  const iOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform==="MacIntel" && navigator.maxTouchPoints>1);
  if(iOS && blob && /^image\/(png|jpeg)$/.test(blob.type||"")){ try{ showImageSave(blob,name); return; }catch(e){ try{ const o=document.getElementById("plxImgSave"); if(o) o.remove(); console.warn("Proof Lab image view:", e && e.message); }catch(_){} } }
  const a=document.createElement("a");
  a.href=URL.createObjectURL(blob);
  a.download=name;
  a.click();
  setTimeout(()=>URL.revokeObjectURL(a.href),3000);
}
/* one design drawn in a finish, as a PNG data URL (the order screen's tiles and its tap-to-view; Thomas, 28 Sep:
   "order screen should update the thumbnail images with the desired finishes for viewing"). The live design's
   thumbnail survives the swap (withDoc's capture clears it, and nothing about it changed). */
function finishedPNG(i, fin, cap){
  if(!holoMod || !docs[i] || !(docs[i].art || i===activeIdx)) return null;
  const draw=()=>{
    buildScene();
    const sz=(typeof cutSizeMm==="function" && cutSizeMm()) ? cutSizeMm() : null;
    const mm=sz ? Math.max(sz.w,sz.h) : 75;
    const ms=Math.min(1, cap/Math.max(baseScene.width, baseScene.height));
    return holoMod.renderHolo(cutScene(),{ finish:lookOf(fin), borderPx:0, stickerWidthMm:mm, scale:ms }).toDataURL("image/png");
  };
  try{
    if(i===activeIdx) return draw();
    const a=activeIdx>=0 && docs[activeIdx], keep=a && a.thumb;
    const url=withDoc(i, draw);
    if(a && keep && !a.thumb) a.thumb=keep;
    return url;
  }catch(e){ console.warn("[proof-lab] finished view:",e&&e.message); return null; }
}
/* a full-screen look at one mock-up: its name, a close, and (order screen) an orange EDIT DESIGN (Thomas, 28 Sep:
   "we need to figure out how to go back to edit from the order screen" / "Perfect with edit in orange") */
function showImageView(url, name, onEdit){
  const old=document.getElementById("plxImgView"); if(old) old.remove();
  const dark=!!document.querySelector('.plx-panel[data-theme="dark"], proof-lab-tool[data-theme="dark"]');
  const bg=dark?"#1b1b1f":"#ffffff", ink=dark?"#f1f1f2":"#1a1a20", muted=dark?"#9a9aa2":"#6a6a74", line=dark?"#3a3a41":"#e9e9ee";
  const dots=dark?"radial-gradient(circle at 50% 50%,#35353c 1.2px,transparent 1.7px) 0 0/22px 22px,#232327":"radial-gradient(circle at 50% 50%,#ececf1 1.2px,transparent 1.7px) 0 0/22px 22px,#ffffff";
  const font="'Sapiens','SF Pro Text',-apple-system,BlinkMacSystemFont,sans-serif";
  const w=document.createElement("div"); w.id="plxImgView"; w.setAttribute("role","dialog"); w.setAttribute("aria-modal","true"); w.setAttribute("aria-label",name||"");
  w.style.cssText="position:fixed;inset:0;z-index:2147483600;display:flex;flex-direction:column;background:"+bg+";color:"+ink+";padding:max(12px,env(safe-area-inset-top)) 14px max(14px,env(safe-area-inset-bottom));overscroll-behavior:none;touch-action:none";
  w.innerHTML=
    '<div style="display:flex;align-items:center;gap:10px;min-height:44px">'+
      '<div data-name style="flex:1;min-width:0;font-family:'+font+';font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:'+muted+';white-space:nowrap;overflow:hidden;text-overflow:ellipsis"></div>'+
      '<button type="button" data-x aria-label="'+stkEsc(stkT("stk.studio.tool.close","Close"))+'" style="flex:none;width:44px;height:44px;border-radius:12px;border:1px solid '+line+';background:'+bg+';color:'+ink+';display:grid;place-items:center;padding:0;cursor:pointer;-webkit-appearance:none"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button>'+
    '</div>'+
    '<div style="flex:1;min-height:0;margin:10px 0 12px;border-radius:14px;background:'+dots+';display:flex;align-items:center;justify-content:center;padding:14px;overflow:hidden"><img alt="" style="max-width:100%;max-height:100%;object-fit:contain;display:block"></div>'+
    (onEdit ? '<button type="button" data-edit style="flex:none;min-height:49px;border:0;border-radius:10px;background:#e06a12;color:#fff;font-family:'+font+';font-size:15px;letter-spacing:1px;text-transform:uppercase;display:flex;align-items:center;justify-content:center;gap:10px;cursor:pointer;-webkit-appearance:none"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg><span></span></button>' : '');
  w.querySelector("[data-name]").textContent=name||"";
  w.querySelector("img").src=url;
  const de=document.documentElement, bd=document.body, was=[de.style.overflow, bd.style.overflow];
  de.style.overflow="hidden"; bd.style.overflow="hidden";
  w.addEventListener("touchmove",e=>{ if(e.cancelable) e.preventDefault(); },{passive:false});
  const close=()=>{ w.remove(); document.removeEventListener("keydown",onKey); de.style.overflow=was[0]; bd.style.overflow=was[1]; };
  const onKey=e=>{ if(e.key==="Escape") close(); };
  document.addEventListener("keydown",onKey);
  w.querySelector("[data-x]").addEventListener("click",close);
  const ed=w.querySelector("[data-edit]");
  if(ed){
    ed.querySelector("span").textContent=stkT("stk.studio.tool.edit_design","Edit design");
    ed.addEventListener("click",()=>{ close(); try{ onEdit(); }catch(e){} });
    ed.addEventListener("pointerdown",()=>{ ed.style.background="#c25a0c"; }); ["pointerup","pointercancel","pointerleave"].forEach(ev=>ed.addEventListener(ev,()=>{ ed.style.background="#e06a12"; }));
  }
  document.body.appendChild(w);
}
function showImageSave(blob,name){
  const old=document.getElementById("plxImgSave"); if(old) old.remove();
  const dark=!!document.querySelector('.plx-panel[data-theme="dark"], proof-lab-tool[data-theme="dark"]');
  const bg=dark?"#1b1b1f":"#ffffff", ink=dark?"#f1f1f2":"#1a1a20", muted=dark?"#9a9aa2":"#6a6a74", tile=dark?"#2e2e34":"#eff0f3", line=dark?"#3a3a41":"#e9e9ee";
  const dots=dark?"radial-gradient(circle at 50% 50%,#35353c 1.2px,transparent 1.7px) 0 0/22px 22px,#232327":"radial-gradient(circle at 50% 50%,#ececf1 1.2px,transparent 1.7px) 0 0/22px 22px,#ffffff";
  const url=URL.createObjectURL(blob), file=new File([blob],name,{type:blob.type});
  const canShare=!!(navigator.share && navigator.canShare && navigator.canShare({files:[file]}));
  const font="'Sapiens','SF Pro Text',-apple-system,BlinkMacSystemFont,sans-serif";
  const w=document.createElement("div"); w.id="plxImgSave"; w.setAttribute("role","dialog"); w.setAttribute("aria-modal","true"); w.setAttribute("aria-label",name);
  w.style.cssText="position:fixed;inset:0;z-index:2147483600;display:flex;flex-direction:column;background:"+bg+";color:"+ink+";padding:max(12px,env(safe-area-inset-top)) 14px max(14px,env(safe-area-inset-bottom))";
  w.innerHTML=
    '<div style="display:flex;align-items:center;gap:10px;min-height:44px">'+
      '<div data-name style="flex:1;min-width:0;font-family:'+font+';font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:'+muted+';white-space:nowrap;overflow:hidden;text-overflow:ellipsis"></div>'+
      '<button type="button" data-x aria-label="'+stkEsc(stkT("stk.studio.tool.close","Close"))+'" style="flex:none;width:44px;height:44px;border-radius:12px;border:1px solid '+line+';background:'+bg+';color:'+ink+';display:grid;place-items:center;padding:0;cursor:pointer;-webkit-appearance:none"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button>'+
    '</div>'+
    '<div style="flex:1;min-height:0;margin:10px 0 12px;border-radius:14px;background:'+dots+';display:flex;align-items:center;justify-content:center;padding:14px;overflow:hidden"><img alt="" style="max-width:100%;max-height:100%;object-fit:contain;display:block;-webkit-touch-callout:default"></div>'+
    '<button type="button" data-save style="flex:none;min-height:49px;border:0;border-radius:10px;background:#147f49;color:#fff;font-family:'+font+';font-size:15px;letter-spacing:1px;text-transform:uppercase;display:flex;align-items:center;justify-content:center;gap:10px;cursor:pointer;-webkit-appearance:none"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M5 21h14"/></svg><span></span></button>'+
    '<div data-hint style="flex:none;margin-top:10px;text-align:center;font-size:12.5px;color:'+muted+'"></div>';
  w.querySelector("[data-name]").textContent=name;
  w.querySelector("img").src=url;
  w.querySelector("[data-save] span").textContent=stkT("stk.studio.tool.save_image","Save image");
  w.querySelector("[data-hint]").textContent=stkT("stk.studio.tool.save_image_hint","Or press and hold the image to save it.");
  /* the page behind never scrolls while this is open (Thomas, 28 Sep: scrolling on the save screen let Safari's toolbar
     shrink and a gap open under Save image): overflow locked on html and body, and a drag on the screen itself moves
     nothing, so there is no rubber-band either. Press and hold on the image still works (it is not a move). */
  const de=document.documentElement, bd=document.body, was=[de.style.overflow, bd.style.overflow, de.style.overscrollBehavior];
  de.style.overflow="hidden"; bd.style.overflow="hidden"; de.style.overscrollBehavior="none";
  const noMove=e=>{ if(e.cancelable) e.preventDefault(); };
  w.addEventListener("touchmove",noMove,{passive:false});
  w.style.overscrollBehavior="none"; w.style.touchAction="none";
  const close=()=>{ w.remove(); setTimeout(()=>URL.revokeObjectURL(url),1000); document.removeEventListener("keydown",onKey);
    de.style.overflow=was[0]; bd.style.overflow=was[1]; de.style.overscrollBehavior=was[2]; };
  const onKey=e=>{ if(e.key==="Escape") close(); };
  document.addEventListener("keydown",onKey);
  w.querySelector("[data-x]").addEventListener("click",close);
  w.querySelector("[data-save]").addEventListener("click",()=>{
    if(canShare){ navigator.share({files:[file]}).catch(()=>{}); return; }
    const a=document.createElement("a"); a.href=url; a.download=name; a.click();
  });
  /* hover and press go darker, never lighter (Thomas, 27 Sep) */
  const sv=w.querySelector("[data-save]"); sv.addEventListener("pointerdown",()=>{ sv.style.background="#0f6a3c"; }); ["pointerup","pointercancel","pointerleave"].forEach(ev=>sv.addEventListener(ev,()=>{ sv.style.background="#147f49"; }));
  document.body.appendChild(w);
  try{ w.querySelector("[data-save]").focus({preventScroll:true}); }catch(e){}
}
function cutBBoxPx(){
  if(ownCut()) return cutLongestPx();      /* P215: exact, so the cut file's path is the size on the chip */
  if(traced()){
    const R=borderPx();
    return maskBBoxLongest(dilateMask(R));   // longest finished cut dimension
  }
  const d=shapeDims();
  return Math.max(d.sw,d.sh);              // circle/square/rect cut edge
}
function sceneMmPerPx(){
  const longestMm = widthMm();             // picked size = longest finished edge
  return longestMm / cutBBoxPx();
}
function printCanvas(withBleed){
  let scene;
  if(withBleed) scene=buildExportScene();
  else { buildScene(); scene=baseScene; }
  const mmpp=sceneMmPerPx();
  const dpi=exportDpi(scene.width, scene.height, mmpp);
  const targetW=Math.round(scene.width*mmpp/25.4*dpi);
  const targetH=Math.round(scene.height*mmpp/25.4*dpi);
  const out=mk(targetW,targetH);
  const x=out.getContext("2d");
  x.imageSmoothingQuality="high";
  x.drawImage(scene,0,0,targetW,targetH);
  // Scaling the scene resamples the hardened outline and softens it straight back into
  // a partial-alpha ramp - the grey rim returns in the PNG while the SVG stays clean.
  // Re-apply the hardened silhouette instead of thresholding the whole composite, so a
  // customer's own semi-transparent artwork is left alone. AI/_rules/LAB-RULES.md rules 2 and 3.
  try {
    if(withBleed && lastBleedMask && lastBleedBB && lastBleedStamp===docStamp
       && lastBleedBB.w===scene.width && lastBleedBB.h===scene.height){
      const m=mk(targetW,targetH), mx=m.getContext("2d");
      mx.imageSmoothingEnabled=false;
      /* drawImage's dx/dy are DESTINATION pixels. lastBleedBB is measured on the
         working canvas, so the offset has to be scaled by the same factor as the
         mask itself. Unscaled it lands off-register by bb*(k-1) and destination-in
         erases a band of real artwork off the right and bottom of every export.
         Measured on a live order 24 Aug 2026: 14px (1.2mm) missing on one file,
         35px (3.0mm) on another; the cut path was unaffected, which is why it read
         as "cut is right, artwork has bits missing". AI/_rules/LAB-RULES.md rules 3 and 4. */
      const kx=targetW/scene.width, ky=targetH/scene.height;
      mx.drawImage(lastBleedMask,-lastBleedBB.x*kx,-lastBleedBB.y*ky,
                   lastBleedMask.width*kx,
                   lastBleedMask.height*ky);
      hardenAlpha(m);
      x.globalCompositeOperation="destination-in";
      x.drawImage(m,0,0);
      x.globalCompositeOperation="source-over";
      /* Measurement, not an eyeball. The export scene is cropped to the bleed
         silhouette's own bounding box, so a correct print canvas is opaque out to
         all four edges. Anything short of that means the silhouette landed
         off-register and ate artwork. AI/_rules/LAB-RULES.md rule 4. */
      try{
        const bbChk=maskBBox(out);
        if(bbChk.x>1||bbChk.y>1||bbChk.w<targetW-1||bbChk.h<targetH-1)
          console.error("BLEED CLIPPED - artwork bbox",bbChk,"in",targetW+"x"+targetH,
                        "(expected 0,0,"+targetW+","+targetH+")");
      }catch(e){}
    }
  } catch(e){ console.warn("silhouette re-apply skipped:",e); }
  return {out,scene,mmpp};
}
function svgPathFromMask(maskCanvas,mmpp){
  let pts=traceContour(maskCanvas);
  if(pts.length<3) return "";
  const f=v=>(v*mmpp).toFixed(2);
  const R=refineContour(pts, pxPerMm());
  if(R.rect) return rectPathD(R.rect, f);   // real arcs, so nothing downstream re-rounds it
  /* Simplify (P136), as in svgPathFromMaskOff: RAW trace, px per mm = 1/mmpp */
  const segs=simplifyTrace(pts, 1/mmpp);
  if(segs) return simplifyPathD(segs, p=>[p[0]*mmpp,p[1]*mmpp], 2);
  pts=R.pts;
  let d="M"+f(pts[0][0])+" "+f(pts[0][1]);
  for(let i=1;i<pts.length;i++) d+="L"+f(pts[i][0])+" "+f(pts[i][1]);
  return d+"Z";
}

/* ================= design system (ported verbatim from Bookmark Creator) ================= */
function hslToHex(h,sat,l){
  sat/=100; l/=100;
  const k=n=>(n+h/30)%12;
  const a=sat*Math.min(l,1-l);
  const f=n=>l-a*Math.max(-1,Math.min(k(n)-3,Math.min(9-k(n),1)));
  const to=v=>Math.max(0,Math.min(255,Math.round(v*255))).toString(16).padStart(2,"0");
  return "#"+to(f(0))+to(f(8))+to(f(4));
}
function hexToHsl(hex){
  const m=/^#?([0-9a-f]{6})$/i.exec(hex); if(!m) return null;
  const n=parseInt(m[1],16);
  const r=((n>>16)&255)/255, g=((n>>8)&255)/255, b=(n&255)/255;
  const mx=Math.max(r,g,b), mn=Math.min(r,g,b), d=mx-mn;
  let h=0, sv=0; const l=(mx+mn)/2;
  if(d>0){
    sv = l>0.5 ? d/(2-mx-mn) : d/(mx+mn);
    if(mx===r) h=((g-b)/d+(g<b?6:0)); else if(mx===g) h=(b-r)/d+2; else h=(r-g)/d+4;
    h*=60;
  }
  return {h, s:sv*100, l:l*100};
}
function printSafe(hex){
  const c=hexToHsl(hex); if(!c) return hex;
  if(c.s<5) return hex.toLowerCase();
  const sat=Math.min(c.s,78), l=Math.max(16,Math.min(93,c.l));
  if(sat===c.s && l===c.l) return hex.toLowerCase();
  return hslToHex(c.h,sat,l);
}
function lighten(hex){
  const m=/^#?([0-9a-f]{6})$/i.exec(hex); if(!m) return hex;
  const n=parseInt(m[1],16);
  let r=((n>>16)&255)/255, g=((n>>8)&255)/255, b=(n&255)/255;
  const mx=Math.max(r,g,b), mn=Math.min(r,g,b), d=mx-mn;
  let h=0, s=0, l=(mx+mn)/2;
  if(d>0){
    s = l>0.5 ? d/(2-mx-mn) : d/(mx+mn);
    if(mx===r) h=((g-b)/d+(g<b?6:0));
    else if(mx===g) h=(b-r)/d+2;
    else h=(r-g)/d+4;
    h/=6;
  }
  // raise lightness toward a pastel, keep most of the saturation
  l = l + (1-l)*0.75;
  /* 27 Sep 2026 (Thomas: swatches shown as empty rings, "when i click black i get green", a hex
     reading #10bd5b0): s*1.5 ran past 1, the channels past 255, and toString(16) made 7-8 char
     strings that CSS and the canvas ignore, so the click kept the previous colour. Clamped. */
  s = Math.min(1, s*1.5);
  const hue=(p,q,t)=>{ if(t<0)t+=1; if(t>1)t-=1; if(t<1/6)return p+(q-p)*6*t; if(t<1/2)return q; if(t<2/3)return p+(q-p)*(2/3-t)*6; return p; };
  let R,G,B;
  if(s===0){ R=G=B=l; }
  else{
    const q=l<0.5?l*(1+s):l+s-l*s, p=2*l-q;
    R=hue(p,q,h+1/3); G=hue(p,q,h); B=hue(p,q,h-1/3);
  }
  const h2=v=>Math.max(0,Math.min(255,Math.round(v*255))).toString(16).padStart(2,"0");
  return "#"+h2(R)+h2(G)+h2(B);
}
/* Thomas, 18 Sep: "this wheel just isnt useful at all, the colours are terrible it would be better
   to replace them with something like this but horizontal", with the macOS Colours spectrum panel
   as the reference. Twelve fixed segments is a palette, not a picker: it cannot reach most colours.
   This is a continuous spectrum, hue across, white to colour to black down, drag to choose, with a
   crosshair on the current colour. The old wheel is kept below, unused, in case he wants it back. */
function buildSpectrum(onpick, applyRaw, current){
  const wrap=document.createElement("div"); wrap.className="spectrum";
  const cv=document.createElement("canvas");
  const W=248, H=132;
  cv.width=W*2; cv.height=H*2;   /* drawn at 2x so it stays sharp */
  cv.style.width=W+"px"; cv.style.height=H+"px"; cv.className="spectrum__cv";
  const g=cv.getContext("2d");
  for(let x=0;x<cv.width;x++){
    const hue=x/cv.width*360;
    const col=g.createLinearGradient(0,0,0,cv.height);
    col.addColorStop(0,"#ffffff");
    col.addColorStop(0.5,hslToHex(hue,100,50));
    col.addColorStop(1,"#000000");
    g.fillStyle=col; g.fillRect(x,0,1,cv.height);
  }
  const dot=document.createElement("span"); dot.className="spectrum__dot";
  const place=(hex)=>{
    const c=hexToHsl(hex); if(!c) return;
    const x=Math.max(0,Math.min(1,c.h/360))*W;
    const y=(c.l>=50 ? (1-(c.l-50)/50)*0.5 : 0.5+(1-c.l/50)*0.5)*H;
    dot.style.left=(x/W*100)+"%"; dot.style.top=(y/H*100)+"%";   /* the pad is fluid (22 Oct 2026): the crosshair sits by share, not by px */
  };
  const at=(ev)=>{
    const r=cv.getBoundingClientRect();
    const px=Math.max(0,Math.min(r.width-1, (ev.touches?ev.touches[0].clientX:ev.clientX)-r.left));
    const py=Math.max(0,Math.min(r.height-1,(ev.touches?ev.touches[0].clientY:ev.clientY)-r.top));
    const d=g.getImageData(Math.min(cv.width-1,Math.round(px*cv.width/r.width)),Math.min(cv.height-1,Math.round(py*cv.height/r.height)),1,1).data;   /* read at the drawn size, whatever the pad's width */
    const h2=n=>Math.max(0,Math.min(255,n)).toString(16).padStart(2,"0");
    dot.style.left=(px/r.width*100)+"%"; dot.style.top=(py/r.height*100)+"%";
    return "#"+h2(d[0])+h2(d[1])+h2(d[2]);
  };
  /* P172 (30 Sep 2026): the canvas captures the pointer and the drag ends on the colour it last applied, so a spectrum
     rebuilt mid-drag can never commit a colour read from a detached canvas (the solid colour reset). One undo step per
     drag, back to the colour before it (the old end snapshot was taken after the drag, so Undo did nothing), and no
     window listener left behind by every redraw. */
  let dragging=false, last=null, before=null;
  const down=ev=>{ dragging=true; ev.preventDefault(); try{ cv.setPointerCapture(ev.pointerId); }catch(e){}
    before=snapBefore(); last=at(ev); applyRaw(last); };
  const move=ev=>{ if(dragging){ ev.preventDefault(); last=at(ev); applyRaw(last); } };
  const up=()=>{ if(!dragging) return; dragging=false; if(last) pushUndo(before); last=before=null; };
  cv.addEventListener("pointerdown",down); cv.addEventListener("pointermove",move);
  ["pointerup","pointercancel","lostpointercapture"].forEach(t=>cv.addEventListener(t,up));
  wrap._place=hex=>{ if(!dragging) place(hex); };   /* markSwatch moves the crosshair to a colour picked elsewhere */
  wrap.appendChild(cv); wrap.appendChild(dot);
  place(current||"#ffffff");
  return wrap;
}
function buildColourWheel(onpick, applyRaw){
  const wrap=document.createElement("div"); wrap.className="wheelbox";
  const NS="http://www.w3.org/2000/svg";
  const svg=document.createElementNS(NS,"svg");
  svg.setAttribute("viewBox","-56 -56 112 112");
  svg.setAttribute("width","112"); svg.setAttribute("height","112");   /* v2.9.2 (R1): every inline SVG carries a size */
  svg.setAttribute("class","wheel");
  const COLS=["#ffc40c","#f7941d","#f15a24","#d64541","#f4907e","#a463f2","#6c3ce0","#2c5aa0","#17839c","#0f9d58","#a9dcc0","#b8e061"];
  const OUTER=[52,47,50,46,51,47,49,46,52,47,50,46];
  const R0=31;
  const segPath=(r0,r1,a0,a1)=>{
    const p=(r,a)=>[r*Math.cos(a),r*Math.sin(a)];
    const [x0,y0]=p(r1,a0),[x1,y1]=p(r1,a1),[x2,y2]=p(r0,a1),[x3,y3]=p(r0,a0);
    return `M${x0.toFixed(2)} ${y0.toFixed(2)}A${r1} ${r1} 0 0 1 ${x1.toFixed(2)} ${y1.toFixed(2)}L${x2.toFixed(2)} ${y2.toFixed(2)}A${r0} ${r0} 0 0 0 ${x3.toFixed(2)} ${y3.toFixed(2)}Z`;
  };
  COLS.forEach((raw,i)=>{
    const col=printSafe(raw);
    const a0=(i*30-90)*Math.PI/180, a1=((i+1)*30-90)*Math.PI/180;
    const path=document.createElementNS(NS,"path");
    path.setAttribute("d",segPath(R0,OUTER[i],a0,a1));
    path.setAttribute("fill",col);
    path.addEventListener("click",()=>onpick(col));
    svg.appendChild(path);
  });
  wrap.appendChild(svg);
  const centre=document.createElement("div"); centre.className="wheelcentre";
  const dot=(bg,title,fn,cls)=>{
    const d=document.createElement("div");
    d.className="wheeldot"+(cls?" "+cls:""); d.title=title;
    if(bg) d.style.background=bg;
    d.onclick=fn; return d;
  };
  centre.appendChild(dot("#1a1a20",stkT("stk.studio.colour.black","Black"),()=>onpick("#1a1a20")));
  const nat=document.createElement("input"); nat.type="color";
  nat.style.cssText="position:absolute;opacity:0;width:1px;height:1px;pointer-events:none";
  /* live preview on every drag tick (no undo push), one push when the OS
     picker commits - snapshotting the colour from before the drag began. */
  let dragBefore=null;
  nat.addEventListener("input",()=>{
    if(dragBefore===null) dragBefore=snapBefore();
    applyRaw(nat.value);
  });
  nat.addEventListener("change",()=>{
    if(dragBefore!==null){ pushUndo(dragBefore); dragBefore=null; }
  });
  const spec=dot(null,stkT("stk.studio.colour.all","All colours"),()=>nat.click(),"wheeldot--spec");
  spec.appendChild(nat);
  centre.appendChild(spec);
  centre.appendChild(dot("#ffffff",stkT("stk.studio.colour.white","White"),()=>onpick("#ffffff")));
  wrap.appendChild(centre);
  return wrap;
}
function eyedropSwatch(onpick){
  if(!window.EyeDropper) return null;
  const d=document.createElement("div");
  d.className="sw eyedrop"; d.title=stkT("stk.studio.colour.eyedrop","Pick a colour from anywhere on screen");
  d.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m2 22 1-1h3l9-9"/><path d="M3 21v-3l9-9"/><path d="m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z"/></svg>';
  d.onclick=()=>{ new EyeDropper().open().then(r=>onpick(r.sRGBHex)).catch(()=>{}); };
  return d;
}
/* Thomas, 18 Sep: "i would also like the second gradient colours to adapt to the first selection,
   so include artwork colours but also give me lighter and darker version of the selected colour".
   `relate` is that colour: the TO row gets five steps of it either side of the artwork palette. */
function rampOf(hex){
  const t=safeHex(hex,""); if(!t) return [];
  const rgb=hexRgb(t), out=[];
  [0.75,0.5,0.25].forEach(k=>out.push(mixHex(t,"#ffffff",k)));
  [0.25,0.5].forEach(k=>out.push(mixHex(t,"#000000",k)));
  return out;
}
function mixHex(a,b,k){
  const A=hexRgb(safeHex(a,"#000000")), B=hexRgb(safeHex(b,"#000000"));
  const h=n=>Math.max(0,Math.min(255,Math.round(n))).toString(16).padStart(2,"0");
  return "#"+h(A[0]+(B[0]-A[0])*k)+h(A[1]+(B[1]-A[1])*k)+h(A[2]+(B[2]-A[2])*k);
}
function toPick(c){ opts.bgTo=c; markSwatch(bgToHostEl(), c); render(); }
function bgToHostEl(){ try{ return $("bgToHost"); }catch(e){ return null; } }
function markSwatch(host, c){
  if(!host) return;
  const t=String(c||"").toLowerCase();
  host.querySelectorAll(".sw").forEach(el=>{
    if(el.classList.contains("custom")) return;
    const bg=(el.style.background||"").toLowerCase();
    el.classList.toggle("on", bg===t || bg===hexRgbCss(t));
  });
  const dot=host.querySelector(".swfoot__dot"); if(dot) dot.style.background=c;
  const hx=host.querySelector(".hexin"); if(hx) hx.value=c;
  const sp=host.querySelector(".spectrum"); if(sp && sp._place) sp._place(c);
}
function hexRgbCss(t){ const v=hexRgb(t); return v?("rgb("+v[0]+", "+v[1]+", "+v[2]+")"):""; }
function buildSwatchHost(host, current, onpick, withArtwork, relate){
  /* applyRaw: pure apply (mutate + rerender), no undo push - safe to call
     repeatedly while dragging. commitPick: one push per click/commit, used
     everywhere except the native colour input's live drag ticks. */
  /* shown: the colour chosen now (P172: no host is rebuilt after a pick any more, so a bad hex entry goes back to
     this, not to the colour the host was built with) */
  let shown=current;
  const applyRaw=c=>{ shown=printSafe(c); onpick(shown); };
  const commitPick=c=>{ const before=snapBefore(); applyRaw(c); pushUndo(before); };
  host.innerHTML="";
  /* one flat grid: basics, then artwork colours, then their tints - no sub-labels.
     Last circle opens the full colour picker; a hex readout sits below. */
  let cols=[...BASICS];
  if(withArtwork && palette.length) cols=cols.concat(palette, paletteLight);
  if(relate) cols=cols.concat(rampOf(relate));
  const seen=new Set();
  cols=cols.filter(c=>{ const k=c.toLowerCase(); if(seen.has(k)) return false; seen.add(k); return true; });
  /* P170 (Thomas, 28 Sep: the gradient pickers are "a grid of 9-12 colours"): with a small artwork
     palette the gradient grids are topped up to 10 with the brand rainbow and two greys */
  if(host && (host.id==="bgFromHost" || host.id==="bgToHost") && cols.length<10){
    ["#f0513c","#f78d28","#ffc707","#5dba68","#4b8dc8","#5f4c9f","#8a8a95","#d9dade"].forEach(c=>{ if(cols.length<10 && !seen.has(c)){ seen.add(c); cols.push(c); } });
  }
  const row=document.createElement("div"); row.className="swatches";
  cols.forEach(col=>{
    const s=document.createElement("div");
    s.className="sw"+(col.toLowerCase()===current.toLowerCase()?" on":"");
    s.style.background=col; s.onclick=()=>commitPick(col);
    row.appendChild(s);
  });
  const wheelWrap=document.createElement("div"); wheelWrap.className="wheelwrap";
  wheelWrap.style.display = openWheels.has(host.id) ? "" : "none";
  wheelWrap.appendChild(buildSpectrum(commitPick, applyRaw, current));
  const cust=document.createElement("div"); cust.className="sw custom"; cust.title=stkT("stk.studio.colour.wheel","Colour wheel");
  cust.onclick=()=>{
    const open=wheelWrap.style.display==="none";
    wheelWrap.style.display=open?"":"none";
    if(open) openWheels.add(host.id); else openWheels.delete(host.id);
  };
  row.appendChild(cust);
  const eye=eyedropSwatch(commitPick); if(eye) row.appendChild(eye);
  host.appendChild(row);
  host.appendChild(wheelWrap);
  const foot=document.createElement("div"); foot.className="swfoot";
  const dot=document.createElement("span"); dot.className="swfoot__dot"; dot.style.background=current;
  const hex=document.createElement("input");
  hex.className="hexin"; hex.value=current; hex.placeholder="#FFFFFF"; hex.maxLength=7; hex.spellcheck=false;
  hex.addEventListener("change",()=>{
    let v=hex.value.trim(); if(!v.startsWith("#")) v="#"+v;
    if(/^#[0-9a-fA-F]{6}$/.test(v)) commitPick(v.toLowerCase()); else hex.value=shown;
  });
  foot.appendChild(dot); foot.appendChild(hex);
  host.appendChild(foot);
}
function segmentizeRange(r){
  if(r._segfill) return;
  const metaSpan=r.parentNode ? r.parentNode.querySelector(".range-meta span:nth-child(2)") : null;
  const wrap=document.createElement("div"); wrap.className="segslider";
  r.parentNode.insertBefore(wrap,r);
  const badge=document.createElement("div"); badge.className="segslider__val";
  const track=document.createElement("div"); track.className="segslider__track";
  const bar=document.createElement("div"); bar.className="segbar";
  const fill=document.createElement("div"); fill.className="segbar__fill";
  bar.appendChild(fill); track.appendChild(bar);
  wrap.appendChild(badge); wrap.appendChild(track);
  /* the title sits above the bar, right-aligned, so the bar keeps full width */
  const lbl=r.parentNode.querySelector("label.lbl-sub,.lbl-sub");
  if(lbl) lbl.classList.add("segslider__lbl");
  track.appendChild(r);
  r._segfill=fill; r._segbadge=badge; r._segmeta=metaSpan;
}
function updateSeg(r){
  if(!r._segfill) return;
  const min=+r.min||0, max=+r.max||100, v=+r.value;
  const pct=Math.max(0,Math.min(1,(v-min)/(max-min)));
  r._segfill.style.width=(pct*100).toFixed(1)+"%";
  r._segbadge.textContent = r._segmeta ? r._segmeta.textContent : r.value;
}
function crc32(bytes){
  let c, crc=0xFFFFFFFF;
  for(let i=0;i<bytes.length;i++){
    c=(crc^bytes[i])&0xFF;
    for(let k=0;k<8;k++) c = c&1 ? (c>>>1)^0xEDB88320 : c>>>1;
    crc=(crc>>>8)^c;
  }
  return (crc^0xFFFFFFFF)>>>0;
}
function makeZip(files){
  // files: [{name, bytes:Uint8Array}]
  const enc=new TextEncoder();
  const chunks=[]; const central=[]; let offset=0;
  const u16=v=>new Uint8Array([v&255,(v>>8)&255]);
  const u32=v=>new Uint8Array([v&255,(v>>8)&255,(v>>16)&255,(v>>24)&255]);
  for(const f of files){
    const nameB=enc.encode(f.name);
    const crc=crc32(f.bytes), sz=f.bytes.length;
    const local=[].concat(
      [...u32(0x04034b50)],[...u16(20)],[...u16(0)],[...u16(0)],
      [...u16(0)],[...u16(0)],            // time/date
      [...u32(crc)],[...u32(sz)],[...u32(sz)],
      [...u16(nameB.length)],[...u16(0)]
    );
    const localHead=new Uint8Array(local);
    chunks.push(localHead, nameB, f.bytes);
    const cen=[].concat(
      [...u32(0x02014b50)],[...u16(20)],[...u16(20)],[...u16(0)],[...u16(0)],
      [...u16(0)],[...u16(0)],
      [...u32(crc)],[...u32(sz)],[...u32(sz)],
      [...u16(nameB.length)],[...u16(0)],[...u16(0)],
      [...u16(0)],[...u16(0)],[...u32(0)],
      [...u32(offset)]
    );
    central.push({head:new Uint8Array(cen), name:nameB});
    offset += localHead.length + nameB.length + f.bytes.length;
  }
  const cstart=offset; let csize=0;
  for(const c of central){ chunks.push(c.head, c.name); csize+=c.head.length+c.name.length; }
  const end=[].concat(
    [...u32(0x06054b50)],[...u16(0)],[...u16(0)],
    [...u16(central.length)],[...u16(central.length)],
    [...u32(csize)],[...u32(cstart)],[...u16(0)]
  );
  chunks.push(new Uint8Array(end));
  return new Blob(chunks,{type:"application/zip"});
}
function dbTx(mode,fn){
  return new Promise((res,rej)=>{
    const q=indexedDB.open("stickiply-proof-lab",1);
    q.onupgradeneeded=()=>{ q.result.createObjectStore("designs",{keyPath:"id"}); };
    q.onerror=()=>rej(q.error);
    q.onsuccess=()=>{
      const tx=q.result.transaction("designs",mode), st=tx.objectStore("designs");
      const out=fn(st);
      tx.oncomplete=()=>res(out ? out.result : undefined);
      tx.onerror=()=>rej(tx.error);
    };
  });
}

/* Add to cart (lab-cart shared module), only when the section turns it on. Reuses the
   tool's own docs/opts/captureDoc/loadDocGlobals/buildArtworkFiles unchanged.
   Property map, v2 (P158, 24 Sep 2026, Thomas's decision): per design two lines,
   "Artwork N · {qty} × {name}" whose value is ONE zip holding that design's print PNG and cut
   SVG as buildArtworkFiles() makes them (names made file-safe, repeats numbered), then
   "Artwork N size" underneath; nothing else except any _stk_* quote keys (Thomas: "no need
   at all for designs4 tool proof lab all that shit"). No preview file. The full schema is in
   lab-cart.js ("LabCart v2"). It replaces the 12 Sep map (print PNGs -> "Artwork Upload (1..4)",
   cut SVGs -> "_cut_1..4", previews -> "_Preview"/"_Preview_2..4"), which every order placed
   before this keeps, so the readers keep that branch. Dispatch's artworkUrlOf takes the first
   http property, now design 1's zip.
   Guards, built in the same pass: G1 every design's zip is checked (one PNG, one SVG, STORE,
   sizes match), uploaded, and HEAD-checked at its public URL, or it throws before /cart/add.js
   (the 12 Sep code dropped a failed cut upload silently); G2 strictVariant re-checks every
   option value, no fallback variant id ever; G3 refuses with zero network calls when there is
   no design, too many designs, no variant, a sold-out variant or no rights tick. */
/* ===== P170 (27 Sep 2026): DOWNLOADS, THE STANDALONE PAGE'S THIRD STEP =====================
   Thomas: "make proof lab look like studio ... the order page will just turn into a 'downloads'
   page". With no cart the sheet's third step is DOWNLOADS: the download card that sat under the
   tool moves into it (same nodes, same ids, same handlers), the foot carries NEXT and DOWNLOADS
   the way the product page carries NEXT and ORDER, and on the DOWNLOADS step the foot's black
   button is the ZIP. The card's badges and green block become rows (proof-lab.css .dlcard--pane). */
(function initDownloads(){
  const host=root.host;
  if(!host || host.dataset.cart==="1") return;
  const card=root.querySelector(".dlcard"), mount=root.getElementById("cartMount"), step3=root.getElementById("step3"), foot=root.getElementById("cartFoot");
  if(!card||!mount||!step3||!foot) return;
  const T_DL=stkT("stk.studio.tool.step_downloads","Downloads");
  const t3=step3.querySelector(".step__t"); if(t3) t3.textContent=T_DL;
  /* Thomas, 28 Sep 00:20: "none of this is my design" - the DOWNLOADS step is built from the ORDER
     step's own parts: the design tiles (.ogrid/.oq), a titled FINISH chip grid with a free mock up
     download under it, the files as quantity-style rows, and the big green foot button for the ZIP.
     The old download card stays in the DOM, hidden, so its handlers do the work. Finishes are the
     product page's three (holographic is not finished as a finish yet). */
  card.hidden=true; card.style.display="none";
  mount.appendChild(card);
  const zip=root.getElementById("dlZip");
  const FIN=[["matte",stkT("stk.p172.proof_lab.finish_matte","Matte")],["gloss",stkT("stk.p172.proof_lab.finish_gloss","Glossy")],["glitter",stkT("stk.p172.proof_lab.finish_glitter","Glitter")]];
  const DOWN='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/><path d="M12 15V3"/></svg>';
  const ARROW='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>';
  const ADD='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m17 8-5-5-5 5"/><path d="M12 3v12"/></svg>';
  const X='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
  const box=document.createElement("div"); box.className="dlx"; mount.insertBefore(box, card);
  /* Thomas, 28 Sep 01:05: "make the finishes 3 tiles across ... visual circles": each circle is the
     finish's own texture (the renderer's gloss and glitter maps); matte is the flat vinyl */
  /* the circles are drawn by the finish renderer itself (a plain vinyl disc through renderHolo), so each
     shows the real matte / gloss sheen / glitter sparkle; until it loads, a CSS stand-in */
  const finImg={};
  const finStyle=k=>finImg[k]?' style="background:url('+finImg[k]+') center/cover no-repeat"':'';
  function paintFinishes(){
    if(!holoMod || finImg.matte) return;
    try{
      FIN.forEach(f=>{
        /* drawn at the circle's own device size (34 css px x2): a bigger canvas scaled down averages the sparkle away */
        const S=72, c=document.createElement("canvas"); c.width=S; c.height=S;
        /* glitter needs to read at 34px (Thomas, 28 Sep 01:25): a mid-grey disc and the sparkle drawn as if
           the disc were 6 mm across, so each flake is big enough to see; matte and gloss at 16 mm */
        const x=c.getContext("2d"); x.fillStyle=f[0]==="glitter"?"#8f929b":"#c9cbd2"; x.beginPath(); x.arc(S/2,S/2,S/2-2,0,Math.PI*2); x.fill();
        const out=holoMod.renderHolo(c,{ finish:lookOf(f[0]), borderPx:0, stickerWidthMm:(f[0]==="glitter"?2.5:10), scale:1 });
        const o=document.createElement("canvas"); o.width=S; o.height=S;
        o.getContext("2d").drawImage(out, (S-out.width)/2, (S-out.height)/2);
        finImg[f[0]]=o.toDataURL("image/png");
      });
    }catch(e){ console.warn("[proof-lab] finish circles:",e&&e.message); }
    if(finImg.matte) draw();
  }
  /* Thomas, 28 Sep 00:55: "i still want the icons": the old card's own icons, in their tint tiles */
  const icOf=id=>{ const e=root.getElementById(id), i=e&&e.querySelector(".dl__ic"); return i?i.innerHTML:""; };
  const IC={ cut:icOf("dlCut"), print:icOf("dlPrint"), mock:icOf("dlProof") };
  const stepNo=()=>{ for(const i of [1,2,3]){ const el=root.getElementById("step"+i); if(el && !el.hidden && !el.classList.contains("collapsed")) return i; } return 0; };
  function tiles(){
    try{
      docs.forEach((d,i)=>{ if(d && !d.thumb && d.art && i!==activeIdx) withDoc(i,()=>{ d.thumb=docThumbPNG(); }); });
      if(activeIdx>=0 && docs[activeIdx] && !docs[activeIdx].thumb && art) docs[activeIdx].thumb=docThumbPNG();
    }catch(e){}
    let cells="";
    docs.forEach((d,i)=>{
      cells+='<div class="oq is-filled'+(i===activeIdx?" on":"")+'" data-dli="'+i+'" role="button" tabindex="0" aria-label="'+stkEsc(stkT("stk.studio.design.edit_aria","Edit this design"))+'">'+
        '<span class="oq__n">'+(i+1)+'</span>'+
        '<button type="button" class="oq__x" data-dlx="'+i+'" aria-label="'+stkEsc(stkT("stk.studio.design.remove_aria","Remove this design"))+'">'+X+'</button>'+
        (d.thumb?'<img class="oq__th" alt="" src="'+d.thumb+'">':'<span class="oq__th"></span>')+
        '<span class="oq__nm">'+stkEsc(d.artName||stkFmt(stkT("stk.studio.design.n","Design [n]"),{n:i+1}))+'</span></div>';
    });
    cells+='<button type="button" class="oq is-empty" data-dladd aria-label="'+stkEsc(stkT("stk.studio.design.add","Add a design"))+'"><span class="oq__ic">'+ADD+'</span><span class="oq__addtx"><span class="oq__add">'+stkEsc(stkT("stk.studio.design.add","Add a design"))+'</span></span></button>';
    return '<div class="ogrid">'+cells+'</div>';
  }
  /* Thomas, 28 Sep 01:50: "that tile on the right next to the heart should be the grid shortcut", and under
     the one image and the grid, "5 selected" */
  const GRID='<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';
  function oneTile(){
    const i=activeIdx, d=docs[i]; if(!d) return "";
    try{ if(!d.thumb && art) d.thumb=docThumbPNG(); }catch(e){}
    return '<div class="ogrid">'+
      '<div class="oq is-filled on" data-dli="'+i+'" role="button" tabindex="0" aria-label="'+stkEsc(stkT("stk.studio.design.edit_aria","Edit this design"))+'">'+
        '<span class="oq__n">'+(i+1)+'</span>'+
        '<button type="button" class="oq__x" data-dlx="'+i+'" aria-label="'+stkEsc(stkT("stk.studio.design.remove_aria","Remove this design"))+'">'+X+'</button>'+
        (d.thumb?'<img class="oq__th" alt="" src="'+d.thumb+'">':'<span class="oq__th"></span>')+
        '<span class="oq__nm">'+stkEsc(d.artName||stkFmt(stkT("stk.studio.design.n","Design [n]"),{n:i+1}))+'</span></div>'+
      '<button type="button" class="oq is-empty" data-dlgrid aria-label="'+stkEsc(stkT("stk.studio.tool.all_designs","All designs"))+'"><span class="oq__ic">'+GRID+'</span><span class="oq__addtx"><span class="oq__cnt">'+stkEsc(stkFmt(stkT(docs.length===1?"stk.studio.dl.designs_one":"stk.studio.dl.designs_n",docs.length===1?"[count] design":"[count] designs"),{count:docs.length}))+'</span></span></button>'+
      '</div>';
  }
  function draw(){
    const ready=!!(zip && !zip.disabled);
    /* Thomas, 28 Sep 01:40: "why we're showing all stickers in the download panel when we have a grid view
       for this exact reason": no design tiles here; the tabs and the grid view pick the design */
    const nSel=selectedTileIdxs().length;
    box.innerHTML=oneTile()+(nSel?'<div class="dlx__sel">'+stkEsc(stkFmt(stkT("stk.studio.dl.selected","[count] selected"),{count:nSel}))+'</div>':'')+
      '<div class="lbl-sub dlx__t">'+stkEsc(stkT("stk.p172.proof_lab.finish","Finish"))+'</div>'+
      '<div class="dlx__chips" role="radiogroup">'+FIN.map(f=>'<button type="button" role="radio" aria-checked="'+(orderFinish===f[0])+'" class="dlx__chip'+(orderFinish===f[0]?" on":"")+'" data-dlf="'+f[0]+'"><span class="finsw finsw--'+f[0]+'"'+finStyle(f[0])+'></span>'+stkEsc(f[1])+'</button>').join("")+'</div>'+
      '<button type="button" class="dlx__row dlx__row--mock" data-dld="mock"'+(ready?'':' disabled')+'><span class="dlx__ic dlx__ic--mock">'+IC.mock+'</span><span class="dlx__nm">'+stkEsc(stkT("stk.p172.proof_lab.mockup_free","Free mock up"))+'</span><span class="dlx__go">'+DOWN+'</span></button>'+
      (DLBAR() ? '' : '<div class="lbl-sub dlx__t">'+stkEsc(stkT("stk.p172.proof_lab.files","Files"))+'</div>'+
      '<button type="button" class="dlx__row" data-dld="cut"'+(ready?'':' disabled')+'><span class="dlx__ic dlx__ic--cut">'+IC.cut+'</span><span class="dlx__nm">'+stkEsc(stkT("stk.p172.proof_lab.cut_svg","Cut file SVG"))+'</span><span class="dlx__go">'+DOWN+'</span></button>'+
      '<button type="button" class="dlx__row" data-dld="print"'+(ready?'':' disabled')+'><span class="dlx__ic dlx__ic--print">'+IC.print+'</span><span class="dlx__nm">'+stkEsc(stkT("stk.p172.proof_lab.print_png","Print PNG · 300 DPI"))+'</span><span class="dlx__go">'+DOWN+'</span></button>');
  }
  box.addEventListener("click",async e=>{
    const x=e.target.closest("[data-dlx]"); if(x){ e.stopPropagation(); closeDoc(+x.dataset.dlx); return; }
    const add=e.target.closest("[data-dladd]"); if(add){ if(docs.length && window.__plBeginAnother) window.__plBeginAnother(); $("file").click(); return; }
    const gr=e.target.closest("[data-dlgrid]"); if(gr){ try{ openDocGrid(); }catch(err){} return; }
    const t=e.target.closest("[data-dli]"); if(t){ activateDoc(+t.dataset.dli); try{ openStep(2); }catch(err){} return; }
    const f=e.target.closest("[data-dlf]"); if(f){ orderFinish=f.dataset.dlf; draw(); try{ setOrderView(true, orderFinish); if(!holoMod) holoReady().then(()=>{ if(stepNo()===3) setOrderView(true, orderFinish); }).catch(()=>{}); }catch(err){} return; }
    const d=e.target.closest("[data-dld]"); if(!d || d.disabled) return;
    if(d.dataset.dld==="cut") $("dlCut").click();
    else if(d.dataset.dld==="print") $("dlPrint").click();
    else { try{ await holoReady(); }catch(err){} let m=null; try{ m=await mockupFile(); }catch(err){} if(m) saveBlob(new Blob([m.bytes],{type:"image/png"}), m.name.replace(/^PREVIEW-ONLY-/,"")); else dlProof(); }
  });
  function syncStep3(){
    const want=docs.length>0;
    if(step3.hidden!==!want){ step3.hidden=!want; if(want && typeof renderStepStrip==="function") renderStepStrip(); }
  }
  /* PAGE MODE DOWNLOAD BAR (20 Oct 2026, the owner: "download buttons where the current shortcut links are: Cut file SVG, Print PNG
     300 dpi, Download all files [ZIP]"; "this second screen for stickers should be used for mock up and design library saving"):
     the section leaves a nav#plxDl under the Studio in place of the tool links; the bar presses the Studio's own buttons (dlCut,
     dlPrint, the ZIP) at every step once a design is ready; with the bar in the page the DOWNLOADS card keeps only the finish,
     the mock-up and the library, and the step's foot drops its ZIP. The product page never has the nav. */
  function DLBAR(){ try{ const p=host.closest && host.closest(".plx-panel"); return (p && p.querySelector("#plxDl")) || document.getElementById("plxDl"); }catch(e){ return null; } }
  function dlBarZip(){
    const sel=selectedTileIdxs();
    if(sel.length>1){ dlZipBatchGo(); return; }
    const spinTxt=$("spin").textContent; $("spin").classList.add("show");
    setTimeout(async()=>{ try{ await dlZipRun(); }catch(e){ showError(stkFmt(stkT("stk.studio.msg.zip_failed","Couldn't build the ZIP: [error]"),{error:(e.message||e)})); } $("spin").classList.remove("show"); $("spin").textContent=spinTxt; },30);
  }
  function paintDlBar(){
    const nav=DLBAR(); if(!nav) return;
    const z=$("dlZip"), ready=!!(z && !z.disabled);
    try{ const og=z && z.closest(".dl-group--order"); if(og) og.hidden=true; }catch(e){}
    if(!nav.dataset.built){
      nav.dataset.built="1";
      const items=[["cut",$("dlCut") ? $("dlCut").querySelector("svg") : null,"cut",stkT("stk.p172.proof_lab.cut_svg","Cut file SVG")],
                   ["print",$("dlPrint") ? $("dlPrint").querySelector("svg") : null,"print",stkT("stk.p172.proof_lab.print_png","Print PNG \u00b7 300 DPI")],
                   ["zip",null,"zip",stkT("stk.p172.proof_lab.zip_all_files","Download all files [ZIP]")]];
      nav.innerHTML=items.map(([k,svg,cls,label])=>'<button type="button" class="plx-tool plx-tool--dl'+(k==="zip"?" plx-tool--zip":"")+'" data-icon="'+cls+'" data-dlbar="'+k+'" disabled><span class="plx-tool__ic" aria-hidden="true">'+(svg?svg.outerHTML:DOWN)+'</span><span class="plx-tool__tx"><span class="plx-tool__n">'+stkEsc(String(label).replace(/ \u00b7 /g,"\u00a0\u00b7\u00a0"))+'</span></span><span class="plx-tool__go" aria-hidden="true">'+DOWN+'</span></button>').join("");
      /* 21 Oct 2026 (Thomas, desktop: the row filled 3/4 of the width on a 4-column grid): one equal tile per file, ZIP last, across the full width */
      { const n=items.length, cols=()=>{ nav.style.gridTemplateColumns=(window.matchMedia && window.matchMedia("(min-width:768px)").matches) ? "repeat("+n+",minmax(0,1fr))" : ""; }; cols(); window.addEventListener("resize",cols); }
      nav.addEventListener("click",e=>{
        const b=e.target.closest("[data-dlbar]"); if(!b || b.disabled) return;
        const k=b.dataset.dlbar;
        if(k==="zip"){ dlBarZip(); return; }
        const t=$(k==="cut" ? "dlCut" : "dlPrint"); if(t && !t.disabled) t.click();
      });
      try{ if(z && window.MutationObserver) new MutationObserver(()=>paintDlBar()).observe(z,{ attributes:true, attributeFilter:["disabled"] }); }catch(e){}
    }
    nav.querySelectorAll("[data-dlbar]").forEach(b=>{ b.disabled=!ready; });
  }
  function paintFoot(){
    paintDlBar();
    const n=stepNo(), has=docs.length>0;
    foot.hidden=false;
    if(n===3 && DLBAR()){ foot.innerHTML=""; foot.hidden=true; return; }   /* the bar holds the ZIP */
    if(n===3){
      /* the ORDER foot: one big green button, here the ZIP */
      /* "just download files changes to download all files": the design on screen, or every ticked design */
      const ready=!!(zip && !zip.disabled), sel=selectedTileIdxs();
      const many=sel.length>1;
      foot.innerHTML='<div class="labfoot labfoot--one"><button type="button" class="stepdone" id="footZip"'+(ready?'':' disabled')+'>'+DOWN+stkEsc(many?stkT("stk.p172.proof_lab.zip_all_files","Download all files [ZIP]"):stkT("stk.p172.proof_lab.zip_files","Download files [ZIP]"))+'</button></div>';
      const fz=foot.querySelector("#footZip");
      if(fz) fz.addEventListener("click",()=>{
        if(many){ dlZipBatchGo(); return; }
        const spinTxt=$("spin").textContent; $("spin").classList.add("show");
        setTimeout(async()=>{ try{ await dlZipRun(); }catch(e){ showError(stkFmt(stkT("stk.studio.msg.zip_failed","Couldn't build the ZIP: [error]"),{error:(e.message||e)})); } $("spin").classList.remove("show"); $("spin").textContent=spinTxt; },30);
      });
      return;
    }
    /* Thomas, 28 Sep 00:00: "NEXT and downloads both do the same thing": one green button. NEXT while a
       pane or step is still to come, DOWNLOADS when that is what opens next. */
    /* Thomas, 28 Sep 01:25: "this should say next, not downloads": the foot always reads NEXT */
    foot.innerHTML='<div class="labfoot labfoot--one">'+
      '<button type="button" class="stepdone" id="stepNext"'+(has?'':' disabled')+'>'+stkEsc(stkT("stk.studio.order.next","Next"))+ARROW+'</button>'+
      '<div class="labfoot__status" id="cartStatus"></div></div>';
    const nx=foot.querySelector("#stepNext");
    if(nx) nx.addEventListener("click",()=>{
      if(n===2 && typeof window.__plSegNext==="function" && window.__plSegNext()) return;
      if(typeof foldStep==="function") foldStep(n||1);
    });
  }
  window.__plFootRefresh=paintFoot;
  /* "scrap that black apply settings to 5, that should appear at the top of the design panel in green" */
  const pb=root.querySelector(".panel__body");
  const ap=document.createElement("button"); ap.type="button"; ap.className="stepdone plapply"; ap.hidden=true;
  if(pb) pb.insertBefore(ap, pb.firstChild);
  ap.addEventListener("click",()=>{ try{ applySettingsToTicked(); }catch(e){} });
  window.__plSelChanged=function(k){
    const was=ap.hidden;
    ap.hidden=!(k>0);
    ap.textContent=stkFmt(stkT("stk.studio.grid.apply_n","Apply settings to [designs]"),{designs:k});
    if(was!==ap.hidden) requestAnimationFrame(()=>{ try{ window.dispatchEvent(new Event("resize")); }catch(e){} });
    if(stepNo()===3){ draw(); paintFoot(); }
  };
  /* "scrap the tabs, and should have the grid icon present always on the design field in the top right" */
  const stage=root.getElementById("stage");
  if(stage){
    const gb=document.createElement("button"); gb.type="button"; gb.className="ctool gridbtn"; gb.title=stkT("stk.studio.tool.all_designs","All designs"); gb.setAttribute("aria-label",stkT("stk.studio.tool.all_designs","All designs"));
    /* one button opens and shuts the grid view (it sits where the grid's own close x was) */
    gb.innerHTML=GRID; gb.addEventListener("click",()=>{ try{ openDocGrid(); }catch(e){} });
    stage.appendChild(gb);
  }
  /* the grid's close is a drawn cross: the text x sat low in its tile (Thomas, 28 Sep: "x is not centered") */
  const gcx=root.getElementById("docGridClose");
  if(gcx) gcx.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
  /* on DOWNLOADS the canvas shows the mock up in the chosen finish (the Studio's ORDER canvas); leaving puts the design back */
  window.__plStepChanged=function(n){
    paintFoot();
    try{
      if(n===3){ draw(); paintFinishes(); setOrderView(true, orderFinish); if(!holoMod) holoReady().then(()=>{ paintFinishes(); if(stepNo()===3) setOrderView(true, orderFinish); }).catch(()=>{}); }
      else setOrderView(false);
    }catch(e){}
  };
  window.__plDocsChanged=function(){ syncStep3(); paintFoot(); if(stepNo()===3){ draw(); try{ setOrderView(true, orderFinish); }catch(e){} } };
  if(zip && window.MutationObserver){ try{ new MutationObserver(()=>{ if(stepNo()===3){ draw(); paintFoot(); } }).observe(zip,{attributes:true,attributeFilter:["disabled"]}); }catch(e){} }
  syncStep3(); paintFoot(); draw();
})();

/* ===== Studio sync (28 Sep 2026, Thomas: "Apply all those differences to studio ... the finish tab should be the
   circular image tiles on studio like proof lab"). The product-page Studio (cart on) takes the Proof Lab page's grid
   (drawn close cross, the green "Apply settings to N" at the top of the panel instead of the black bulk bar) and its
   finish circles on the Final check's Finish tiles. The Finish tiles are the product page's own variant picker, so the
   circles are added to its tiles; the choice still goes through the picker. ===== */
(function initStudioSync(){
  const host=root.host;
  if(!host || host.dataset.cart!=="1") return;
  const gcx=root.getElementById("docGridClose");
  if(gcx) gcx.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
  const pb=root.querySelector(".panel__body");
  const ap=document.createElement("button"); ap.type="button"; ap.className="stepdone plapply"; ap.hidden=true;
  if(pb) pb.insertBefore(ap, pb.firstChild);
  ap.addEventListener("click",()=>{ try{ applySettingsToTicked(); }catch(e){} });
  if(typeof window.__plSelChanged!=="function") window.__plSelChanged=function(k){
    const was=ap.hidden;
    ap.hidden=!(k>0);
    ap.textContent=stkFmt(stkT("stk.studio.grid.apply_n","Apply settings to [designs]"),{designs:k});
    /* the phone pane is sized by fit() on resize; the button takes room, so re-fit when it appears or goes */
    if(was!==ap.hidden) requestAnimationFrame(()=>{ try{ window.dispatchEvent(new Event("resize")); }catch(e){} });
  };
  const KIND=v=>{ v=String(v||"").toLowerCase(); return /glitter/.test(v)?"glitter":/gloss/.test(v)?"gloss":/matt/.test(v)?"matte":null; };
  const img={};
  function paint(){
    if(!holoMod || img.matte) return;
    try{
      ["matte","gloss","glitter"].forEach(k=>{
        /* the Proof Lab circles: drawn at the circle's own device size, glitter on a darker disc as if 2.5 mm across */
        const S=72, c=document.createElement("canvas"); c.width=S; c.height=S;
        const x=c.getContext("2d"); x.fillStyle=k==="glitter"?"#8f929b":"#c9cbd2"; x.beginPath(); x.arc(S/2,S/2,S/2-2,0,Math.PI*2); x.fill();
        const out=holoMod.renderHolo(c,{ finish:lookOf(k), borderPx:0, stickerWidthMm:(k==="glitter"?2.5:10), scale:1 });
        const o=document.createElement("canvas"); o.width=S; o.height=S;
        o.getContext("2d").drawImage(out,(S-out.width)/2,(S-out.height)/2);
        img[k]=o.toDataURL("image/png");
      });
    }catch(e){ console.warn("[proof-lab] studio finish circles:",e&&e.message); }
  }
  function decorate(){
    const mount=root.getElementById("cartMount"); if(!mount) return;
    mount.querySelectorAll(".cgrid").forEach(g=>{
      const ins=[...g.querySelectorAll('input[type="radio"]')];
      if(!ins.length || !ins.every(i=>KIND(i.value))) return;
      g.classList.add("cgrid--fin");
      ins.forEach(i=>{
        const lab=g.querySelector('label[for="'+i.id+'"]'); if(!lab) return;
        const k=KIND(i.value);
        let sw=lab.querySelector(".finsw");
        if(!sw){ sw=document.createElement("span"); sw.className="finsw finsw--"+k; sw.setAttribute("aria-hidden","true"); lab.insertBefore(sw,lab.firstChild); }
        if(img[k] && sw.dataset.painted!=="1"){ sw.style.backgroundImage="url("+img[k]+")"; sw.style.backgroundSize="cover"; sw.dataset.painted="1"; }
      });
    });
  }
  const mount=root.getElementById("cartMount");
  if(mount && window.MutationObserver){ try{ new MutationObserver(()=>decorate()).observe(mount,{childList:true,subtree:true}); }catch(e){} }
  decorate();
  try{ holoReady().then(()=>{ paint(); decorate(); }).catch(()=>{}); }catch(e){}
})();

(function initCart(){
  const host=root.host;
  if(!host || host.dataset.cart!=="1" || !window.LabCart) return;
  let products=[]; try{ products=JSON.parse(host.dataset.products||host.dataset.product||"[]"); }catch(e){}
  if(!Array.isArray(products)) products=products?[products]:[];
  products=products.filter(p=>p&&p.variants&&p.variants.length);
  if(!products.length) return;
  const mount=root.getElementById("cartMount"); if(!mount) return;
  /* v1.7: the ORDER card is in the panel with Artwork and Sticker, and the price and
     the button are a sticky footer at the foot of that panel. Both are in the markup
     already; they are only revealed when the cart is on. */
  const foot=root.getElementById("cartFoot");
  /* Step 3 arrives when there is something to order, and never before: an Order
     card above an empty canvas is a step the customer cannot act on. */
  const step3=root.getElementById("step3");
  function syncStep3(){
    if(!step3) return;
    const want=docs.length>0;
    if(step3.hidden===!want) return;
    step3.hidden=!want;
    if(want){ if(typeof renderStepStrip==="function") renderStepStrip(); }
  }
  const FROM_PRODUCT = host.dataset.fromProduct==="1" && !!window.LabProofConfirm;
  let overlayStatus=null;   // the overlay's status line, while it is open
  const esc=s=>String(s==null?"":s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
  /* P128 grid: every figure in the CART currency, in the shop's own money format (the grid config
     carries {{ 123456789 | money }}); every other product keeps the pound sign it always printed */
  const GRID=PL_GRID;
  /* P128 OPTION B (1 Oct 2026, Thomas): the band product. Size S1-S17 x Finish x Quantity 50-2,000
     in 50s, every variant a priced pack, ONE cart line per job at quantity 1, priced at the band of
     its largest design. It rides the grid's hooks (GRID is its data, "bands":true); the B branches
     below replace the one-sticker pricing. Customers never see sheets or S codes. */
  const BANDS=!!(GRID&&GRID.bands);
  const gMoney=(GRID && window.StkGrid) ? window.StkGrid.moneyFormatter(GRID.moneySample) : null;
  const money=n=>gMoney ? gMoney(Number(n)) : "£"+(Number(n)/100).toFixed(2);
  /* P214 (7 Oct 2026): LabCart.picker's rows, unit line and footer take this, so every figure
     on the order card is in the shop's own money format (it was CUR_SYM + toFixed(2): 'SEK 1389.48'
     beside '1 389,48 kr', 'HUF 31543.44' beside '31.543 Ft'). No grid formatter = the symbol, as before. */
  const PICK_MONEY=n=>money(n);
  const CUR_SYM=(function(){
    if(!gMoney) return "£";
    const pre=String(gMoney(0)).replace(/[0-9].*$/,"");
    return pre || ((window.Shopify&&Shopify.currency&&Shopify.currency.active)||"")+" ";
  })();
  if(GRID) products=[gridProduct(products[0])];
  const cart=window.LabCart.create({ apiBase:host.dataset.apiBase, tool:"proof-lab", previewFieldId:"proof-preview", unit:PL_NOUN });
  const MAX_DESIGNS=MAX_SLOTS;         // Thomas: up to 4 designs per order/package; v2.6: the section setting
  const NOUN=String((host.dataset.noun||"sticker")).trim().toLowerCase()||"sticker";
  let activeP=products[0], optNames=[], sizeOpt=-1, sel={};
  const optNamesOf=p=>(p.options||[]).map(o=>typeof o==="string"?o:(o&&o.name));
  const valuesOf=(p,i)=>{ const seen=[]; p.variants.forEach(v=>{ const val=(v.options||[v.option1,v.option2,v.option3])[i]; if(val!=null && seen.indexOf(String(val))<0) seen.push(String(val)); }); return seen; };
  const valuesFor=i=>valuesOf(activeP,i);
  const normv=v=>String(v==null?"":v).trim().toLowerCase();

  /* G2. LabCart.resolveVariant treats an unset selection as a wildcard, so on a product whose
     option names do not line up it can return the FIRST variant, which is the cheapest. That is
     exactly the silent-underpricing defect found in the Gang Sheet lane. strictVariant refuses
     unless every option position matches the value the customer actually chose. */
  function strictVariant(){
    if(GRID) gSync();
    const v=window.LabCart.resolveVariant(activeP,sel);
    if(!v) return null;
    const names=optNamesOf(activeP);
    const vals=v.options||[v.option1,v.option2,v.option3];
    for(let i=0;i<names.length;i++){
      const want=sel[names[i]];
      if(want==null||want==="") return null;            // an option we never asked about
      if(normv(vals[i])!==normv(want)) return null;     // resolver matched something else
    }
    return v;
  }
  function rebuildOptions(){
    optNames=optNamesOf(activeP); sel={}; optNames.forEach((n,i)=>{ sel[n]=valuesFor(i)[0]; });
    // which option is the sticker Size (values carry 2/3/4) - Size drives the canvas, so it syncs
    // to #sizeSeg; if no digit is present it stays a plain variant chip (manual fallback).
    /* i18n: the size option is known by its values (2/3/4 inches), which translation keeps; the
       English name test stays as the fallback. Same pick as before: either test, first index. */
    sizeOpt=-1; optNames.forEach((n,i)=>{ if(sizeOpt<0 && (valuesFor(i).every(v=>/[234]/.test(v)) || /size|größe|grösse|taille|tamaño|dimensioni|formaat|størrelse|koko|storlek/i.test(n||""))) sizeOpt=i; });  /* P172: translated Size names too */
    if(sizeOpt>=0){ const w=valuesFor(sizeOpt).find(v=>String(v).indexOf(String(opts.sizeIn))===0); if(w) sel[optNames[sizeOpt]]=w; }
  }
  rebuildOptions();

  /* ===== P128 SIZE GRID (27 Sep 2026) =====================================================
     The Studio keeps its own picker (Finish chips, Quantity rows, the Custom bar) by pricing a
     VIRTUAL product: options Size (hidden), Finish, Quantity, one row per preset. Each virtual
     variant carries the REAL grid variant's id for the active design's snapped size and that
     finish, and as its price the whole order at that quantity: every design is its own cart
     line (DESIGN.md s.8), at its own snapped size, its share of the order, priced by
     StkGrid.lineCents exactly as the Bulk price function charges it. The cart gets the real
     ids and the real quantities (doAdd); the virtual rows only ever exist on screen. */
  const G_PRESETS=(GRID&&GRID.presets)||[48,96,200,500,1000,2000];
  function gSizeOf(v){ const m=/CVS-(\d{3})X(\d{3})-/.exec(String((v&&v.sku)||"")); return m?{ L:+m[1], S:+m[2] }:null; }
  function gFinishes(){ const o=[]; GRID.variants.forEach(v=>{ if(o.indexOf(v.f)<0) o.push(v.f); }); return o; }
  function gRate(){ const r=Number(window.Shopify&&Shopify.currency&&Shopify.currency.rate); return r>0?r:1; }
  /* one line in cart-currency cents: the variant price x q minus the Bulk price */
  function gLine(v,q){
    if(!v || !window.StkGrid || !(q>0)) return null;
    const c=window.StkGrid.lineCents(v.g,q,v.p,gRate());
    return c==null?null:Math.round(c);
  }
  function gCm(mm){ const c=Math.round(Number(mm))/10; return Number.isInteger(c)?String(c):c.toFixed(1); }
  /* 2 Oct (sizes.md edit 1): a design's size as TRUE SIZE writes it, width x height in the shop's decimals */
  function gWH(d){ return (d && d.w>0 && d.h>0) ? plLenTxt(d.w)+" \u00d7 "+plLenTxt(d.h)+" "+plUnitLbl() : ""; }   /* builder audit row 15: display only */
  /* the cart's whole-mm size of a design: UP to the whole mm, the rule bBandOf and the cart transform band by */
  function bMmWH(d){ return (d && d.w>0 && d.h>0) ? Math.ceil(Number(d.w)-1e-9)+" \u00d7 "+Math.ceil(Number(d.h)-1e-9) : ""; }
  function gCurFin(){ const fn=finishName(); const f=fn?sel[fn]:null; return f!=null?f:gFinishes()[0]; }
  /* Liquid lists the first 250 variants. Past that (the full 1,890 grid) the exact size is asked
     of sections/stk-grid-variant.liquid by option value ids, Dawn's own ?option_values= route */
  const gCache={};
  function gFetch(want,fin,key){
    gCache[key]="pending";
    const lbl=window.StkGrid.sizeLabel(want.L/10,want.S/10);
    const sid=GRID.sizeIds&&GRID.sizeIds[lbl], fid=GRID.finishIds&&GRID.finishIds[fin];
    if(!sid || !fid){ gCache[key]=null; return; }
    const rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
    fetch(rootUrl+"products/"+encodeURIComponent(GRID.handle)+"?section_id=stk-grid-variant&option_values="+sid+","+fid,{ cache:"no-store" })
      .then(r=>r.text()).then(x=>{
        const m=/<script[^>]*data-stk-grid-variant[^>]*>([\s\S]*?)<\/script>/.exec(x);
        let v=null; try{ v=m?JSON.parse(m[1]):null; }catch(e){ v=null; }
        const z=gSizeOf(v);
        /* the section answers with the first variant when the pair does not exist: the SKU decides */
        gCache[key]=(v && z && z.L===want.L && z.S===want.S && v.f===fin) ? v : null;
      }).catch(()=>{ delete gCache[key]; })
      .then(()=>{ drawSoon(); });
  }
  /* the variant a true cut size is charged as: the grid step it snaps up to; on a product that
     lists only some sizes (the 27-variant test product), the smallest listed size that fits */
  function gPick(d,fin){
    if(!d || !window.StkGrid) return { err:"size" };
    const sp=window.StkGrid.snapPair(d.w,d.h);
    if(!sp) return { err:"big" };
    const want={ L:sp.longMm, S:sp.shortMm };
    let best=null;
    GRID.variants.forEach(v=>{
      if(v.f!==fin) return;
      const z=gSizeOf(v); if(!z || z.L<want.L || z.S<want.S) return;
      if(!best || z.L*z.S<best.z.L*best.z.S || (z.L*z.S===best.z.L*best.z.S && z.L<best.z.L)) best={ v:v, z:z };
    });
    if(best && best.z.L===want.L && best.z.S===want.S) return { v:best.v, L:want.L, S:want.S, exact:true, want:want };
    if(Number(GRID.total)>GRID.variants.length){
      const key=want.L+"x"+want.S+"|"+fin, c=gCache[key];
      if(c==="pending") return { pending:true, want:want };
      if(c) return { v:c, L:want.L, S:want.S, exact:true, want:want };
      if(c===undefined){ gFetch(want,fin,key); return { pending:true, want:want }; }
    }
    if(!best) return { err:"none", want:want };
    return { v:best.v, L:best.z.L, S:best.z.S, exact:false, want:want };
  }
  /* a design's cut size, measured once per scene (dilating the mask on every redraw is not free) */
  const gDimCache={};
  function gDims(i){
    try{
      const k=i===activeIdx ? (art?sceneKey(opts,art,eraseStrokes,trimOff):"") : docSceneKey(docs[i]);
      if(!k) return null;
      if(!(k in gDimCache)) gDimCache[k]=(i===activeIdx) ? cutSizeMm() : withDoc(i,()=>cutSizeMm());
      return gDimCache[k];
    }catch(e){ return null; }
  }
  /* the whole order at a total: each design its own line, its own size, its share (the shares on
     screen for the order as it stands, an even split for the other rows, as jobDesigns() did) */
  function gPlan(total,fin){
    if(BANDS) return bPlan(total,fin);
    const live=liveDocIdxs();
    if(!live.length){
      const v=GRID.variants.find(x=>x.f===fin)||GRID.variants[0];
      return { lines:[{ idx:-1, v:v, q:total, pick:{ v:v, exact:true } }], cents:gLine(v,total), small:total<QTY_MIN };
    }
    /* the shares on screen when they are this total's (splitPack() may not have run yet for a
       total just picked), else an even split with the remainder to the first designs */
    let shares=total===packTotal() ? live.map(i=>Number(perQty[docs[i].id])||0) : null;
    if(!shares || shares.reduce((a,b)=>a+b,0)!==total){ const n=live.length, b=Math.floor(total/n), r=total-b*n; shares=live.map((_,j)=>b+(j<r?1:0)); }
    const out={ lines:[], cents:0, small:false, pending:false, err:null };
    live.forEach((i,j)=>{
      const d=gDims(i), p=d?gPick(d,fin):{ err:"size" };
      out.lines.push({ idx:i, v:p.v||null, q:shares[j], pick:p, dims:d });
      if(p.pending) out.pending=true;
      else if(!p.v) out.err=out.err||p.err||"none";
      if(shares[j]<QTY_MIN) out.small=true;
    });
    if(out.pending || out.err){ out.cents=null; return out; }
    out.lines.forEach(l=>{ const c=gLine(l.v,l.q); if(out.cents!=null) out.cents=(c==null?null:out.cents+c); });
    return out;
  }
  function gTotal(q){ if(!(q>0)) return null; const p=gPlan(q,gCurFin()); return p.cents; }
  /* ----- option B helpers (function declarations: gridProduct() runs before any const below) ----- */
  function bNum(s){ return Number(String(s||"").slice(1))||0; }
  /* a design's band: its true cut size up to the whole mm (20 mm floor), looked up in the packer's
     1 mm capacity table (GRID.sizes: per long side, [short side where a run starts, band number]).
     The 0.5 cm grid step it replaced priced a 2 in sticker (50.8 mm) as 5.5 cm, 35% over (1 Oct). */
  function bBandOf(d){
    if(!d || !(d.w>0) || !(d.h>0)) return { err:"size" };
    const L=Math.max(20,Math.ceil(Math.max(d.w,d.h)-1e-9)), S=Math.max(20,Math.ceil(Math.min(d.w,d.h)-1e-9));
    const runs=GRID.sizes && GRID.sizes[String(L)];
    if(!runs) return { err:"big" };
    let b=0; for(const r of runs){ if(r[0]<=S) b=r[1]; else break; }
    return b>0 ? { s:"S"+b, L:L, S:S } : { err:"big" };
  }
  /* the job's band: its largest design's (Thomas, 27 Sep: one line per Studio job, the largest
     design's size, the total quantity, the designs as attachments). 5 x 5 cm before any design. */
  function bJob(){
    const live=liveDocIdxs();
    if(!live.length) return { s:String(GRID.variants[0].s), L:51, S:51, none:true };
    let best=null, err=null;
    live.forEach(i=>{
      const d=gDims(i), b=d?bBandOf(d):{ err:"size" };
      if(b.err){ err=err||b.err; return; }
      if(!best || bNum(b.s)>bNum(best.s) || (bNum(b.s)===bNum(best.s) && b.L*b.S>best.L*best.S)) best=Object.assign({ w:d.w, h:d.h },b);
    });
    return err ? { err:err } : best;
  }
  /* one band and finish's quantity ladder {q: {id,p,a}}: from the listed variants when all 40 are
     there, else from sections/stk-bands-ladder.liquid ("pending" while it is asked) */
  function bCacheM(){ return bCacheM.m||(bCacheM.m={}); }
  function bWaitM(){ return bWaitM.m||(bWaitM.m={}); }
  /* the same ladder, as a promise: the add waits here for the job variant's id when the price
     came from the band price table and the ladder has not been asked yet */
  function bRowsAsync(band,fin){
    const r=bRows(band,fin);
    if(r!=="pending") return Promise.resolve(r);
    const W=bWaitM(), key=band+"|"+fin;
    return W[key]||Promise.resolve(null);
  }
  /* the ladder when it is already here (listed in full, or asked before), never a request */
  function bRowsHeld(band,fin){
    const key=band+"|"+fin, C=bCacheM();
    if(C[key]!==undefined) return C[key];
    const m={}; let n=0;
    GRID.variants.forEach(v=>{ if(String(v.s)===String(band) && v.f===fin){ m[String(v.q)]={ id:v.id, p:v.p, a:v.a }; n++; } });
    if(n>=bLadderN()){ C[key]=m; return m; }
    return null;
  }
  function bRows(band,fin){
    const key=band+"|"+fin, C=bCacheM();
    if(C[key]!==undefined) return C[key];
    const m={}; let n=0;
    GRID.variants.forEach(v=>{ if(String(v.s)===String(band) && v.f===fin){ m[String(v.q)]={ id:v.id, p:v.p, a:v.a }; n++; } });
    if(n>=bLadderN()){ C[key]=m; return m; }
    C[key]="pending";
    const sid=GRID.sizeIds&&GRID.sizeIds[band], fid=GRID.finishIds&&GRID.finishIds[fin], qid=GRID.qtyIds&&GRID.qtyIds[String(GRID.min)];
    if(!sid || !fid || !qid){ C[key]=null; return null; }
    bWaitM()[key]=bLadderGet(band,fin).then(out=>{ C[key]=out; }).catch(()=>{ delete C[key]; })
      .then(()=>{ delete bWaitM()[key]; drawSoon(); return C[key]===undefined ? null : C[key]; });
    return "pending";
  }
  /* the ladder asked of the section, never cached here: {q: {id,p,a}}, or null when the section does not answer for this
     band and finish (rejects when the request fails). bRows caches it; mktFresh (7 Oct) asks it again before an add */
  function bLadderGet(band,fin){
    const sid=GRID.sizeIds&&GRID.sizeIds[band], fid=GRID.finishIds&&GRID.finishIds[fin], qid=GRID.qtyIds&&GRID.qtyIds[String(GRID.min)];
    if(!sid || !fid || !qid) return Promise.resolve(null);
    const rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
    return fetch(rootUrl+"products/"+encodeURIComponent(GRID.handle)+"?section_id="+(GRID.ladder||"stk-bands-ladder")+"&option_values="+sid+","+fid+","+qid,{ cache:"no-store" })
      .then(r=>r.text()).then(x=>{
        const mm=/<script[^>]*data-stk-bands-ladder[^>]*>([\s\S]*?)<\/script>/.exec(x);
        let j=null; try{ j=mm?JSON.parse(mm[1]):null; }catch(e){ j=null; }
        /* the section answers with another variant when the ids do not exist: band and finish decide */
        if(j && String(j.s)===String(band) && j.f===fin && Array.isArray(j.rows)){
          const out={}; j.rows.forEach(r=>{ if(r) out[String(r.q)]={ id:r.id, p:r.p, a:r.a }; }); return out;
        }
        return null;
      });
  }
  function QTY_MAX_B(){ return Number(GRID.max)||2000; }
  /* the packs one band and finish has: 40 on the sticker band product, the 33 of GRID.qtys on magnets */
  function bLadderN(){ return PL_MG ? ((GRID.qtys||[]).length||1) : Math.round((QTY_MAX_B()-GRID.min)/GRID.step)+1; }
  /* 2 Oct 2026 (Thomas, final): ONE line, the job's largest band at the total quantity Q as its
     variant, and as its price the SUM over the designs of P(band_i, finish, Q) x q_i / Q (band_i
     from design i's own size, bBandOf, the cart transform's rule), up to the penny, then UP to an
     ending of .00/.25/.50/.75/.95. The cart transform charges exactly this on the order; one design
     is the ladder price itself. P comes from the band price table (no request) or, without it, the
     ladder. All in GBP pence, then the cart currency's rate. */
  const B_ENDS=[0,25,50,75,95];
  function bEnding(p){
    const pounds=Math.floor(p/100), c=p-pounds*100;
    for(const e of B_ENDS) if(c<=e) return pounds*100+e;
    return (pounds+1)*100;
  }
  /* P(band, finish, Q) in GBP pence: a number, "pending" while the ladder is asked, or null */
  function bPence(band,fin,q){
    const T=PL_BAND_PRICES;
    if(T){
      const i=T.q.indexOf(Number(q)), F=T.p[String(fin).toUpperCase()]||T.p[String(fin)], a=F&&F[String(band)];
      const v=(i>=0 && Array.isArray(a)) ? Number(a[i]) : NaN;
      return v>0 ? v : null;
    }
    const rows=bRows(band,fin);
    if(rows==="pending") return "pending";
    const r=rows && rows[String(q)];
    return r ? r.p/gRate() : null;
  }
  /* 5 Oct 2026 (Thomas: "51-99 should have individual pricing"): every figure 50 to 2,000 has its
     own price, on the straight line between the two packs around it (73 = 50's price + 23/50 of the
     step to 100). Returned x50 so it stays a whole number: P(lo)x(hi-q) + P(hi)x(q-lo). A pack
     figure is 50 x its own price, so the multi-design sum below is unchanged for packs. The cart
     transform (bandPence50) charges this same formula. */
  function bPackQ(q){ if(PL_MG) return bMgUp(q); return Math.min(QTY_MAX_B(), Math.ceil(q/GRID.step-1e-9)*GRID.step); }
  /* magnets: the pack a figure rides is the next one up in GRID.qtys (12..100 in 4s, 110..200 in 10s); over the top it is its own
     figure, which no pack carries, so it is never priced (qtyError says the email line) */
  function bMgUp(q){ q=Number(q); const L=(GRID&&GRID.qtys)||[]; if(!(q>0) || !L.length) return q; if(q>L[L.length-1]) return q; for(const x of L) if(x>=q) return x; return q; }
  /* v3.8: the hidden item's variant id for a band ("S8") and finish ("GLOSSY"), from its product JSON (unlisted,
     Online Store only), asked once per page; null when it cannot be found */
  /* v3.10 (6 Oct 2026, market factor): the same request also keeps each variant's own price in this market (cart cents),
     the S of the factor for a figure between packs; cqHeld is that map once it is here (redraws when it lands) */
  let cqIds=null, cqHeld=null;
  function cqSku(band, fin){
    const m=/^S(\d+)$/.exec(String(band||"")); if(!m || !fin) return null;
    return "CVS-CQ-S"+String(m[1]).padStart(2,"0")+"-"+String(fin).toUpperCase();
  }
  function cqLoad(){
    if(PL_MG){ if(!cqHeld) cqHeld={}; return cqIds||(cqIds=Promise.resolve({})); }   /* magnets: every figure is a pack, no hidden item */
    if(!cqIds){
      const rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
      cqIds=fetch(rootUrl+"products/custom-vinyl-stickers-cq.js",{cache:"no-store"}).then(r=>r.ok?r.json():null)
        /* v3.12: on a Bulk Edit sale (compare-at above the price) the S is the compare-at, the unsold 9999.00 in this market, as the
           cart transform reads it, so a sale on the hidden item never moves the factor */
        .then(j=>{ const o=cqMapOf(j); cqHeld=o; drawSoon(); return o; })
        .catch(()=>{ cqIds=null; if(!cqHeld){ cqHeld={}; drawSoon(); } return {}; });
    }
    return cqIds;
  }
  function cqMapOf(j){ const o={}; ((j&&j.variants)||[]).forEach(v=>{ if(v && v.sku){ const p=Number(v.price), ca=Number(v.compare_at_price); o[v.sku]={ id:Number(v.id), p:(ca>p ? ca : p) }; } }); return o; }
  /* P212 audit fault 1 (7 Oct 2026). Shopify moves a market's exchange rate several times a day (HUF measured 4 times in
     2.5 h) and the functions charge at the rate of the moment, while this page kept the rate and the market prices it opened
     with: a figure between packs was refused at the read-back (charged up to 0.1 % over the quote) on every try until a
     reload, and a pack line charged a price the screen never showed. So before every add outside GBP the inputs the quote
     reads in this market are asked again, together: the rate (Shopify.currency in the head of /search?view=stk-rate, an
     empty page on layout/stk-rate.liquid: ~16 KB, ~0.2-0.5 s; the full search page was ~76 KB, ~1 s), the hidden item's
     prices (its product JSON) and the ladder of each band the quote reads, for the finish. All of them or none: with one
     missing the page stays as it was (the read-back still guards). GBP (rate 1: the UK and the GBP list markets) asks
     nothing. Returns {was, rate} once applied, else null. */
  function mktHeadCurrency(){
    const rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/", re=/Shopify\.currency\s*=\s*(\{[^}]*\})/;
    const pick=t=>{ const m=re.exec(t); if(!m) return null; try{ return JSON.parse(m[1]); }catch(e){ return null; } };
    return fetch(rootUrl+"search?view=stk-rate",{ cache:"no-store", credentials:"same-origin" }).then(async r=>{
      if(!r.ok) return null;
      if(!(r.body && r.body.getReader && typeof TextDecoder==="function")) return pick(await r.text());
      const rd=r.body.getReader(), dec=new TextDecoder(); let t="", c=null;
      while(!c && t.length<500000){ const x=await rd.read(); if(x.done) break; t+=dec.decode(x.value,{ stream:true }); c=pick(t); }
      try{ const q=rd.cancel(); if(q && q.catch) q.catch(()=>{}); }catch(e){}
      return c;
    }).catch(()=>null);
  }
  /* the bands the quote reads a ladder for: the job's (its pack variant); without the band price table, every design's too */
  function mktBands(){
    const j=bJob(), out=[];
    if(j && !j.err && j.s) out.push(String(j.s));
    if(!PL_BAND_PRICES) liveDocIdxs().forEach(i=>{ const d=gDims(i), b=d?bBandOf(d):null; if(b && b.s && out.indexOf(b.s)<0) out.push(b.s); });
    return out;
  }
  async function mktFresh(bands,fin){
    if(gRate()===1) return null;
    const cur=String((window.Shopify&&Shopify.currency&&Shopify.currency.active)||""), rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
    const got=await Promise.all([
      mktHeadCurrency(),
      PL_MG ? Promise.resolve({ variants:[] }) : fetch(rootUrl+"products/custom-vinyl-stickers-cq.js",{ cache:"no-store" }).then(r=>r.ok?r.json():null).catch(()=>null),
      Promise.all(bands.map(b=>bLadderGet(b,fin).catch(()=>null)))
    ]);
    const c=got[0], cq=got[1], lads=got[2];
    /* the same currency as the page, or nothing: a market switched in another tab is not this page's to reprice */
    const rate=(c && String(c.active||"")===cur && Number(c.rate)>0) ? String(c.rate) : null;
    if(!rate || !cq || !Array.isArray(cq.variants) || lads.some(x=>!x)){
      try{ console.warn("[proof-lab] market prices not refreshed", !!rate, !!cq, lads.map(x=>!!x).join(",")); }catch(e){}
      return null;
    }
    const was=String(Shopify.currency.rate);
    Shopify.currency.rate=rate;
    const o=cqMapOf(cq); cqHeld=o; cqIds=Promise.resolve(o);
    bands.forEach((b,k)=>{ bCacheM()[b+"|"+fin]=lads[k]; });
    return { was:was, rate:rate };
  }
  function cqVariantId(band, fin){
    const sku=cqSku(band, fin); if(!sku) return Promise.resolve(null);
    return cqLoad().then(o=>(o&&o[sku]&&o[sku].id>0)?o[sku].id:null);
  }
  /* the hidden item's own unit price in this market (cart cents): a number, "pending" (and asks), or null */
  function cqSentinel(band, fin){
    const sku=cqSku(band, fin); if(!sku) return null;
    if(!cqHeld){ cqLoad(); return "pending"; }
    const v=cqHeld[sku];
    return (v && v.p>0) ? v.p : null;
  }
  function bPence50(band,fin,q){
    q=Number(q); const st=GRID.step;
    if(q%st===0){ const p=bPence(band,fin,q); return typeof p==="number" ? p*st : p; }
    const hi=bPackQ(q), lo=hi-st;
    const a=bPence(band,fin,lo), b=bPence(band,fin,hi);
    if(a==="pending" || b==="pending") return "pending";
    if(typeof a!=="number" || typeof b!=="number") return null;
    return a*(hi-q)+b*(q-lo);
  }
  /* the designs' shares at a total: the ones on screen when they are this total's, else an even split */
  function bShares(live,total){
    let shares=total===packTotal() ? live.map(i=>Number(perQty[docs[i].id])||0) : null;
    if(!shares || shares.reduce((a,b)=>a+b,0)!==total){ const n=live.length, b=Math.floor(total/n), r=total-b*n; shares=live.map((_,j)=>b+(j<r?1:0)); }
    return shares;
  }
  /* v3.12: the shares when a figure between packs is sold as the pack above (Q): each design scaled up from the shares at its
     own total (rounded down), the stickers left over one each to the designs of the largest band first */
  function bUpShares(live,total,Q){
    const base=bShares(live,total), out=base.map(q=>Math.floor(q*Q/total));
    let rem=Q-out.reduce((a,b)=>a+b,0);
    const ord=live.map((i,k)=>{ const d=gDims(i), b=d?bBandOf(d):null; return { k:k, n:(b&&b.s)?bNum(b.s):0 }; }).sort((a,b)=>b.n-a.n || a.k-b.k);
    for(let t=0; rem>0 && ord.length; t++, rem--) out[ord[t%ord.length].k]++;
    return out;
  }
  /* do the job's designs fall in more than one band (the per-sticker figure is then an average) */
  function bMixed(){
    const live=liveDocIdxs(); if(live.length<2) return false;
    const seen={}; let n=0;
    live.forEach(i=>{ const d=gDims(i), b=d?bBandOf(d):null; if(b && b.s && !seen[b.s]){ seen[b.s]=1; n++; } });
    return n>1;
  }
  function bPlan(total,fin,sharesIn){
    if(!cqHeld) cqLoad();   /* v3.10: the hidden item's own prices (the market factor), asked once as Studio first prices */
    const j=bJob();
    if(j.err) return { lines:[], cents:null, err:j.err };
    if(!(total>=GRID.min) || total!==Math.round(total)) return { lines:[], cents:null, small:true, job:j };
    const live=liveDocIdxs();
    /* the cart line's variant: the job band at Q; its id from the listed variants or the ladder,
       asked only for the finish on screen (the price never waits for it). 5 Oct: a figure between
       packs rides the pack above it (73 -> the 100 variant); the transform charges the figure. */
    const packQ=bPackQ(total), between=packQ!==total;
    let row=null, rowLo=null;
    if(!PL_BAND_PRICES){
      const rows=bRows(j.s,fin);
      if(rows==="pending") return { lines:[], cents:null, pending:true, job:j };
      row=rows ? (rows[String(packQ)]||null) : null;
      rowLo=rows ? (rows[String(packQ-GRID.step)]||null) : null;
      if(!row) return { lines:[], cents:null, err:"price", job:j };
    } else {
      const rows=(fin===gCurFinSafe()) ? bRows(j.s,fin) : bRowsHeld(j.s,fin);
      if(rows && rows!=="pending"){ row=rows[String(packQ)]||null; rowLo=rows[String(packQ-GRID.step)]||null; }
    }
    if(row && row.a===false) return { lines:[{ idx:-1, v:{ id:row.id, p:row.p, a:false, s:j.s }, q:total }], cents:null, err:"soldout", job:j };
    const rate=gRate();
    /* GBP pence to the cart currency, the cart transform's toPresentment() exactly */
    const toCur=g=>rate===1 ? g : Math.round(Number((g*rate).toFixed(6)));
    /* v3.10 (6 Oct 2026, Thomas approved: between figures follow each market's own pack prices, UK exact). The market
       factor m = S/B from the line's OWN live price, exactly as the cart transform (band-line.mjs marketFactor):
       S = the line's unit price in this market (cart cents), B = its GBP table price x rate. Returns [S,B], or null
       (refused). gaps-2026-10-06/MARKET-FACTOR.md
       v3.12: at rate 1 (GBP: the UK, or the -5% list of NO / Rest of World / International) the list's 0.95 is taken by the
       hidden item and by a pack QUANTITY on the pack variant (v3.11); a pack-variant line BETWEEN packs at rate 1 is refused
       here and sold as the pack above, so no Bulk Edit sale on the pack can reach it */
    const factor=(S,B,hidden,btw)=>{
      if(!(S>0) || !(B>0)) return null;
      if(S===B) return [1,1];
      if(rate===1){
        if(S===Math.round(B*95/100)) return (hidden || !btw) ? [S,B] : null;
        return hidden ? [1,1] : null;                                /* GBP hidden item ignores any other price; a GBP pack line is exact */
      }
      if(S*100>B*130 || S*100<B*80) return null;                     /* stale table or broken data */
      return [S,B];
    };
    /* v3.12: a figure between packs sold as the pack above (Q, on the pack variant, which pays the live variant price): the
       designs scaled up to Q (bUpShares); the add sends those shares. Only from a figure between packs. */
    const upPlan=()=>{
      const sh=bUpShares(live,total,packQ), p=bPlan(packQ,fin,sh);
      if(p.lines && p.lines.length && p.cents>0) return Object.assign(p,{ up:{ from:total, to:packQ, shares:sh } });
      return (p.pending || p.err) ? p : { lines:[], cents:null, err:"price", job:j };
    };
    let f=[1,1], pv=false, stale=false;
    if(between){
      /* the cart line is the hidden item (9999.00 GBP): S = its own price here, B = 999900 x rate */
      const s=cqSentinel(j.s,fin);
      if(s==="pending") return { lines:[], cents:null, pending:true, job:j };
      const B=toCur(999900);
      if(s>0) f=factor(s,B,true);
      else {
        /* v3.12: no hidden item for this band and finish: the line is the pack variant itself, its own price the S */
        pv=true;
        const pj=bPence(j.s,fin,packQ);
        f=(row && row.p>0 && typeof pj==="number") ? factor(row.p,toCur(pj),false,true) : (rate===1 ? [1,1] : null);
        if(!f && row && row.p>0 && row.a!==false) return upPlan();
      }
      if(!f || (!PL_BAND_PRICES && f[0]!==f[1])) return { lines:[], cents:null, err:"price", job:j };
      /* 2 Oct review, MONEY GUARD: the band price table must still be the pack variant's price under the same factor
         (GBP UK: to the penny, as before); otherwise the table is stale and this figure has no price of its own */
      if(PL_BAND_PRICES && row && row.p>0){
        const pj=bPence(j.s,fin,packQ);
        if(typeof pj==="number"){
          const want=f[0]===f[1] ? toCur(pj) : Math.round(toCur(pj)*f[0]/f[1]), tol=(rate===1 && f[0]===f[1]) ? 0 : Math.max(2,Math.round(want*0.005));
          if(Math.abs(row.p-want)>tol){
            try{ console.warn("[proof-lab] band price table disagrees with the variant", j.s, fin, total, pj, row.p); }catch(e){}
            stale=true;   /* v3.12: refused below, unless the figure is outside the live packs (then sold as the pack above) */
          }
        }
      }
    } else if(PL_BAND_PRICES){
      /* a pack: the pack variant's own price, S = row.p, B = the table x rate. Refused (stale, or a GBP list): the
         cart takes the variant's own price, so that is the quote */
      const pj=bPence(j.s,fin,packQ);
      if(typeof pj==="number"){
        if(row && row.p>0){
          f=factor(row.p,toCur(pj),false);
          if(!f){
            try{ console.warn("[proof-lab] band price table disagrees with the variant", j.s, fin, total, pj, row.p); }catch(e){}
            return { lines:[{ idx:-1, v:{ id:row.id, p:row.p, a:row.a, s:j.s }, q:total }], cents:row.p, job:j };
          }
        } else if(rate!==1){
          /* the variant's price is not here yet: this finish's ladder is on its way (it redraws), or (another finish's
             row, display only) the hidden item's factor stands in until that finish is picked */
          if(fin===gCurFinSafe()) return { lines:[], cents:null, pending:true, job:j };
          const s=cqSentinel(j.s,fin);
          if(s==="pending") return { lines:[], cents:null, pending:true, job:j };
          f=(s>0) ? factor(s,toCur(999900),true) : null;
          if(!f) return { lines:[], cents:null, err:"price", job:j };
        } else {
          /* v3.12, rate 1 (display only until the ladder lands; the add waits for it): the hidden item's factor stands in,
             so the -5% GBP list (NO / Rest of World / International) shows its 0.95 here too; the UK stays 1 */
          const s=cqSentinel(j.s,fin);
          if(s>0) f=factor(s,toCur(999900),true)||[1,1];
        }
      }
    }
    /* the figure c (cart cents) in this market: round(c x S / B), c x S first */
    const up=c=>f[0]===f[1] ? c : Math.round(c*f[0]/f[1]);
    let cents=null;
    if(live.length<=1 && between){
      /* one design between packs: the straight line, to the nearest 5p (SPEC.md; transform v3.5 priceBetween) */
      const p=bPence50(j.s,fin,total);
      if(p==="pending") return { lines:[], cents:null, pending:true, job:j };
      if(p==null) return { lines:[], cents:null, err:"price", job:j };
      /* v3.12: never above the pack above's table price (binds only on a sale price that is not a price ending) */
      const top=PL_BAND_PRICES ? bPence(j.s,fin,packQ) : null, g5=Math.floor((p+125)/250)*5;   /* the table's own cell (no table: the ladder, no cap) */
      cents=up(toCur(typeof top==="number" ? Math.min(g5,top) : g5));   /* nearest 5p (the transform's priceBetween): the endings would price 99 as the 100 pack */
    } else if(live.length<=1){
      /* one design: the ladder price itself. In GBP that is the variant's own price; in another currency the GBP
         table price x rate x the factor, which is the variant's own price again (v3.10) */
      const p1=(PL_BAND_PRICES && rate!==1) ? bPence(j.s,fin,total) : null;
      if(typeof p1==="number") cents=up(toCur(p1));
      else if(row && row.p>0) cents=row.p;
      else { const p=bPence(j.s,fin,total); if(p==="pending") return { lines:[], cents:null, pending:true, job:j }; if(p==null) return { lines:[], cents:null, err:"price", job:j }; cents=up(toCur(p)); }
    } else {
      const shares=sharesIn||bShares(live,total);
      let num=0;
      for(let k=0;k<live.length;k++){
        const d=gDims(live[k]), b=d?bBandOf(d):{ err:"size" };
        if(b.err) return { lines:[], cents:null, err:b.err, job:j };
        const p=bPence50(b.s,fin,total);   /* 5 Oct: x50, so a figure between packs stays whole */
        if(p==="pending") return { lines:[], cents:null, pending:true, job:j };
        if(p==null) return { lines:[], cents:null, err:"price", job:j };
        num+=p*shares[k];
      }
      /* up to the penny (num is whole pence x quantities x 50 when P comes from the table), then the ending */
      const gbp0=between ? Math.floor((num+125*total)/(250*total))*5 : bEnding(Math.ceil(num/(total*GRID.step)-1e-9));   /* 5 Oct: between packs, nearest 5p (transform v3.5) */
      /* v3.12: never above the pack of the largest design's band (the job's band) at this pack; binds only on a sale price that is not an ending */
      const top=PL_BAND_PRICES ? bPence(j.s,fin,packQ) : null;   /* the table's own cell (no table: the ladder, no cap) */
      cents=up(toCur(typeof top==="number" ? Math.min(gbp0,top) : gbp0));
    }
    /* v3.12 (Bulk Edit sale, SALES.md): a figure between packs is sold only inside the live packs around it: above the pack above
       (a sale written, the table not yet synced) or, one design, under the pack below (a sale ended, the table not yet synced), it
       is sold as the pack above. Several designs: their pack below is priced from their own mix, not the job band's, so only the
       pack above bounds them here (the table check above refuses a stale table) */
    if(between && row && row.p>0 && cents>0 && row.a!==false){
      /* review 6 Oct: AT the pack above's price too (the product page's rule): fewer stickers never cost the whole pack */
      if(cents>=row.p || (live.length<=1 && rowLo && rowLo.p>0 && cents<rowLo.p)) return upPlan();
    }
    if(stale) return { lines:[], cents:null, err:"price", job:j };
    return { lines:[{ idx:-1, v:{ id:row?row.id:0, p:cents, a:row?row.a:true, s:j.s }, q:total }], cents:cents, pv:pv, job:j };
  }
  /* the virtual product the ORDER card draws; ids and prices refreshed on every strictVariant() */
  /* built once, before the rest of this panel exists: GRID data only, no design state (the
     consts below are not initialised yet); gSync() refills it on every strictVariant() */
  function gridProduct(src){
    const qn=stkT("stk.studio.order.quantity","Quantity");
    /* the title names the piece for the rows' "/ per sticker" (LabCart's unitWord reads it) */
    const P={ id:GRID.productId, title:String((src&&src.title)||"Custom Vinyl Stickers"), options:["Size","Finish",qn], variants:[], __grid:true };
    /* 2 Oct 2026: headings in the shop language; the option NAMES stay "Size"/"Finish"/qn (sel keys, finishOptIdx) */
    P.optionLabels={ Size:stkT("stk.studio.tool.size","Size"), Finish:stkT("stk.p172.proof_lab.finish","Finish") };
    P.optionLabels[qn]=stkT("products.product.quantity.label","Quantity");
    if(GRID.bands){
      /* option B: the 5 x 5 cm band's real packs until a design says otherwise (gFill) */
      const lbl0=String(GRID.variants[0].s), fins0=[];
      GRID.variants.forEach(v=>{ if(fins0.indexOf(v.f)<0) fins0.push(v.f); });
      fins0.forEach(f=>(GRID.presets||[50,100,200,500,1000,2000]).forEach(q=>{
        const v=GRID.variants.find(x=>String(x.s)===lbl0 && x.f===f && Number(x.q)===q), o=[lbl0,f,String(q)];
        P.variants.push({ id:v?Number(v.id):0, sku:v?v.sku:"", title:o.join(" / "), options:o, price:v?v.p:0, compare_at_price:0, available:!!v && v.a!==false });
      }));
      return P;
    }
    const pres=GRID.presets||[48,96,200,500,1000,2000], fins=[], lbl=String(GRID.variants[0].s);
    GRID.variants.forEach(v=>{ if(fins.indexOf(v.f)<0) fins.push(v.f); });
    fins.forEach(f=>{
      const base=GRID.variants.find(x=>x.f===f);
      pres.forEach(q=>{
        const c=gLine(base,q), o=[lbl,f,String(q)];
        P.variants.push({ id:Number(base.id), sku:base.sku, title:o.join(" / "), options:o, price:c==null?0:c, compare_at_price:0, available:base.a!==false && c!=null });
      });
    });
    return P;
  }
  function gFill(P,plans){
    if(BANDS){
      /* option B: every preset row is the job band's real pack for that finish */
      /* 2 Oct: every row's price is the job's summed price (bPlan) at that finish and quantity */
      const j=bJob(), lbl=(j&&j.s)||String(GRID.variants[0].s), vs=[];
      gFinishes().forEach(f=>{
        G_PRESETS.forEach(q=>{
          const pl=j.err?null:bPlan(q,f), ln=pl&&pl.lines&&pl.lines[0], ok=!!(pl && pl.cents!=null), o=[lbl,f,String(q)];
          vs.push({ id:(ln&&ln.v.id)?Number(ln.v.id):0, sku:"", title:o.join(" / "), options:o, price:ok?pl.cents:0, compare_at_price:0, available:ok && !(ln && ln.v.a===false) });
        });
      });
      P.variants=vs;
      return lbl;
    }
    const fins=gFinishes(), vs=[];
    let lbl=null;
    fins.forEach(f=>{
      const act=(function(){
        const live=liveDocIdxs(), i=live.indexOf(activeIdx)>=0?activeIdx:live[0];
        if(i==null){ const v=GRID.variants.find(x=>x.f===f); return v?{ v:v }:{}; }
        const d=gDims(i); return d?gPick(d,f):{};
      })();
      const base=act.v || GRID.variants.find(x=>x.f===f) || GRID.variants[0];
      if(lbl==null || f===gCurFinSafe()) lbl=(act.v&&act.v.s) || base.s;
      G_PRESETS.forEach(q=>{
        const pl=plans?plans(q,f):null, c=pl?pl.cents:gLine(base,q);
        vs.push({ id:Number(base.id), sku:base.sku, title:"", options:[null,f,String(q)], price:c==null?0:c,
          compare_at_price:0, available:(act.v?act.v.a!==false:!act.pending && !act.err && base.a!==false) && c!=null });
      });
    });
    vs.forEach(v=>{ v.options[0]=lbl; v.title=v.options.join(" / "); });
    P.variants=vs;
    return lbl;
  }
  function gCurFinSafe(){ try{ return gCurFin(); }catch(e){ return null; } }
  function gSync(){
    if(!GRID || !activeP || !activeP.__grid) return;
    const lbl=gFill(activeP,(q,f)=>gPlan(q,f));
    if(sizeOpt>=0 && lbl) sel[optNames[sizeOpt]]=lbl;
  }
  function syncToolSize(v){ const m=String(v).match(/[234]/); if(!m) return; const seg=root.getElementById("sizeSeg"); const btn=seg&&seg.querySelector('[data-v="'+m[0]+'"]'); if(btn && !btn.classList.contains("on")) btn.click(); }
  /* v1.7: the picker is a CARD IN THE LAB'S OWN PANEL, at the panel's width, price and
     button pinned to its foot (Thomas, 12 Sep 16:05: "it has to be adapted for the new
     screen"). ONE SIZE CONTROL: the Sticker card's size chips ARE the product's Size
     option, so Size is hidden from the picker and #sizeSeg drives sel[]. */
  const PICKER=window.LabCart.picker;
  /* v2.9: the ORDER card's styles moved to assets/proof-lab.css (same shadow root): the
     section had reached Shopify's 262,144-byte ceiling for a Liquid file. */
  /* ===== THE PACK, AND HOW IT SPLITS (v2.3, Thomas 12 Sep 22:20) ==========
     "the 4 files should show under each other like the upload field on the product page
     with the qty split auto until changed." So: ONE ladder for the pack, one row per
     design under it, split evenly with remainders to the first rows, and a row the
     customer types into is fixed while the rest re-split what is left.
     THE ALGORITHM AND THE PROPERTY NAMES ARE THE APP'S: ported from applyQtyDefaults in
     stickiply-uploads artwork-upload.js, and the line carries "Artwork Upload (n)" with
     "Artwork Upload (n) Qty" beside it (order #8588), which is what Studio's parser and
     the order manifest read. One cart line, the pack variant, quantity 1. */
  const perQty={};        // doc id -> count
  const qtyManual={};     // doc id -> the customer typed this one (18 Oct 2026: the order typed, 1, 2, 3...)
  let qtySeq=0, qtyEpoch=0;   /* qtyEpoch: bumped by every quantity or pack change the customer makes (Undo checks it) */
  /* v2.9.3: the ORDER panel's own half of resetPack(). The pack's quantities belong to
     the pack that was ordered, so they go when it does. */
  window.__plPackReset=function(){
    Object.keys(perQty).forEach(k=>delete perQty[k]);
    Object.keys(qtyManual).forEach(k=>delete qtyManual[k]);
    qtyEpoch++;
  };
  /* 18 Oct 2026 (Thomas: "yes" to the three gaps): closeDoc() keeps the figures as they stood
     and undoCloseDoc() hands them back, so Undo returns the customer's own split. Restored only
     when nothing else changed meanwhile: the same pack and the same designs, plus the one coming
     back. Otherwise the pack re-splits as usual. */
  window.__plQtySnap=function(){
    const ids=liveDocIdxs().map(i=>docs[i].id), q={}, m={};
    ids.forEach(id=>{ q[id]=perQty[id]; if(qtyManual[id]) m[id]=qtyManual[id]; });
    return { total:packTotal(), ids:ids, q:q, m:m, epoch:qtyEpoch };
  };
  window.__plQtyRestore=function(s, backId){
    if(!s || !s.ids || s.epoch!==qtyEpoch || s.total!==packTotal() || s.ids.indexOf(backId)<0) return;
    const now=liveDocIdxs().map(i=>docs[i].id);
    if(now.length+1!==s.ids.length || now.some(id=>s.ids.indexOf(id)<0)) return;
    s.ids.forEach(id=>{ perQty[id]=s.q[id]; if(s.m[id]) qtyManual[id]=s.m[id]; else delete qtyManual[id]; });
  };
  /* v2.9.3: the order as it stood when it succeeded, and the bar's phase. Both exist
     because the editor is emptied as soon as the add returns (see the rule by docs[]). */
  let addedSnap=null;
  const addPhase={ name:null, n:0, of:0 };
  function orderSnapshot(){
    const liveNow=liveDocIdxs();
    const thumbs=liveNow.map(i=>docs[i]&&(docs[i].thumb||(i===activeIdx&&art?docThumbPNG():null))).filter(Boolean);
    const rows=proofRows(liveNow.length);
    const total=chargedPence();
    const q=packTotal()||0;
    /* i18n: third item = the row's role, fourth = the done card's own wording, so
       lab-proof-confirm.js never parses a label that is now translated */
    if(total!=null && q>0){ const pu=money(Math.round(total/q)); rows.push([stkFmt(stkT("stk.studio.order.per_unit","Per [unit]"),{unit:nounOne(NOUN)}), pu, "per", stkFmt(stkT("stk.studio.order.done_per_unit","[price] per [unit]"),{price:pu,unit:nounOne(NOUN)})]); }
    return { thumbs:thumbs, rows:rows, n:liveNow.length };
  }
  /* v2.9.3 (Thomas: "the added to your cart is now over the studio not automatically
     going back to the product page"). Empty pack, lab closed, card left over the product
     page. ADD MORE DESIGNS reopens it. */
  function finishAfterAdd(){
    overlayStatus=null;
    try{ resetPack(); }catch(e){}
    try{ if(window.proofLab) window.proofLab.close(); }catch(e){}
    try{ draw(); }catch(e){}
  }
  function qtyName(){ return optNames[qtyOptIdx()]; }
  /* P128: a typed quantity (48 to 2,000) is the pack while it is set; every share (setQty / qtyLimit /
     splitPack) reads packTotal(), so the designs rebalance off it with no arithmetic for the customer */
  let customQty=null;
  function packTotal(){ return (PL_TRUE_SIZE && customQty) ? customQty : qtyNumber(sel[qtyName()]); }
  /* ONE TRUTH, v2.4. The panel, the proof window and the cart all count designs
     with THIS function and nothing else. v2.3 had two - liveDocIdxs() here and
     liveIdxs() by the proof window - and they disagreed the moment a fourth
     file landed: the panel said 3 designs at 16 each while the proof said 4
     (Thomas, 12 Sep 23:00). A slot counts when its record carries artwork, or
     when it is the slot on screen and the editor is holding artwork. */
  function liveDocIdxs(){ const o=[]; docs.forEach((d,i)=>{ if(d&&(d.art||(i===activeIdx&&art))) o.push(i); }); return o; }
  function splitPack(){
    const live=liveDocIdxs(); if(!live.length) return;
    const total=packTotal(); if(!total) return;
    /* 18 Oct 2026 (measured: the Final check showed 30 beside a 50 pack after a design was removed):
       when the design taking up the rest is removed, every design left can be fixed and the shares stop
       adding up (the tile showed the old figure, the price split the pack evenly, Add to cart refused
       with the money guard). setQty's rule now holds after a removal too:
       - a lone design is never fixed: its figure is the pack;
       - with two or more, one always takes up the rest: the design typed longest ago gives way and keeps
         the newer typed figures (Thomas: "yes" to keeping them, 18 Oct);
       - fixed figures over the pack (a product switch to a smaller pack): every design gives way. */
    if(live.length===1) delete qtyManual[docs[live[0]].id];
    let auto=live.filter(i=>!qtyManual[docs[i].id]);
    let manualSum=live.reduce((n,i)=>n+(qtyManual[docs[i].id]?(Number(perQty[docs[i].id])||0):0),0);
    if(manualSum>total){
      live.forEach(i=>{ delete qtyManual[docs[i].id]; });
      auto=live; manualSum=0;
    } else if(!auto.length){
      const oldest=live.reduce((a,i)=>(Number(qtyManual[docs[i].id])<Number(qtyManual[docs[a].id])?i:a), live[0]);
      manualSum-=Number(perQty[docs[oldest].id])||0;
      delete qtyManual[docs[oldest].id];
      auto=[oldest];
    }
    const remaining=Math.max(0,total-manualSum);
    const base=Math.floor(remaining/auto.length), rem=remaining-base*auto.length;
    auto.forEach((idx,j)=>{ perQty[docs[idx].id]=base+(j<rem?1:0); });
  }
  /* v3.1 (Thomas, 24 Sep: "if i enter 502 it says something weird, i shouldnt be able to go
     to 502 if i selected 500. it should be greyed out on +"). THE SHARES ALWAYS ADD UP TO THE
     PACK. The design being changed takes its new figure and at least one other design always
     takes up the rest, so no figure can push the total past the pack: + stops at what the
     others can give up, - at 0, and with one design its figure IS the pack. */
  function qtyLimit(id){
    const live=liveDocIdxs(), total=packTotal()||0;
    const others=live.filter(i=>docs[i].id!==id);
    if(!others.length) return { min:total, max:total };
    const autoOthers=others.filter(i=>!qtyManual[docs[i].id]);
    const fixed=autoOthers.length ? others.reduce((n,i)=>n+(qtyManual[docs[i].id]?(Number(perQty[docs[i].id])||0):0),0) : 0;
    return { min:0, max:Math.max(0,total-fixed) };
  }
  function setQty(id,v){
    const lim=qtyLimit(id);
    const n=Math.min(lim.max,Math.max(lim.min,Math.round(Number(v)||0)));
    const others=liveDocIdxs().filter(i=>docs[i].id!==id);
    /* every other design already fixed: they give way, so the pack still adds up */
    if(others.length && !others.some(i=>!qtyManual[docs[i].id])) others.forEach(i=>{ delete qtyManual[docs[i].id]; });
    perQty[id]=n;
    qtyEpoch++;
    if(others.length) qtyManual[id]=++qtySeq;     /* a lone design is not "fixed": the next one shares the pack (18 Oct: the order typed, for splitPack) */
    splitPack();
  }
  function qtyLimits(live){
    const m={};
    live.forEach(i=>{ m[String(i)]=qtyLimit(docs[i].id); });
    return m;
  }
  /* v3.6 (Thomas: "cant type in the final check quantity"). With ONE design its figure is the pack,
     so in the Final check a typed figure or a step picks the PACK: up goes to the smallest pack that
     holds the figure, down to the largest pack under it (the largest / smallest at the ends), exactly
     as ticking that QUANTITY row on ORDER does; the price box follows. Two or more designs keep the
     shares (qtyLimit / setQty). The ORDER card's own stepper is unchanged: its QUANTITY rows sit under it. */
  function packList(){
    const nm=qtyName();
    return [...mount.querySelectorAll("input[data-opt]")]
      .filter(r=>r.getAttribute("data-opt")===nm && !r.disabled)
      .map(r=>({ v:r.getAttribute("data-val"), n:qtyNumber(r.getAttribute("data-val")) }))
      .sort((a,b)=>a.n-b.n);
  }
  function finalLim(id){
    if(liveDocIdxs().length!==1) return qtyLimit(id);
    if(PL_TRUE_SIZE) return { min:QTY_MIN, max:QTY_MAX };   /* P128: one design types any quantity */
    const p=packList();
    return p.length ? { min:p[0].n, max:p[p.length-1].n } : qtyLimit(id);
  }
  /* P128: set the order quantity to a typed figure. 2,000 is where the box stops (Thomas: no message
     past it); under 48 is kept and refused with his words; a figure that IS a preset selects that
     preset, so a catalogue size at a catalogue quantity still rides its own variant. */
  const QTY_MIN=PL_MG?Number(PL_GRID.min):((PL_GRID&&PL_GRID.bands)?50:48), QTY_MAX=PL_MG?Number(PL_GRID.max):2000;   /* P128 grid too since 27 Sep 23:10 (Thomas: "2000 should be max"), exact; option B starts at 50 */
  const QTY_STEP=1;   /* 5 Oct 2026 (Thomas: "51-99 should have individual pricing"): every figure, not 50s (1 Oct); bPence50 prices it */
  /* option B words: the shop's own translated keys where one already says it (P1 key budget) */
  const B_NUM=n=>{ try{ return Number(n).toLocaleString(document.documentElement.lang||undefined); }catch(e){ return String(n); } };
  const QTY_ERR_SMALL=stkFmt(stkT("stk.pricing.err_min_order","The smallest order is [min] stickers."),{min:PL_MG?QTY_MIN:((PL_GRID&&PL_GRID.bands)?50:48)});
  const QTY_ERR_BIG="Over 2,000? Email us and we will quote it.";
  function setCustomQty(n){
    n=Math.round(Number(n)||0);
    if(PL_MG && n>0 && n<=QTY_MAX) n=bMgUp(n);   /* magnets: UP to the next pack (50 -> 52, 5 -> 12); over 200 is kept and refused (the email line) */
    /* option B: a figure inside 50 to 2,000 goes UP to the next 50 (170 -> 200: the customer gets at
       least what they typed); outside it is kept and refused */
    if(QTY_STEP>1 && n>=QTY_MIN && n<=QTY_MAX) n=Math.min(QTY_MAX,Math.ceil(n/QTY_STEP)*QTY_STEP);   /* inert since 5 Oct (QTY_STEP 1) */
    if(n>QTY_MAX && !GRID) n=QTY_MAX;        /* the grid keeps the figure and says why it cannot */
    if(n<=0){ customQty=null; }
    else {
      const p=packList().find(x=>x.n===n);
      if(p){ sel[qtyName()]=p.v; customQty=null; }
      else customQty=n;
    }
    Object.keys(qtyManual).forEach(k=>delete qtyManual[k]); qtyEpoch++;
    draw();
  }
  function qtyError(){
    if(GRID && customQty && customQty>QTY_MAX) return BANDS ? stkT("stk.pricing.err_too_big_email","That order is too big to price here. Please email hello@stickiply.com and we will quote it.") : stkFmt(stkT("stk.studio.order.grid_over_max",QTY_ERR_BIG),{max:B_NUM(QTY_MAX)});
    return (PL_TRUE_SIZE && customQty && customQty<QTY_MIN) ? QTY_ERR_SMALL : null;
  }
  function finalLims(live){
    const m={};
    live.forEach(i=>{ m[String(i)]=finalLim(docs[i].id); });
    return m;
  }
  function pickPackFor(n){
    if(PL_TRUE_SIZE){ setCustomQty(n); return; }            /* P128: the typed figure IS the order */
    const p=packList(), cur=packTotal(); n=Math.round(Number(n)||0);
    if(!p.length || n===cur) return;
    const t = n>cur ? (p.find(x=>x.n>=n)||p[p.length-1]) : (p.slice().reverse().find(x=>x.n<=n)||p[0]);
    if(t.n===cur) return;
    sel[qtyName()]=t.v;
    Object.keys(qtyManual).forEach(k=>delete qtyManual[k]); qtyEpoch++;
    draw();
  }
  /* ===== THE ORDER CARD OPENS WITH FOUR QUARTERS (v2.5) ==================
     Thomas, 12 Sep 17:30, verbatim: "top of order screen should be 2x2 grid of
     tiles showing available spots for new designs. with subtitle add more
     designs? and then the variants etc underneath, no need for the stock part."
     Four equal quarters; a filled one carries thumbnail, name and its own stepper on the
     SAME pack split (data-sau / data-sauq); an empty one is the page's upload field. */
  /* v3.2: the stepper's minus and plus are drawn, so they sit dead centre in the circle */
  const QMINUS='<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M3 7h8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  const QPLUS='<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M3 7h8M7 3v8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  const OQ_ADD_SVG='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M17 8l-5-5-5 5"/><path d="M12 3v12"/></svg>';
  const OQ_X_SVG='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function orderGrid(live){
    if(MAX_DESIGNS<2 && !PL_MG) return "";          // v2.6: one design per order has no grid to fill (magnets: the ORDER card below)
    /* v3.9 (Thomas: "dark mode artwork preview missing"): a quarter drew an empty box whenever the
       design's thumbnail had been cleared (captureDoc nulls it) and the slot strip had not rebuilt
       it yet. Rebuilt here the way renderDocTabs does: the others first, the one on screen last. */
    try{
      live.forEach(i=>{ const d=docs[i]; if(d && !d.thumb && d.art && i!==activeIdx) withDoc(i,()=>{ d.thumb=docThumbPNG(); }); });
      if(activeIdx>=0 && docs[activeIdx] && !docs[activeIdx].thumb && art) docs[activeIdx].thumb=docThumbPNG();
    }catch(e){}
    /* the tiles show each design in the chosen finish once the finish renderer is in (Thomas, 28 Sep) */
    const fin=(typeof finishId==="function" && finishId()) || orderFinish;
    const finUrl={};
    if(holoMod){
      live.forEach(i=>{
        const d=docs[i]; if(!d) return;
        const o=(i===activeIdx) ? opts : d.opts, a=(i===activeIdx) ? art : d.art;
        const key=fin+"|"+JSON.stringify(o)+"|"+((i===activeIdx?eraseStrokes:d.eraseStrokes)||[]).length;
        if(d._finKey!==key || d._finArt!==a){ const u=finishedPNG(i, fin, 360); if(u){ d._finKey=key; d._finArt=a; d._finUrl=u; } }
        if(d._finKey===key) finUrl[i]=d._finUrl;
      });
    } else if(!orderGrid._waiting){ orderGrid._waiting=true; try{ holoReady().then(()=>{ if(holoMod) draw(); }).catch(()=>{}); }catch(e){} }
    /* CUSTOM MAGNETS (30 Oct 2026, Thomas: "the order screen needs to same style as the other builders the preview mock up window
       with edit button"): ONE design per order, so ORDER opens with the bookmark Studio's design card - the finished magnet in the
       chosen finish's look, its size and name, X to remove, and the orange EDIT DESIGN that goes back to the design. The quantity
       is the Quantity list's (one design per order); no add tile, no count. */
    if(PL_MG && MAX_DESIGNS<2){
      const i=live[0]; if(i==null) return "";
      const d=docs[i], id=d.id;
      let pic=finUrl[i]||null;
      if(holoMod){ const o=(i===activeIdx)?opts:d.opts, k2=fin+"|"+JSON.stringify(o)+"|"+((i===activeIdx?eraseStrokes:d.eraseStrokes)||[]).length;
        if(d._mgKey!==k2 || d._mgArt!==((i===activeIdx)?art:d.art)){ const u=finishedPNG(i, fin, 720); if(u){ d._mgKey=k2; d._mgArt=(i===activeIdx)?art:d.art; d._mgUrl=u; } }
        if(d._mgKey===k2) pic=d._mgUrl; }
      pic=pic||d.thumb;
      const nm=(function(){ const n0=d.artName||stkFmt(stkT("stk.studio.design.n","Design [n]"),{n:1}); const sz=BANDS?gWH(gDims(i)):""; return sz?sz+" \u00b7 "+n0:n0; })();
      return '<div class="ogrid ogrid--one"><div class="oq is-filled on" data-sau="'+esc(id)+'" role="button" tabindex="0" aria-label="'+stkEsc(stkT("stk.studio.design.edit_aria","Edit this design"))+'">'+
        '<button type="button" class="oq__x" data-oqx="'+esc(id)+'" aria-label="'+stkEsc(stkT("stk.studio.design.remove_aria","Remove this design"))+'">'+OQ_X_SVG+'</button>'+
        (pic?'<img class="oq__th" alt="" src="'+pic+'">':'<span class="oq__th"></span>')+
        '<span class="oq__nm">'+esc(nm)+'</span>'+
        '<button type="button" class="oq__edit" data-oqedit="'+esc(id)+'"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg><span>'+stkEsc(stkT("stk.studio.tool.edit_design","Edit design"))+'</span></button>'+
        '</div></div>';
    }
    const total=packTotal();
    const sum=live.reduce((n,i)=>n+(Number(perQty[docs[i].id])||0),0);
    let cells="", empties=0;
    for(let s=0;s<MAX_DESIGNS;s++){
      const i=live[s];
      if(i==null){
        empties++;
        /* v3.1: the product page's own count, "1 of 4 uploaded", on the add tile (Thomas, 24 Sep) */
        cells+='<button type="button" class="oq is-empty" data-oqadd aria-label="'+stkEsc(stkT("stk.studio.design.add","Add a design"))+'">'+
          '<span class="oq__ic">'+OQ_ADD_SVG+'</span>'+
          '<span class="oq__addtx"><span class="oq__add">'+stkEsc(stkT("stk.studio.design.add","Add a design"))+'</span>'+
          (empties===1?'<span class="oq__cnt">'+stkEsc(stkFmt(stkT("stk.studio.design.uploaded_count","[filled] of [total] uploaded"),{filled:live.length,total:MAX_DESIGNS}))+'</span>':'')+'</span></button>';
        continue;
      }
      const d=docs[i], id=d.id, q=Number(perQty[id])||0, lim=finalLim(id);   /* v3.9: one design steps the packs */
      cells+='<div class="oq is-filled'+(i===activeIdx?" on":"")+'" data-sau="'+esc(id)+'" role="button" tabindex="0" aria-label="'+stkEsc(stkT("stk.studio.design.edit_aria","Edit this design"))+'">'+
        '<span class="oq__n">'+(s+1)+'</span>'+
        '<button type="button" class="oq__x" data-oqx="'+esc(id)+'" aria-label="'+stkEsc(stkT("stk.studio.design.remove_aria","Remove this design"))+'">'+OQ_X_SVG+'</button>'+
        ((finUrl[i]||d.thumb)?'<img class="oq__th" alt="" src="'+(finUrl[i]||d.thumb)+'">':'<span class="oq__th"></span>')+
        '<span class="oq__nm">'+esc((function(){ const nm=d.artName||stkFmt(stkT("stk.studio.design.n","Design [n]"),{n:s+1}); const sz=BANDS?gWH(gDims(i)):""; return sz?sz+" \u00b7 "+nm:nm; })())+'</span>'+   /* 2 Oct (sizes.md edit 5) */
        '<span class="sau-qty oq__q">'+
          '<button type="button" data-sauq="-1" aria-label="'+stkEsc(stkT("stk.studio.design.qty_minus","One fewer"))+'"'+(q<=lim.min?' disabled':'')+'>'+QMINUS+'</button>'+
          '<input type="number" min="'+lim.min+'" max="'+lim.max+'" inputmode="numeric" value="'+q+'" aria-label="'+stkEsc(stkT("stk.studio.design.qty_input","Quantity of this design"))+'"'+(lim.min===lim.max?' readonly':'')+'>'+
          '<button type="button" data-sauq="1" aria-label="'+stkEsc(stkT("stk.studio.design.qty_plus","One more"))+'"'+(q>=lim.max?' disabled':'')+'>'+QPLUS+'</button>'+
        '</span></div>';
    }
    /* v2.6 (item 10, Thomas: "add more designs? below the 4 tiles. no need."):
       the subtitle is gone; the empty quarters say it themselves */
    return '<div class="ogrid">'+cells+'</div>'+
      (live.length && sum!==total ? '<div class="ogrid__warn">'+stkEsc(stkFmt(stkT("stk.studio.order.sum_warn","These add up to [sum], and the pack is [total]. Adjust one quarter."),{sum:sum,total:total}))+'</div>' : "");
  }
  /* v3.1 (Thomas, 24 Sep: "if i click matte/gloss/glitter it scrolls back up to the top ...
     same with quantity"). draw() replaces the whole ORDER card, and WebKit clamped the sheet's
     scroll to 0 while it did (measured: 300 -> 0 on a finish tap, 450 -> 0 on a pack tap).
     Every scrolling box around the card keeps its position through the redraw. */
  function scrollBoxes(){
    const out=[]; const pb=root.querySelector(".panel__body"); if(pb) out.push(pb);
    const sb=host.closest&&host.closest(".plx-body"); if(sb) out.push(sb);
    return out;
  }
  let cqRefocus=false;
  /* option B quotes as the figure is typed (Thomas, 1 Oct): what the customer typed stays in the
     box (cqRaw) while the card redraws around it; cqDrawing stops the blur a redraw causes from
     reading as the customer leaving the box */
  let cqRaw=null, cqDrawing=false, cqTimer=0;
  /* 2 Oct 2026 (perf.md C): the redraws nobody is waiting on (a ladder reply, a size change, the poll)
     are merged into ONE per animation frame; a draw that runs in between makes the pending one moot */
  function drawSoon(){
    if(drawSoon.raf) return;
    const go=()=>{ drawSoon.raf=0; try{ draw(); }catch(e){} };
    drawSoon.raf=(typeof requestAnimationFrame==="function") ? requestAnimationFrame(go) : setTimeout(go,16);
  }
  function draw(){
    if(drawSoon.raf){ try{ cancelAnimationFrame(drawSoon.raf); }catch(e){} drawSoon.raf=0; }
    const keep=scrollBoxes().map(b=>[b,b.scrollTop]);
    const rk0=mount.querySelector("#cartRights"), rights0=rk0?rk0.checked:null;   /* the tick survives the redraw */
    cqDrawing=true;
    try{ drawCard(); } finally { cqDrawing=false; }
    if(rights0!=null){ const rk1=mount.querySelector("#cartRights"); if(rk1) rk1.checked=rights0; }
    try{ draw.seenMm=effectiveSize().mm; if(GRID){ const d=gDims(activeIdx); draw.seenGk=d?d.w+"x"+d.h:""; } }catch(e){}
    keep.forEach(k=>{ if(k[0].scrollTop!==k[1]) k[0].scrollTop=k[1]; });
    if(cqRefocus){ const id=cqRefocus===true?"cqIn":cqRefocus; cqRefocus=false; const c=root.getElementById(id); if(c) try{ c.focus({ preventScroll:true });
      /* 5 Oct 2026 (Thomas: "when i type 400, its randomly deleting the 4"): the box is rebuilt 300 ms after each key, and
         focusing a fresh box SELECTS ALL of it in Safari (the next digit replaced the 4) and puts the caret at the start in
         Chrome ("04"). A number box has no setSelectionRange, so the value is set again: caret at the end, nothing selected. */
      if(id==="cqIn"){ const v=c.value; c.value=""; c.value=v; } }catch(e){} }
  }
  /* P128b gap 3 (6 Oct 2026): a short random id for one hidden-item job (hidden key _stk_job, never printed) */
  function stkJobId(){
    try{ const a=new Uint8Array(6); crypto.getRandomValues(a); return Array.prototype.map.call(a,x=>(x%36).toString(36)).join("")+Date.now().toString(36).slice(-4); }
    catch(e){ return Math.random().toString(36).slice(2,8)+Date.now().toString(36).slice(-4); }
  }
  /* P128b gap 1 (6 Oct 2026): every custom line costs the cart transform and the discount about a million
     instructions and Shopify stops a function at 11 million per cart; past that every custom line falls back to
     its own price. The cart (read from /cart.js) plus this job is weighed with stickiply-custom/shared/job-weight.mjs,
     inlined below, and refused over its BUDGET (the cap less 10%). The line is built as /cart.js would show it:
     product id, SKU (band, finish, pack) and the "_Artwork N size" keys that carry each design's qty. A cart that
     cannot be read lets the add through (the checkout validation is the backstop). */
  function jobCapMsg(){ return stkT("stk.cart.job_cap","This order can't hold more custom sticker jobs. Check out this order, then start a new one for the rest."); }
  async function jobCapFull(isCq,band,fin,total,props){
    try{
      const JW=stkJobWeight(), m=/^S(\d+)$/.exec(String(band||"")), b=m?String(m[1]).padStart(2,"0"):"17", F=String(fin||"").toUpperCase();
      const line={ product_id:isCq?JW.PRODUCT_CQ:JW.PRODUCT_PACK, sku:isCq?"CVS-CQ-S"+b+"-"+F:"CVS-S"+b+"-"+F+"-"+String(bPackQ(total)).padStart(4,"0"), properties:props||{} };
      const rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
      const c=await (await fetch(rootUrl+"cart.js",{ cache:"no-store", headers:{ Accept:"application/json" } })).json();
      const full=!JW.cartFits(((c&&c.items)||[]).concat([line]));
      if(full) try{ console.warn("[proof-lab] job cap: cart weight", JW.cartWeight(((c&&c.items)||[]).concat([line])), "over", JW.BUDGET); }catch(e){}
      return full;
    }catch(e){ return false; }
  }
/* BEGIN GENERATED stk-job-weight: AI/stickiply-custom/shared/job-weight.mjs md5 4f1f8979586831fd42326bad0804c75b, by gaps-2026-10-06/theme/gen-job-weight-inline.mjs. Do not edit: regenerate. */
function stkJobWeight(){
if(stkJobWeight.m) return stkJobWeight.m;
stkJobWeight.m=(function(){
/* Stickiply Custom - what one cart line costs a Shopify Function, in instructions.   6 Oct 2026 (P128b gap 1)

   Why: a function run is cut off at 11,000,000 instructions, PER CART. Every custom line (a design job) costs the
   cart transform (custom-price) and the discount (cq-round) about a million each, so a cart of six to twenty
   custom jobs (by type) goes over: every custom line then falls back to its own price. This module is the one
   place that knows the cost of each kind of line, so the product page, Studio, the cart and the custom-line-guard
   validation can all ask the same question: does this cart still fit?

   The numbers are MEASURED, not estimated: `shopify app function run` (CLI 4.8.2) on the built wasm of band-line
   v3.9 (lazy ladder), one cart per line type at 1 and 6 lines, the cost of one line = (6 lines - 1 line) / 5.
   Each weight is the MAX of custom-price and cq-round (the cart must fit both), rounded UP to a whole instruction,
   and is the worst case of its type: Finish Glitter (longest prices), designs spread over as many different bands
   as the line allows, a between-packs quantity (two price cells per design). Regenerate with
   AI/stickiply-custom/gaps-2026-10-06/ladder/gen-weights.mjs after any change to band-line.mjs, the size table or
   the price tables' shape, then re-run tests/job-weight.test.mjs.

   BUDGET is the cap less a 10% safety margin. A cart with FIXED + the sum of its line weights over BUDGET does not fit.

   Shapes accepted by lineWeight: a /cart.js item ({product_id, sku, properties: {key: value}}), a Storefront or
   function cart line ({merchandise: {sku, product: {id}}} with attributes as {key, value} rows, or the function's
   aliased reads hsize1..4, up1..4, upq1..4), and an order line item ({product_id, sku, properties: [{name, value}]}). */

const PRODUCT_PACK = "15921984602495";   /* Custom Vinyl Stickers, the band product (SKU CVS-Snn-FINISH-qqqq) */
const PRODUCT_CQ = "15931199717759";     /* the hidden custom-quantity item (SKU CVS-CQ-Snn-FINISH) */
const PRODUCT_OLD = "8759617880358";     /* the old catalogue product: no function runs on it, it costs like any plain line */

const CAP = 11000000;
const SAFETY = 0.10;
const BUDGET = Math.floor(CAP * (1 - SAFETY));

/* BEGIN MEASURED (generated by gaps-2026-10-06/ladder/gen-weights.mjs from results-o2.json; do not edit by hand) */
/* the fixed cost of a cart with any custom line (an empty cart costs less), and one plain line */
const FIXED = 1169138;
const PER_PLAIN_LINE = 80710;
/* instructions per line, index = designs - 1. cq: a Studio line on the hidden item, by the item's band (SKU); cqPage: a product-page
   line on the hidden item (the three chips); pack: a pack-variant line (the dearest band measured: S5, S8, S17 Studio; S5, S8, S12 page) */
const WEIGHTS = {
  cq: {
    S1: [480376, 599959, 712178, 827122],
    S2: [517862, 679000, 803818, 924059],
    S3: [548777, 712172, 850092, 955956],
    S4: [582651, 747760, 881724, 1019786],
    S5: [617478, 781504, 918123, 1056269],
    S6: [649353, 814909, 956953, 1094046],
    S7: [688300, 854032, 995793, 1137369],
    S8: [717842, 887281, 1033305, 1172569],
    S9: [749590, 916806, 1068389, 1209977],
    S10: [783854, 948835, 1085614, 1248971],
    S11: [818886, 968311, 1132980, 1280480],
    S12: [851350, 1019460, 1169648, 1319615],
    S13: [882902, 1053272, 1204728, 1355181],
    S14: [917102, 1086879, 1240128, 1391680],
    S15: [952407, 1122601, 1279537, 1433341],
    S16: [988116, 1160557, 1315155, 1468461],
    S17: [1018675, 1194062, 1351912, 1505728],
  },
  cqPage: {
    S5: [613525, 715164, 815332, 916427],
    S8: [718813, 830965, 941375, 1052829],
    S12: [848505, 963219, 1077271, 1190609],
  },
  pack: {
    studio: { between: [611298, 757852, 897392, 1033502], exact: [592252, 757852, 897392, 1033502] },
    page: { between: [592085, 707358, 819843, 931599], exact: [483167, 562345, 637679, 715483] },
  },
};
/* END MEASURED */

/* ---------------- reading a cart line, whatever its shape ---------------- */
const SIZE_KEYS = ["_Artwork 1 size", "_Artwork 2 size", "_Artwork 3 size", "_Artwork 4 size"];
const UP_KEYS = ["_Artwork Upload (1)", "_Artwork Upload (2)", "_Artwork Upload (3)", "_Artwork Upload (4)"];
const UPQ_KEYS = ["_Artwork Upload (1) Qty", "_Artwork Upload (2) Qty", "_Artwork Upload (3) Qty", "_Artwork Upload (4) Qty"];
const ALIAS = { "_Artwork 1 size": "hsize1", "_Artwork 2 size": "hsize2", "_Artwork 3 size": "hsize3", "_Artwork 4 size": "hsize4",
  "_Artwork Upload (1)": "up1", "_Artwork Upload (2)": "up2", "_Artwork Upload (3)": "up3", "_Artwork Upload (4)": "up4",
  "_Artwork Upload (1) Qty": "upq1", "_Artwork Upload (2) Qty": "upq2", "_Artwork Upload (3) Qty": "upq3", "_Artwork Upload (4) Qty": "upq4" };

function present(v) { return v !== undefined && v !== null && v !== ""; }

/* the value of a property by its real key: from an object, an array of {key|name, value}, or the function's alias */
function prop(line, key) {
  const p = line.properties !== undefined ? line.properties : line.attributes;
  if (p && typeof p === "object" && !Array.isArray(p) && present(p[key])) return p[key];
  if (Array.isArray(p)) {
    for (let i = 0; i < p.length; i++) {
      const row = p[i];
      if (row && (row.key === key || row.name === key) && present(row.value)) return row.value;
    }
  }
  const a = line[ALIAS[key]];
  if (a !== undefined && a !== null) {
    const v = typeof a === "object" ? a.value : a;
    if (present(v)) return v;
  }
  return null;
}

function digits(x) {
  if (x === undefined || x === null) return null;
  const m = /(\d+)\s*$/.exec(String(x));
  return m ? m[1] : null;
}

function productOf(line) {
  const m = line.merchandise || line.variant || null;
  if (line.product_id !== undefined) return digits(line.product_id);
  if (line.productId !== undefined) return digits(line.productId);
  if (m && m.product && m.product.id !== undefined) return digits(m.product.id);
  if (line.product && line.product.id !== undefined) return digits(line.product.id);
  return null;
}
function skuOf(line) {
  const m = line.merchandise || line.variant || null;
  if (typeof line.sku === "string") return line.sku;
  if (m && typeof m.sku === "string") return m.sku;
  return "";
}

/* what kind of line this is, and what the cost depends on:
   { kind: "cq" | "pack" | "plain", mode: "studio" | "page", band, designs (1..4), between } */
function classify(line) {
  if (!line || typeof line !== "object") return { kind: "plain" };
  const pid = productOf(line), sku = skuOf(line);
  const cq = /^CVS-CQ-S(\d{1,2})-(MATTE|GLOSSY|GLITTER)$/.exec(sku);
  const pack = /^CVS-S(\d{1,2})-(MATTE|GLOSSY|GLITTER)-(\d{4})$/.exec(sku);
  const isCq = pid === PRODUCT_CQ || (pid === null && !!cq), isPack = pid === PRODUCT_PACK || (pid === null && !!pack);
  if (!isCq && !isPack) return { kind: "plain" };

  /* the job: Studio sizes, else page uploads; none at all (a bare line, refused by the function) counts as one design */
  let sizes = 0, uploads = 0, nStudio = 0, nPage = 0, qtyKnown = true;
  for (let i = 0; i < 4; i++) {
    const s = prop(line, SIZE_KEYS[i]);
    if (s !== null) {
      sizes++;
      const q = /qty (\d+)\s*$/.exec(String(s));
      if (q) nStudio += Number(q[1]); else qtyKnown = false;
    }
    if (prop(line, UP_KEYS[i]) !== null) {
      uploads++;
      const q = prop(line, UPQ_KEYS[i]);
      if (q !== null && /^\d+$/.test(String(q))) nPage += Number(q); else qtyKnown = false;
    }
  }
  const page = sizes === 0 && uploads > 0;
  const designs = Math.min(4, Math.max(1, page ? uploads : sizes));
  const N = page ? nPage : nStudio;

  if (isCq) {
    const b = cq ? Number(cq[1]) : 17;                              /* an unreadable band is weighed as the largest */
    return { kind: "cq", mode: page ? "page" : "studio", band: b >= 1 && b <= 17 ? b : 17, designs: designs };
  }
  const b = pack ? Number(pack[1]) : 17, Q = pack ? Number(pack[3]) : 0;
  /* a pack line whose designs add up to its pack is the cheap case; anything else (or unreadable) is the dear one */
  const between = !(qtyKnown && (page ? uploads : sizes) > 0 && N === Q);
  return { kind: "pack", mode: page ? "page" : "studio", band: b >= 1 && b <= 17 ? b : 17, designs: designs, between: between };
}

/* instructions one cart line costs a function run (the larger of custom-price and cq-round) */
function lineWeight(line) {
  const c = classify(line);
  if (c.kind === "plain") return PER_PLAIN_LINE;
  if (c.kind === "cq") {
    if (c.mode === "page") {
      const row = WEIGHTS.cqPage["S" + c.band];
      if (row) return row[c.designs - 1];                           /* a page line exists at the three chips only; elsewhere it is refused, below */
    }
    return WEIGHTS.cq["S" + c.band][c.designs - 1];
  }
  return WEIGHTS.pack[c.mode][c.between ? "between" : "exact"][c.designs - 1];
}

/* the whole cart: FIXED + every line */
function cartWeight(lines) {
  let w = FIXED;
  if (!lines) return w;
  for (let i = 0; i < lines.length; i++) w += lineWeight(lines[i]);
  return w;
}

/* true when the cart, with a safety margin, stays under the 11,000,000 cap */
function cartFits(lines) {
  return cartWeight(lines) <= BUDGET;
}

/* how many MORE lines of this kind fit beside the lines already in the cart (0 when it is full) */
function roomFor(lines, line) {
  const w = lineWeight(line);
  if (!(w > 0)) return Infinity;
  const left = BUDGET - cartWeight(lines);
  return left < 0 ? 0 : Math.floor(left / w);
}

/* how many lines of one type fit in an otherwise empty cart under BUDGET: maxJobs("cq", {band: 17, designs: 4}) */
function maxJobs(kind, o) {
  o = o || {};
  const d = o.designs || 1, b = o.band || 17;
  let w;
  if (kind === "plain") w = PER_PLAIN_LINE;
  else if (kind === "cq") w = WEIGHTS.cq["S" + b][d - 1];
  else if (kind === "cqPage") w = WEIGHTS.cqPage["S" + b][d - 1];
  else if (kind === "pack") w = WEIGHTS.pack[o.mode || "studio"][o.between === false ? "exact" : "between"][d - 1];
  else throw new Error("unknown kind " + kind);
  return Math.floor((BUDGET - FIXED) / w);
}
return { PRODUCT_PACK, PRODUCT_CQ, PRODUCT_OLD, CAP, SAFETY, BUDGET, FIXED, PER_PLAIN_LINE, WEIGHTS, classify, lineWeight, cartWeight, cartFits, roomFor, maxJobs };
})();
return stkJobWeight.m;
}
/* END GENERATED stk-job-weight */
  /* P128b gap 4 (6 Oct 2026): what a band plan's error tells the customer. Only "big" (no band holds the
     size) is "too big"; missing price data ("price": a stale or partial band table, a figure between packs
     with no price) asks them to try again; a sold-out pack ("soldout") says sold out. All existing keys. */
  function bErrBlock(err,tAgain,tFail,tCannot){
    if(err==="big") return { label:tCannot, msg:stkT("stk.studio.order.bands_too_big","That size is too big to make here. Email us and we will quote it.") };
    if(err==="soldout") return { label:stkT("stk.lab_cart.sold_out_badge","Sold out"), msg:stkT("stk.studio.msg.sold_out","That option is sold out right now.") };
    return { label:tAgain, msg:tFail||stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment.") };
  }
  /* P128: why a custom job cannot go to the cart right now, if it cannot (null = it can) */
  function customBlock(){
    if(BANDS){
      const tAgain=stkT("stk.studio.order.try_again","Try again in a moment"), tFail=stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment.");
      const tCannot=stkT("stk.studio.order.btn_cannot","That size cannot be made"), tMin=stkFmt(stkT("stk.studio.order.min_label","Smallest order is [min]"),{min:B_NUM(PL_MG?QTY_MIN:50)});
      if(!window.StkGrid) return { label:tAgain, msg:tFail };
      const szErr=sizeError(); if(szErr) return { label:tCannot, msg:szErr };
      const qErr=qtyError(); if(qErr) return { label:(customQty>QTY_MAX?stkFmt(stkT("stk.studio.order.max_label","Over [max]"),{max:B_NUM(PL_MG?QTY_MAX:2000)}):tMin), msg:qErr };
      const pl=gPlan(packTotal(),gCurFin());
      if(pl.err) return bErrBlock(pl.err,tAgain,tFail,tCannot);
      if(pl.small) return { label:tMin, msg:QTY_ERR_SMALL };
      if(pl.pending) return { label:stkT("stk.studio.order.btn_pricing","Pricing your size..."), msg:"" };
      if(pl.cents==null) return { label:tAgain, msg:tFail };
      return null;
    }
    /* P172 (2 Oct 2026): the labels of the two older branches below, through stkT (English unchanged); the bands branch above has its own */
    const tAg=stkT("stk.studio.order.try_again","Try again in a moment"), tFl=stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment.");
    const tSz=stkT("stk.studio.order.btn_size_cannot","Size cannot be made"), tPr=stkT("stk.studio.order.btn_pricing_order","Pricing your order...");
    const tMn=stkFmt(stkT("stk.studio.order.min_label","Smallest order is [min]"),{min:B_NUM(48)});
    if(GRID){
      if(!window.StkGrid) return { label:tAg, msg:tFl };
      const szErr=sizeError(); if(szErr) return { label:tSz, msg:szErr };
      const qErr=qtyError(); if(qErr) return { label:(customQty>QTY_MAX?stkFmt(stkT("stk.studio.order.max_label","Over [max]"),{max:B_NUM(QTY_MAX)}):tMn), msg:qErr };
      const pl=gPlan(packTotal(),gCurFin());
      if(pl.pending) return { label:tPr, msg:"" };
      if(pl.err) return { label:tSz, msg:stkT("stk.studio.order.grid_too_big",SIZE_ERR_GRID) };
      if(pl.small) return { label:stkFmt(stkT("stk.studio.order.btn_grid_min","[min] per design"),{min:B_NUM(48)}), msg:stkT("stk.studio.order.grid_min_design","Each design needs at least 48 stickers.") };
      if(pl.cents==null) return { label:tAg, msg:tFl };
      return null;
    }
    if(!PL_TRUE_SIZE) return null;
    const szErr=sizeError(); if(szErr) return { label:tSz, msg:szErr };
    const qErr=qtyError(); if(qErr) return { label:tMn, msg:qErr };
    const custom=typedSize() || !!customQty;
    if(custom && quote.busy) return { label:tPr, msg:"" };
    if(custom && quote.error) return { label:stkT("stk.studio.order.btn_unpriced","Cannot be priced here"), msg:quote.error };
    if(custom && quote.failed) return { label:tAg, msg:tFl };
    if(custom && !CUSTOM_CART_READY) return { label:stkT("stk.studio.order.btn_not_on_sale","Custom orders not on sale yet"), msg:stkT("stk.studio.order.not_on_sale","Custom sizes and quantities are not on sale yet.") };
    return null;
  }
  /* P128: the Custom row under the six presets, in the rows' own markup so it takes their look */
  /* baseUnit: the first preset row's price per sticker (its quote for a typed size, else its variant),
     so the saving is worked out exactly as the preset rows work theirs out (Thomas, 25 Sep: "the
     saving must reflect the number typed") */
  function cqPct(n){ return Math.round((Math.max(QTY_MIN,Math.min(QTY_MAX,n))-QTY_MIN)*1000/(QTY_MAX-QTY_MIN))/10; }
  function customQtyRow(baseUnit){
    const on=!!customQty, q=customQty||"";
    const pence=GRID ? ((on && !qtyError()) ? gTotal(customQty) : null)
                     : ((on && quote.byQty[String(customQty)]!=null) ? quote.byQty[String(customQty)] : null);
    let badge="";
    if(pence!=null && customQty && baseUnit>0){
      const pct=Math.round((baseUnit-pence/customQty)*100/baseUnit);
      if(pct>0 && pct<80) badge=stkSaveBadge(pct);   /* 7 Oct 2026 (P212 audit 4): the product page's own badge ("19 % SPAREN"), was stk.pricing.save ("SPARE 16 %") */
    }
    const price = pence!=null ? money(pence) : (on && quote.busy ? stkT("stk.pricing.pricing","Pricing...") : "");
    const err=qtyError();
    /* v4.9 (Thomas, 25 Sep, superseding the row: "custom can be light grey but a smaller option bar
       below the size and below the quantity selectors. 2/3 of the size of the others" and "typing
       should replace where it says custom"): the product page's own bar (.stkcq, variant-rows.css),
       light grey, no chosen fill - the presets untick instead */
    /* v5.0 (26 Sep 2026, Thomas: "custom quantity will also need updating here too"): the product
       page's v3 custom quantity row (variant-rows.css .stkcq--qty, loaded in this shadow root): a
       preset row's box, no icon, the field where a preset's number sits, a 48 to 2,000 slider in the
       middle, the SAVE badge and price where a preset's price sits. On = the selected row's fill. */
    const rv=Math.max(QTY_MIN,Math.min(QTY_MAX,Number(customQty)||QTY_MIN));
    const shown=(BANDS && cqRaw!=null) ? cqRaw : q;   /* option B: the figure as typed, while typing */
    return '<div class="stkcq-qwrap"><div class="stkcq stkcq--qty cqbar'+(on?' is-stk-on':'')+(err?' is-bad':'')+'">'+
        '<input type="number" class="stkcq__in stkcq__in--qty" id="cqIn" min="'+QTY_MIN+'" max="'+QTY_MAX+'" step="'+QTY_STEP+'" inputmode="numeric" placeholder="'+esc(BANDS?(PL_MG?stkT("stk.studio.magnet.qty_between",stkFmt(stkT("stk.studio.order.qty_between","[min] to [max]"),{min:B_NUM(QTY_MIN),max:B_NUM(QTY_MAX)})):stkFmt(stkT("stk.studio.order.qty_between","[min] to [max]"),{min:B_NUM(50),max:B_NUM(2000)})):GRID?stkT("stk.studio.order.custom_qty_hint_grid","48 to 2,000"):stkT("stk.studio.order.custom_qty_hint","48 to 2,000"))+'" value="'+shown+'" aria-label="'+esc(stkFmt(stkT("stk.studio.order.custom_qty_aria","Custom quantity, [min] to [max]"),{min:B_NUM(QTY_MIN),max:B_NUM(QTY_MAX)}))+'">'+
        '<input type="range" class="stkcq__range" id="cqRange" min="'+QTY_MIN+'" max="'+QTY_MAX+'" step="'+QTY_STEP+'" value="'+rv+'" style="--stk-p:'+cqPct(on?rv:QTY_MIN)+'%" aria-label="'+esc(stkFmt(stkT("stk.studio.order.custom_qty_aria","Custom quantity, [min] to [max]"),{min:B_NUM(QTY_MIN),max:B_NUM(QTY_MAX)}))+'">'+
        '<span class="stkcq__pc">'+
          (badge?'<span class="vrow__badge">'+esc(badge)+'</span>':'')+
          (price?'<span class="vrow__price">'+esc(price)+'</span>':'<span class="vrow__hint">'+stkEsc((BANDS&&!PL_MG)?stkT("stk.studio.order.custom_quote_hint","Quote"):stkT("stk.studio.order.custom_price_hint","Price"))+'</span>')+   /* option B: "Quote" (Thomas, 1 Oct) */
        '</span>'+
      '</div></div>'+
      (err?'<div class="cq__err" role="alert">'+esc(err)+'</div>':'');
  }
  function drawCard(){
    const variant=strictVariant();
    const live=liveDocIdxs();
    const shown=Math.min(live.length,MAX_DESIGNS), over=live.length>MAX_DESIGNS;
    const multi=live.length>1;
    splitPack();
    const esz=effectiveSize();
    const quoted=(isCustom() && Object.keys(quote.byQty).length) ? quote.byQty : null;
    /* A custom size is only refused when the ENDPOINT refuses it - 20mm is its
       floor and 280 x 400mm its ceiling, and it owns both. The lab's own 10cm
       stop is gone: true-size pricing is what replaced it. */
    const cblock=customBlock();
    const blocked=!!(isCustom() && quote.error) || quote.busy || (!TRUE_SIZE && typedSize() && esz.over) || !!cblock;
    const ready=!!(variant&&variant.available!==false&&live.length&&!over&&!blocked);
    /* the ladder is the PACK's, exactly as on the product page */
    const hideList=(sizeOpt>=0?[optNames[sizeOpt]]:[]);
    mount.innerHTML=
      '<div class="cartp">'+
      /* v2.5: the four quarters open the card; no IN STOCK strip (Thomas) */
      orderGrid(live)+
      (products.length>1?'<div class="cartp__opt"><div class="cartp__lbl">'+stkEsc(stkT("stk.studio.order.product","Product"))+'</div><div class="seg2">'+products.map((p,i)=>'<button type="button" class="'+(activeP===p?'is-on':'')+'" data-prod="'+i+'">'+esc(p.title)+'</button>').join("")+'</div></div>':"")+
      PICKER.render({ product:activeP, sel:sel, compact:true, quoted:quoted, hide:hideList, dark:darkMode, currency:(gMoney&&PICKER.fmtMoney?PICK_MONEY:CUR_SYM) })+
      sizeNote()+
      (over?'<div class="cartp__over">'+stkEsc(stkFmt(stkT("stk.studio.order.over_max","This product takes up to [max] designs per order. Please remove [remove] before adding to cart."),{max:MAX_DESIGNS,remove:live.length-MAX_DESIGNS}))+'</div>':"")+
      /* From a product page the rights tick moves into the proof overlay so there is exactly
         ONE confirm. The input stays in the DOM, hidden, because doAdd's guard reads it. */
      '<label class="cartp__rights"'+(FROM_PRODUCT?' hidden style="display:none"':'')+'><input type="checkbox" id="cartRights"> '+esc(window.LabCart.RIGHTS_COPY)+'</label>'+
      '</div>';
    /* The footer shows the QUOTED price when there is one, so the figure the
       customer presses the button under is the figure the transform charges.
       With several designs it is their sum, and the label counts them. */
    const qSel=GRID ? (customQty ? (qtyError()?null:gTotal(customQty)) : null)
                    : customQty ? (quote.byQty[String(customQty)]!=null ? quote.byQty[String(customQty)] : null)
                         : (quoted?quoted[String(sel[qtyName()])]:null);
    const total=(qSel!=null)?qSel:(customQty?null:(variant?variant.price:null));
    /* 7 Oct 2026 (P212 audit, found on the copy): a typed quantity's per-sticker figure in the footer read English
       "/ per sticker" on every language; it now takes the word the preset rows print ("Stück", "stk.", "kpl"),
       as the line under the list does since 6 Oct. No row yet = the old words. */
    const fw0=mount.querySelector(".vrows .vrow__unit"), fw=fw0 ? / \/ (.+)$/.exec(fw0.textContent.trim()) : null;
    const unitTxt0=customQty ? (qSel!=null ? money(Math.round(qSel/customQty))+" / "+(fw ? fw[1] : "per "+NOUN) : "") : PICKER.unitLine(activeP,sel,(gMoney&&PICKER.fmtMoney?PICK_MONEY:CUR_SYM),quoted);
    /* 2 Oct: designs in different bands cost different amounts each, so the figure is an average */
    const bAvg=!!(BANDS && bMixed());
    const bAvgOf=t=>{ const pr=String(t||"").split(" / ")[0].trim(); return pr ? stkFmt(stkT("stk.studio.order.avg_per_sticker","avg [price] / sticker"),{price:pr}) : t; };
    const unitTxt=(bAvg && unitTxt0) ? bAvgOf(unitTxt0) : unitTxt0;
    const footVariant=(total!=null&&variant)?{ id:variant.id, price:total, compare_at_price:0, available:variant.available }:variant;
    /* v2.9 (Thomas, 17 Sep, notes 2 and 6): while ARTWORK or DESIGN is open the foot is ONE
       big green NEXT and nothing else - no price, no count. ORDER keeps the price block and
       its button reads FINISH. */
    const stepNo=openStepNo();
    if(foot){
      if(FROM_PRODUCT && stepNo!==3){
        /* v3.1 (Thomas, 24 Sep): NEXT half width with ORDER beside it, straight to the order
           screen. On a phone NEXT walks DESIGN's three segments first (Size, Shape, Border). */
        foot.innerHTML='<div class="labfoot labfoot--next">'+
          '<button type="button" class="stepdone stepnext" id="stepNext"'+(live.length&&!sizeError()?'':' disabled')+'>'+stkEsc(stkT("stk.studio.order.next","Next"))+
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg></button>'+
          '<button type="button" class="stepdone steporder" id="stepOrder"'+(live.length&&!sizeError()?'':' disabled')+'>'+
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>'+stkEsc(stkT("stk.studio.tool.step_order","Order"))+'</button>'+
          '<div class="labfoot__status'+(sizeError()?' is-error':'')+'" id="cartStatus">'+esc(sizeError()||"")+'</div></div>';
        const nx=foot.querySelector("#stepNext");
        if(nx) nx.addEventListener("click",()=>{
          if(stepNo===2 && typeof window.__plSegNext==="function" && window.__plSegNext()) return;
          if(typeof foldStep==="function") foldStep(stepNo||1);
        });
        const ob=foot.querySelector("#stepOrder");
        if(ob) ob.addEventListener("click",()=>{
          if(typeof foldStep!=="function") return;
          for(let g=0; g<3 && openStepNo()!==3; g++) foldStep(openStepNo()||1);
        });
      } else {
        foot.innerHTML=PICKER.footer({
          variant:footVariant, disabled:!ready, unit:unitTxt, currency:(gMoney&&PICKER.fmtMoney?PICK_MONEY:CUR_SYM),
          note:(variant&&optNames.length?stkFmt(live.length>1?stkT("stk.studio.order.foot_qty_designs","[qty] [units], [designs] designs"):stkT("stk.studio.order.foot_qty","[qty] [units]"),{qty:String(packTotal()),units:nounMany(NOUN),designs:live.length}):stkT("stk.studio.order.total","Total")),
          label:(cblock?cblock.label:(quote.busy?stkT("stk.studio.order.btn_pricing","Pricing your size..."):(quote.error?stkT("stk.studio.order.btn_cannot","That size cannot be made"):(!TRUE_SIZE&&typedSize()&&esz.over)?stkT("stk.studio.order.btn_over","Over 10cm: email us"):(!live.length?stkT("stk.studio.order.btn_add_design","Add a design to continue"):(FROM_PRODUCT?stkT("stk.studio.order.btn_finish","Finish"):stkT("stk.studio.add_to_cart","Add to cart"))))))
        });
        /* P128 (Custom Sticker Pricing, 25 Sep): the reason sits next to the disabled button, never
           only in a tooltip or below the fold */
        if(cblock && cblock.msg){ const st=foot.querySelector(".labfoot__status"); if(st){ st.textContent=cblock.msg; st.className="labfoot__status is-error"; } }
        /* P128: a typed quantity with no quote yet (or refused) shows no price - the preset's price
           left standing would be a figure that is not this order's (measured: 20 showed GBP 42.70) */
        if(customQty && qSel==null){
          const pr=foot.querySelector(".labfoot__price"); if(pr) pr.textContent="-";
          foot.querySelectorAll(".labfoot__unit").forEach(u=>{ u.style.display="none"; });
        }
      }
    }
    /* v2.9 (notes 3, 12): finish chips two across, third full width, STATIC selected fill;
       the sliding highlight is removed from every grid */
    mount.querySelectorAll('[data-chip-grid]').forEach(g=>{
      /* i18n: the finish grid is the one labelled with the finish option's own name (found by
         finishOptIdx, not by the word "finish", which is translated on /fr) */
      if(g.getAttribute("aria-label")===finishName()){ g.style.setProperty("--cgrid-cols","2"); g.classList.toggle("cgrid--orphan", g.querySelectorAll(".cgrid__item").length%2===1); }   /* the lone third chip spans; four (magnets) are a 2x2 */
      const hl=g.querySelector("[data-chip-hl]"); if(hl) hl.remove();
    });
    /* v2.9 (note 15): dark rows are the standalone lab's darker grey with a #7c7c86 hairline.
       The picker emits its colours inline, so they are set inline too. */
    if(darkMode) mount.querySelectorAll(".vpick-group,.vpick").forEach(el=>{
      el.style.setProperty("--vr-bg","#2e2e34"); el.style.setProperty("--vr-hover-bg","#26262b");
      el.style.setProperty("--vr-line","#7c7c86"); el.style.setProperty("--vr-row-bw","1px");
    });
    if(PL_TRUE_SIZE){
      const qn=qtyName();
      const radios=[...mount.querySelectorAll("input[data-opt]")].filter(r=>r.getAttribute("data-opt")===qn);
      const rows=radios.length ? radios[0].closest(".vrows") : null;
      if(rows){
        /* v4.9: the Custom bar sits UNDER the last quantity row (Thomas superseded "above 48"); the
           saving is against a QUOTE for the first preset at the real size, never the catalogue price
           (Custom Sticker Pricing: at 6 x 3 cm the true 48 is 16.10, the catalogue 17.50) */
        const firstVal=valuesFor(qtyOptIdx())[0], baseQty=qtyNumber(firstVal);
        const basePence=GRID ? gTotal(baseQty) : (quote.byQty[String(firstVal)]!=null ? quote.byQty[String(firstVal)] : null);
        rows.insertAdjacentHTML("afterend", customQtyRow(basePence!=null && baseQty>0 ? basePence/baseQty : 0));
        if(customQty){
          radios.forEach(r=>{ r.checked=false; });
          /* the per-sticker line under the list is the typed quantity's, or nothing until it is priced */
          const u=rows.parentNode.querySelector(".vrows__unit"), pc=GRID?(qtyError()?null:gTotal(customQty)):quote.byQty[String(customQty)];
          /* 6 Oct 2026: the unit word the preset rows print in the shop's language ("stk.", "Stück"), not English "per sticker" */
          const r0=rows.querySelector(".vrow__unit"), w0=r0 ? / \/ (.+)$/.exec(r0.textContent.trim()) : null, word=w0 ? w0[1] : "per "+NOUN;
          if(u){ const sp=u.querySelector("span"); if(pc!=null && sp) sp.textContent=money(Math.round(pc/customQty))+" / "+word; else u.style.display="none"; }
        }
      }
    }
    if(bAvg){
      mount.querySelectorAll(".vrow__unit").forEach(u=>{ u.textContent=bAvgOf(u.textContent); });
      mount.querySelectorAll(".vrows__unit span").forEach(u=>{ u.textContent=bAvgOf(u.textContent); });
    }
    syncStep3();
  }
  function openStepNo(){
    for(const i of [1,2,3]){ const el=root.getElementById("step"+i); if(el && !el.hidden && !el.classList.contains("collapsed")) return i; }
    return 0;
  }
  /* i18n: WHICH option is the finish, and WHICH finish a value is, come from the variant SKUs
     (48-2IN-GLOSS-CUSTOM-STICKER), which translation never touches; option names and values
     reach this file in the customer's language. The finish option is the one whose values
     line up one-to-one with a SKU finish word. A product whose SKUs carry no finish word
     falls back to the English name and value tests exactly as before. */
  function optValsOf(v){ return (v.options||[v.option1,v.option2,v.option3]); }
  function skuFinish(v){
    const w=String((v&&v.sku)||"").toUpperCase().split(/[^A-Z0-9]+/).find(t=>t==="MATTE"||t==="GLOSS"||t==="GLOSSY"||t==="GLITTER"||t==="HOLO"||t==="HOLOGRAPHIC");
    return w==="GLOSSY"?"GLOSS":(w==="HOLOGRAPHIC"?"HOLO":(w||null));
  }
  function finishOptIdx(){
    const vs=(activeP&&activeP.variants)||[];
    for(let i=0;i<optNames.length && vs.length;i++){
      const byVal={}; let ok=true;
      for(const v of vs){
        const w=skuFinish(v), val=String(optValsOf(v)[i]);
        if(!w || (byVal[val]!=null && byVal[val]!==w)){ ok=false; break; }
        byVal[val]=w;
      }
      if(ok && new Set(Object.keys(byVal).map(k=>byVal[k])).size>1) return i;
    }
    return optNames.findIndex(n=>/finish/i.test(n||""));
  }
  function finishName(){ const i=finishOptIdx(); return i>=0?optNames[i]:null; }
  function finishIdOf(val){
    const i=finishOptIdx();
    if(i>=0 && val!=null){
      const w=skuFinish(((activeP&&activeP.variants)||[]).find(v=>String(optValsOf(v)[i])===String(val)));
      if(w) return w==="GLITTER"?"glitter":(w==="GLOSS"?"gloss":(w==="HOLO"?"holo":"matte"));
    }
    const v=String(val||"matte").toLowerCase();
    return /gloss/.test(v)?"gloss":(/glitter/.test(v)?"glitter":(/holo/.test(v)?"holo":"matte"));
  }
  function finishId(){ const fn=finishName(); return finishIdOf(fn?sel[fn]:null); }
  /* the quote API's finish word. Before: the English value lowercased (matte, glossy, glitter).
     Now the same words from the SKU, so a translated value never reaches the API; a product
     without SKU finish words sends the value as before. Dormant while TRUE_SIZE is false. */
  function finishApi(){
    const API_FINISH={MATTE:"matte",GLOSS:"glossy",GLITTER:"glitter"};
    const fn=finishName(), val=fn?sel[fn]:undefined, i=finishOptIdx();
    const w=(i>=0 && val!=null) ? skuFinish(((activeP&&activeP.variants)||[]).find(v=>String(optValsOf(v)[i])===String(val))) : null;
    return w ? API_FINISH[w] : String(val||"").toLowerCase();
  }
  /* v2.9: the step tells the foot and the canvas what to show */
  window.__plStepChanged=function(n){
    try{ draw(); }catch(e){}
    try{ if(typeof setOrderView==="function") setOrderView(n===3 && FROM_PRODUCT, finishId()); }catch(e){}
  };
  /* Size, shape, finish and quantity all change the quote, and the shape lives
     in the Design card, so the watcher is on the drawing state, not on a click. */
  let _qk=null;
  setInterval(()=>{
    if(!needsQuote()){ if(quote.key){ quote={ key:null, byQty:{}, meta:null, error:null, failed:false, busy:false }; draw(); } _qk=null; return; }
    const k=quoteKey();
    if(k && k!==_qk){ _qk=k; refreshQuote(); }
  }, 500);
  /* THE ONE SIZE CONTROL: the Design card's chips and custom field are the product's Size
     option; a typed size is priced at the TIER IT FITS (5cm 2IN, 7.5cm 3IN, 10cm 4IN) and the
     Order card says so; above 10cm the order is refused (Thomas, 12 Sep 18:05). */
  const TIER_MM={2:50.8, 3:76.2, 4:101.6};
  function effectiveSize(){
    let mm=0; try{ mm=widthMm(); }catch(e){ mm=0; }
    if(!(mm>0)) return { mm:0, tier:null, over:false, custom:false };
    const tier=[2,3,4].find(k=>mm<=TIER_MM[k]+0.01) || null;
    return { mm:mm, tier:tier, over:!tier, custom:!!opts.sizeCustomMm };
  }
  /* THE LINE STILL HAS TO BE A PRODUCT. A custom size is charged by the cart
     transform, but /cart/add.js needs a real variant, so the variant is the tier
     the size fits and, past the largest tier, the largest tier. The price on the
     line is the quote's, not that variant's. */
  function syncSizeFromLab(){
    if(GRID) return false;                  /* the grid snaps the true size, gSync() */
    if(sizeOpt<0) return false;
    const e=effectiveSize(); if(!e.mm) return false;
    const tier=e.tier || 4;
    const want=valuesFor(sizeOpt).find(x=>String(x).indexOf(String(tier))===0);
    if(want && normv(sel[optNames[sizeOpt]])!==normv(want)){ sel[optNames[sizeOpt]]=want; return true; }
    return false;
  }

  /* ===== TRUE-SIZE PRICING (v2.0, 12 Sep 2026) ==========================
     A typed size is quoted by /api/custom-quote for the sticker's REAL w/h, shape, finish
     and quantity, and Stickiply Custom's cart transform charges the same figure off the
     _stk_* properties (proven: 2IN/Matte/96 at 27x27mm came back GBP22.75, not GBP30.00).
     SIX CALLS, NOT ONE: the whole ladder is quoted in parallel (505ms warm, 1021ms cold,
     inside one debounce) or five rows would print tier prices. If the endpoint fails the
     card falls back to the tier ladder AND SAYS SO: a silent fallback would charge a price
     the customer was never shown. */
  /* TRUE_SIZE (22 Sep 2026). false = a typed size is charged the listed size it
     fits (5cm 2IN, 7.5cm 3IN, 10cm 4IN), the way Proof Lab works, and over 10cm
     is refused with an email route. Nothing is quoted and no _stk_* property is
     sent, so the cart transform leaves the line at that variant's own price.
     true = true-size pricing through /api/custom-quote. Stays false until the
     v2.0 formula is live (TASKS P128). */
  const TRUE_SIZE=PL_TRUE_SIZE;   /* P128: the section setting, per theme (see PL_TRUE_SIZE) */
  /* P128: a custom size or quantity must ride the Made to Size carrier product (STUDIO-UI-SPEC 4).
     Until Custom Sticker Pricing wires doAdd to it, those lines are refused: a catalogue variant
     carrying a custom job would charge the variant's own price. Per theme, like true_size: the
     section setting "Custom orders can be bought (P128)" -> data-custom-cart-ready="1", default off,
     so live needs BOTH switches ticked on purpose, and either can be unticked in the theme editor. */
  const CUSTOM_CART_READY=host.dataset.customCartReady==="1";
  /* P128 (25 Sep 2026): a custom size or a custom quantity cannot ride a catalogue
     variant. If the cart transform ever fails to price the line, the customer pays
     that variant's OWN price, which is up to GBP 499 below the true price on a big
     4in job. Custom jobs ride the hidden "Made to Size" product instead, whose bands
     are priced so a failure always overcharges slightly, never undercharges. The
     bands come from Liquid (data-carrier) so the ids and prices are whatever the
     shop holds today, never a copy in this file. */
  const CARRIER=(function(){ try{ return JSON.parse(host.dataset.carrier||"null"); }catch(e){ return null; } })();
  function carrierBand(sheets){
    if(!CARRIER || !CARRIER.bands || !CARRIER.bands.length || !(sheets>0)) return null;
    let best=null;
    CARRIER.bands.forEach(b=>{ if(b && b.available!==false && b.sheets>=sheets && (!best || b.sheets<best.sheets)) best=b; });
    return best;
  }
  /* P128: data-quote-base (the section's "Quote API base", blank everywhere but the approval copy) sends
     only the QUOTES to Custom Sticker Pricing's draft endpoint; uploads keep data-api-base */
  const QUOTE_URL=(host.dataset.quoteBase||host.dataset.apiBase||"https://stickiply-uploads-api.stickiply.workers.dev").replace(/\/+$/,"")+"/api/custom-quote";
  /* 17 Oct 2026: checkout picture saved to Shopify (the pricing function accepts only Shopify-CDN pictures) */
  const PREVIEW_URL=(host.dataset.apiBase||"https://stickiply-uploads-api.stickiply.workers.dev").replace(/\/+$/,"")+"/api/preview";
  /* 17 Oct 2026 (Thomas: "what happens when someone orders multiple artwork"): every design (up to 4) in ONE checkout
     picture: 1 = itself (400 px), 2 = side by side, 3-4 = a 2x2 grid, white with #e5e5e5 hairline dividers. Same rule as
     the product pages' stk-checkout-thumb.js. */
  const stkCompose=async imgs=>{
    const n=Math.min(imgs.length,4), c=document.createElement("canvas"); let g;
    if(n===1){ const d=imgs[0], s=Math.min(1,400/Math.max(d.width,d.height)); c.width=Math.max(1,Math.round(d.width*s)); c.height=Math.max(1,Math.round(d.height*s));
      g=c.getContext("2d"); g.fillStyle="#ffffff"; g.fillRect(0,0,c.width,c.height); g.drawImage(d,0,0,c.width,c.height); }
    else { const cell=200, pad=10, inner=cell-2*pad, at=[[0,0],[cell,0],[0,cell],[cell,cell]]; c.width=400; c.height=n===2?cell:400;
      g=c.getContext("2d"); g.fillStyle="#ffffff"; g.fillRect(0,0,c.width,c.height);
      for(let i=0;i<n;i++){ const d=imgs[i], k=Math.min(inner/d.width,inner/d.height), dw=d.width*k, dh=d.height*k; g.drawImage(d,at[i][0]+(cell-dw)/2,at[i][1]+(cell-dh)/2,dw,dh); }
      g.strokeStyle="#e5e5e5"; g.lineWidth=1; g.beginPath(); g.moveTo(cell+0.5,0); g.lineTo(cell+0.5,c.height); if(n>2){ g.moveTo(0,cell+0.5); g.lineTo(400,cell+0.5); } g.stroke(); }
    return await new Promise(res=>c.toBlob(res,"image/jpeg",0.85));
  };
  const SHAPE_Q={custom:"die-cut", circle:"circle", square:"square", rect:"rectangle"};
  let quote={ key:null, byQty:{}, meta:null, error:null, failed:false, busy:false };
  let quoteTimer=0;
  function quoteInput(qty){
    const d=cutSizeMm(); if(!d) return null;
    const fin=finishApi();
    return { w:d.w, h:d.h, qty:Number(qty), shape:SHAPE_Q[opts.shape]||"die-cut",
             finish:fin||"matte", profile:"stickers" };
  }
  function quoteKey(){
    const a=quoteInput(1); if(!a) return null;
    /* every design in the job, and its share, is part of what is quoted */
    const live=liveDocIdxs();
    const others=live.filter(i=>i!==activeIdx).map(i=>docSceneKey(docs[i])).join("#");
    const shares=live.map(i=>Number(perQty[docs[i].id])||0).join(",");
    return [a.w,a.h,a.shape,a.finish,(customQty&&customQty>=QTY_MIN)?customQty:"",typedSize()?"t":"",shares,others].join("|");
  }
  /* P128 (Custom Sticker Pricing, 25 Sep): the WHOLE job in one call - every design's cut size in mm
     and its share of the order, the shares summing to the order - so the price is the same whichever
     design is on screen (it moved GBP 114.55 / 91.05 with the active design before). The charged row
     uses the real shares; the other rows of the ladder split their quantity evenly. One design keeps
     the single {w,h,qty} form. */
  function jobDesigns(total){
    const live=liveDocIdxs(); if(!live.length) return null;
    const dims=live.map(i=>{ try{ return i===activeIdx ? cutSizeMm() : withDoc(i,()=>cutSizeMm()); }catch(e){ return null; } });
    if(dims.some(d=>!d)) return null;
    let shares;
    if(total===packTotal()) shares=live.map(i=>Number(perQty[docs[i].id])||0);
    else { const n=live.length, base=Math.floor(total/n), rem=total-base*n; shares=live.map((_,j)=>base+(j<rem?1:0)); }
    return live.map((i,j)=>({ w:dims[j].w, h:dims[j].h, qty:shares[j],
      shape:SHAPE_Q[((i===activeIdx?opts:(docs[i].opts||{})).shape)]||"die-cut" }));
  }
  function quoteBody(total){
    const a=quoteInput(total); if(!a) return null;
    const ds=jobDesigns(Number(total)); if(!ds) return null;
    if(ds.length===1) return a;
    return { designs:ds, finish:a.finish, shape:ds[0].shape, profile:"stickers" };
  }
  /* v5.1 (26 Sep 2026): quoted in WHOLE mm. The cart line carries "Artwork N size" in whole mm
     (lab-cart.js sizeValue, Math.round) and the cart transform prices from those, so a quote for
     the raw cut size could differ from the charge: 71.3 x 76.2 at 75 quoted GBP 33.15, charged
     33.10, and the price check took the line back out. Same Math.round here, so quote = charge. */
  function wholeMm(o){ if(o && o.w!=null) o.w=Math.round(Number(o.w)); if(o && o.h!=null) o.h=Math.round(Number(o.h)); return o; }
  function askQuote(body){
    body=Object.assign({},body);
    if(Array.isArray(body.designs)) body.designs=body.designs.map(d=>wholeMm(Object.assign({},d))); else wholeMm(body);
    return fetch(QUOTE_URL,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)})
      .then(r=>r.text()).then(x=>{ try{ return JSON.parse(x); }catch(e){ return { ok:false, error:"" }; } });
  }
  function isCustom(){ return TRUE_SIZE && !!opts.sizeCustomMm && !!cutSizeMm(); }
  /* P128: a quote is needed for a typed size (every row) or a typed quantity (its own row) */
  function needsQuote(){ return !GRID && TRUE_SIZE && !!cutSizeMm() && (isCustom() || (!!customQty && customQty>=QTY_MIN)); }
  function typedSize(){ return !!opts.sizeCustomMm && !!cutSizeMm(); }
  function refreshQuote(){
    if(!needsQuote()){ quote={ key:null, byQty:{}, meta:null, error:null, failed:false, busy:false }; return; }
    const key=quoteKey(); if(!key) return;
    if(key===quote.key && !quote.busy) return;
    clearTimeout(quoteTimer);
    quoteTimer=setTimeout(()=>{
      const k=quoteKey(); if(!k) return;
      quote.busy=true; quote.key=k; draw();
      /* a typed size quotes the whole ladder; a catalogue size only the typed quantity (the presets
         ride their own variants and keep their own prices) */
      const qtys=(isCustom()?valuesFor(qtyOptIdx()).map(v=>String(v)):[]);
      if(customQty && customQty>=QTY_MIN && qtys.indexOf(String(customQty))<0) qtys.push(String(customQty));
      if(customQty && customQty>=QTY_MIN){ const f0=String(valuesFor(qtyOptIdx())[0]); if(qtys.indexOf(f0)<0) qtys.push(f0); }
      Promise.all(qtys.map(q=>{ const bd=quoteBody(qtyNumber(q)); return bd ? askQuote(bd).then(j=>({q:q,j:j})) : Promise.resolve({q:q,j:{ok:false,error:""}}); }))
        .then(list=>{
          if(quoteKey()!==k) return;                 // the size moved on while we asked
          const by={}; let bad=null, meta=null;
          list.forEach(r=>{
            if(r.j && r.j.ok){ by[r.q]=Math.round(r.j.price*100); if(String(customQty||sel[optNames[qtyOptIdx()]])===r.q) meta=r.j; }
            else if(!bad) bad=(r.j&&r.j.error)||"";
          });
          quote.byQty=by; quote.meta=meta; quote.error=Object.keys(by).length?null:(bad||"");
          quote.failed=!Object.keys(by).length && !bad;
          quote.busy=false; draw();
        })
        .catch(err=>{
          console.warn("[proof-lab] quote failed",err);
          quote.byQty={}; quote.meta=null; quote.error=null; quote.failed=true; quote.busy=false; draw();
        });
    },400);
  }
  function qtyNumber(v){ const m=String(v).match(/\d+/); return m?Number(m[0]):1; }
  /* the option the ladder lives on, found the same way the picker finds it */
  function qtyOptIdx(){
    for(let i=optNames.length-1;i>=0;i--){
      const vs=valuesFor(i);
      if(vs.length>1 && vs.every(v=>/^\d/.test(String(v)))) return i;
    }
    return optNames.length-1;
  }
  function sizeNote(){
    if(BANDS){
      /* the size the job is charged as, in cm, never the band or anything about sheets */
      if(sizeError()) return '<span class="tiernote is-block">'+esc(sizeError())+'</span>';
      const d=gDims(activeIdx); if(!d) return "";
      const b=bBandOf(d);
      if(b.err) return '<span class="tiernote is-block">'+stkEsc(stkT("stk.studio.order.bands_too_big","That size is too big to make here. Email us and we will quote it."))+'</span>';
      /* 2 Oct: no "priced at its largest design" note: every design is priced at its own size now
         (the summed price), so there is nothing to explain */
      return "";
    }
    if(GRID){
      if(sizeError()) return '<span class="tiernote is-block">'+esc(sizeError())+'</span>';
      const d=gDims(activeIdx); if(!d) return "";
      const p=gPick(d,gCurFin());
      if(p.pending) return '<span class="tiernote">'+stkEsc(stkT("stk.studio.order.grid_finding","Finding your size..."))+'</span>';
      if(!p.v) return '<span class="tiernote is-block">'+stkEsc(stkT("stk.studio.order.grid_too_big",SIZE_ERR_GRID))+'</span>';
      const tru=gCm(Math.max(d.w,d.h))+" \u00d7 "+gCm(Math.min(d.w,d.h))+" cm", lbl=String(p.v.s||"");
      const same=Math.round(Math.max(d.w,d.h))===p.L && Math.round(Math.min(d.w,d.h))===p.S;
      if(same) return '<span class="tiernote">'+stkEsc(stkFmt(stkT("stk.studio.order.grid_exact","Priced at [size]."),{size:lbl}))+'</span>';
      return '<span class="tiernote">'+stkEsc(stkFmt(p.exact
        ? stkT("stk.studio.order.grid_next","Priced as [size], the next size up from your [true].")
        : stkT("stk.studio.order.grid_listed","Priced as [size], the smallest size we list that fits your [true]."),{size:lbl,true:tru}))+'</span>';
    }
    if(TRUE_SIZE && sizeError()) return '<span class="tiernote is-block">'+esc(sizeError())+'</span>';
    if(!TRUE_SIZE && typedSize()){
      const d0=cutSizeMm(), e0=effectiveSize();
      const size0=stkDec(d0.w/10,1)+" x "+stkDec(d0.h/10,1)+"cm";
      if(e0.over) return '<span class="tiernote is-block">'+stkEsc(stkT("stk.studio.order.over10_note","Stickers over 10cm are priced by hand for now. Email hello@stickiply.com with your size and quantity."))+'</span>';
      return '<span class="tiernote">'+stkEsc(stkFmt(stkT("stk.studio.order.tier_note","[size] is priced as our [tier] size."),{size:size0,tier:plChipTxt(e0.tier)}))+'</span>';
    }
    if(!isCustom()) return "";
    const d=cutSizeMm(); if(!d) return "";
    const size=stkDec(d.w/10,1)+" x "+stkDec(d.h/10,1)+"cm";
    if(quote.busy) return '<span class="tiernote">'+stkEsc(stkFmt(stkT("stk.studio.order.pricing_size","Pricing [size]..."),{size:size}))+'</span>';
    if(quote.error) return '<span class="tiernote is-block">'+esc(quote.error||stkT("stk.studio.order.cannot_made","That size cannot be made."))+'</span>';
    if(quote.failed) return '<span class="tiernote is-block">'+stkEsc(stkFmt(stkT("stk.studio.order.quote_failed","We could not price [size] just now, so this shows the standard tier price. Please try again in a moment."),{size:size}))+'</span>';
    /* P128 (Thomas, 25 Sep): the customer is never told about sheets */
    if(quote.meta) return '<span class="tiernote">'+stkEsc(stkFmt(stkT("stk.studio.order.true_size","Priced at your true size, [size]"),{size:size}))+'</span>';
    return '<span class="tiernote">'+stkEsc(stkFmt(stkT("stk.studio.order.custom_size","Custom [size]"),{size:size}))+'</span>';
  }
  {
    const seg=root.getElementById("sizeSeg");
    if(seg) seg.addEventListener("click",()=>{ setTimeout(()=>{ syncSizeFromLab(); drawSoon(); },0); });
    ["sizeCustom","sizeW","sizeH"].forEach(id=>{
      const cus=root.getElementById(id);
      if(cus) ["change"].concat(id==="sizeCustom"?["input"]:[]).forEach(ev=>cus.addEventListener(ev,()=>{ setTimeout(()=>{ syncSizeFromLab(); drawSoon(); },0); }));
    });
  }
  syncSizeFromLab();
  window.__plRedrawCart=draw;
  draw();
  // The cart panel is separate from the tool's own render, so refresh it when the design count
  // changes (add/remove) - keeps the count, price gating and over-limit note live. Rights tick preserved.
  let _n="", _rights=false;
  /* v2.4: renderDocTabs() calls this on every artwork load, slot switch and
     removal, so the ORDER panel can never be a redraw behind the slot strip.
     The 450ms poll below stays as a backstop and now watches the live COUNT,
     not just how many slots exist. */
  const redrawCart=()=>{ splitPack(); draw(); const rc=mount.querySelector("#cartRights"); if(rc) rc.checked=_rights; };
  window.__plDocsChanged=redrawCart;
  /* P128: the Custom quantity box. Typing past the chosen preset unticks it at once (Thomas); the
     figure is committed on Enter or when the box is left, and priced then */
  mount.addEventListener("input",e=>{
    if(!e.target || (e.target.id!=="cqIn" && e.target.id!=="cqRange")) return;
    const row=e.target.closest(".cqbar"), fld=row&&row.querySelector("#cqIn"), rg=row&&row.querySelector("#cqRange");
    /* v5.0: a drag writes the field (one figure, one path, as on the product page); typing moves the thumb */
    if(e.target.id==="cqRange" && fld) fld.value=PL_MG ? String(bMgUp(Math.round(+e.target.value||0))) : e.target.value;   /* magnets: the drag moves in the grid's packs */
    let n=Math.round(+(fld?fld.value:e.target.value)||0);
    if(n>QTY_MAX && !GRID){ n=QTY_MAX; if(fld) fld.value=String(QTY_MAX); }
    if(rg){ if(e.target.id==="cqIn" && n>=QTY_MIN) rg.value=String(n); rg.style.setProperty("--stk-p", cqPct(n>=QTY_MIN?n:QTY_MIN)+"%"); }
    if(n>=QTY_MIN && n!==qtyNumber(sel[qtyName()])){
      mount.querySelectorAll("input[data-opt]").forEach(r=>{ if(r.getAttribute("data-opt")===qtyName()) r.checked=false; });
      if(row) row.classList.add("is-stk-on");
    }
    /* option B: quote while typing - 30 already prices as 50, 300 as 300 - with the box kept as typed */
    if(BANDS && e.target.id==="cqIn"){
      cqRaw=fld?fld.value:"";
      clearTimeout(cqTimer);
      cqTimer=setTimeout(()=>{ const v=Math.round(+cqRaw||0); if(v>0){ cqRefocus=true; setCustomQty(v); } },300);
    }
  });
  mount.addEventListener("keydown",e=>{
    if(!e.target || e.target.id!=="cqIn" || e.key!=="Enter") return;
    e.preventDefault(); clearTimeout(cqTimer); cqRaw=null; cqRefocus=true; setCustomQty(e.target.value);
  });
  /* 5 Oct 2026 (Thomas: "studio is showing option 100 when entering 60"): the quote-as-you-type redraw
     rebuilds the box with the typed figure already in it, so leaving it fired no change and the typed
     figure stayed beside a different pack. Leaving the box always settles it. */
  mount.addEventListener("focusout",e=>{
    if(!e.target || e.target.id!=="cqIn" || cqDrawing || cqRaw==null) return;
    clearTimeout(cqTimer); cqRaw=null;
    const n=Math.round(+e.target.value||0); if(n>0) setCustomQty(n); else draw();
  });
  /* 18 Oct 2026 (Thomas: "launching people back at their design when inputting quantities"): a typed
     figure settles when its box loses focus, and that redraw rebuilds every quarter while the next press
     is still going down. Measured on iPhone Safari: typing in design 1's box and then tapping design 2's
     box never focused the box, the quarter took the focus, and a click on a quarter opens that design
     (768px and up; the mock-up on a phone). A press that starts on a quantity control now never opens a
     design, and the box it was aimed at gets the focus once the quarters are rebuilt. */
  let qtyPress=null;
  mount.addEventListener("pointerdown",e=>{
    const q=e.target&&e.target.closest&&e.target.closest(".sau-qty"), row=q&&q.closest("[data-sau]");
    qtyPress=q ? { at:Date.now(), id:row?row.getAttribute("data-sau"):null, box:!!e.target.closest(".sau-qty input") } : null;
  },true);
  const qtyPressed=()=>!!(qtyPress && Date.now()-qtyPress.at<1500);
  function qtyFocusBox(p,fromId){
    if(!p || !p.box || !p.id || p.id===fromId) return;
    const row=[...mount.querySelectorAll("[data-sau]")].find(r=>r.getAttribute("data-sau")===p.id);
    const ni=row && row.querySelector(".sau-qty input");
    if(!ni || ni.readOnly || root.activeElement===ni) return;
    try{ ni.focus({preventScroll:true}); ni.select(); }catch(err){}
  }
  mount.addEventListener("change",e=>{
    if(e.target && e.target.id==="cqIn"){
      if(cqDrawing) return;                       /* a redraw replaced the box: not the customer leaving it */
      if(BANDS){ clearTimeout(cqTimer); cqRaw=null; const n=Math.round(+e.target.value||0); if(n>0) setCustomQty(n); else draw(); return; }
      const n=Math.round(+e.target.value||0); if(n!==(customQty||qtyNumber(sel[qtyName()]))) setCustomQty(n); return; }
    if(e.target && e.target.id==="cqRange"){ const n=Math.round(+e.target.value||0); cqRefocus="cqRange"; if(n!==(customQty||qtyNumber(sel[qtyName()]))) setCustomQty(n); else cqRefocus=false; return; }
    if(e.target && e.target.id==="cartRights"){ _rights=e.target.checked; return; }
    /* The picker's controls are REAL radios, exactly as on the product page, so
       the selection arrives as a change, not a click on a button. */
    /* the stepper's own number box: typing a figure fixes that row and the
       others re-split what is left, the same as pressing the buttons */
    const sn=e.target&&e.target.closest&&e.target.closest(".sau-qty input");
    if(sn){
      const row=sn.closest("[data-sau]"); if(!row) return;
      const id=row.getAttribute("data-sau");
      /* v3.9 (Thomas: "quantity field cant be typed in"): with ONE design the figure picks the pack,
         as in the Final check (pickPackFor); two or more keep the shares */
      if(liveDocIdxs().length===1){ pickPackFor(sn.value); draw(); return; }
      setQty(id,sn.value); draw();
      if(qtyPressed()) qtyFocusBox(qtyPress,id);   /* 18 Oct: the next box keeps the press */
      return;
    }
    const r=e.target&&e.target.closest&&e.target.closest("input[data-opt]");
    if(r){
      const opt=r.getAttribute("data-opt"), val=r.getAttribute("data-val");
      sel[opt]=val; if(optNames[sizeOpt]===opt) syncToolSize(val);
      if(opt===qtyName()) customQty=null;      /* P128: a preset wins over a typed quantity */
      /* a new pack size re-splits every row that the customer has not fixed */
      if(opt===qtyName()){ Object.keys(qtyManual).forEach(k=>delete qtyManual[k]); qtyEpoch++; }
      draw();
      if(opt===finishName() && typeof setOrderView==="function" && openStepNo()===3) setOrderView(true, finishId());   /* i18n: by option, not by the word */
      const rc=mount.querySelector("#cartRights"); if(rc) rc.checked=_rights; }
  });
  let _mm=-1, _gk="";
  setInterval(()=>{
    syncStep3();
    const e=effectiveSize();
    /* 2 Oct: only when no draw has shown this size yet, and batched with any other redraw */
    if(e.mm!==_mm){ _mm=e.mm; syncSizeFromLab(); if(draw.seenMm!==e.mm) drawSoon(); }
    else if(GRID){ const d=gDims(activeIdx), k=d?d.w+"x"+d.h:""; if(k!==_gk){ _gk=k; if(draw.seenGk!==k) drawSoon(); } }
    const lk=liveDocIdxs().join(",")+"/"+docs.length;
    if(lk!==_n){ _n=lk; redrawCart(); }
  }, 450);
  /* v1.7: the status line and the button live in the panel's sticky FOOTER now,
     not inside the Order card, so both are looked up there first. */
  const inPanel=sel2=>(foot&&foot.querySelector(sel2))||mount.querySelector(sel2);
  function setStatus(msg,kind){ const s=inPanel("#cartStatus"); if(s){ s.textContent=msg||""; s.className="labfoot__status"+(kind?" is-"+kind:""); } const add=inPanel("#cartAdd"); if(add) add.disabled=(kind==="busy"); if(overlayStatus&&kind==="busy") overlayStatus(msg,"busy"); }
  mount.addEventListener("click",e=>{
    const pb=e.target.closest("[data-prod]");
    if(pb){ const np=products[+pb.getAttribute("data-prod")]; if(np && np!==activeP){ activeP=np; qtyEpoch++; rebuildOptions(); draw(); } return; }
    /* v2.5: an empty quarter IS the upload field. It runs the same two steps the
       slot strip's empty slot runs, so there is one way to start a design and
       the "same settings?" prompt appears from both. */
    const oa=e.target.closest("[data-oqadd]");
    if(oa){
      if(docs.length && window.__plBeginAnother) window.__plBeginAnother();
      const fi=root.getElementById("file"); if(fi) fi.click();
      return;
    }
    /* CUSTOM MAGNETS: the ORDER card's orange EDIT DESIGN goes back to the design (the bookmark Studio's) */
    const oe=e.target.closest("[data-oqedit]");
    if(oe){ const ti=docs.findIndex(d=>d&&d.id===oe.getAttribute("data-oqedit")); if(ti>=0){ activateDoc(ti); openStep(2); } return; }
    /* v2.5: a quarter's remove. closeDoc owns the undo toast and the re-activation,
       so this never duplicates it. */
    const ox=e.target.closest("[data-oqx]");
    if(ox){
      const id=ox.getAttribute("data-oqx");
      const i=docs.findIndex(d=>d&&d.id===id);
      if(i>=0){ closeDoc(i); splitPack(); draw(); renderDocTabs(); }
      return;
    }
    /* v2.3: the steppers, now inside the quarters. A quarter the customer
       touches is fixed and the others re-split what is left, which is what the
       product page's upload field does. */
    const sq=e.target.closest("[data-sauq]");
    if(sq){
      const row=sq.closest("[data-sau]"); if(!row) return;
      const id=row.getAttribute("data-sau");
      if(sq.disabled) return;
      const nq=(Number(perQty[id])||0)+Number(sq.getAttribute("data-sauq"));
      if(liveDocIdxs().length===1){ pickPackFor(nq); draw(); return; }   /* v3.9: one design steps the packs */
      setQty(id,nq); draw();
      return;
    }
    /* the quarter opens that design (Thomas, 17 Sep). With the thumb strip gone on
       phones it is the only way to reach another one. The x and steppers return above. */
    /* v3.1 (Thomas: "when i click the quantity under the artwork it goes to edit artwork not to
       type a number in the box"): the number box and a greyed button belong to the stepper */
    /* 18 Oct 2026: a press that began on a quantity control is still the quantity when the click lands
       on the rebuilt quarter, never the design; the box it was aimed at takes the focus (see qtyPress above) */
    if(qtyPressed()){ const p=qtyPress; qtyPress=null; qtyFocusBox(p,null); return; }
    if(e.target.closest(".sau-qty")) return;
    const tile=e.target.closest("[data-sau]");
    if(tile){
      const ti=docs.findIndex(d=>d&&d.id===tile.getAttribute("data-sau"));
      if(ti>=0){
        const edit=()=>{ activateDoc(ti); openStep(2); };
        /* a phone has no canvas on this screen: the tap shows the mock-up, EDIT DESIGN goes back (Thomas, 28 Sep) */
        if(window.matchMedia && window.matchMedia("(max-width:767px)").matches){
          const fin=(typeof finishId==="function" && finishId()) || orderFinish;
          const open=()=>{ const u=finishedPNG(ti, fin, 1000) || docs[ti].thumb; if(u) showImageView(u, docs[ti].artName||"", edit); else edit(); };
          if(holoMod) open(); else holoReady().then(open).catch(edit);
        } else edit();
      }
      return;
    }
    /* option clicks: handled by the change listener above (real radios). */
  });
  /* v4.1 (Thomas: "when a scroll bar appears it goes behind the header too. it should stop at the
     header"): on desktop the panel scrolls with the foot pinned inside it, so the scrollbar ran the
     full height. The foot's height, in the panel's own (zoomed) CSS px, is --pl-footd; the desktop
     scrollbar track ends there (proof-lab.css v4.1). Phones read nothing from it. */
  if(foot && window.ResizeObserver){
    try{ new ResizeObserver(()=>{ try{ root.host.style.setProperty("--pl-footd", foot.offsetHeight+"px"); }catch(e){} }).observe(foot); }catch(e){}
  }
  /* the action button lives in the footer, so it is bound there, not on the card. */
  if(foot) foot.addEventListener("click",e=>{
    if(e.target.closest("#cartAdd")){ if(FROM_PRODUCT) reviewProof(); else doAdd(); }
  });
  const isHttp=u=>typeof u==="string" && /^https?:\/\//i.test(u);

  /* ===== THE PROOF WINDOW'S PAYLOAD (v2.4) ============================
     FOUR QUARTERS, ALWAYS. A quarter with artwork is a proof, with VIEW,
     EDIT, REMOVE and its own quantity on it; an empty quarter is an
     add-a-design tile. Thomas, 12 Sep 23:05: "why would add designs appear...
     i have 4" and "add designs should appear in the 4 quarter tiles centred".
     One builder, so a removal or a typed quantity rebuilds the window from the
     same numbers the ORDER panel is reading. */
  function proofRows(nLive){
    const variant=strictVariant();
    const rows=[];
    /* i18n: every row carries its role as a third item, so lab-proof-confirm.js picks the icon
       and the total by role, not by the words of a label that is now translated */
    if(products.length>1) rows.push([stkT("stk.studio.order.product","Product"),activeP.title,"product"]);
    const qIdx=qtyOptIdx(), fIdx=finishOptIdx();
    /* v2.6: the quantity reads as its number. v2.9.3 (Thomas: "size should just say
       custom, no need for the exact amount and no need for the extra 'true size'"): a
       custom order's SIZE cell is the word Custom, the TRUE SIZE cell is gone, and six
       cells on one row was what clipped "6.4 x 6.4cm" to "6.4 X...". */
    /* v5.1: the quantity is the pack as it stands (a typed quantity included), not the ticked preset.
       v5.2: SIZE says Custom whenever the order rides the Made to Size line (a typed size or a typed
       quantity), because the cart line is then the true size, not the ticked preset's variant. */
    optNames.forEach((n,i)=>rows.push([(activeP&&activeP.optionLabels&&activeP.optionLabels[n])||n,  /* P172: heading in the page language */
      i===qtyOptIdx() ? String(packTotal()||qtyNumber(sel[n]))
      : (!GRID && i===sizeOpt && (isCustom() || !!customQty)) ? stkT("stk.studio.order.custom", "Custom")
      : (BANDS && i===sizeOpt) ? (function(){
          /* 2 Oct: one design names its own size; several say how many sizes (each card carries its own) */
          const j=bJob(); if(!j || j.err) return "-";
          const sz=[]; liveDocIdxs().forEach(k=>{ const t=gWH(gDims(k)); if(t && sz.indexOf(t)<0) sz.push(t); });
          if(sz.length>1) return stkFmt(stkT("stk.studio.order.n_sizes","[n] sizes"),{n:sz.length});
          return sz[0] || (j.w>0 ? gWH(j) : gCm(j.L)+" \u00d7 "+gCm(j.S)+" cm"); })()   /* option B: the (largest) design's own size as TRUE SIZE shows it, never the band */
      : (i===fIdx) ? (function(v){ /* P172: the finish word in the page language (the grid keeps English values) */ const k={matte:"finish_matte",gloss:"finish_gloss",glossy:"finish_gloss",glitter:"finish_glitter"}[v.toLowerCase()]; return k?stkT("stk.p172.proof_lab."+k,v):v; })(String(sel[n]))
      : String(sel[n]),
      /* 2 Oct 2026: the role picks the Final check icon in any language (lab-proof-confirm.js ICON_ROLE); the label only matched English */
      i===qtyOptIdx()?"quantity":(i===sizeOpt?"size":(i===fIdx?"finish":""))]));
    /* v3.1 (Thomas, 24 Sep): no DESIGNS cell, "as we have tiles showing the design" */
    /* v2.9.3: no TRUE SIZE cell - SIZE says Custom, the measurement is on the cart line. */
    const pc=chargedPence();
    if(variant && pc!=null) rows.push([stkT("stk.studio.order.price","Price"),money(pc),"price"]);
    return rows;
  }
  /* v5.1: the price the Final check shows is the one the footer shows and the cart charges: a typed
     quantity's quote, else a typed size's quote for the ticked pack, else the variant's own price.
     A typed quantity with no quote yet shows no price rather than the preset's. */
  function chargedPence(){
    const variant=strictVariant();
    if(GRID) return customQty ? (qtyError()?null:gTotal(customQty)) : (variant ? variant.price : null);
    if(customQty) return quote.byQty[String(customQty)]!=null ? quote.byQty[String(customQty)] : null;
    const qS=isCustom()?quote.byQty[String(sel[optNames[qtyOptIdx()]])]:null;
    return (qS!=null) ? qS : (variant ? variant.price : null);
  }
  function qtyMap(live){
    const m={};
    live.forEach(i=>{ m[String(i)]=Number(perQty[docs[i].id])||0; });
    return m;
  }
  /* THE PROOF USED TO FAIL ON A SECOND DESIGN (12 Sep 20:30): the loop walked empty
     slots too, and buildScene dilating a null mask0 threw the whole render. Only slots
     carrying artwork are proofed, ordered or counted, each in its own try. */
  function proofPayload(){
    const back0=activeIdx; if(back0>=0 && docs[back0]) captureDoc();
    const live=liveDocIdxs();
    splitPack();
    const slots=[], failed=[];
    live.slice(0,MAX_DESIGNS).forEach(i=>{
      /* one design at a time, each in its own try: a single unreadable slot
         must not cost the customer the proofs of the others */
      try{
        loadDocGlobals(docs[i]); activeIdx=i;
        slots.push({ n:slots.length+1, id:String(i),
          src:proofCanvasCheck().toDataURL("image/png"),   /* v2.9 (note 16): alpha kept; v2.9.2 (R8): static cut line */
          /* 2 Oct (sizes.md edit 4): each card names its own size, size first so a long name is cut instead */
          caption:(function(){ const nm=artName||stkFmt(stkT("stk.studio.design.n","Design [n]"),{n:slots.length+1}); const sz=BANDS?gWH(gDims(i)):""; return sz?sz+" \u00b7 "+nm:nm; })(),
          qty:Number(perQty[docs[i].id])||0, lim:finalLim(docs[i].id) });
      }catch(e){
        console.warn("[proof-lab] proof render failed for design "+(i+1),e);
        failed.push(i+1);
      }
    });
    activeIdx=back0; if(back0>=0 && docs[back0]) loadDocGlobals(docs[back0]);
    /* every quarter that is not a proof is an ADD tile, so the grid is 2x2 at
       one design and at four */
    while(slots.length<MAX_DESIGNS) slots.push({ n:slots.length+1, empty:true });
    return { slots:slots, rows:proofRows(live.length), qtys:qtyMap(live),
             canAddMore:live.length<MAX_DESIGNS, live:live, failed:failed };
  }
  /* the empty quarter, and the slot strip's empty slot, do the same thing:
     close what is on screen and put the customer on that slot's upload */
  function openFreeSlot(){
    overlayStatus=null;
    openStep(1);
    const liveSet=liveDocIdxs();
    let free=-1;
    for(let i=0;i<docs.length;i++){ if(liveSet.indexOf(i)<0){ free=i; break; } }
    if(free>=0) activateDoc(free);
    else if(docs.length && window.__plBeginAnother) window.__plBeginAnother();
    const at=(free>=0?free:docs.length);
    const slot=root.querySelector('.dslot[data-slot="'+at+'"]')||root.querySelector(".dslot.is-empty");
    if(slot){ if(!(root.host && root.host.dataset && root.host.dataset.inline==="1")) try{ slot.scrollIntoView({block:"center"}); }catch(e){}
      slot.classList.add("over"); setTimeout(()=>slot.classList.remove("over"),1500); }
    const f=root.getElementById("file"); if(f) f.click();
  }
  /* v1.4, the product-page flow: the proof of every open design on screen, ONE confirm,
     then the product page's own Add to cart button (cloned by lab-proof-confirm.js, not
     restyled). Nothing is built at print size, nothing is uploaded and no cart call is
     made until that button is pressed, so every guard in doAdd still runs afterwards. */
  async function reviewProof(){
    addedSnap=null;                       /* v2.9.3: this order's summary is taken when it succeeds */
    const live=liveDocIdxs();
    if(!live.length){ setStatus(stkT("stk.studio.msg.add_one_first","Add at least one design first."),"error"); return false; }
    if(live.length>MAX_DESIGNS){ setStatus(stkFmt(stkT("stk.studio.msg.up_to_max","Up to [max] designs per order. Please remove [remove]."),{max:MAX_DESIGNS,remove:live.length-MAX_DESIGNS}),"error"); return; }
    if(!TRUE_SIZE && typedSize() && effectiveSize().over){ setStatus(stkT("stk.studio.msg.over10","Stickers over 10cm are priced by hand for now. Email hello@stickiply.com."),"error"); return false; }
    const variant=strictVariant();
    if(!variant){ setStatus(stkT("stk.studio.msg.combo_unavailable","Sorry, that combination is not available. Please pick another option."),"error"); return; }
    if(variant.available===false){ setStatus(stkT("stk.studio.msg.sold_out","That option is sold out right now."),"error"); return; }
    setStatus(stkT("stk.studio.msg.rendering","Rendering your proof…"),"busy");
    const pay=proofPayload();
    if(!pay.slots.filter(s=>!s.empty).length){
      setStatus(stkT("stk.studio.msg.render_failed","Sorry, we could not render your proof. Open the design and press Review again."),"error"); return;
    }
    setStatus("",null);
    window.LabProofConfirm.open({
      /* P240 v2 (1 Nov 2026): the artwork check tile shows the total it charges, one check per design line. Only the
         grid path makes one line per design; the band path (Custom Vinyl, Magnets: PL_GRID.bands) and single make ONE */
      checkLines:(PL_GRID && !PL_GRID.bands) ? live.length : 1,
      title:stkT("stk.studio.order.final_title", "Final check"),
      lead:stkT("stk.studio.order.final_lead", "Check each design, its cut line, style and quantity. Then download your files or add them straight to your cart."),
      /* v2.9 (notes 8, 9): the status line stays above the bar, and the download line clears.
         P158 (24 Sep 2026): one file per design now, its zip; the preview is no longer sent. */
      addingText:stkT("stk.studio.msg.adding", "Adding to cart"),
      /* v2.9.3 (Thomas: "the upload 12 was coming from instead of 4"). THE BAR COUNTS
         DESIGNS. The file triple is ours, not his. It also covers the PREPARE phase, which
         ran with no bar at all (2.3s for four 4.4MB sources here, longer on his own art). */
      progressCaption:function(done,total,frac){
        if(frac>=1) return stkT("stk.studio.confirm.files_sent","Files sent");
        if(addPhase.of){
          if(addPhase.name==="prep") return stkFmt(stkT("stk.studio.order.prog_prep","Preparing design [n] of [total]"),{n:Math.min(addPhase.n+1,addPhase.of),total:addPhase.of});
          if(addPhase.name==="send") return stkFmt(stkT("stk.studio.order.prog_send","Sending design [n] of [total]"),{n:Math.min(addPhase.n+1,addPhase.of),total:addPhase.of});
        }
        return frac>=1 ? stkT("stk.studio.confirm.files_sent","Files sent") : stkT("stk.studio.order.prog_sending","Sending your designs");
      },
      /* v2.9.2 (R10): the order summary, counted when the add succeeds. v2.9.3: the pack
         is emptied at that moment, so this reads the snapshot, not docs[]. */
      doneSummary:function(){ return addedSnap ? { thumbs:addedSnap.thumbs, rows:addedSnap.rows } : orderSnapshot(); },
      /* v2.9.3: finishAfterAdd already closed the lab; this keeps it closed. */
      onDoneClose:function(){ try{ if(window.proofLab) window.proofLab.close(); }catch(e){} },
      /* v3.1 (Thomas, 24 Sep: "we dont need the confirmation screen after on mobile"): on a phone
         the window closes on success and the store's own "Added" toast is what he sees (measured:
         the theme shows its toast for this add, the drawer stays closed, as for a product-page add) */
      /* v4.3 (Thomas, desktop: "no need for this screen"): every width now - the window closes on
         success and the store's own "Added" toast is what the customer sees */
      skipDone:function(){ return true; },
      /* v3.1: on a phone a proof is tapped to edit it, as an ORDER quarter is */
      /* v4.4: desktop takes the phone's Final check tiles too (no eye / pencil), so the proof edits at every width */
      /* 28 Sep 2026 (Thomas: "tapping on that screen views your mock up instead ... Maybe not final screen" for edit):
         the proof tap shows it large; the order screen behind it keeps EDIT DESIGN */
      tapToEdit:function(){ return false; },
      downloadDoneText:stkT("stk.studio.order.files_downloaded", "Files downloaded"),
      downloadDoneMs:2500,
      slots:pay.slots,
      rows:pay.rows,
      canAddMore:pay.canAddMore,
      confirmText:window.LabCart.RIGHTS_COPY,
      addLabel:stkT("stk.studio.add_to_cart","Add to cart"),
      /* v1.9: from the proof window the customer can also take the files away
         without losing the proof. It is the lab's OWN ZIP builder, unchanged:
         print PNG + cut SVG + the proof for every open design. dlZipBatchGo is
         NOT used here, because it reads the design grid's selection and nothing
         is selected from inside the overlay - it would build an empty ZIP and
         say nothing. v2.4 gives it the LIVE page's download-group styling. */
      downloadLabel:stkT("stk.studio.confirm.download_files","Download files"),
      downloadNote:stkT("stk.studio.confirm.download_note","Print PNG + cut SVG + your proof, one ZIP"),
      onDownload:function(){
        const idxs=docs.map(function(d,i){ return i; });
        return idxs.length>1 ? dlZipBatch(idxs) : dlZipRun();
      },
      /* counted when the add SUCCEEDS, not when the window opened: a design can
         be removed or added while the proof is on screen, and v2.3 said "Your
         design and its print files" over a line carrying four of them. */
      doneText:function(){
        const n=addedSnap ? addedSnap.n : liveDocIdxs().length;   /* v2.9.3: the pack is already cleared */
        return n>1
          ? stkFmt(stkT("stk.studio.order.done_many","Your [designs] designs and their print files are on the order."),{designs:n})
          : stkT("stk.studio.confirm.done_body","Your design and its print files are on the order.");
      },
      /* a tile can send the customer back to that design, take it out of the
         bundle, or change just that design's share of the pack - and the ORDER
         panel's row follows, because both read perQty (Thomas, 12 Sep 23:00) */
      onEditDesign:function(id){ const i=Number(id); if(!isNaN(i)&&docs[i]){ activateDoc(i); openStep(2); } },
      onRemoveDesign:function(id){
        const i=Number(id);
        if(!isNaN(i)&&docs[i]){ closeDoc(i); splitPack(); draw(); renderDocTabs(); }
        return proofPayload();
      },
      /* round 2 (owner 31 Oct: cm/in on every screen): a unit flip in the Final check redraws its sizes in the new unit */
      onUnits:function(){ const p=proofPayload(); return { slots:p.slots, rows:p.rows, qtys:p.qtys, limits:finalLims(p.live) }; },
      onQty:function(id,n){
        const i=Number(id), d=docs[i];
        if(d && liveDocIdxs().length===1) pickPackFor(n);      /* v3.6: one design - the figure picks the pack */
        else if(d){ setQty(d.id,n); draw(); }
        const liveNow=liveDocIdxs();
        return { qtys:qtyMap(liveNow), limits:finalLims(liveNow), rows:proofRows(liveNow.length) };
      },
      /* an empty quarter: close the window, open that slot for upload */
      onAddSlot:function(){ openFreeSlot(); },
      /* v2.9.2 (R10): a FRESH pack - the added designs are on the order now - and the chosen
         file lands in slot 1. v2.9.3: the add already closed the lab and emptied the pack, so
         this is the ONE exception that opens it again; the pack is already clean. */
      onAddMoreDone:function(){
        overlayStatus=null; addedSnap=null;
        try{ if(window.proofLab) window.proofLab.open(); }catch(e){}
        try{ resetPack(); }catch(e){}
        if(window.__plBeginAnother) window.__plBeginAnother(); else openStep(1);
        renderDocTabs();
        const f=root.getElementById("file"); if(f) f.click();
      },
      onAdd:function(fn){
        overlayStatus=fn;
        { const cb=customBlock(); if(cb) return Promise.reject(new Error(cb.msg||cb.label)); }
        const rc=mount.querySelector("#cartRights"); if(rc) rc.checked=true;
        return doAdd().then(function(ok){
          if(ok===false){ const s=inPanel("#cartStatus"); throw new Error((s&&s.textContent)||""); }
          /* v2.9.3: the order is placed. Freeze the summary, then hand the pack over to the
             cart line: empty the editor and close the lab so the card lands on the product
             page instead of floating over an editor full of designs he has already bought. */
          addedSnap=orderSnapshot();
          finishAfterAdd();
          return true;
        });
      },
      onBack:function(){ overlayStatus=null; }
    });
  }
  /* 7 Oct 2026 (P212 fault 1): the product page's Final check (lab-proof-confirm.js, outside this shadow root) keeps the
     figures it opened with; after mktFresh its tiles take the refreshed ones (proofRows, same rows in the same order) */
  function mktOverlayRows(){
    const ts=document.querySelectorAll(".lpc .lpc__tiles .lpc__tile .lpc__tv"), rows=proofRows(liveDocIdxs().length);
    if(!ts.length || ts.length!==rows.length) return;
    rows.forEach((r,k)=>{ const v=String(r[1]); if(ts[k].textContent!==v){ ts[k].textContent=v; ts[k].setAttribute("title",v); } });
  }
  async function doAdd(){
    /* v2.3: ONE CART LINE, the pack variant at quantity 1, with every design's
       files and its own share of the pack beside it.
       P158 (24 Sep 2026): each design is ONE property, "Artwork N · {qty} × {name}",
       whose value is ONE zip of its print PNG and cut SVG; its share of the pack rides
       in the key, and "Artwork N size" follows it. Built by LabCart (lab-cart.js, "LabCart v2"). Orders placed before
       this keep "Artwork Upload (n)" / "Artwork Upload (n) Qty", and every reader keeps
       reading those; the Uploads order zip writes the same manifest labels for the files
       inside each design zip, so Studio's parser reads a v2 order unchanged. */
    const live=liveDocIdxs();
    // G3: everything that can refuse, refuses here, before a single network call.
    if(!live.length){ setStatus(stkT("stk.studio.msg.add_one_first","Add at least one design first."),"error"); return; }
    if(live.length>MAX_DESIGNS){ setStatus(stkFmt(stkT("stk.studio.msg.up_to_max","Up to [max] designs per order. Please remove [remove]."),{max:MAX_DESIGNS,remove:live.length-MAX_DESIGNS}),"error"); return false; }
    if(!TRUE_SIZE && typedSize() && effectiveSize().over){ setStatus(stkT("stk.studio.msg.over10","Stickers over 10cm are priced by hand for now. Email hello@stickiply.com."),"error"); return false; }
    if(GRID){ const cb=customBlock(); if(cb){ setStatus(cb.msg||cb.label,"error"); return false; } }
    const rights=mount.querySelector("#cartRights");
    if(!(rights&&rights.checked)){ setStatus(stkT("stk.studio.msg.tick_rights","Please tick the box to confirm you have the rights to this artwork."),"error"); return false; }
    /* G2: ONE line, the pack variant, exactly as the product page sends it. */
    const variant=strictVariant();
    if(!variant){ setStatus(stkT("stk.studio.msg.combo_unavailable","Sorry, that combination is not available. Please pick another option."),"error"); return false; }
    if(variant.available===false){ setStatus(stkT("stk.studio.msg.sold_out","That option is sold out right now."),"error"); return false; }
    splitPack();
    const plan=live.map(i=>({ idx:i, doc:docs[i], qty:Number(perQty[docs[i].id])||0 }));
    /* MONEY GUARD (24 Sep 2026, found by the Custom Sticker Pricing session): the line is
       charged at the pack (packTotal()), so the designs' shares must add up to exactly that
       pack, or a customer pays for 48 and the order asks for 300. v3.1's setQty caps every
       entry; this refuses anything that still gets through, before any file is sent. */
    const pack=packTotal()||0, shares=plan.reduce((n,pl)=>n+pl.qty,0);
    if(pack>0 && shares!==pack){ setStatus(stkFmt(stkT("stk.studio.msg.qty_mismatch","Your designs add up to [shares] stickers but the pack is [pack]. Please adjust the quantities so they add up to [pack]."),{shares:shares,pack:pack}),"error"); return false; }
    /* P128b gap 1 (6 Oct 2026): a cart too full for the price functions refuses here, before any file is sent */
    if(BANDS){
      const j0=bJob(), p0={};
      plan.forEach((pl,k)=>{ p0["_Artwork "+(k+1)+" size"]=(bMmWH(gDims(pl.idx))||"0 × 0")+" mm, qty "+pl.qty; });
      const pu=(pack!==bPackQ(pack)) ? gPlan(pack,gCurFin()) : null;   /* v3.12: sold as the pack above: a pack line */
      if(await jobCapFull(pack!==bPackQ(pack) && !(pu && pu.up), j0 && j0.s, finishApi(), pack, p0)){ setStatus(jobCapMsg(),"error"); return false; }
    }
    setStatus(stkT("stk.studio.msg.preparing", "Preparing your files"),"busy");
    /* v2.9.3: ONE BAR OVER THE WHOLE JOB, counted in units. P158 (24 Sep 2026): two per
       design, one when it is built, one when its zip has been sent, the second moving with
       the bytes on the wire. Designs are built and sent ONE AT A TIME and each one's bytes
       are dropped before the next is built, so a phone holds one design's PNG and its zip,
       never four PNGs (v2.9.3 built every design before sending any). */
    const jobUnits=plan.length*2;
    let unitsDone=0;
    const tell=part=>{ if(overlayStatus&&overlayStatus.progress) overlayStatus.progress(Math.min(1,(unitsDone+(part||0))/jobUnits), unitsDone, jobUnits); };
    addPhase.name="prep"; addPhase.n=0; addPhase.of=plan.length;
    tell(0);
    const harness=host.dataset.harness==="1";
    const back=activeIdx;
    let swapped=false;
    /* the doc globals go back to the design on screen on the way out, success or not */
    const restore=()=>{ if(!swapped) return; swapped=false; activeIdx=back; if(back>=0 && docs[back]) loadDocGlobals(docs[back]); };
    try{
      if(back>=0 && docs[back]) captureDoc();
      swapped=true;
      const fin=(()=>{ /* P172: the finish word from the variant SKU, as finishApi(); value text only as before when no SKU word */ const i=finishOptIdx(), fn=finishName(), val=fn?sel[fn]:undefined; const w=(i>=0&&val!=null)?skuFinish(((activeP&&activeP.variants)||[]).find(v=>String(optValsOf(v)[i])===String(val))):null; return w?({MATTE:"matte",GLOSS:"glossy",GLITTER:"glitter",HOLO:"holographic"})[w]:((t)=>({"matt":"matte","glänzend":"glossy","glitzer":"glitter","holografisch":"holographic","mat":"matte","brillant":"glossy","pailleté":"glitter","holographique":"holographic","mate":"matte","brillante":"glossy","holográfico":"holographic","opaco":"matte","lucido":"glossy","olografico":"holographic","blank":"glossy","holografisk":"holographic","matta":"matte","kiiltävä":"glossy","holografinen":"holographic","glansig":"glossy","glanzend":"glossy"})[t]||t)(String(val||"matte").toLowerCase()); })();  /* text fallback maps translated finish words back to English */
      plan.forEach(pl=>{ pl.quoteProps=null; pl.url=null; });
      let bandThumb=null;   /* 3 Oct: design 1's small PNG for the checkout image (_stk_thumb) */
      const labThumbs=[];   /* 17 Oct: one small bitmap per design (max 4), composed into the one checkout picture after the loop */
      /* review 24 Sep: two designs with the same name made identical zip entries, and
         Studio flattens nested zips by file name, so the last quantity won for both.
         A repeat gets "-N-" before its print/cut suffix; PNG and SVG keep one stem. */
      const usedStems=new Set();
      for(let k=0;k<plan.length;k++){
        const pl=plan[k];
        addPhase.name="prep"; addPhase.n=k; tell(0);
        loadDocGlobals(docs[pl.idx]); activeIdx=pl.idx;
        let files=await buildArtworkFiles();
        (files||[]).forEach(f=>{ if(f&&f.name) f.name=String(f.name).normalize("NFKD").replace(/[^\w.\-]+/g,"_"); });
        const stemOf=f=>String(f&&f.name||"").replace(/-(print-300dpi\.png|cutfile\.svg)$/i,"").toLowerCase();
        if(files && files[0] && usedStems.has(stemOf(files[0]))) files.forEach(f=>{ if(f&&f.name) f.name=f.name.replace(/-(print-300dpi\.png|cutfile\.svg)$/i,"-"+(k+1)+"-$1"); });
        if(files && files[0]) usedStems.add(stemOf(files[0]));
        pl.name=(artName||("design-"+(pl.idx+1)));
        pl.size=cutSizeMm();
        pl.custom=!!opts.sizeCustomMm;
        pl.shape=SHAPE_Q[opts.shape]||"die-cut";
        /* 18 Oct 2026 (P215): where the cut came from, for Dispatch (hidden "_Cut source", only when a file had one) */
        pl.cutSrc = custCut ? cutSrcClean(ownCut() ? "customer: "+custCut.label : "traced (the file's cut line not used)") : "";   /* 18 Oct 2026 (review): the label is the customer's layer / swatch name */
        if(!files || !files[0] || !files[0].bytes || !files[0].bytes.length) throw new Error(stkT("stk.studio.msg.print_failed", "Your print file did not build. Please reopen the design and try again."));

        /* G4, true size: every custom line is quoted AGAIN here, for the size and
           the quantity on screen right now. A failure refuses the order rather
           than adding it at a price the customer was never shown. The pack is one
           price, so it is one quote: the first design's true size at the pack
           quantity, which is what the ladder priced on screen. P158: asked once
           design 1 is built, before any zip is sent. */
        unitsDone++; tell(0);                              /* this design is built */

        /* G1: the zip is REQUIRED, print AND cut. cart.uploadDesign checks the zip reads
           back as exactly these two files (STORE, sizes match), PUTs it with the
           "proof-design" field and HEADs the public URL; any failure throws out of doAdd
           and /cart/add.js is never reached. The 12 Sep code let a failed cut upload
           through as .catch(()=>null) and the order arrived with no cut line. */
        addPhase.name="send"; addPhase.n=k; tell(0);
        if(harness){
          /* the harness sends nothing: it proves the zip builds and reads back */
          const z=await window.LabCart.zipDesign(files);
          pl.url="https://harness.invalid/"+window.LabCart.zipFilename(k+1,pl.name);
          pl.zipKb=Math.round(z.size/1024);
        } else {
          cart.onProgress=ev=>tell(ev&&ev.total?Math.min(1,ev.loaded/ev.total):0);
          /* the job owns the bytes: uploadDesign lets go of them once the zip is built,
             so only the zip is held while it uploads */
          /* 3 Oct 2026 (Thomas: "where are the thumbnails at checkout"): design 1's print PNG, scaled to 400 px as a JPEG on white,
             goes up as a small preview; its URL rides as _stk_thumb and the cart transform shows it as the checkout
             image. Taken before the job owns the bytes; a failure never stops the order (the photo stays). */
          if(BANDS && labThumbs.length<4 && files[0] && files[0].bytes){
            try{ labThumbs.push(await createImageBitmap(new Blob([files[0].bytes],{type:"image/png"}),{resizeWidth:400,resizeQuality:"medium"})); }
            catch(e){ console.warn("[proof-lab] checkout thumb not built:",e&&e.message); }
          }
          const job={ fieldId:"proof-design", files:files, n:k+1, name:pl.name };
          files=null;
          pl.url=await cart.uploadDesign(job);
          cart.onProgress=null;
        }
        files=null;                                        /* released before the next design */
        if(!isHttp(pl.url)) throw new Error(stkFmt(stkT("stk.studio.msg.send_failed","We could not send \u201c[name]\u201d just now. Please try again in a moment."),{name:pl.name}));
        unitsDone++; tell(0);                              /* this design's zip is sent */
      }
      restore();
      if(overlayStatus&&overlayStatus.progress) overlayStatus.progress(1,jobUnits,jobUnits);
      if(plan.some(pl=>!isHttp(pl.url))) throw new Error(stkT("stk.studio.msg.not_all_uploaded", "Not every design uploaded. Nothing was added to your cart."));
      /* 17 Oct 2026: every design in the one checkout picture (a failure never stops the order: the photo stays) */
      if(labThumbs.length){
        try{ const cb=await stkCompose(labThumbs); const tr=await fetch(PREVIEW_URL,{method:"POST",headers:{"Content-Type":"image/jpeg"},body:cb}); if(!tr.ok) throw new Error("preview "+tr.status); const tu=(await tr.json()).url; if(/^https:\/\//i.test(String(tu||""))) bandThumb=String(tu); }
        catch(e){ console.warn("[proof-lab] checkout thumb not sent:",e&&e.message); }
        labThumbs.forEach(b=>{ try{ if(b&&b.close) b.close(); }catch(_){} }); labThumbs.length=0;
      }

      /* G4, true size: the WHOLE job is quoted again here, every design at the size and
         share on screen right now, and the order is refused rather than added at a price
         the customer was never shown. One call, so a two-design pack is priced once:
         quoting design 1 alone charged one setup instead of two and read whichever design
         happened to be open (Opus review, 24 Sep). */
      /* P128 SIZE GRID: one cart line per design, the grid variant its true size snaps to, at its
         share of the order (48 to 2,000). Priced by the Bulk price function, not by this file: the
         line carries no price, only the variant and the quantity. Labels (Thomas, 27 Sep: "yes
         better"): the visible "Artwork Upload (1)" is the design's name, the address rides the
         hidden "_Artwork Upload (1)", "Artwork Upload (1) Qty" as the upload box writes it.
         _stk_w_mm/_stk_h_mm = the true cut size, _stk_qty "1" (Dispatch multiplies it by the line
         quantity), a visible "Cut size" only when the cut is smaller than the size charged. */
      if(BANDS){
        /* P128 OPTION B: ONE line, the pack variant (largest design's band x finish x the total)
           at quantity 1, every design as an attachment with its own share, exactly as the
           product page sends a pack. Visible Size = the charged size in cm; _stk_* for Dispatch. */
        const fin=gCurFin(), total=packTotal()||0;
        /* P212 audit fault 1 (7 Oct 2026): outside GBP every add first takes this market's rate and prices as they are now
           (mktFresh) and quotes again; the card is redrawn with that figure before the add, so the price on screen is the
           price charged, pack or between. A line the read-back refuses is taken out and tried ONCE more on prices asked
           again; refused twice, the customer is told and nothing stays in the cart. GBP: no request, no second try. The
           loop body below is not re-indented; it runs a second time only from the read-back. */
        for(let attempt=0;;attempt++){
        const shown=gPlan(total,fin).cents, fresh=await mktFresh(mktBands(),fin);
        let pl0=gPlan(total,fin);
        /* v3.10: outside GBP a pack's price waits for its variant (the ladder) and a figure between packs for the hidden
           item's own price; both are asked already, so the add waits for them here once */
        if(pl0.pending && pl0.job && !pl0.job.err){ await Promise.all([bRowsAsync(pl0.job.s,fin), cqLoad()]).catch(()=>null); pl0=gPlan(total,fin); }
        /* 2 Oct: the price came from the band price table; the job variant's id comes from the ladder,
           asked once for this band and finish, and waited for here if it has not answered yet */
        if(pl0.lines.length && !(Number(pl0.lines[0].v.id)>0) && pl0.job && !pl0.job.err){ await bRowsAsync(pl0.job.s,fin); pl0=gPlan(total,fin); }
        if(fresh){
          try{ console.info("[proof-lab] market rate "+fresh.was+" -> "+fresh.rate+", quote "+shown+" -> "+pl0.cents); }catch(e){}
          try{ draw(); }catch(e){}   /* the card shows the figure about to be added */
          try{ mktOverlayRows(); }catch(e){}   /* and so does the product page's Final check */
        }
        if(pl0.pending) throw new Error(stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment."));
        if(pl0.small) throw new Error(QTY_ERR_SMALL);
        if(!pl0.lines.length) throw new Error(bErrBlock(pl0.err||"price","","","").msg);   /* P128b gap 4: "too big" only for a size no band holds */
        const bv=pl0.lines[0].v;
        if(bv.a===false) throw new Error(stkT("stk.studio.msg.sold_out","That option is sold out right now."));
        if(!(Number(bv.id)>0)) throw new Error(stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment."));
        /* MONEY GUARD: the line is priced on screen from these same designs; refuse if a design has no size */
        if(plan.some(pl=>!(pl.size && pl.size.w>0 && pl.size.h>0))) throw new Error(stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment."));
        if(plan.some(pl=>!(pl.qty>=1))) throw new Error(stkT("stk.studio.msg.design_min_one","Each design needs at least 1 sticker."));
        /* 2 Oct 2026 (property design): the cart line carries ONE visible key, the rest hidden.
           "_Artwork N file" = the design's zip, "_Artwork N size" = "{W} × {H} mm, qty {q}" (whole mm UP,
           as the cart transform bands it), "_stk_finish". Visible: one design "Size" = "{W} × {H} mm",
           several "Designs" = "{n} ({W1} × {H1}, ... mm)", in the shop's language. The transform writes
           the price and the order line's keys from these. */
        const whs=plan.map(pl=>bMmWH(pl.size));
        const visKey=plan.length===1 ? stkT("stk.studio.tool.size","Size") : stkT("stk.studio.order.designs_prop","Designs");
        const visVal=plan.length===1 ? whs[0]+" mm" : plan.length+" ("+whs.join(", ")+" mm)";
        /* v3.12: a figure between packs sold as the pack above sends the designs scaled up to that pack (the plan's own shares) */
        const upSh=(pl0.up && Array.isArray(pl0.up.shares) && pl0.up.shares.length===plan.length) ? pl0.up.shares : null;
        if(pl0.up && !upSh) throw new Error(stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment."));
        let props=cart.buildProperties({ tool:"proof-lab", bandKeys:true, visible:{ key:visKey, value:visVal },
          designs:plan.map((pl,k)=>({ url:pl.url, name:pl.name, qty:upSh ? upSh[k] : pl.qty, size:pl.size })),
          hidden:{ stk_finish:finishApi()||"matte", stk_thumb:bandThumb||"" } });
        /* 6 Oct 2026 (Thomas's 18:40 Studio 422, iPhone simulator): that add reached Shopify as the band pack with NONE of
           these keys, so the custom-line guard refused it as "no artwork". Not reproduced (4 runs of the same job added
           fine); only LabCart's older builder writes a line whose keys the functions cannot read. So the band line is
           checked here: any band key missing and Studio writes the whole set itself from this plan, the same values the
           builder writes. A band line never goes to /cart/add.js without its artwork. */
        {
          const want=[["_stk_label",visKey]];
          plan.forEach((pl,k)=>{ want.push(["_Artwork "+(k+1)+" file",pl.url]); want.push(["_Artwork "+(k+1)+" size",whs[k]+" mm, qty "+(upSh ? upSh[k] : pl.qty)]); });
          if(want.some(([k,v])=>/ file$/.test(k) && !/^https?:\/\//i.test(String(v||""))))
            throw new Error(stkT("stk.lab_cart.err_upload_incomplete","Your artwork did not finish uploading. Please try again."));
          const miss=want.filter(([k])=>!(props && props[k])).map(([k])=>k);
          if(miss.length){
            try{ console.warn("[proof-lab] band keys missing from the cart line, rebuilt by Studio:", miss.join(", "), Object.keys(props||{}).join(", ")); }catch(e){}
            props={}; props[visKey]=visVal;
            for(const [k,v] of want) props[k]=String(v);
            props._stk_finish=finishApi()||"matte";
            if(/^https:\/\//i.test(String(bandThumb||""))) props._stk_thumb=String(bandThumb);
          }
        }
        { const cs=cutSourceProp(plan); if(cs) props["_Cut source"]=cs; }   /* P215 */
        if(harness){
          console.log("[proof-lab] cart (harness stub, bands):",{ variantId:bv.id, quantity:1, properties:props });
          setStatus("Added to cart (harness, payload logged to console)","done"); return true;
        }
        setStatus(stkT("stk.studio.msg.adding", "Adding to cart"),"busy");
        /* v3.8 (5 Oct 2026, Thomas: "hide the quantity when custom is selected everywhere, checkout, emails"): a figure
           between packs goes in as the hidden item itself ("S8 / Glossy", no "/ 100"), priced by the cart transform
           from that item's own table. Not found (a fetch fails): the pack above, as before. */
        let lineId=Number(bv.id);
        const btwn=total!==bPackQ(total) && !pl0.up;   /* v3.12: a figure sold as the pack above is a pack line */
        if(btwn && !pl0.pv){ const cq=await cqVariantId(pl0.job && pl0.job.s, String(finishApi()||"").toUpperCase()); if(cq) lineId=cq; }
        /* P128b gap 3 (6 Oct 2026): a hidden-item line is one job; a unique hidden _stk_job keeps two adds two lines
           (Shopify merges lines with the same variant and properties). Pack figures stay as they were. */
        if(lineId!==Number(bv.id)) props._stk_job=stkJobId();
        /* v3.10 (6 Oct 2026): the figure's exact total in this market (cart cents), which only the theme knows (the market
           factor from the hidden item's own price). cq-round reads it outside the UK to take the rounding pennies off; the
           UK ignores it and recomputes. Every market, so a line always carries it. */
        if(btwn && Number(pl0.cents)>0) props._stk_cq_cents=String(Math.round(Number(pl0.cents)));   /* v3.12: on a pack-variant between line too */
        /* P128b gap 1: the cart must still fit the functions' instruction cap with this job in it (checked again here,
           with the real line, after the files went up) */
        if(await jobCapFull(lineId!==Number(bv.id), pl0.job && pl0.job.s, finishApi(), total, props)) throw new Error(jobCapMsg());
        /* P240 (1 Nov 2026): the artwork check line rides the same request when ticked; design line stays items[0] */
        const acL=(window.LabProofConfirm&&LabProofConfirm.withCheck?LabProofConfirm.withCheck({ id:lineId, quantity:1, properties:props }):{ id:lineId, quantity:1, properties:props });
        const addRes=await cart.addToCart(acL);
        /* 5 Oct 2026 MONEY GUARD: a figure between packs rides the pack above it, and only the cart
           transform brings it down to the figure's price. Without it the line pays the whole pack, so
           the line is read back and taken out again unless it is the price on screen. */
        if(btwn){
          /* v3.6 + review (5 Oct): the line THIS add made (its key from /cart/add.js, not the first same-variant
             line, which could be an earlier job), read back: after discounts it must cost no more than the quote.
             More = the transform refused it (the whole pack) or cq-round did not take the rounding pennies off.
             Less is only ever a customer's own discount code, so it stays. */
          const want=Number(pl0.cents), key=addRes&&addRes.items&&((addRes.items.find(it=>!(it&&it.properties&&it.properties._check_for))||addRes.items[0]||{}).key);   /* P240 v2: the design line, not its check line */
          let line=null;
          try{
            const c=await (await fetch("/cart.js",{cache:"no-store"})).json();
            line=(c.items||[]).find(it=>it && key && it.key===key) || null;
          }catch(e){ line=null; }
          const got=line ? Number(line.final_line_price!=null ? line.final_line_price : line.line_price) : null;
          const orig=line ? Number(line.original_line_price!=null ? line.original_line_price : line.line_price) : null;
          /* v3.10: the quote is the transform's own figure in every market (the market factor), so to the cent everywhere */
          const tol=0;
          /* v3.8: before discounts the transform's line is never under the quote (whole-penny unit rounded up); a hidden
             item the transform did not price sits at its own price, under it, and is taken out too */
          if(!line || !(want>0) || !(got>0) || !(got<=want+tol) || !(orig>=want-tol)){
            try{ console.warn("[proof-lab] between-pack line not at the quoted price", total, want, got); }catch(e){}
            const rm=line ? line.key : key;
            if(rm) try{ await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({ id:rm, quantity:0 })}); }catch(e){}
            try{ if(window.LabProofConfirm&&LabProofConfirm.dropChecks) await LabProofConfirm.dropChecks(acL); }catch(e){}   /* P240: its paired artwork check goes with it */
            /* 7 Oct: once more on this market's prices asked again (a rate that moved between the ask and the add) */
            if(attempt===0 && gRate()!==1){ try{ console.warn("[proof-lab] read-back refused: market prices asked again, one more try"); }catch(e){} continue; }
            throw new Error(stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment."));
          }
        }
        setStatus(stkT("stk.studio.msg.added","Added to cart"),"done");
        try{ document.dispatchEvent(new CustomEvent("pl:added")); }catch(e){}
        return true;
        }   /* end of the 7 Oct add loop */
      }
      if(GRID){
        const fin=gCurFin(), items=[];
        for(const pl of plan){
          const pk=gPick(pl.size,fin);
          if(!pk.v) throw new Error(pk.pending ? stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment.") : stkT("stk.studio.order.grid_too_big",SIZE_ERR_GRID));
          if(pk.v.a===false) throw new Error(stkT("stk.studio.msg.sold_out","That option is sold out right now."));
          if(!(pl.qty>=QTY_MIN)) throw new Error(stkT("stk.studio.order.grid_min_design","Each design needs at least 48 stickers."));
          if(pl.qty>QTY_MAX) throw new Error(stkFmt(stkT("stk.studio.order.grid_over_max",QTY_ERR_BIG),{max:B_NUM(QTY_MAX)}));
          const w=Math.round(Number(pl.size.w)), h=Math.round(Number(pl.size.h));
          const props={};
          props["Artwork Upload (1)"]=String(pl.name||"Artwork 1").replace(/[\u0000-\u001f\u007f-\u009f]/g," ").trim().slice(0,60)||"Artwork 1";
          props["_Artwork Upload (1)"]=pl.url;
          props["Artwork Upload (1) Qty"]=String(pl.qty);
          if(Math.max(w,h)<pk.L || Math.min(w,h)<pk.S) props["Cut size"]=gCm(Math.max(w,h))+" \u00d7 "+gCm(Math.min(w,h))+" cm";
          props._stk_w_mm=String(w); props._stk_h_mm=String(h); props._stk_qty="1";
          props._stk_shape=pl.shape; props._stk_finish=finishApi()||"matte";
          if(pl.cutSrc) props["_Cut source"]=pl.cutSrc;   /* P215 */
          items.push({ id:Number(pk.v.id), quantity:pl.qty, properties:props });
        }
        if(harness){
          console.log("[proof-lab] cart (harness stub, grid):",items);
          setStatus("Added to cart (harness, payload logged to console)","done"); return true;
        }
        setStatus(stkT("stk.studio.msg.adding", "Adding to cart"),"busy");
        await cart.addToCart((window.LabProofConfirm&&LabProofConfirm.withCheck?LabProofConfirm.withCheck(items):items));   /* P240: one artwork check line per design line when ticked */
        setStatus(stkT("stk.studio.msg.added","Added to cart"),"done");
        try{ document.dispatchEvent(new CustomEvent("pl:added")); }catch(e){}
        return true;
      }
      let jobQuote=null, carrier=null;
      /* "custom" is the same test the picker and customBlock() use: a typed size on any
         design, or a typed quantity that is not one of the six presets. */
      const isCustomJob=plan.some(pl=>pl.custom) || !!customQty;
      if(TRUE_SIZE && isCustomJob){
        const designs=plan.map(pl=>({ w:pl.size&&pl.size.w, h:pl.size&&pl.size.h, qty:pl.qty, shape:pl.shape }));
        if(designs.some(d=>!(d.w>0)||!(d.h>0)||!(d.qty>0))) throw new Error(stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment."));
        jobQuote=await askQuote(designs.length>1
          ? { designs:designs, finish:fin, shape:designs[0].shape, profile:"stickers" }
          : { w:designs[0].w, h:designs[0].h, qty:designs[0].qty, shape:designs[0].shape, finish:fin, profile:"stickers" });
        if(!jobQuote || jobQuote.ok!==true) throw new Error((jobQuote&&jobQuote.error)||stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment."));
        if(CUSTOM_CART_READY){
          carrier=carrierBand(jobQuote.sheets);
          if(!carrier) throw new Error(stkT("stk.studio.order.err_too_big_job","That job is too big to price here. Please email hello@stickiply.com and we will quote it."));
        }
        plan[0].quoteProps=jobQuote.properties||null;
      }

      const first=plan[0];
      const hidden={ product:activeP.title,
        sticker_size:(first.custom&&first.size)?((first.size.w/10).toFixed(1)+"x"+(first.size.h/10).toFixed(1)+"cm"):(opts.sizeIn+"in") };
      /* the _stk_* quote keys go through extra exactly as /api/custom-quote named them:
         the cart transform reads them off this line by those names */
      const extra={};
      /* the builder writes "Artwork N ..." and "Artwork N size" beside each design, so the
         endpoint's copies of those keys are dropped here rather than written twice */
      if(first.quoteProps) Object.keys(first.quoteProps).forEach(k=>{ if(!/^Artwork \d+ size$/.test(k)) extra[k]=first.quoteProps[k]; });
      /* the per-design keys and sizes are written by the builder from designs[]; size is
         cutSizeMm(), the figure the quote is sent, and becomes whole mm there */
      const props=cart.buildProperties({ tool:"proof-lab",
        designs:plan.map(pl=>({ url:pl.url, name:pl.name, qty:pl.qty, size:pl.size })),
        extra:extra, hidden:hidden });
      { const cs=cutSourceProp(plan); if(cs) props["_Cut source"]=cs; }   /* P215 */
      if(harness){
        console.log("[proof-lab] cart (harness stub):",{ variantId:variant.id, quantity:1, zips:plan.map(pl=>({ name:pl.name, qty:pl.qty, kb:pl.zipKb })), properties:props });
        setStatus("Added to cart (harness, payload logged to console)","done"); return true;
      }
      setStatus(stkT("stk.studio.msg.adding", "Adding to cart"),"busy");
      const lineVariantId=(carrier && carrier.id) ? carrier.id : variant.id;
      const acL1=(window.LabProofConfirm&&LabProofConfirm.withCheck?LabProofConfirm.withCheck({ id:lineVariantId, quantity:1, properties:props }):{ id:lineVariantId, quantity:1, properties:props });   /* P240 */
      await cart.addToCart(acL1);
      /* THE PRICE ON THE LINE IS PROVED, NOT ASSUMED. The band's own list price is above
         the quote by design, so a cart transform outage would silently charge it: a median
         2.4x the quoted total. The line is read back and removed if it is not the price the
         customer was shown. */
      if(jobQuote && carrier){
        /* 27 Sep 2026: the line is charged in the cart's currency (cart transform v2.8:
           GBP quote x presentmentCurrencyRate), so the GBP quote is converted the same way
           before it is compared. Shopify.currency.rate is inferred, not measured, to be the
           function's rate: check with a EUR cart after the v2.8 deploy. */
        const fx=Number(window.Shopify&&Shopify.currency&&Shopify.currency.rate)||1;
        const want=Math.round(Math.round(Number(jobQuote.price)*100)*fx);
        let line=null;
        try{
          const c=await (await fetch("/cart.js",{cache:"no-store"})).json();
          const acTok=Array.isArray(acL1)&&acL1[0]&&acL1[0].properties ? acL1[0].properties._check_id : null;   /* P240 v2 (review LOW 12): this add's line by its pairing token */
          if(acTok) line=(c.items||[]).find(it=>it && it.properties && it.properties._check_id===acTok) || null;
          else for(let i=(c.items||[]).length-1;i>=0;i--){ const it=c.items[i]; if(it && it.variant_id===lineVariantId){ line=it; break; } }
        }catch(e){ line=null; }
        const got=line ? Number(line.final_line_price!=null ? line.final_line_price : line.line_price) : null;
        /* up to 10p (or 1% in a converted currency) either way is rounding, not an outage
           (an outage charges the band's own list price, a median 2.4x the quote) */
        if(line && !(Math.abs(got-want)<=Math.max(10,Math.round(want*0.01)))){
          try{ await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({ id:line.key, quantity:0 })}); }catch(e){}
          try{ if(window.LabProofConfirm&&LabProofConfirm.dropChecks) await LabProofConfirm.dropChecks(acL1); }catch(e){}   /* P240 */
          throw new Error(stkT("stk.pricing.quote_failed","We could not price that just now. Please try again in a moment."));
        }
      }
      setStatus(stkT("stk.studio.msg.added","Added to cart"),"done");
      try{ document.dispatchEvent(new CustomEvent("pl:added")); }catch(e){}
      return true;
    }catch(e){
      restore(); cart.onProgress=null;               /* P158: put the design on screen back */
      // v1.5: the developer text stays in the console, never on the status line.
      if(e) console.warn("[proof-lab] add to cart failed",e);
      const plain = (window.LabCart && window.LabCart.plainError)
        ? window.LabCart.plainError(e,stkT("stk.studio.msg.add_failed","Could not add to the cart. Try again."))
        : stkT("stk.studio.msg.add_failed","Could not add to the cart. Try again.");
      setStatus(plain,"error"); return false;
    }
  }
})();
}

class ProofLabTool extends HTMLElement {
  connectedCallback(){
    if(this.shadowRoot) return;
    const r = this.attachShadow({mode:"open"});
    /* v1.6: the product page's own picker stylesheet, linked INTO the shadow
       root. A <link> inside a shadow tree styles that tree, and it is the only
       route variant-rows.css has into the lab. Custom properties and @font-face
       already cross the boundary, so Sapiens and the theme tokens come with it. */
    let sheets = "";
    if(this.dataset.toolCss) sheets += '<link rel="stylesheet" href="'+this.dataset.toolCss+'">';
    if(this.dataset.cart==="1" && this.dataset.rowsCss && window.LabCart && window.LabCart.picker){
      sheets += window.LabCart.picker.styleTag(this.dataset.rowsCss, this.dataset.dispatchCss);
    }
    /* v2.9.2 (R1): invisible until the stylesheet has applied (the unstyled upload SVG used to flash); layout is kept so plInit measures */
    r.innerHTML = '<style data-pl-boot>.app{visibility:hidden}</style>'+sheets+PL_HTML;
    var boot = r.querySelector('[data-pl-boot]'), link = r.querySelector('link[rel="stylesheet"]');
    var reveal = function(){ if(boot && boot.parentNode) boot.parentNode.removeChild(boot); boot = null; };
    if(link){
      /* the load / error events only: WebKit hands a <link> an empty .sheet while it is still downloading (measured 17 Sep with the CSS delayed 900ms: the shell showed unstyled for 13 frames) */
      link.addEventListener('load', reveal); link.addEventListener('error', reveal);
      setTimeout(reveal, 2500);
    } else reveal();
    plInit(r);
  }
}
customElements.define("proof-lab-tool", ProofLabTool);
})();
